import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const AiConversationFragmentDoc = gql`
    fragment AIConversation on AIConversationObject {
  id
  title
  lastAIMessage
  conversationType
  createdAt
  updatedAt
  deletedAt
}
    `;
export const UserSettingsFragmentDoc = gql`
    fragment UserSettings on UserSettingsObject {
  id
  selectedOrganization {
    id
    name
    hasDescendants
    contractSystemCredentials {
      id
      hasInvalidCredentials
      isReady
      type
      username
      dotloopProfileId
      dotloopTeamName
    }
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment User on UserObject {
  id
  firstName
  lastName
  fullName
  userName
  phoneNumber
  roles
  email
  profileBio
  offerCollectionEmail
  profilePicture {
    fileName
    url
  }
  settings {
    ...UserSettings
  }
}
    ${UserSettingsFragmentDoc}`;
export const AccessControlFragmentDoc = gql`
    fragment AccessControl on AccessControlObject {
  id
  accessRole
  accessUser {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const PublicUserFragmentDoc = gql`
    fragment PublicUser on PublicUserObject {
  id
  firstName
  lastName
  fullName
  userName
  phoneNumber
  email
  offerCollectionEmail
  profilePicture {
    fileName
    url
  }
}
    `;
export const MlsListingAddressFragmentDoc = gql`
    fragment MLSListingAddress on MLSListingAddressObject {
  city
  country
  crossStreet
  full
  postalCode
  state
  streetName
  streetNumber
  streetNumberText
  unit
}
    `;
export const ActivityFragmentDoc = gql`
    fragment Activity on ActivityObject {
  id
  type
  createdAt
  metadata
  user {
    ...PublicUser
  }
  listing @include(if: $includeListing) {
    id
    property {
      id
      slug
    }
    mlsListing {
      id
      address {
        ...MLSListingAddress
      }
    }
  }
}
    ${PublicUserFragmentDoc}
${MlsListingAddressFragmentDoc}`;
export const AppEventFragmentDoc = gql`
    fragment AppEvent on AppEventObject {
  id
  name
  doneBy {
    id
  }
  offer {
    id
  }
}
    `;
export const ChartTrendFragmentDoc = gql`
    fragment ChartTrend on ChartTrend {
  value
  period
}
    `;
export const ChartMetricFragmentDoc = gql`
    fragment ChartMetric on ChartMetric {
  value
  description
  trend {
    ...ChartTrend
  }
  unit
}
    ${ChartTrendFragmentDoc}`;
export const ChartDataPointFragmentDoc = gql`
    fragment ChartDataPoint on ChartDataPoint {
  label
  value
}
    `;
export const ChartDataFragmentDoc = gql`
    fragment ChartData on ChartData {
  type
  title
  styleConfig {
    showLegend
  }
  mainMetric {
    ...ChartMetric
  }
  data {
    ...ChartDataPoint
  }
  verticalReferenceLine {
    ...ChartDataPoint
  }
  valueUnit
  labelUnit
}
    ${ChartMetricFragmentDoc}
${ChartDataPointFragmentDoc}`;
export const BusinessOverviewStatFragmentDoc = gql`
    fragment BusinessOverviewStat on BusinessOverviewStat {
  metric
  current {
    value
    from
    to
  }
  previous {
    value
    from
    to
  }
  chart {
    ...ChartData
  }
  estimatedDealValue
}
    ${ChartDataFragmentDoc}`;
export const BizOverviewOfferFragmentDoc = gql`
    fragment BizOverviewOffer on BizOverviewOfferObject {
  id
  createdAt
  status
  agent {
    fullName
    profilePicture {
      url
      fileName
    }
  }
  property {
    address {
      streetAddress
      city
      state
      zipCode
      unit
    }
    coverPhotoUrl
  }
  buyerNames
  purchasePrice
  status
}
    `;
export const GetOfferMetadataFragmentDoc = gql`
    fragment GetOfferMetadata on GetOfferMetadataObject {
  buyer_name
  buyer_signed
  buyer_signed_date
  close_date
  co_buyer_name
  co_seller_name
  created_at
  due_diligence_end_date
  due_diligence_fee
  due_diligence_period_in_days
  earnest_money_deposit
  financing_type
  has_financing_contingency
  has_home_sale_contingency
  id
  indigo_offer_status
  is_entity_buyer
  is_entity_seller
  listing_agent_email
  listing_agent_name
  metadata
  metadata_s3_key
  mls_listing_id
  organization_id
  participants
  property_city
  property_full_address
  property_state
  property_street_address
  property_tax_id
  property_unit
  property_zip_code
  purchase_price
  seller_concessions
  seller_name
  seller_signed
  seller_signed_date
  selling_agent_email
  selling_agent_name
  team_name
  termination_fee
  transaction_side
  updated_at
}
    `;
export const ListingStatusFragmentDoc = gql`
    fragment ListingStatus on ListingObject {
  status
  deletedFromRetsFeedAt
}
    `;
export const MlsListingPropertyFragmentDoc = gql`
    fragment MLSListingProperty on MLSListingPropertyObject {
  roof
  cooling
  style
  area
  bathsFull
  bathsHalf
  stories
  fireplaces
  flooring
  heating
  bathrooms
  foundation
  poolFeatures
  laundryFeatures
  occupantName
  ownerName
  lotDescription
  acres
  subType
  bedrooms
  interiorFeatures
  lotSize
  areaSource
  maintenanceExpense
  additionalRooms
  exteriorFeatures
  water
  view
  lotSizeArea
  lotSizeAreaUnits
  subdivision
  construction
  type
  garageSpaces
  bathsThreeQuarter
  accessibility
  occupantType
  yearBuilt
  subTypeText
}
    `;
export const MlsListingContactFragmentDoc = gql`
    fragment MLSListingContact on MLSListingContactObject {
  email
  office
  cell
}
    `;
export const MlsListingOfficeFragmentDoc = gql`
    fragment MLSListingOffice on MLSListingOfficeObject {
  brokerid
  name
  servingName
  contact {
    ...MLSListingContact
  }
}
    ${MlsListingContactFragmentDoc}`;
export const MlsListingMlsFragmentDoc = gql`
    fragment MLSListingMLS on MLSListingMLSObject {
  statusText
  status
  daysOnMarket
  originalEntryTimestamp
  originatingSystemName
  logoUrl
  disclaimer
}
    `;
export const MlsListingAssociationFragmentDoc = gql`
    fragment MLSListingAssociation on MLSListingAssociationObject {
  fee
  frequency
  name
  amenities
}
    `;
export const MlsListingComplianceFragmentDoc = gql`
    fragment MLSListingCompliance on MLSListingComplianceObject {
  buyerAgencyCompensation
  buyerAgencyCompensationType
  subAgencyCompensation
  subAgencyCompensationType
  attributionContact
}
    `;
export const MlsListingSalesFragmentDoc = gql`
    fragment MLSListingSales on MLSListingSalesObject {
  closeDate
  closePrice
  contractDate
}
    `;
export const MlsListingGeoFragmentDoc = gql`
    fragment MLSListingGeo on MLSListingGeoObject {
  location {
    lat
    lon
  }
}
    `;
export const MlsListingSearchResultFragmentDoc = gql`
    fragment MLSListingSearchResult on MLSListingObject {
  id
  mlsId
  listingId
  listDate
  listPrice
  originalListPrice
  terms
  photos
  remarks
  modified
  mlsName
  deleted_at
  address {
    ...MLSListingAddress
  }
  addressFull
  property {
    ...MLSListingProperty
  }
  office {
    ...MLSListingOffice
  }
  mls {
    ...MLSListingMLS
  }
  association {
    ...MLSListingAssociation
  }
  compliance {
    ...MLSListingCompliance
  }
  sales {
    ...MLSListingSales
  }
  geo {
    ...MLSListingGeo
  }
}
    ${MlsListingAddressFragmentDoc}
${MlsListingPropertyFragmentDoc}
${MlsListingOfficeFragmentDoc}
${MlsListingMlsFragmentDoc}
${MlsListingAssociationFragmentDoc}
${MlsListingComplianceFragmentDoc}
${MlsListingSalesFragmentDoc}
${MlsListingGeoFragmentDoc}`;
export const MlsListingAgentObjectFragmentDoc = gql`
    fragment MLSListingAgentObject on MLSListingAgentObject {
  id
  mlsId
  firstName
  lastName
  contact {
    ...MLSListingContact
  }
}
    ${MlsListingContactFragmentDoc}`;
export const MlsListingFragmentDoc = gql`
    fragment MLSListing on MLSListingObject {
  ...MLSListingSearchResult
  agent {
    ...MLSListingAgentObject
  }
  coAgent {
    ...MLSListingAgentObject
  }
}
    ${MlsListingSearchResultFragmentDoc}
${MlsListingAgentObjectFragmentDoc}`;
export const PreferenceFragmentDoc = gql`
    fragment Preference on PreferenceObject {
  id
  name
  slug
  usStates
  fieldId
  valueType
}
    `;
export const PreferenceValueFragmentDoc = gql`
    fragment PreferenceValue on PreferenceValueObject {
  preference {
    ...Preference
  }
  numberValue
  textValue
  stringValue
  stringArray
  booleanValue
  dateTimeValue
  readOnly
}
    ${PreferenceFragmentDoc}`;
export const PublicStorefrontConfigurationStatusObjectFragmentDoc = gql`
    fragment PublicStorefrontConfigurationStatusObject on StorefrontConfigurationStatusObject {
  hasSetup
  configuredCount
  progressTotal
  sellerPreferences
  comparables
  documents
}
    `;
export const ListingFragmentDoc = gql`
    fragment Listing on ListingObject {
  id
  isOwner
  property {
    id
    slug
    state
  }
  offersSubmitted {
    id
    status
  }
  listDate
  ...ListingStatus
  offersCountDisplay
  submittedOffersCount
  followerCount
  listingAgent {
    id
    inboundEmail
    user {
      id
      firstName
      lastName
      fullName
      profilePicture {
        fileName
        url
      }
      userName
    }
  }
  coListingAgent {
    id
    inboundEmail
    user {
      id
      firstName
      lastName
      fullName
      phoneNumber
      profilePicture {
        fileName
        url
      }
      email
    }
  }
  mlsListing {
    ...MLSListing
  }
  listingPreferences @include(if: $preferenceValues) {
    ...PreferenceValue
  }
  isPremium
  storefrontSetup {
    listingPackage {
      fileName
      url
    }
    continueStep
  }
  setupDetails {
    ...PublicStorefrontConfigurationStatusObject
  }
}
    ${ListingStatusFragmentDoc}
${MlsListingFragmentDoc}
${PreferenceValueFragmentDoc}
${PublicStorefrontConfigurationStatusObjectFragmentDoc}`;
export const ConsumerFragmentDoc = gql`
    fragment Consumer on ConsumerObject {
  id
  email
  fullName
  phoneNumber
  isEntity
  entityName
  entityTitle
  profilePicture {
    fileName
    url
  }
}
    `;
export const PartyFragmentDoc = gql`
    fragment Party on PartyObject {
  id
  createdAt
  purchaseOffers {
    id
    updatedAt
    listing {
      id
      property {
        id
        slug
        state
      }
      mlsListing {
        ...MLSListing
      }
      isPremium
      listingAgent {
        id
        user {
          id
        }
      }
    }
  }
  primaryConsumer {
    ...Consumer
  }
  secondaryConsumers {
    ...Consumer
  }
  partyFinancing {
    id
    financingType
    loanAmount
    percentDownPayment
    cashReserves
    preapprovalFile {
      fileName
      url
    }
  }
}
    ${MlsListingFragmentDoc}
${ConsumerFragmentDoc}`;
export const IndigoOffersSourceFragmentDoc = gql`
    fragment IndigoOffersSource on IndigoOffersSource {
  type
  metadata {
    confidence
    distanceMiles
    timePeriodMonths
  }
}
    `;
export const CompsSourceFragmentDoc = gql`
    fragment CompsSource on CompsSource {
  type
}
    `;
export const MlsSourceFragmentDoc = gql`
    fragment MLSSource on MLSSource {
  type
}
    `;
export const MarketDataSourceFragmentDoc = gql`
    fragment MarketDataSource on MarketDataSource {
  __typename
  ... on IndigoOffersSource {
    ...IndigoOffersSource
  }
  ... on CompsSource {
    ...CompsSource
  }
  ... on MLSSource {
    ...MLSSource
  }
}
    ${IndigoOffersSourceFragmentDoc}
${CompsSourceFragmentDoc}
${MlsSourceFragmentDoc}`;
export const KeyTermFragmentDoc = gql`
    fragment KeyTerm on KeyTerm {
  label
  type
  unit
  context {
    marketData {
      low
      high
    }
    marketDataPercentages {
      yes
      no
    }
    source {
      ...MarketDataSource
    }
  }
  recommendation
}
    ${MarketDataSourceFragmentDoc}`;
export const KeyTermErrorFragmentDoc = gql`
    fragment KeyTermError on KeyTermError {
  label
  type
  unit
  reason
  sourceType
}
    `;
export const KeyTermResultFragmentDoc = gql`
    fragment KeyTermResult on KeyTermResult {
  __typename
  ... on KeyTerm {
    ...KeyTerm
  }
  ... on KeyTermError {
    ...KeyTermError
  }
}
    ${KeyTermFragmentDoc}
${KeyTermErrorFragmentDoc}`;
export const ContingencyFragmentDoc = gql`
    fragment Contingency on Contingency {
  type
  context {
    marketData {
      yes
      no
    }
    source {
      ...MarketDataSource
    }
  }
  recommendation
}
    ${MarketDataSourceFragmentDoc}`;
export const ContingencyErrorFragmentDoc = gql`
    fragment ContingencyError on ContingencyError {
  type
  reason
}
    `;
export const ContingencyResultFragmentDoc = gql`
    fragment ContingencyResult on ContingencyResult {
  __typename
  ... on Contingency {
    ...Contingency
  }
  ... on ContingencyError {
    ...ContingencyError
  }
}
    ${ContingencyFragmentDoc}
${ContingencyErrorFragmentDoc}`;
export const PriceAnalysisFragmentDoc = gql`
    fragment PriceAnalysis on PriceAnalysis {
  avgCompBidAskRatio
  isPotentiallyOverpriced
  isPotentiallyUnderpriced
  pricePositioning
}
    `;
export const CompetitivenessMetricsFragmentDoc = gql`
    fragment CompetitivenessMetrics on CompetitivenessMetrics {
  bidAsk
  bidAskScore
  daysOnMarket
  daysOnMarketScore
  minMarketBidAskRatio
  maxMarketBidAskRatio
  priceAnalysis {
    ...PriceAnalysis
  }
}
    ${PriceAnalysisFragmentDoc}`;
export const CompetitivenessScoreFragmentDoc = gql`
    fragment CompetitivenessScore on CompetitivenessScore {
  error
  metrics {
    ...CompetitivenessMetrics
  }
  rating
  score
}
    ${CompetitivenessMetricsFragmentDoc}`;
export const OfferRecsFragmentDoc = gql`
    fragment OfferRecs on OfferRecsPayload {
  keyTerms {
    ...KeyTermResult
  }
  contingencies {
    ...ContingencyResult
  }
  competitiveness {
    ...CompetitivenessScore
  }
}
    ${KeyTermResultFragmentDoc}
${ContingencyResultFragmentDoc}
${CompetitivenessScoreFragmentDoc}`;
export const AgentContingencyOfferRecFragmentDoc = gql`
    fragment AgentContingencyOfferRec on AgentContingencyOfferRec {
  value
  notes
  type
}
    `;
export const AgentKeyTermsOfferRecFragmentDoc = gql`
    fragment AgentKeyTermsOfferRec on AgentKeyTermsOfferRec {
  value
  notes
  type
}
    `;
export const CompetitivenessAdjustmentFragmentDoc = gql`
    fragment CompetitivenessAdjustment on CompetitivenessAdjustment {
  adjustedLevel
  reason
}
    `;
export const AgentOfferRecsFragmentDoc = gql`
    fragment AgentOfferRecs on AgentOfferRecsPayload {
  contingencies {
    ...AgentContingencyOfferRec
  }
  keyTerms {
    ...AgentKeyTermsOfferRec
  }
  competitivenessAdjustment {
    ...CompetitivenessAdjustment
  }
}
    ${AgentContingencyOfferRecFragmentDoc}
${AgentKeyTermsOfferRecFragmentDoc}
${CompetitivenessAdjustmentFragmentDoc}`;
export const OfferScoreFragmentDoc = gql`
    fragment OfferScore on OfferScore {
  reason
  value
  offerScoreExplanation
}
    `;
export const OfferScoreResultFragmentDoc = gql`
    fragment OfferScoreResult on OfferScoreResult {
  ... on OfferScore {
    ...OfferScore
  }
  ... on OfferScoreNotCalculated {
    reason
  }
}
    ${OfferScoreFragmentDoc}`;
export const BuyerOfferAnalysisFragmentDoc = gql`
    fragment BuyerOfferAnalysis on BuyerOfferAnalysisObject {
  id
  createdAt
  buyersAgent {
    id
    user {
      ...User
    }
  }
  listing {
    ...Listing
  }
  party {
    ...Party
  }
  indigoOfferRecs {
    ...OfferRecs
  }
  agentOfferRecs {
    ...AgentOfferRecs
  }
  prevAgentOfferRecs {
    ...AgentOfferRecs
  }
  offerScore {
    ...OfferScoreResult
  }
  hideOfferScore
  agentNotes
  title
  isShared
}
    ${UserFragmentDoc}
${ListingFragmentDoc}
${PartyFragmentDoc}
${OfferRecsFragmentDoc}
${AgentOfferRecsFragmentDoc}
${OfferScoreResultFragmentDoc}`;
export const TeamLeadOfferScorecardRowFragmentDoc = gql`
    fragment TeamLeadOfferScorecardRow on BuyerOfferAnalysisObject {
  id
  createdAt
  buyersAgent {
    id
    user {
      ...User
    }
  }
  listing {
    id
    property {
      id
      slug
      state
    }
    mlsListing {
      ...MLSListing
    }
  }
  party {
    id
    primaryConsumer {
      ...Consumer
    }
    secondaryConsumers {
      ...Consumer
    }
  }
  indigoOfferRecs {
    ...OfferRecs
  }
  agentOfferRecs {
    ...AgentOfferRecs
  }
  offerScore {
    ...OfferScoreResult
  }
  agentNotes
  title
  isShared
}
    ${UserFragmentDoc}
${MlsListingFragmentDoc}
${ConsumerFragmentDoc}
${OfferRecsFragmentDoc}
${AgentOfferRecsFragmentDoc}
${OfferScoreResultFragmentDoc}`;
export const InputFormatFragmentDoc = gql`
    fragment InputFormat on InputFormatObject {
  type
  options {
    precision
    formatString
    currencySymbol
  }
}
    `;
export const BoundingBoxFragmentDoc = gql`
    fragment BoundingBox on BoundingBoxObject {
  left
  top
  right
  bottom
}
    `;
export const PublicDocumentVersionFieldFragmentDoc = gql`
    fragment PublicDocumentVersionField on PublicDocumentVersionFieldObject {
  id
  align
  pageNumber
  fontFamily
  fontSize
  label
  inputFormat {
    ...InputFormat
  }
  boundingBox {
    ...BoundingBox
  }
  readOnly
  width
  height
  x
  y
  mappingKey
  fieldType
}
    ${InputFormatFragmentDoc}
${BoundingBoxFragmentDoc}`;
export const ExternalIngestionFolderListRowFragmentDoc = gql`
    fragment ExternalIngestionFolderListRow on IngestionFolderObject {
  id
  organizationUuid
  folderId
  folderName
  transactionSide
  status
  normalizedStatus
  stage
  platform
  folderUpdatedAt
  folderCreatedAt
  metadata
  validationErrorCount
  keyTermColumns
  transactionPipeline @include(if: $includeTransactionPipeline) {
    id
    usState
    transactionPropertyType
  }
}
    `;
export const ResoOfficeFragmentDoc = gql`
    fragment RESOOffice on RESOOfficeObject {
  OfficeName
  OfficeEmail
  OfficeKey
  OfficeMlsId
  OfficeStatus
  OriginatingSystemName
}
    `;
export const GuestbookSignerFragmentDoc = gql`
    fragment GuestbookSigner on GuestbookSignerObject {
  user {
    ...User
  }
  signedAt
  isSubscribed
  openHouseId
  isWorkingWithAgent
  office {
    ...RESOOffice
  }
}
    ${UserFragmentDoc}
${ResoOfficeFragmentDoc}`;
export const IngestionDocumentReviewFragmentDoc = gql`
    fragment IngestionDocumentReview on IngestionDocumentReviewObject {
  id
  createdAt
  updatedAt
  status
  version
  reviewedAt
  reviewedByUserUuid
  reason
  ingestionDocument {
    id
    documentId
    documentName
    version
  }
  submission {
    id
    submittedAt
    submittedByUserUuid
  }
}
    `;
export const DebugLogIdentityFragmentDoc = gql`
    fragment DebugLogIdentity on DebugLogIdentity {
  logId
  logUuid
  organizationUuid
  organizationName
  partnerUuid
  partnerName
  folderId
  templateUuid
  templateTitle
  notificationKind
  stage
  side
  notificationType
}
    `;
export const DebugLogLifecycleFragmentDoc = gql`
    fragment DebugLogLifecycle on DebugLogLifecycle {
  createdAt
  scheduledAt
  pausedAt
  addedToQueueAt
  sentAt
  undeliverableAt
  isDryRun
  displayStatus
  sendWindowResult {
    outsideWindow
    deferrals {
      deferredAt
      deferralMinutes
      deferUntil
    }
  }
}
    `;
export const DebugTemplateSourceFragmentDoc = gql`
    fragment DebugTemplateSource on DebugTemplateSource {
  templateUuid
  title
  eventType
  side
  recipientTypes
  delayMinutes
  dataToShare
  messageContent
  hasAssignedPartner
  isAttachedToPartner
  status
  orderIndex
}
    `;
export const DebugStageIntroSourceFragmentDoc = gql`
    fragment DebugStageIntroSource on DebugStageIntroSource {
  side
  stage
  newRelationshipMessageContent
  existingRelationshipMessageContent
  allowPartnerContactAssignment
}
    `;
export const DebugPartnerConfigFragmentDoc = gql`
    fragment DebugPartnerConfig on DebugPartnerConfig {
  partnerUuid
  partnerName
  isActive
  dryRunNotifications
  contactCount
  adminContactCount
}
    `;
export const DebugRecipientContactFragmentDoc = gql`
    fragment DebugRecipientContact on DebugRecipientContact {
  uuid
  fullName
  email
  phoneNumber
  contactType
}
    `;
export const DebugRawRecipientFragmentDoc = gql`
    fragment DebugRawRecipient on DebugRawRecipient {
  id
  fullName
  email
  phoneNumber
  contactType
}
    `;
export const DebugRecipientResolutionFragmentDoc = gql`
    fragment DebugRecipientResolution on DebugRecipientResolution {
  requestedRecipientTypes
  resolvedContacts {
    ...DebugRecipientContact
  }
  resolvedRawRecipients {
    ...DebugRawRecipient
  }
  agentContactUuid
  rosterUsed
  isPaused
  isFirstAssignment
  pauseReason
}
    ${DebugRecipientContactFragmentDoc}
${DebugRawRecipientFragmentDoc}`;
export const DebugRoutingDecisionFragmentDoc = gql`
    fragment DebugRoutingDecision on DebugRoutingDecision {
  key
  outcome
  reason
}
    `;
export const DebugRoutingDecisionsFragmentDoc = gql`
    fragment DebugRoutingDecisions on DebugRoutingDecisions {
  decisions {
    ...DebugRoutingDecision
  }
}
    ${DebugRoutingDecisionFragmentDoc}`;
export const DebugAutofillRenderingFragmentDoc = gql`
    fragment DebugAutofillRendering on DebugAutofillRendering {
  computedAutofillValues
  renderedTitle
  renderedBody
  templateVariables
}
    `;
export const DebugDeliveryFragmentDoc = gql`
    fragment DebugDelivery on DebugDelivery {
  workflowId
  preSanitizationRecipients {
    ...DebugRawRecipient
  }
  postSanitizationRecipients {
    ...DebugRawRecipient
  }
  isDryRunSkipped
  isNoRecipientSkipped
}
    ${DebugRawRecipientFragmentDoc}`;
export const InternalEssentialsNotificationLogDebugFragmentDoc = gql`
    fragment InternalEssentialsNotificationLogDebug on InternalEssentialsNotificationLogDebugObject {
  identity {
    ...DebugLogIdentity
  }
  lifecycle {
    ...DebugLogLifecycle
  }
  templateSource {
    ...DebugTemplateSource
  }
  stageIntroSource {
    ...DebugStageIntroSource
  }
  partnerConfig {
    ...DebugPartnerConfig
  }
  recipientResolution {
    ...DebugRecipientResolution
  }
  routingDecisions {
    ...DebugRoutingDecisions
  }
  autofillRendering {
    ...DebugAutofillRendering
  }
  delivery {
    ...DebugDelivery
  }
  rawLog
  normalizedFieldValues
}
    ${DebugLogIdentityFragmentDoc}
${DebugLogLifecycleFragmentDoc}
${DebugTemplateSourceFragmentDoc}
${DebugStageIntroSourceFragmentDoc}
${DebugPartnerConfigFragmentDoc}
${DebugRecipientResolutionFragmentDoc}
${DebugRoutingDecisionsFragmentDoc}
${DebugAutofillRenderingFragmentDoc}
${DebugDeliveryFragmentDoc}`;
export const SimulationCandidateResultFragmentDoc = gql`
    fragment SimulationCandidateResult on SimulationCandidateResult {
  outcome
  reason
  templateSource {
    ...DebugTemplateSource
  }
  stageIntroSource {
    ...DebugStageIntroSource
  }
  recipientResolution {
    ...DebugRecipientResolution
  }
  routingDecisions {
    ...DebugRoutingDecisions
  }
  autofillRendering {
    ...DebugAutofillRendering
  }
}
    ${DebugTemplateSourceFragmentDoc}
${DebugStageIntroSourceFragmentDoc}
${DebugRecipientResolutionFragmentDoc}
${DebugRoutingDecisionsFragmentDoc}
${DebugAutofillRenderingFragmentDoc}`;
export const InternalEssentialsNotificationLogItemFragmentDoc = gql`
    fragment InternalEssentialsNotificationLogItem on InternalEssentialsNotificationLogItem {
  id
  logId
  logUuid
  title
  notificationKind
  displayStatus
  partnerName
  notificationType
  createdAt
  sentAt
  isDryRun
}
    `;
export const InvitationFragmentDoc = gql`
    fragment Invitation on InvitationObject {
  id
  acceptedAt
  revokedAt
  expiresAt
  notificationMeta
  invitee {
    ...User
  }
  inviter {
    ...User
  }
}
    ${UserFragmentDoc}`;
export const ListingAnnouncementFragmentDoc = gql`
    fragment ListingAnnouncement on ListingAnnouncementObject {
  id
  message
  type
  bestAndFinalDate
  createdAt
}
    `;
export const ListingComparableAdjustmentsFragmentDoc = gql`
    fragment ListingComparableAdjustments on ListingComparableAdjustmentsObject {
  id
  priceAdjustmentsPerFields
  totalAdjustmentPrice
  notes
}
    `;
export const ListingComparableFragmentDoc = gql`
    fragment ListingComparable on ListingComparableObject {
  id
  mlsListing {
    ...MLSListing
  }
  source
  order
  adjustments {
    ...ListingComparableAdjustments
  }
}
    ${MlsListingFragmentDoc}
${ListingComparableAdjustmentsFragmentDoc}`;
export const ListingComparableSetFragmentDoc = gql`
    fragment ListingComparableSet on ListingComparableSetObject {
  id
  listingComparables {
    ...ListingComparable
  }
  agent {
    id
  }
  listing {
    id
  }
  propertyDetails {
    id
  }
  buyerOfferAnalysis {
    id
  }
  agentNotes
}
    ${ListingComparableFragmentDoc}`;
export const ListingDocumentTypeFragmentDoc = gql`
    fragment ListingDocumentType on ListingDocumentTypeObject {
  id
  slug
  usState
  name
  formName
  type
}
    `;
export const ListingDocumentUploadFragmentDoc = gql`
    fragment ListingDocumentUpload on ListingDocumentUploadObject {
  id
  file {
    fileName
    url
  }
  listingDocumentType {
    ...ListingDocumentType
  }
  customDocumentType
  customDocumentName
}
    ${ListingDocumentTypeFragmentDoc}`;
export const ListingDocumentTypeWithDocumentsFragmentDoc = gql`
    fragment ListingDocumentTypeWithDocuments on ListingDocumentTypeObject {
  id
  document {
    id
    form
    name
    description
    activeDocumentVersion {
      id
      mappingKeys
      previewImages: hiddenPreviewImages {
        id
        ordering
        file {
          url
        }
      }
    }
  }
}
    `;
export const ListingFollowerFragmentDoc = gql`
    fragment ListingFollower on ListingFollowerObject {
  user {
    ...User
  }
  followedAt
}
    ${UserFragmentDoc}`;
export const ReportConfidenceFragmentDoc = gql`
    fragment ReportConfidence on ReportConfidence {
  confidence
  maxDistanceMiles
  maxTimePeriodMonths
  maxClosePrice
  minClosePrice
  zipCode
  subType
  subTypes
}
    `;
export const ChartCardFragmentDoc = gql`
    fragment ChartCard on ChartCard {
  chart {
    ...ChartData
  }
  title
}
    ${ChartDataFragmentDoc}`;
export const TableColumnFragmentDoc = gql`
    fragment TableColumn on TableColumn {
  title
  summary
  key
  isHighlighted
}
    `;
export const OffersByFinancingTypeTableRowFragmentDoc = gql`
    fragment OffersByFinancingTypeTableRow on OffersByFinancingTypeTableRow {
  allTypes {
    value
    subValue
  }
  cash {
    value
    subValue
  }
  conventional {
    value
    subValue
  }
  fhaVaUsda {
    value
    subValue
  }
  other {
    value
    subValue
  }
}
    `;
export const TableRowFragmentDoc = gql`
    fragment TableRow on TableRow {
  title
  data {
    ...OffersByFinancingTypeTableRow
  }
}
    ${OffersByFinancingTypeTableRowFragmentDoc}`;
export const TableDataFragmentDoc = gql`
    fragment TableData on TableData {
  title
  columns {
    ...TableColumn
  }
  rows {
    ...TableRow
  }
}
    ${TableColumnFragmentDoc}
${TableRowFragmentDoc}`;
export const ListingReportResponseFragmentDoc = gql`
    fragment ListingReportResponse on ListingReportResponse {
  confidence {
    ...ReportConfidence
  }
  charts {
    ...ChartCard
  }
  tables {
    ...TableData
  }
}
    ${ReportConfidenceFragmentDoc}
${ChartCardFragmentDoc}
${TableDataFragmentDoc}`;
export const NotificationTemplateDetailsFragmentDoc = gql`
    fragment NotificationTemplateDetails on NotificationTemplateObject {
  id
  title
  eventType
  side
  notificationType
  recipients
  hasAssignedPartner
  isAttachedToPartner
  delayMinutes
  dataToShare
  messageContent
  messageContentTemplates {
    html
    text
  }
  status
  orderIndex
}
    `;
export const NotificationTemplateListItemFragmentDoc = gql`
    fragment NotificationTemplateListItem on NotificationTemplateObject {
  id
  title
  eventType
  side
  notificationType
  recipients
  status
  messageContent
  messageContentTemplates {
    html
    text
  }
  delayMinutes
  orderIndex
  partner {
    id
    name
    isActive
    logo {
      url
    }
  }
}
    `;
export const OrganizationPartnerItemFragmentDoc = gql`
    fragment OrganizationPartnerItem on OrganizationPartnerObject {
  id
  name
  partnerType
  isActive
  dryRunNotifications
  adminContacts {
    id
    firstName
    lastName
    email
    phoneNumber
    contactType
  }
  existingRelationshipIntroMessage
  newRelationshipIntroMessage
  hasDrafts
  logo {
    url
  }
  contacts {
    id
    firstName
    lastName
  }
  createdAt
  updatedAt
}
    `;
export const OrganizationPartnerStageIntroItemFragmentDoc = gql`
    fragment OrganizationPartnerStageIntroItem on OrganizationPartnerStageIntroObject {
  id
  side
  stage
  newRelationshipMessageContent
  existingRelationshipMessageContent
  allowPartnerContactAssignment
}
    `;
export const OrganizationRosterItemFragmentDoc = gql`
    fragment OrganizationRosterItem on OrganizationRosterObject {
  id
  isContactable
  createdAt
  contact {
    id
    firstName
    lastName
    email
    phoneNumber
    contactType
  }
  preferences {
    id
    partnerType
    preferenceType
    partner {
      id
      name
    }
    partnerContact {
      id
      firstName
      lastName
      partner {
        id
        name
      }
    }
  }
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfoObject {
  totalCount
  hasNextPage
  hasPrevPage
  nextCursor
  prevCursor
}
    `;
export const PartnerContactBaseFragmentDoc = gql`
    fragment PartnerContactBase on PartnerContactBaseObject {
  id
  firstName
  lastName
  contactType
  email
  phoneNumber
  createdAt
  updatedAt
}
    `;
export const PartnerContactFragmentDoc = gql`
    fragment PartnerContact on OrganizationPartnerContactUnion {
  ... on LoanOfficerContactObject {
    ...PartnerContactBase
    loanOfficerConfig {
      preApprovalAppUrl
      calendarSchedulingUrl
    }
  }
  ... on TitleAgentContactObject {
    ...PartnerContactBase
  }
  ... on InsuranceAgentContactObject {
    ...PartnerContactBase
  }
}
    ${PartnerContactBaseFragmentDoc}`;
export const PropertyFragmentDoc = gql`
    fragment Property on PropertyObject {
  id
  streetAddress
  unit
  city
  state
  zipCode
  zipCodePlus4
  county
  lot
  block
  platBook
  platBookPage
  subdivision
  parcelId
  yearBuilt
  assessorParcelNumber
  otherLegalDescription
}
    `;
export const GetPropertyDetailsSuccessFragmentDoc = gql`
    fragment GetPropertyDetailsSuccess on GetPropertyDetailsSuccess {
  areaSqFt
  yearBuilt
  bedrooms
  bathsFull
  bathsHalf
  propertyType
  propertySubtype
  subdivision
  schoolDistrict
}
    `;
export const GetPropertyDetailsFailedFragmentDoc = gql`
    fragment GetPropertyDetailsFailed on GetPropertyDetailsFailed {
  error
}
    `;
export const GetPropertyDetailsResultFragmentDoc = gql`
    fragment GetPropertyDetailsResult on GetPropertyDetailsResult {
  ... on GetPropertyDetailsSuccess {
    ...GetPropertyDetailsSuccess
  }
  ... on GetPropertyDetailsFailed {
    ...GetPropertyDetailsFailed
  }
}
    ${GetPropertyDetailsSuccessFragmentDoc}
${GetPropertyDetailsFailedFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on AddressObject {
  streetAddress
  city
  state
  zipCode
  unit
}
    `;
export const GeoFragmentDoc = gql`
    fragment Geo on GeoObject {
  lat
  lng
}
    `;
export const LocationFragmentDoc = gql`
    fragment Location on Location {
  address {
    ...Address
  }
  coords {
    ...Geo
  }
}
    ${AddressFragmentDoc}
${GeoFragmentDoc}`;
export const PropertyDetailsFragmentDoc = gql`
    fragment PropertyDetails on PropertyDetailsObject {
  id
  streetAddress
  city
  state
  zipCode
  unit
  geo {
    ...Geo
  }
  targetPrice
  areaSqFt
  yearBuilt
  bedrooms
  bathsFull
  bathsHalf
  propertyType
  propertySubtype
  subdivision
  schoolDistrict
}
    ${GeoFragmentDoc}`;
export const ShareLinkFragmentDoc = gql`
    fragment ShareLink on ShareLinkObject {
  id
  token
  expiresAt
  accessType
  status
  recipientEmail
  recipientPhoneNumber
  isForPdf
}
    `;
export const StorefrontActivitySummaryFragmentDoc = gql`
    fragment StorefrontActivitySummary on StorefrontActivitySummaryObject {
  count
  activityType
  users {
    ...User
  }
  activities {
    id
    type
    createdAt
    user {
      id
    }
  }
}
    ${UserFragmentDoc}`;
export const NotificationTemplateFragmentDoc = gql`
    fragment NotificationTemplate on NotificationTemplateObject {
  id
  title
  eventType
  side
  notificationType
  recipients
  hasAssignedPartner
  delayMinutes
  dataToShare
  messageContent
  messageContentTemplates {
    html
    text
  }
  status
  orderIndex
  createdAt
  updatedAt
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on ContactObject {
  id
  firstName
  lastName
  contactType
  email
  phoneNumber
}
    `;
export const TransactionNotificationLogFragmentDoc = gql`
    fragment TransactionNotificationLog on TransactionNotificationLogObject {
  id
  title
  messageContent
  scheduledAt
  sentAt
  createdAt
  notificationTemplate {
    ...NotificationTemplate
  }
  recipients {
    ...Contact
  }
  rawRecipients {
    id
    fullName
    email
    phoneNumber
    contactType
  }
}
    ${NotificationTemplateFragmentDoc}
${ContactFragmentDoc}`;
export const ValidationReviewSubmissionFragmentDoc = gql`
    fragment ValidationReviewSubmission on ValidationReviewSubmissionObject {
  id
  submittedAt
  submittedByUserUuid
  totalErrorCount
  hiddenErrorCount
  documentErrorCount
  folderErrorCount
  createdAt
  updatedAt
}
    `;
export const OpenHouseCardFragmentDoc = gql`
    fragment OpenHouseCard on OpenHouseObject {
  id
  date
  startTime
  endTime
  numGuestbookSigners
  source
}
    `;
export const ComplianceDashboardBannerFragmentDoc = gql`
    fragment ComplianceDashboardBanner on OrganizationComplianceDashboardBannerObject {
  hoursSaved
  assumptionLabel
}
    `;
export const ComplianceDashboardFiltersFragmentDoc = gql`
    fragment ComplianceDashboardFilters on OrganizationComplianceDashboardFiltersObject {
  selectedOffice
  selectedOffices
  selectedState
  officeOptions {
    label
    value
  }
  officeSections {
    label
    officeValues
    value
  }
  stateOptions {
    label
    value
  }
  rangePresets {
    label
    value
  }
}
    `;
export const ComplianceDashboardSummaryFragmentDoc = gql`
    fragment ComplianceDashboardSummary on OrganizationComplianceDashboardSummaryObject {
  startDate
  endDate
  lastUpdatedAt
}
    `;
export const ComplianceDashboardSectionLayoutFragmentDoc = gql`
    fragment ComplianceDashboardSectionLayout on OrganizationComplianceDashboardSectionLayoutObject {
  id
  title
  selectedBreakdown
  breakdownOptions {
    label
    value
  }
  cardKeys
}
    `;
export const ComplianceDashboardMetricCardFragmentDoc = gql`
    fragment ComplianceDashboardMetricCard on ComplianceDashboardMetricCardObject {
  id
  title
  description
  metricLabel
  metricValue
  metricDetail
  accentText
  chart {
    series {
      key
      label
      color
    }
    points {
      label
      segments {
        seriesKey
        value
      }
    }
  }
}
    `;
export const ComplianceDashboardInsightsFragmentDoc = gql`
    fragment ComplianceDashboardInsights on OrganizationComplianceDashboardInsightsObject {
  panels {
    id
    dataCoverageStartDate
    description
    lastUpdatedAt
    title
    tabs {
      label
      value
    }
    rows {
      title
      count
      detail
      kind
      status
    }
  }
}
    `;
export const ComplianceDashboardLeaderboardRowFragmentDoc = gql`
    fragment ComplianceDashboardLeaderboardRow on OrganizationComplianceDashboardLeaderboardRowObject {
  agentName
  avatarInitials
  transactionsReviewed
  issueFreeRate
}
    `;
export const ComplianceDashboardTransactionRowFragmentDoc = gql`
    fragment ComplianceDashboardTransactionRow on OrganizationComplianceDashboardTransactionRowObject {
  ingestionFolderId
  folderId
  title
  location
  imageUrl
  fallbackInitial
  platform
  transactionSideLabel
  transactionTypeLabel
  stageLabel
  autoApprovedCount
  autoApprovedLabel
  lastAutoApprovedAt
  issueCount
  noCheckCount
}
    `;
export const PublicListingStatusFragmentDoc = gql`
    fragment PublicListingStatus on PublicListingObject {
  status
  deletedFromRetsFeedAt
}
    `;
export const PublicOpenHouseFragmentDoc = gql`
    fragment PublicOpenHouse on PublicOpenHouseObject {
  id
  date
  startTime
  endTime
}
    `;
export const PublicPreferenceFragmentDoc = gql`
    fragment PublicPreference on PublicPreferenceObject {
  id
  name
  slug
  usStates
  valueType
}
    `;
export const PublicPreferenceValueFragmentDoc = gql`
    fragment PublicPreferenceValue on PublicPreferenceValueObject {
  preference {
    ...PublicPreference
  }
  numberValue
  textValue
  stringValue
  stringArray
  booleanValue
  dateTimeValue
  readOnly
}
    ${PublicPreferenceFragmentDoc}`;
export const PublicListingPriceHistoryFragmentDoc = gql`
    fragment PublicListingPriceHistory on ListingPriceHistoryObject {
  listDate
  mlsStatus
  listPrice
  closePrice
  closeDate
  modified
}
    `;
export const PublicListingFragmentDoc = gql`
    fragment PublicListing on PublicListingObject {
  id
  property {
    id
    slug
    state
    otherLegalDescription
    county
  }
  ...PublicListingStatus
  offersCountDisplay
  listDate
  followerCount
  guestbookSignersCount
  currentAndUpcomingOpenHouses {
    ...PublicOpenHouse
  }
  listingAgent {
    id
    inboundEmail
    user {
      id
      firstName
      lastName
      fullName
      phoneNumber
      profilePicture {
        fileName
        url
      }
      email
      userName
    }
  }
  coListingAgent {
    id
    inboundEmail
    user {
      id
      firstName
      lastName
      fullName
      phoneNumber
      profilePicture {
        fileName
        url
      }
      email
    }
  }
  mlsListing {
    ...MLSListing
  }
  listingPreferences {
    ...PublicPreferenceValue
  }
  priceHistories {
    ...PublicListingPriceHistory
  }
  isPremium
  setupDetails {
    ...PublicStorefrontConfigurationStatusObject
  }
}
    ${PublicListingStatusFragmentDoc}
${PublicOpenHouseFragmentDoc}
${MlsListingFragmentDoc}
${PublicPreferenceValueFragmentDoc}
${PublicListingPriceHistoryFragmentDoc}
${PublicStorefrontConfigurationStatusObjectFragmentDoc}`;
export const PublicListingAnnouncementFragmentDoc = gql`
    fragment PublicListingAnnouncement on PublicListingAnnouncementObject {
  id
  message
  createdAt
}
    `;
export const PublicListingComparableFragmentDoc = gql`
    fragment PublicListingComparable on PublicListingComparableObject {
  id
  source
  mlsListing {
    ...MLSListing
  }
  order
}
    ${MlsListingFragmentDoc}`;
export const PublicListingComparableSetFragmentDoc = gql`
    fragment PublicListingComparableSet on PublicListingComparableSetObject {
  listingComparables {
    ...PublicListingComparable
  }
  agent {
    id
  }
  listing {
    id
  }
  agentNotes
}
    ${PublicListingComparableFragmentDoc}`;
export const PublicListingDocumentTypeFragmentDoc = gql`
    fragment PublicListingDocumentType on PublicListingDocumentTypeObject {
  id
  slug
  usState
  name
  formName
  type
}
    `;
export const PublicListingDocumentUploadFragmentDoc = gql`
    fragment PublicListingDocumentUpload on PublicListingDocumentUploadObject {
  id
  listingDocumentType {
    ...PublicListingDocumentType
  }
  file {
    fileName
    url
  }
  customDocumentName
  customDocumentType
}
    ${PublicListingDocumentTypeFragmentDoc}`;
export const PublicListingDocumentTypeWithDocumentsFragmentDoc = gql`
    fragment PublicListingDocumentTypeWithDocuments on PublicListingDocumentTypeObject {
  id
  document {
    id
    form
    name
    description
    activeDocumentVersion {
      id
      mappingKeys
      previewImages: hiddenPreviewImages {
        id
        ordering
        file {
          url
        }
      }
    }
  }
}
    `;
export const PublicUserListingFragmentDoc = gql`
    fragment PublicUserListing on PublicListingObject {
  id
  ...PublicListingStatus
  listDate
  offersCountDisplay
  property {
    id
    slug
  }
  isPremium
  mlsListing {
    ...MLSListing
  }
}
    ${PublicListingStatusFragmentDoc}
${MlsListingFragmentDoc}`;
export const PublicUserWithLicensesFragmentDoc = gql`
    fragment PublicUserWithLicenses on PublicUserWithLicensesObject {
  id
  firstName
  lastName
  fullName
  phoneNumber
  email
  profileBio
  profilePicture {
    fileName
    url
  }
  hasListings
  licenses {
    id
    licenseType
    licenseNumber
    mls {
      id
      name
      originatingSystemName
    }
  }
}
    `;
export const ActiveIntegrationClientFragmentDoc = gql`
    fragment ActiveIntegrationClient on IntegrationClientObject {
  id
  provider
  clientType
  isActive
  logoFile {
    url
  }
}
    `;
export const MlsObjectForAllMlSesFragmentDoc = gql`
    fragment MLSObjectForAllMLSes on MLSObject {
  id
  name
  originatingSystemName
}
    `;
export const AuditEssentialsNotificationFragmentDoc = gql`
    fragment AuditEssentialsNotification on AuditEssentialsNotificationsObject {
  auditSnapshot
  eventType
  notificationLogUuid
  notificationTemplateUuid
  occurredAt
  organizationPartnerUuid
  organizationUuid
  ingestionFolderUuid
  pausedNotificationLogUuids
  stage
  twilioConversationSid
  aiConversationUuid
}
    `;
export const AutofillConsumerFragmentDoc = gql`
    fragment AutofillConsumer on AutofillConsumerObject {
  email
  name
  phoneNumber
  isEntity
  entityName
  entityTitle
  id
}
    `;
export const CurrentUserFragmentDoc = gql`
    fragment CurrentUser on UserObject {
  id
  firstName
  lastName
  fullName
  userName
  email
  phoneNumber
  roles
  hasListings
  profilePicture {
    fileName
    url
  }
  profileBio
  offerCollectionEmail
  settings {
    ...UserSettings
  }
  licenses {
    id
    licenseNumber
    licenseType
    states
    mls {
      id
      shortName
      name
      originatingSystemName
      states
      supportedFeatures
      agentSignUpEnabled
    }
  }
  tours {
    id
    tourName
  }
}
    ${UserSettingsFragmentDoc}`;
export const ResoMemberFragmentDoc = gql`
    fragment RESOMember on RESOMemberObject {
  MemberFirstName
  MemberLastName
  MemberFullName
  MemberMiddleName
  MemberEmail
  MemberDirectPhone
  MemberMobilePhone
  MemberMlsId
  MemberNationalAssociationId
  OfficeMlsId
  MemberStatus
  OriginatingSystemName
  Media {
    MediaKey
    MediaURL
    ImageWidth
    ImageHeight
    ImageSizeDescription
    MediaModificationTimestamp
  }
}
    `;
export const FindMlsAgentFragmentDoc = gql`
    fragment FindMLSAgent on FindMLSAgentPayload {
  mlsAgent {
    ...RESOMember
  }
  mls {
    id
    name
    memberIdPrefix
    originatingSystemName
  }
  office {
    ...RESOOffice
  }
}
    ${ResoMemberFragmentDoc}
${ResoOfficeFragmentDoc}`;
export const ListingPricingEvaluationFragmentDoc = gql`
    fragment ListingPricingEvaluation on ListingPricingEvaluationObject {
  analysis
  adjustedComps {
    address
    closePrice
    adjustmentReason
    finalAdjustedPrice
  }
}
    `;
export const IndigoContractsForCurrentUserFragmentDoc = gql`
    fragment IndigoContractsForCurrentUser on IndigoContractObject {
  id
  createdAt
  contract {
    id
    autofillValues @include(if: $includeFieldValues)
    contractDocuments @include(if: $includeContractDocuments) {
      id
      order
      documentVersion {
        id
        document {
          id
        }
      }
    }
    fieldValues @include(if: $includeFieldValues)
    signatureRequests {
      id
      events {
        id
        createdAt
        eventType
      }
      allSignedDocument {
        fileName
        url
      }
    }
  }
  party {
    id
    createdAt
    buyersAgent {
      user {
        ...User
      }
    }
    primaryConsumer {
      ...Consumer
    }
    secondaryConsumers {
      ...Consumer
    }
  }
}
    ${UserFragmentDoc}
${ConsumerFragmentDoc}`;
export const ContractValidationFragmentDoc = gql`
    fragment ContractValidation on ContractValidationObject {
  field {
    id
    mappingKey
    fieldType
    label
    displayLabel
    group
    inputFormat {
      type
      options {
        precision
        formatString
        currencySymbol
      }
    }
  }
  documentVersionField {
    id
    mappingKey
    fieldType
    label
    displayLabel
    inputFormat {
      type
      options {
        precision
        formatString
        currencySymbol
      }
    }
  }
  results {
    inputValue
    message
    validationValue
    rule {
      id
      ruleType
    }
  }
}
    `;
export const DocumentVersionFieldFragmentDoc = gql`
    fragment DocumentVersionField on DocumentVersionFieldObject {
  id
  align
  pageNumber
  fontFamily
  fontSize
  label
  inputFormat {
    ...InputFormat
  }
  boundingBox {
    ...BoundingBox
  }
  readOnly
  width
  height
  x
  y
  mappingKey
  fieldType
  labelBoundingBox {
    ...BoundingBox
  }
  labelField {
    height
    width
    x
    y
  }
}
    ${InputFormatFragmentDoc}
${BoundingBoxFragmentDoc}`;
export const ContractDocumentFragmentDoc = gql`
    fragment ContractDocument on ContractDocumentObject {
  id
  order
  documentVersion {
    id
    document {
      id
      name
      form
      documentType
    }
    mappingKeys
    version
  }
  file {
    fileName
    url
  }
  fields {
    ...DocumentVersionField
  }
  externalDocumentType
  externalDocumentName
}
    ${DocumentVersionFieldFragmentDoc}`;
export const OfferContractFragmentDoc = gql`
    fragment OfferContract on ContractObject {
  id
  fieldValues
  validations {
    ...ContractValidation
  }
  contractDocuments {
    ...ContractDocument
  }
  enabledSecondaryDocumentVersionsFromRules
  signatureRequests {
    id
    provider
    externalId
    allSignedDocument {
      fileName
      url
    }
  }
}
    ${ContractValidationFragmentDoc}
${ContractDocumentFragmentDoc}`;
export const OfferFragmentDoc = gql`
    fragment Offer on OfferObject {
  id
  status
  source
  isUploaded
  submittedAt
  noteToListingAgent
  primaryBuyer {
    ...Consumer
  }
  secondaryBuyers {
    ...Consumer
  }
  file {
    fileName
    url
  }
  events {
    id
    name
    createdAt
  }
  buyersAgent {
    id
    fullName
    user {
      ...User
    }
  }
  party {
    id
  }
}
    ${ConsumerFragmentDoc}
${UserFragmentDoc}`;
export const OffersForListingFragmentDoc = gql`
    fragment OffersForListing on OfferObject {
  ...Offer
  contract {
    id
    fieldValues
    contractDocuments {
      id
      documentVersion {
        id
        document {
          id
          documentType
        }
      }
      file {
        fileName
        url
      }
    }
    validations {
      ...ContractValidation
    }
    signatureRequests {
      id
      provider
      externalId
      allSignedDocument {
        fileName
        url
      }
    }
  }
}
    ${OfferFragmentDoc}
${ContractValidationFragmentDoc}`;
export const ListingForOrganizationFragmentDoc = gql`
    fragment ListingForOrganization on ListingObject {
  id
  ...ListingStatus
  offersCountDisplay
  guestbookSignersCount
  submittedOffersCount
  listDate
  property {
    id
    slug
    state
    geo {
      lat
      lng
    }
  }
  currentAndUpcomingOpenHouses {
    id
    date
    startTime
    endTime
  }
  listingAgent {
    id
    user {
      ...User
    }
  }
  coListingAgent {
    id
    user {
      ...User
    }
  }
  mlsListing {
    ...MLSListing
  }
  isPremium
  organizations {
    id
  }
  setupDetails {
    configuredCount
    documents
    progressTotal
    sellerPreferences
    comparables
  }
  isSharedListing
}
    ${ListingStatusFragmentDoc}
${UserFragmentDoc}
${MlsListingFragmentDoc}`;
export const OffersForCurrentUserFragmentDoc = gql`
    fragment OffersForCurrentUser on OfferObject {
  id
  updatedAt
  status
  buyersAgent {
    id
    user {
      ...User
    }
  }
  party {
    id
  }
  primaryBuyer {
    id
    ...Consumer
  }
  secondaryBuyers {
    id
    ...Consumer
  }
  listing {
    id
    listingAgent {
      id
      user {
        id
      }
    }
    mlsListing {
      id
      photos
      address {
        ...MLSListingAddress
      }
    }
  }
}
    ${UserFragmentDoc}
${ConsumerFragmentDoc}
${MlsListingAddressFragmentDoc}`;
export const OpenHouseForCurrentUserFragmentDoc = gql`
    fragment OpenHouseForCurrentUser on OpenHouseObject {
  id
  date
  startTime
  endTime
  listing {
    id
    followerCount
    mlsListing {
      ...MLSListing
    }
  }
}
    ${MlsListingFragmentDoc}`;
export const OrganizationCrawlerInfoFragmentDoc = gql`
    fragment OrganizationCrawlerInfo on OrganizationObject {
  id
  contractSystemCredentials {
    id
    isHourly
    isLive
  }
}
    `;
export const OrganizationFragmentDoc = gql`
    fragment Organization on OrganizationObject {
  id
  name
  contractSystemCredentials {
    id
    isReady
    type
    hasInvalidCredentials
    username
    dotloopProfileId
    dotloopTeamName
  }
  mainMLS {
    id
    name
    originatingSystemName
  }
  hasDescendants
}
    `;
export const PerAgentOfferAcceptRateFragmentDoc = gql`
    fragment PerAgentOfferAcceptRate on PerAgentOfferAcceptRateObject {
  name
  accepted_offers
  offer_accept_rate
  submitted_offers
  total_offers
  average_bid_ask
  average_dd_days
  average_ddf_ratio
  average_termination_fee_ratio
  average_offer_to_close_days
  average_purchase_price
  closed_volume
  pending_volume
  total_volume
}
    `;
export const PerAgentTransactionStatsFragmentDoc = gql`
    fragment PerAgentTransactionStats on PerAgentTransactionStatsObject {
  name
  buy_side_homes_count
  sell_side_homes_count
  closed_homes_count
  pending_homes_count
  total_homes_count
  unknown_homes_count
  terminated_homes_count
  buy_side_volume
  closed_volume
  pending_volume
  sell_side_volume
  total_volume
}
    `;
export const PerOfficeOfferAcceptRateFragmentDoc = gql`
    fragment PerOfficeOfferAcceptRate on PerOfficeOfferAcceptRateObject {
  name
  accepted_offers
  offer_accept_rate
  submitted_offers
  total_offers
  average_bid_ask
  average_dd_days
  average_ddf_ratio
  average_termination_fee_ratio
  average_offer_to_close_days
  average_purchase_price
  closed_volume
  pending_volume
  total_volume
}
    `;
export const PerOfficeTransactionStatsFragmentDoc = gql`
    fragment PerOfficeTransactionStats on PerOfficeTransactionStatsObject {
  name
  buy_side_homes_count
  sell_side_homes_count
  closed_homes_count
  pending_homes_count
  total_homes_count
  unknown_homes_count
  terminated_homes_count
  buy_side_volume
  closed_volume
  pending_volume
  sell_side_volume
  total_volume
}
    `;
export const PrioritizedListingFragmentDoc = gql`
    fragment PrioritizedListing on ListingObject {
  lastActivityDate
  ...Listing
  currentAndUpcomingOpenHouses {
    ...PublicOpenHouse
  }
}
    ${ListingFragmentDoc}
${PublicOpenHouseFragmentDoc}`;
export const PublicFeaturedStorefrontFragmentDoc = gql`
    fragment PublicFeaturedStorefront on PublicListingObject {
  id
  property {
    id
    slug
    state
    otherLegalDescription
    county
  }
  ...PublicListingStatus
  offersCountDisplay
  listDate
  followerCount
  guestbookSignersCount
  listingAgent {
    id
    user {
      id
      firstName
      lastName
    }
  }
  mlsListing {
    ...MLSListing
  }
  isPremium
}
    ${PublicListingStatusFragmentDoc}
${MlsListingFragmentDoc}`;
export const ListingForSearchMlsListingFragmentDoc = gql`
    fragment ListingForSearchMlsListing on PublicListingObject {
  id
  ...PublicListingStatus
  offersCountDisplay
  listDate
  property {
    id
    slug
  }
  listingAgent {
    user {
      id
    }
  }
  coListingAgent {
    user {
      id
    }
  }
  isPremium
}
    ${PublicListingStatusFragmentDoc}`;
export const IngestionDocumentValidationFragmentDoc = gql`
    fragment IngestionDocumentValidation on IngestionDocumentValidationObject {
  id
  isCurrent
  version
  errorCount
  warningCount
  aiErrorCount
  aiWarningCount
  validationSummary {
    errorCount
    warningCount
    aiErrorCount
    aiWarningCount
  }
  transactionStage {
    id
    stage
  }
  validationResults
  aiValidationResults
  aiAnalysis
  resolvedIssues {
    message
    resolvedFormNames
    ruleUuid
    targetDocumentCategory
  }
  createdAt
  updatedAt
  ingestionDocument {
    id
  }
}
    `;
export const IngestionFolderValidationFragmentDoc = gql`
    fragment IngestionFolderValidation on IngestionFolderValidationObject {
  id
  isCurrent
  version
  errorCount
  validationResults
  createdAt
  validatedAt
  updatedAt
  ingestionFolder {
    id
  }
}
    `;
export const IngestionFolderPropertyFragmentDoc = gql`
    fragment IngestionFolderProperty on DocumentPropertyObject {
  id
  slug
  streetAddress
  unit
  city
  state
  zipCode
  zipCodePlus4
  county
  countyFips
  msa
  lot
  block
  platBook
  platBookPage
  subdivision
  parcelId
  yearBuilt
  otherLegalDescription
  geo {
    lat
    lng
  }
}
    `;
export const IngestionFolderAutofillDataFragmentDoc = gql`
    fragment IngestionFolderAutofillData on OfferIngestionAutofillObject {
  ingestion {
    transactionSide
    metadata {
      agent_name
      folder_name
      participants {
        buyerAgentNames
        listingAgentNames
        buyerNames
        sellerNames
        otherTeamMemberNames
      }
      folder_id
      office_id
      office_name
      transaction_closing_date
    }
  }
}
    `;
export const ExternalValidationReportDataFragmentDoc = gql`
    fragment ExternalValidationReportData on ValidationReportDataObject {
  documentValidations {
    ...IngestionDocumentValidation
  }
  folderValidation {
    ...IngestionFolderValidation
  }
  keyTerms
  property {
    ...IngestionFolderProperty
  }
  autofillData {
    ...IngestionFolderAutofillData
  }
}
    ${IngestionDocumentValidationFragmentDoc}
${IngestionFolderValidationFragmentDoc}
${IngestionFolderPropertyFragmentDoc}
${IngestionFolderAutofillDataFragmentDoc}`;
export const InternalValidationReportDataFragmentDoc = gql`
    fragment InternalValidationReportData on ValidationReportDataObject {
  ...ExternalValidationReportData
}
    ${ExternalValidationReportDataFragmentDoc}`;
export const ExternalIngestionDocumentFragmentDoc = gql`
    fragment ExternalIngestionDocument on IngestionDocumentObject {
  id
  documentId
  documentName
  documentCreatedAt
  documentUpdatedAt
  fileUrl
  isBlank
  needsReview
  isArchived
  isClassified
  version
  complianceStatus
  complianceGroupId
  complianceStatusId
  folderName
  folderId
  autoApprovalState
  wasAutoApproved
  wouldBeAutoApproved
  contractDocuments {
    id
    order
    documentCategory
    externalDocumentName
    documentVersion {
      id
      document {
        id
        name
        form
        documentType
      }
    }
    file {
      url
    }
  }
  contractDocumentPages
}
    `;
export const InternalIngestionDocumentFragmentDoc = gql`
    fragment InternalIngestionDocument on IngestionDocumentObject {
  ...ExternalIngestionDocument
}
    ${ExternalIngestionDocumentFragmentDoc}`;
export const GetIngestionDocumentFragmentDoc = gql`
    fragment GetIngestionDocument on IngestionDocumentObject {
  id
  fields
  fileUrl
  documentName
  documentId
  documentUpdatedAt
  s3Bucket
  s3Key
  isArchived
  isBlank
  isClassified
  needsReview
  version
  complianceStatus
  complianceGroupId
  complianceStatusId
  folderName
  contractDocuments {
    id
    documentCategory
    file {
      url
      fileName
    }
    documentVersion {
      id
      documentVersionFields {
        id
        boundingBox {
          top
          left
          bottom
          right
        }
        field {
          id
          label
          mappingKey
        }
      }
      document {
        id
        documentType
        documentCategory
        name
        form
      }
    }
  }
  docPageErrorMessage
}
    `;
export const InternalGetIngestionDocumentFragmentDoc = gql`
    fragment InternalGetIngestionDocument on IngestionDocumentObject {
  ...GetIngestionDocument
  ingestionFolder {
    organizationUuid
  }
  documentML {
    id
    documentClassification
    updatedAt
  }
  contractDocuments {
    id
    documentCategory
    ingestionFieldValues
    aiIngestionFieldValues
    interpretedFieldValues
    interpretedFieldValuesExplanation
    mergedFieldValues
    reassignedFieldValuesLog
    file {
      url
      fileName
    }
    documentVersion {
      id
      status
      version
      searchRegex
      document {
        id
        documentType
        documentCategory
        name
        form
        usState
      }
      documentVersionFields {
        id
        boundingBox {
          top
          left
          bottom
          right
        }
        field {
          id
          label
          mappingKey
          aiInterpret
          defaultRules {
            id
            message
            ruleType
          }
        }
        rules {
          id
          message
          ruleType
        }
      }
    }
  }
  isValidDocumentMessageForExtraction
  complianceGroupMetadata {
    id
    name
    type
    active
    transactionStageType
  }
  validationRoutingDebug {
    source
    transactionStageType
    shouldIgnore
    isFolderNameOverrideEnabled
    matchedFolderNameKeywordMapping {
      keyword
      action
      transactionStageType
    }
  }
}
    ${GetIngestionDocumentFragmentDoc}`;
export const KeyTermFieldFragmentDoc = gql`
    fragment KeyTermField on KeyTermField {
  fieldLabel
  fieldType
  key
  isEditable
  fieldFormat {
    type
    options {
      precision
      formatString
      currencySymbol
    }
  }
  value
  values {
    value
    timestamp
    source
    sourceLabel
    validationError
    isCurrent
    metadata {
      ... on KeyTermCalculatedMetadata {
        ingestionDocumentId
        contractDocumentId
      }
      ... on KeyTermUserOverrideMetadata {
        overriddenBy {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export const KeyTermChildSectionFragmentDoc = gql`
    fragment KeyTermChildSection on KeyTermSection {
  title
  description
  fields {
    ...KeyTermField
  }
}
    ${KeyTermFieldFragmentDoc}`;
export const KeyTermsSectionFragmentDoc = gql`
    fragment KeyTermsSection on KeyTermSection {
  title
  description
  fields {
    ...KeyTermField
  }
  children {
    ...KeyTermChildSection
  }
}
    ${KeyTermFieldFragmentDoc}
${KeyTermChildSectionFragmentDoc}`;
export const ClientParticipantFragmentDoc = gql`
    fragment ClientParticipant on ClientParticipant {
  email
  name
  phoneNumber
}
    `;
export const AgentParticipantFragmentDoc = gql`
    fragment AgentParticipant on AgentParticipant {
  email
  name
  phoneNumber
  officeName
  officeId
  mlsAgentId
}
    `;
export const ParticipantsFragmentDoc = gql`
    fragment Participants on Participants {
  buyers {
    ...ClientParticipant
  }
  sellers {
    ...ClientParticipant
  }
  buyersAgents {
    ...AgentParticipant
  }
  listingAgents {
    ...AgentParticipant
  }
  transactionCoordinators {
    ...ClientParticipant
  }
  loanOfficers {
    ...ClientParticipant
  }
}
    ${ClientParticipantFragmentDoc}
${AgentParticipantFragmentDoc}`;
export const ExternalIngestionFolderMlsListingFragmentDoc = gql`
    fragment ExternalIngestionFolderMLSListing on MLSListingObject {
  id
  mlsId
  listingId
  mls {
    originatingSystemName
    statusText
    logoUrl
  }
  address {
    full
    unit
    city
    state
    postalCode
  }
  property {
    type
    subType
    subTypeText
  }
}
    `;
export const ExternalIngestionFolderFragmentDoc = gql`
    fragment ExternalIngestionFolder on IngestionFolderObject {
  id
  organizationUuid
  folderId
  folderType
  folderName
  transactionSide
  status
  normalizedStatus
  stage
  activeMlsListingId
  metadata
  platform
  folderUpdatedAt
  keyTerms(sortByDatetime: $sortKeyTermsByDatetime) @include(if: $includeKeyTerms) {
    ...KeyTermsSection
  }
  participants {
    ...Participants
  }
  normalizedFieldValues
  validationErrorCount
  dotloopProfileId
  transactionPipeline @include(if: $includeTransactionPipeline) {
    id
    clientType
    usState
    transactionPropertyType
  }
  mlsListing {
    ...ExternalIngestionFolderMLSListing
  }
}
    ${KeyTermsSectionFragmentDoc}
${ParticipantsFragmentDoc}
${ExternalIngestionFolderMlsListingFragmentDoc}`;
export const InternalIngestionFolderFragmentDoc = gql`
    fragment InternalIngestionFolder on IngestionFolderObject {
  ...ExternalIngestionFolder
  transactionPipeline @include(if: $includeTransactionPipeline) {
    id
    clientType
    usState
    transactionPropertyType
    stages {
      id
      stage
      sortOrder
      validationRules {
        id
        isRequiredDocument
        targetDocument {
          id
          form
        }
        rules {
          id
          ruleType
        }
        children {
          id
          isRequiredDocument
          targetDocument {
            id
            form
          }
          rules {
            id
            ruleType
          }
        }
      }
    }
  }
  aiValidationErrorCount
  regularValidationErrorCount
  fullyReprocessedAt
  txPipelineMatchedBy
  txPipelineUpdatedAt
  txPipelineCandidates {
    pipelineUuid
    pipelineName
    clientType
    usState
    transactionPropertyType
    matchedBy
    ruleMatchFormula
  }
  txPipelineNeedsInvestigationReason
}
    ${ExternalIngestionFolderFragmentDoc}`;
export const IngestionDocumentValidationErrorReviewFragmentDoc = gql`
    fragment IngestionDocumentValidationErrorReview on IngestionDocumentValidationErrorReviewObject {
  id
  isHidden
  isAddedByUser
  message
  createdByUserUuid
  updatedByUserUuid
  createdAt
  updatedAt
  contractDocumentUuid
  ruleUuid
  pageNumber
  ingestionDocument {
    id
    documentId
    documentName
  }
  ingestionDocumentValidation {
    id
    version
  }
  submission {
    id
    submittedAt
    submittedByUserUuid
  }
  validationIssueGroup {
    id
    kind
    platform
    normalizedStatus
    ruleUuid
    primaryForm
    documentCategory
    documentForm
    documentName
    normalizedMessage
    linearIssueId
    linearTicketUrl
    status
    firstSeenAt
    lastSeenAt
    totalReviewCount
    activeReviewCount
    uniqueOrgCount
    uniqueFolderCount
    uniqueUserCount
  }
}
    `;
export const IngestionFolderValidationErrorReviewFragmentDoc = gql`
    fragment IngestionFolderValidationErrorReview on IngestionFolderValidationErrorReviewObject {
  id
  isHidden
  isAddedByUser
  message
  createdByUserUuid
  updatedByUserUuid
  createdAt
  updatedAt
  documentCategory
  documentForm
  documentName
  ruleUuid
  ingestionFolderValidation {
    id
    version
  }
  submission {
    id
    submittedAt
    submittedByUserUuid
  }
  validationIssueGroup {
    id
    kind
    platform
    normalizedStatus
    ruleUuid
    primaryForm
    documentCategory
    documentForm
    documentName
    normalizedMessage
    linearIssueId
    linearTicketUrl
    status
    firstSeenAt
    lastSeenAt
    totalReviewCount
    activeReviewCount
    uniqueOrgCount
    uniqueFolderCount
    uniqueUserCount
  }
}
    `;
export const IngestionFolderValidationFeedbackFragmentDoc = gql`
    fragment IngestionFolderValidationFeedback on IngestionFolderValidationFeedbackObject {
  id
  feedbackType
  source
  comment
  createdByUserUuid
  updatedByUserUuid
  createdAt
  updatedAt
  ingestionFolderValidation {
    id
  }
}
    `;
export const IngestionDocumentValidationFeedbackFragmentDoc = gql`
    fragment IngestionDocumentValidationFeedback on IngestionDocumentValidationFeedbackObject {
  id
  feedbackType
  source
  comment
  createdByUserUuid
  updatedByUserUuid
  createdAt
  updatedAt
  ruleUuid
  contractDocumentUuid
  ingestionDocumentValidation {
    id
  }
}
    `;
export const UpdateOfferWithPartyDocument = gql`
    mutation UpdateOfferWithParty($input: UpdateOfferWithPartyInput!) {
  updateOfferWithParty(input: $input) {
    offer {
      id
    }
  }
}
    `;
export type UpdateOfferWithPartyMutationFn = Apollo.MutationFunction<Types.UpdateOfferWithPartyMutation, Types.UpdateOfferWithPartyMutationVariables>;

/**
 * __useUpdateOfferWithPartyMutation__
 *
 * To run a mutation, you first call `useUpdateOfferWithPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferWithPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferWithPartyMutation, { data, loading, error }] = useUpdateOfferWithPartyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfferWithPartyMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOfferWithPartyMutation, Types.UpdateOfferWithPartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOfferWithPartyMutation, Types.UpdateOfferWithPartyMutationVariables>(UpdateOfferWithPartyDocument, options);
      }
export type UpdateOfferWithPartyMutationHookResult = ReturnType<typeof useUpdateOfferWithPartyMutation>;
export type UpdateOfferWithPartyMutationResult = Apollo.MutationResult<Types.UpdateOfferWithPartyMutation>;
export type UpdateOfferWithPartyMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOfferWithPartyMutation, Types.UpdateOfferWithPartyMutationVariables>;
export const AcceptAccessControlInviteDocument = gql`
    mutation acceptAccessControlInvite($input: AcceptAccessControlInviteInput!) {
  acceptAccessControlInvite(input: $input) {
    user {
      ...User
    }
    targetId
    targetEntityName
  }
}
    ${UserFragmentDoc}`;
export type AcceptAccessControlInviteMutationFn = Apollo.MutationFunction<Types.AcceptAccessControlInviteMutation, Types.AcceptAccessControlInviteMutationVariables>;

/**
 * __useAcceptAccessControlInviteMutation__
 *
 * To run a mutation, you first call `useAcceptAccessControlInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAccessControlInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAccessControlInviteMutation, { data, loading, error }] = useAcceptAccessControlInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptAccessControlInviteMutation(baseOptions?: Apollo.MutationHookOptions<Types.AcceptAccessControlInviteMutation, Types.AcceptAccessControlInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AcceptAccessControlInviteMutation, Types.AcceptAccessControlInviteMutationVariables>(AcceptAccessControlInviteDocument, options);
      }
export type AcceptAccessControlInviteMutationHookResult = ReturnType<typeof useAcceptAccessControlInviteMutation>;
export type AcceptAccessControlInviteMutationResult = Apollo.MutationResult<Types.AcceptAccessControlInviteMutation>;
export type AcceptAccessControlInviteMutationOptions = Apollo.BaseMutationOptions<Types.AcceptAccessControlInviteMutation, Types.AcceptAccessControlInviteMutationVariables>;
export const AccessControlInviteDocument = gql`
    mutation accessControlInvite($input: AccessControlInviteInput!) {
  accessControlInvite(input: $input) {
    invitation {
      id
    }
  }
}
    `;
export type AccessControlInviteMutationFn = Apollo.MutationFunction<Types.AccessControlInviteMutation, Types.AccessControlInviteMutationVariables>;

/**
 * __useAccessControlInviteMutation__
 *
 * To run a mutation, you first call `useAccessControlInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccessControlInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accessControlInviteMutation, { data, loading, error }] = useAccessControlInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccessControlInviteMutation(baseOptions?: Apollo.MutationHookOptions<Types.AccessControlInviteMutation, Types.AccessControlInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AccessControlInviteMutation, Types.AccessControlInviteMutationVariables>(AccessControlInviteDocument, options);
      }
export type AccessControlInviteMutationHookResult = ReturnType<typeof useAccessControlInviteMutation>;
export type AccessControlInviteMutationResult = Apollo.MutationResult<Types.AccessControlInviteMutation>;
export type AccessControlInviteMutationOptions = Apollo.BaseMutationOptions<Types.AccessControlInviteMutation, Types.AccessControlInviteMutationVariables>;
export const CalculateOfferScoreDocument = gql`
    mutation calculateOfferScore($buyerOfferAnalysisId: String!) {
  calculateOfferScore(buyerOfferAnalysisId: $buyerOfferAnalysisId) {
    id
    agentOfferRecs {
      contingencies {
        ...AgentContingencyOfferRec
      }
      keyTerms {
        ...AgentKeyTermsOfferRec
      }
    }
    offerScore {
      ...OfferScoreResult
    }
    prevAgentOfferRecs {
      contingencies {
        ...AgentContingencyOfferRec
      }
      keyTerms {
        ...AgentKeyTermsOfferRec
      }
    }
  }
}
    ${AgentContingencyOfferRecFragmentDoc}
${AgentKeyTermsOfferRecFragmentDoc}
${OfferScoreResultFragmentDoc}`;
export type CalculateOfferScoreMutationFn = Apollo.MutationFunction<Types.CalculateOfferScoreMutation, Types.CalculateOfferScoreMutationVariables>;

/**
 * __useCalculateOfferScoreMutation__
 *
 * To run a mutation, you first call `useCalculateOfferScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateOfferScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateOfferScoreMutation, { data, loading, error }] = useCalculateOfferScoreMutation({
 *   variables: {
 *      buyerOfferAnalysisId: // value for 'buyerOfferAnalysisId'
 *   },
 * });
 */
export function useCalculateOfferScoreMutation(baseOptions?: Apollo.MutationHookOptions<Types.CalculateOfferScoreMutation, Types.CalculateOfferScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CalculateOfferScoreMutation, Types.CalculateOfferScoreMutationVariables>(CalculateOfferScoreDocument, options);
      }
export type CalculateOfferScoreMutationHookResult = ReturnType<typeof useCalculateOfferScoreMutation>;
export type CalculateOfferScoreMutationResult = Apollo.MutationResult<Types.CalculateOfferScoreMutation>;
export type CalculateOfferScoreMutationOptions = Apollo.BaseMutationOptions<Types.CalculateOfferScoreMutation, Types.CalculateOfferScoreMutationVariables>;
export const CapturePropertyDetailsDocument = gql`
    mutation capturePropertyDetails($input: CapturePropertyDetailsInput!) {
  capturePropertyDetails(input: $input) {
    success
    propertyDetails {
      ...PropertyDetails
    }
  }
}
    ${PropertyDetailsFragmentDoc}`;
export type CapturePropertyDetailsMutationFn = Apollo.MutationFunction<Types.CapturePropertyDetailsMutation, Types.CapturePropertyDetailsMutationVariables>;

/**
 * __useCapturePropertyDetailsMutation__
 *
 * To run a mutation, you first call `useCapturePropertyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapturePropertyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capturePropertyDetailsMutation, { data, loading, error }] = useCapturePropertyDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCapturePropertyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CapturePropertyDetailsMutation, Types.CapturePropertyDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CapturePropertyDetailsMutation, Types.CapturePropertyDetailsMutationVariables>(CapturePropertyDetailsDocument, options);
      }
export type CapturePropertyDetailsMutationHookResult = ReturnType<typeof useCapturePropertyDetailsMutation>;
export type CapturePropertyDetailsMutationResult = Apollo.MutationResult<Types.CapturePropertyDetailsMutation>;
export type CapturePropertyDetailsMutationOptions = Apollo.BaseMutationOptions<Types.CapturePropertyDetailsMutation, Types.CapturePropertyDetailsMutationVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: CreateContactInput!) {
  createContact(input: $input) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<Types.CreateContactMutation, Types.CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateContactMutation, Types.CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateContactMutation, Types.CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<Types.CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<Types.CreateContactMutation, Types.CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: UpdateContactInput!) {
  updateContact(input: $input) {
    ...Contact
  }
}
    ${ContactFragmentDoc}`;
export type UpdateContactMutationFn = Apollo.MutationFunction<Types.UpdateContactMutation, Types.UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateContactMutation, Types.UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateContactMutation, Types.UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<Types.UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<Types.UpdateContactMutation, Types.UpdateContactMutationVariables>;
export const CreateAiConversationDocument = gql`
    mutation createAIConversation($input: CreateAIConversationInput!) {
  createAIConversation(input: $input) {
    ...AIConversation
  }
}
    ${AiConversationFragmentDoc}`;
export type CreateAiConversationMutationFn = Apollo.MutationFunction<Types.CreateAiConversationMutation, Types.CreateAiConversationMutationVariables>;

/**
 * __useCreateAiConversationMutation__
 *
 * To run a mutation, you first call `useCreateAiConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiConversationMutation, { data, loading, error }] = useCreateAiConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiConversationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAiConversationMutation, Types.CreateAiConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAiConversationMutation, Types.CreateAiConversationMutationVariables>(CreateAiConversationDocument, options);
      }
export type CreateAiConversationMutationHookResult = ReturnType<typeof useCreateAiConversationMutation>;
export type CreateAiConversationMutationResult = Apollo.MutationResult<Types.CreateAiConversationMutation>;
export type CreateAiConversationMutationOptions = Apollo.BaseMutationOptions<Types.CreateAiConversationMutation, Types.CreateAiConversationMutationVariables>;
export const CreateBuyerOfferAnalysisDocument = gql`
    mutation CreateBuyerOfferAnalysis($input: CreateBuyerOfferAnalysisInput!) {
  createBuyerOfferAnalysis(input: $input) {
    id
  }
}
    `;
export type CreateBuyerOfferAnalysisMutationFn = Apollo.MutationFunction<Types.CreateBuyerOfferAnalysisMutation, Types.CreateBuyerOfferAnalysisMutationVariables>;

/**
 * __useCreateBuyerOfferAnalysisMutation__
 *
 * To run a mutation, you first call `useCreateBuyerOfferAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuyerOfferAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuyerOfferAnalysisMutation, { data, loading, error }] = useCreateBuyerOfferAnalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuyerOfferAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateBuyerOfferAnalysisMutation, Types.CreateBuyerOfferAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateBuyerOfferAnalysisMutation, Types.CreateBuyerOfferAnalysisMutationVariables>(CreateBuyerOfferAnalysisDocument, options);
      }
export type CreateBuyerOfferAnalysisMutationHookResult = ReturnType<typeof useCreateBuyerOfferAnalysisMutation>;
export type CreateBuyerOfferAnalysisMutationResult = Apollo.MutationResult<Types.CreateBuyerOfferAnalysisMutation>;
export type CreateBuyerOfferAnalysisMutationOptions = Apollo.BaseMutationOptions<Types.CreateBuyerOfferAnalysisMutation, Types.CreateBuyerOfferAnalysisMutationVariables>;
export const CreateBuyerOfferAnalysisForUserDocument = gql`
    mutation CreateBuyerOfferAnalysisForUser($input: CreateBuyerOfferAnalysisForUserInput!) {
  createBuyerOfferAnalysisForUser(input: $input) {
    id
  }
}
    `;
export type CreateBuyerOfferAnalysisForUserMutationFn = Apollo.MutationFunction<Types.CreateBuyerOfferAnalysisForUserMutation, Types.CreateBuyerOfferAnalysisForUserMutationVariables>;

/**
 * __useCreateBuyerOfferAnalysisForUserMutation__
 *
 * To run a mutation, you first call `useCreateBuyerOfferAnalysisForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuyerOfferAnalysisForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuyerOfferAnalysisForUserMutation, { data, loading, error }] = useCreateBuyerOfferAnalysisForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBuyerOfferAnalysisForUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateBuyerOfferAnalysisForUserMutation, Types.CreateBuyerOfferAnalysisForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateBuyerOfferAnalysisForUserMutation, Types.CreateBuyerOfferAnalysisForUserMutationVariables>(CreateBuyerOfferAnalysisForUserDocument, options);
      }
export type CreateBuyerOfferAnalysisForUserMutationHookResult = ReturnType<typeof useCreateBuyerOfferAnalysisForUserMutation>;
export type CreateBuyerOfferAnalysisForUserMutationResult = Apollo.MutationResult<Types.CreateBuyerOfferAnalysisForUserMutation>;
export type CreateBuyerOfferAnalysisForUserMutationOptions = Apollo.BaseMutationOptions<Types.CreateBuyerOfferAnalysisForUserMutation, Types.CreateBuyerOfferAnalysisForUserMutationVariables>;
export const CreateEmbeddedSignatureRequestDocument = gql`
    mutation createEmbeddedSignatureRequest($input: CreateEmbeddedSignatureRequestInput!) {
  createEmbeddedSignatureRequest(input: $input) {
    embeddedSignUrl
  }
}
    `;
export type CreateEmbeddedSignatureRequestMutationFn = Apollo.MutationFunction<Types.CreateEmbeddedSignatureRequestMutation, Types.CreateEmbeddedSignatureRequestMutationVariables>;

/**
 * __useCreateEmbeddedSignatureRequestMutation__
 *
 * To run a mutation, you first call `useCreateEmbeddedSignatureRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmbeddedSignatureRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmbeddedSignatureRequestMutation, { data, loading, error }] = useCreateEmbeddedSignatureRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmbeddedSignatureRequestMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateEmbeddedSignatureRequestMutation, Types.CreateEmbeddedSignatureRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateEmbeddedSignatureRequestMutation, Types.CreateEmbeddedSignatureRequestMutationVariables>(CreateEmbeddedSignatureRequestDocument, options);
      }
export type CreateEmbeddedSignatureRequestMutationHookResult = ReturnType<typeof useCreateEmbeddedSignatureRequestMutation>;
export type CreateEmbeddedSignatureRequestMutationResult = Apollo.MutationResult<Types.CreateEmbeddedSignatureRequestMutation>;
export type CreateEmbeddedSignatureRequestMutationOptions = Apollo.BaseMutationOptions<Types.CreateEmbeddedSignatureRequestMutation, Types.CreateEmbeddedSignatureRequestMutationVariables>;
export const CreateEventForOfferDocument = gql`
    mutation CreateEventForOffer($input: CreateEventForOfferInput!) {
  createEventForOffer(input: $input) {
    ...AppEvent
  }
}
    ${AppEventFragmentDoc}`;
export type CreateEventForOfferMutationFn = Apollo.MutationFunction<Types.CreateEventForOfferMutation, Types.CreateEventForOfferMutationVariables>;

/**
 * __useCreateEventForOfferMutation__
 *
 * To run a mutation, you first call `useCreateEventForOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventForOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventForOfferMutation, { data, loading, error }] = useCreateEventForOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventForOfferMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateEventForOfferMutation, Types.CreateEventForOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateEventForOfferMutation, Types.CreateEventForOfferMutationVariables>(CreateEventForOfferDocument, options);
      }
export type CreateEventForOfferMutationHookResult = ReturnType<typeof useCreateEventForOfferMutation>;
export type CreateEventForOfferMutationResult = Apollo.MutationResult<Types.CreateEventForOfferMutation>;
export type CreateEventForOfferMutationOptions = Apollo.BaseMutationOptions<Types.CreateEventForOfferMutation, Types.CreateEventForOfferMutationVariables>;
export const CreateIndigoContractDocument = gql`
    mutation createIndigoContract($input: CreateIndigoContractInput!) {
  createIndigoContract(input: $input) {
    id
  }
}
    `;
export type CreateIndigoContractMutationFn = Apollo.MutationFunction<Types.CreateIndigoContractMutation, Types.CreateIndigoContractMutationVariables>;

/**
 * __useCreateIndigoContractMutation__
 *
 * To run a mutation, you first call `useCreateIndigoContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndigoContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndigoContractMutation, { data, loading, error }] = useCreateIndigoContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndigoContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateIndigoContractMutation, Types.CreateIndigoContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateIndigoContractMutation, Types.CreateIndigoContractMutationVariables>(CreateIndigoContractDocument, options);
      }
export type CreateIndigoContractMutationHookResult = ReturnType<typeof useCreateIndigoContractMutation>;
export type CreateIndigoContractMutationResult = Apollo.MutationResult<Types.CreateIndigoContractMutation>;
export type CreateIndigoContractMutationOptions = Apollo.BaseMutationOptions<Types.CreateIndigoContractMutation, Types.CreateIndigoContractMutationVariables>;
export const CreateNotificationTemplateDocument = gql`
    mutation CreateNotificationTemplate($input: CreateNotificationTemplateInput!) {
  createNotificationTemplate(input: $input) {
    ...NotificationTemplateDetails
  }
}
    ${NotificationTemplateDetailsFragmentDoc}`;
export type CreateNotificationTemplateMutationFn = Apollo.MutationFunction<Types.CreateNotificationTemplateMutation, Types.CreateNotificationTemplateMutationVariables>;

/**
 * __useCreateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationTemplateMutation, { data, loading, error }] = useCreateNotificationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateNotificationTemplateMutation, Types.CreateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateNotificationTemplateMutation, Types.CreateNotificationTemplateMutationVariables>(CreateNotificationTemplateDocument, options);
      }
export type CreateNotificationTemplateMutationHookResult = ReturnType<typeof useCreateNotificationTemplateMutation>;
export type CreateNotificationTemplateMutationResult = Apollo.MutationResult<Types.CreateNotificationTemplateMutation>;
export type CreateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<Types.CreateNotificationTemplateMutation, Types.CreateNotificationTemplateMutationVariables>;
export const CreateOfferDocument = gql`
    mutation createOffer($input: CreateOfferInput!, $isAgentVerified: Boolean = false) {
  createOfferForBuyersAgent(input: $input) @include(if: $isAgentVerified) {
    offer {
      id
      contractId
    }
  }
  createOfferForUnauthenticatedBuyersAgent(input: $input) @skip(if: $isAgentVerified) {
    offer {
      id
      contractId
    }
  }
}
    `;
export type CreateOfferMutationFn = Apollo.MutationFunction<Types.CreateOfferMutation, Types.CreateOfferMutationVariables>;

/**
 * __useCreateOfferMutation__
 *
 * To run a mutation, you first call `useCreateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferMutation, { data, loading, error }] = useCreateOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isAgentVerified: // value for 'isAgentVerified'
 *   },
 * });
 */
export function useCreateOfferMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOfferMutation, Types.CreateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOfferMutation, Types.CreateOfferMutationVariables>(CreateOfferDocument, options);
      }
export type CreateOfferMutationHookResult = ReturnType<typeof useCreateOfferMutation>;
export type CreateOfferMutationResult = Apollo.MutationResult<Types.CreateOfferMutation>;
export type CreateOfferMutationOptions = Apollo.BaseMutationOptions<Types.CreateOfferMutation, Types.CreateOfferMutationVariables>;
export const CreateOrUpdateIngestionDocumentReviewDocument = gql`
    mutation createOrUpdateIngestionDocumentReview($input: ExternalCreateOrUpdateIngestionDocumentReviewInput!) {
  externalCreateOrUpdateIngestionDocumentReview(input: $input) {
    ...IngestionDocumentReview
  }
}
    ${IngestionDocumentReviewFragmentDoc}`;
export type CreateOrUpdateIngestionDocumentReviewMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateIngestionDocumentReviewMutation, Types.CreateOrUpdateIngestionDocumentReviewMutationVariables>;

/**
 * __useCreateOrUpdateIngestionDocumentReviewMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateIngestionDocumentReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateIngestionDocumentReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateIngestionDocumentReviewMutation, { data, loading, error }] = useCreateOrUpdateIngestionDocumentReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateIngestionDocumentReviewMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateIngestionDocumentReviewMutation, Types.CreateOrUpdateIngestionDocumentReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateIngestionDocumentReviewMutation, Types.CreateOrUpdateIngestionDocumentReviewMutationVariables>(CreateOrUpdateIngestionDocumentReviewDocument, options);
      }
export type CreateOrUpdateIngestionDocumentReviewMutationHookResult = ReturnType<typeof useCreateOrUpdateIngestionDocumentReviewMutation>;
export type CreateOrUpdateIngestionDocumentReviewMutationResult = Apollo.MutationResult<Types.CreateOrUpdateIngestionDocumentReviewMutation>;
export type CreateOrUpdateIngestionDocumentReviewMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateIngestionDocumentReviewMutation, Types.CreateOrUpdateIngestionDocumentReviewMutationVariables>;
export const CreateOrUpdateIngestionDocumentValidationErrorReviewDocument = gql`
    mutation createOrUpdateIngestionDocumentValidationErrorReview($input: ExternalCreateOrUpdateIngestionDocumentValidationErrorReviewInput!) {
  externalCreateOrUpdateIngestionDocumentValidationErrorReview(input: $input) {
    ...IngestionDocumentValidationErrorReview
  }
}
    ${IngestionDocumentValidationErrorReviewFragmentDoc}`;
export type CreateOrUpdateIngestionDocumentValidationErrorReviewMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateIngestionDocumentValidationErrorReviewMutation, Types.CreateOrUpdateIngestionDocumentValidationErrorReviewMutationVariables>;

/**
 * __useCreateOrUpdateIngestionDocumentValidationErrorReviewMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateIngestionDocumentValidationErrorReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateIngestionDocumentValidationErrorReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateIngestionDocumentValidationErrorReviewMutation, { data, loading, error }] = useCreateOrUpdateIngestionDocumentValidationErrorReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateIngestionDocumentValidationErrorReviewMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateIngestionDocumentValidationErrorReviewMutation, Types.CreateOrUpdateIngestionDocumentValidationErrorReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateIngestionDocumentValidationErrorReviewMutation, Types.CreateOrUpdateIngestionDocumentValidationErrorReviewMutationVariables>(CreateOrUpdateIngestionDocumentValidationErrorReviewDocument, options);
      }
export type CreateOrUpdateIngestionDocumentValidationErrorReviewMutationHookResult = ReturnType<typeof useCreateOrUpdateIngestionDocumentValidationErrorReviewMutation>;
export type CreateOrUpdateIngestionDocumentValidationErrorReviewMutationResult = Apollo.MutationResult<Types.CreateOrUpdateIngestionDocumentValidationErrorReviewMutation>;
export type CreateOrUpdateIngestionDocumentValidationErrorReviewMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateIngestionDocumentValidationErrorReviewMutation, Types.CreateOrUpdateIngestionDocumentValidationErrorReviewMutationVariables>;
export const CreateOrUpdateIngestionFolderValidationErrorReviewDocument = gql`
    mutation createOrUpdateIngestionFolderValidationErrorReview($input: ExternalCreateOrUpdateIngestionFolderValidationErrorReviewInput!) {
  externalCreateOrUpdateIngestionFolderValidationErrorReview(input: $input) {
    ...IngestionFolderValidationErrorReview
  }
}
    ${IngestionFolderValidationErrorReviewFragmentDoc}`;
export type CreateOrUpdateIngestionFolderValidationErrorReviewMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateIngestionFolderValidationErrorReviewMutation, Types.CreateOrUpdateIngestionFolderValidationErrorReviewMutationVariables>;

/**
 * __useCreateOrUpdateIngestionFolderValidationErrorReviewMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateIngestionFolderValidationErrorReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateIngestionFolderValidationErrorReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateIngestionFolderValidationErrorReviewMutation, { data, loading, error }] = useCreateOrUpdateIngestionFolderValidationErrorReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateIngestionFolderValidationErrorReviewMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateIngestionFolderValidationErrorReviewMutation, Types.CreateOrUpdateIngestionFolderValidationErrorReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateIngestionFolderValidationErrorReviewMutation, Types.CreateOrUpdateIngestionFolderValidationErrorReviewMutationVariables>(CreateOrUpdateIngestionFolderValidationErrorReviewDocument, options);
      }
export type CreateOrUpdateIngestionFolderValidationErrorReviewMutationHookResult = ReturnType<typeof useCreateOrUpdateIngestionFolderValidationErrorReviewMutation>;
export type CreateOrUpdateIngestionFolderValidationErrorReviewMutationResult = Apollo.MutationResult<Types.CreateOrUpdateIngestionFolderValidationErrorReviewMutation>;
export type CreateOrUpdateIngestionFolderValidationErrorReviewMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateIngestionFolderValidationErrorReviewMutation, Types.CreateOrUpdateIngestionFolderValidationErrorReviewMutationVariables>;
export const CreateOrUpdateListingAnnouncementDocument = gql`
    mutation createOrUpdateListingAnnouncement($input: CreateOrUpdateListingAnnouncementInput!) {
  createOrUpdateListingAnnouncement(input: $input) {
    ...ListingAnnouncement
  }
}
    ${ListingAnnouncementFragmentDoc}`;
export type CreateOrUpdateListingAnnouncementMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateListingAnnouncementMutation, Types.CreateOrUpdateListingAnnouncementMutationVariables>;

/**
 * __useCreateOrUpdateListingAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateListingAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateListingAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateListingAnnouncementMutation, { data, loading, error }] = useCreateOrUpdateListingAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateListingAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateListingAnnouncementMutation, Types.CreateOrUpdateListingAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateListingAnnouncementMutation, Types.CreateOrUpdateListingAnnouncementMutationVariables>(CreateOrUpdateListingAnnouncementDocument, options);
      }
export type CreateOrUpdateListingAnnouncementMutationHookResult = ReturnType<typeof useCreateOrUpdateListingAnnouncementMutation>;
export type CreateOrUpdateListingAnnouncementMutationResult = Apollo.MutationResult<Types.CreateOrUpdateListingAnnouncementMutation>;
export type CreateOrUpdateListingAnnouncementMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateListingAnnouncementMutation, Types.CreateOrUpdateListingAnnouncementMutationVariables>;
export const CreateOrUpdateListingComparableAdjustmentDocument = gql`
    mutation createOrUpdateListingComparableAdjustment($input: CreateOrUpdateListingComparableAdjustmentInput!) {
  createOrUpdateListingComparableAdjustment(input: $input) {
    ...ListingComparable
  }
}
    ${ListingComparableFragmentDoc}`;
export type CreateOrUpdateListingComparableAdjustmentMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateListingComparableAdjustmentMutation, Types.CreateOrUpdateListingComparableAdjustmentMutationVariables>;

/**
 * __useCreateOrUpdateListingComparableAdjustmentMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateListingComparableAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateListingComparableAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateListingComparableAdjustmentMutation, { data, loading, error }] = useCreateOrUpdateListingComparableAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateListingComparableAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateListingComparableAdjustmentMutation, Types.CreateOrUpdateListingComparableAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateListingComparableAdjustmentMutation, Types.CreateOrUpdateListingComparableAdjustmentMutationVariables>(CreateOrUpdateListingComparableAdjustmentDocument, options);
      }
export type CreateOrUpdateListingComparableAdjustmentMutationHookResult = ReturnType<typeof useCreateOrUpdateListingComparableAdjustmentMutation>;
export type CreateOrUpdateListingComparableAdjustmentMutationResult = Apollo.MutationResult<Types.CreateOrUpdateListingComparableAdjustmentMutation>;
export type CreateOrUpdateListingComparableAdjustmentMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateListingComparableAdjustmentMutation, Types.CreateOrUpdateListingComparableAdjustmentMutationVariables>;
export const CreateOrUpdateListingComparableAdjustmentV2Document = gql`
    mutation createOrUpdateListingComparableAdjustmentV2($input: CreateOrUpdateListingComparableAdjustmentInputV2!) {
  createOrUpdateListingComparableAdjustmentV2(input: $input) {
    ...ListingComparable
  }
}
    ${ListingComparableFragmentDoc}`;
export type CreateOrUpdateListingComparableAdjustmentV2MutationFn = Apollo.MutationFunction<Types.CreateOrUpdateListingComparableAdjustmentV2Mutation, Types.CreateOrUpdateListingComparableAdjustmentV2MutationVariables>;

/**
 * __useCreateOrUpdateListingComparableAdjustmentV2Mutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateListingComparableAdjustmentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateListingComparableAdjustmentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateListingComparableAdjustmentV2Mutation, { data, loading, error }] = useCreateOrUpdateListingComparableAdjustmentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateListingComparableAdjustmentV2Mutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateListingComparableAdjustmentV2Mutation, Types.CreateOrUpdateListingComparableAdjustmentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateListingComparableAdjustmentV2Mutation, Types.CreateOrUpdateListingComparableAdjustmentV2MutationVariables>(CreateOrUpdateListingComparableAdjustmentV2Document, options);
      }
export type CreateOrUpdateListingComparableAdjustmentV2MutationHookResult = ReturnType<typeof useCreateOrUpdateListingComparableAdjustmentV2Mutation>;
export type CreateOrUpdateListingComparableAdjustmentV2MutationResult = Apollo.MutationResult<Types.CreateOrUpdateListingComparableAdjustmentV2Mutation>;
export type CreateOrUpdateListingComparableAdjustmentV2MutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateListingComparableAdjustmentV2Mutation, Types.CreateOrUpdateListingComparableAdjustmentV2MutationVariables>;
export const CreateOrganizationForAgentDocument = gql`
    mutation createOrganizationForAgent($input: CreateOrganizationInput!) {
  createOrganizationForAgent(input: $input) {
    organization {
      id
      name
    }
    user {
      id
      settings {
        selectedOrganization {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateOrganizationForAgentMutationFn = Apollo.MutationFunction<Types.CreateOrganizationForAgentMutation, Types.CreateOrganizationForAgentMutationVariables>;

/**
 * __useCreateOrganizationForAgentMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationForAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationForAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationForAgentMutation, { data, loading, error }] = useCreateOrganizationForAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationForAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrganizationForAgentMutation, Types.CreateOrganizationForAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrganizationForAgentMutation, Types.CreateOrganizationForAgentMutationVariables>(CreateOrganizationForAgentDocument, options);
      }
export type CreateOrganizationForAgentMutationHookResult = ReturnType<typeof useCreateOrganizationForAgentMutation>;
export type CreateOrganizationForAgentMutationResult = Apollo.MutationResult<Types.CreateOrganizationForAgentMutation>;
export type CreateOrganizationForAgentMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrganizationForAgentMutation, Types.CreateOrganizationForAgentMutationVariables>;
export const CreateOrganizationForTeamLeadDocument = gql`
    mutation createOrganizationForTeamLead($input: CreateOrganizationInput!) {
  createOrganizationForTeamLead(input: $input) {
    organization {
      id
      name
    }
    user {
      id
      settings {
        selectedOrganization {
          id
          name
        }
      }
    }
  }
}
    `;
export type CreateOrganizationForTeamLeadMutationFn = Apollo.MutationFunction<Types.CreateOrganizationForTeamLeadMutation, Types.CreateOrganizationForTeamLeadMutationVariables>;

/**
 * __useCreateOrganizationForTeamLeadMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationForTeamLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationForTeamLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationForTeamLeadMutation, { data, loading, error }] = useCreateOrganizationForTeamLeadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationForTeamLeadMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrganizationForTeamLeadMutation, Types.CreateOrganizationForTeamLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrganizationForTeamLeadMutation, Types.CreateOrganizationForTeamLeadMutationVariables>(CreateOrganizationForTeamLeadDocument, options);
      }
export type CreateOrganizationForTeamLeadMutationHookResult = ReturnType<typeof useCreateOrganizationForTeamLeadMutation>;
export type CreateOrganizationForTeamLeadMutationResult = Apollo.MutationResult<Types.CreateOrganizationForTeamLeadMutation>;
export type CreateOrganizationForTeamLeadMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrganizationForTeamLeadMutation, Types.CreateOrganizationForTeamLeadMutationVariables>;
export const CreatePartyForBuyersAgentDocument = gql`
    mutation CreatePartyForBuyersAgent($input: CreatePartyForBuyersAgentInput!) {
  createPartyForBuyersAgent(input: $input) {
    id
  }
}
    `;
export type CreatePartyForBuyersAgentMutationFn = Apollo.MutationFunction<Types.CreatePartyForBuyersAgentMutation, Types.CreatePartyForBuyersAgentMutationVariables>;

/**
 * __useCreatePartyForBuyersAgentMutation__
 *
 * To run a mutation, you first call `useCreatePartyForBuyersAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartyForBuyersAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartyForBuyersAgentMutation, { data, loading, error }] = useCreatePartyForBuyersAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartyForBuyersAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreatePartyForBuyersAgentMutation, Types.CreatePartyForBuyersAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreatePartyForBuyersAgentMutation, Types.CreatePartyForBuyersAgentMutationVariables>(CreatePartyForBuyersAgentDocument, options);
      }
export type CreatePartyForBuyersAgentMutationHookResult = ReturnType<typeof useCreatePartyForBuyersAgentMutation>;
export type CreatePartyForBuyersAgentMutationResult = Apollo.MutationResult<Types.CreatePartyForBuyersAgentMutation>;
export type CreatePartyForBuyersAgentMutationOptions = Apollo.BaseMutationOptions<Types.CreatePartyForBuyersAgentMutation, Types.CreatePartyForBuyersAgentMutationVariables>;
export const CreateUserTourDocument = gql`
    mutation createUserTour($tourNames: [TourType!]!) {
  createUserTour(tourNames: $tourNames) {
    id
    tourName
  }
}
    `;
export type CreateUserTourMutationFn = Apollo.MutationFunction<Types.CreateUserTourMutation, Types.CreateUserTourMutationVariables>;

/**
 * __useCreateUserTourMutation__
 *
 * To run a mutation, you first call `useCreateUserTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserTourMutation, { data, loading, error }] = useCreateUserTourMutation({
 *   variables: {
 *      tourNames: // value for 'tourNames'
 *   },
 * });
 */
export function useCreateUserTourMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateUserTourMutation, Types.CreateUserTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateUserTourMutation, Types.CreateUserTourMutationVariables>(CreateUserTourDocument, options);
      }
export type CreateUserTourMutationHookResult = ReturnType<typeof useCreateUserTourMutation>;
export type CreateUserTourMutationResult = Apollo.MutationResult<Types.CreateUserTourMutation>;
export type CreateUserTourMutationOptions = Apollo.BaseMutationOptions<Types.CreateUserTourMutation, Types.CreateUserTourMutationVariables>;
export const DeleteAiConversationDocument = gql`
    mutation deleteAIConversation($input: DeleteAIConversationInput!) {
  deleteAIConversation(input: $input)
}
    `;
export type DeleteAiConversationMutationFn = Apollo.MutationFunction<Types.DeleteAiConversationMutation, Types.DeleteAiConversationMutationVariables>;

/**
 * __useDeleteAiConversationMutation__
 *
 * To run a mutation, you first call `useDeleteAiConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiConversationMutation, { data, loading, error }] = useDeleteAiConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAiConversationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAiConversationMutation, Types.DeleteAiConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAiConversationMutation, Types.DeleteAiConversationMutationVariables>(DeleteAiConversationDocument, options);
      }
export type DeleteAiConversationMutationHookResult = ReturnType<typeof useDeleteAiConversationMutation>;
export type DeleteAiConversationMutationResult = Apollo.MutationResult<Types.DeleteAiConversationMutation>;
export type DeleteAiConversationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAiConversationMutation, Types.DeleteAiConversationMutationVariables>;
export const DeleteAccessControlDocument = gql`
    mutation deleteAccessControl($input: DeleteAccessControlInput!) {
  deleteAccessControl(input: $input) {
    deleted
  }
}
    `;
export type DeleteAccessControlMutationFn = Apollo.MutationFunction<Types.DeleteAccessControlMutation, Types.DeleteAccessControlMutationVariables>;

/**
 * __useDeleteAccessControlMutation__
 *
 * To run a mutation, you first call `useDeleteAccessControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccessControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccessControlMutation, { data, loading, error }] = useDeleteAccessControlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAccessControlMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteAccessControlMutation, Types.DeleteAccessControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteAccessControlMutation, Types.DeleteAccessControlMutationVariables>(DeleteAccessControlDocument, options);
      }
export type DeleteAccessControlMutationHookResult = ReturnType<typeof useDeleteAccessControlMutation>;
export type DeleteAccessControlMutationResult = Apollo.MutationResult<Types.DeleteAccessControlMutation>;
export type DeleteAccessControlMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAccessControlMutation, Types.DeleteAccessControlMutationVariables>;
export const DeleteContractSystemCredentialsDocument = gql`
    mutation deleteContractSystemCredentials($input: DeleteContractSystemCredentialsInput!) {
  deleteContractSystemCredentials(input: $input)
}
    `;
export type DeleteContractSystemCredentialsMutationFn = Apollo.MutationFunction<Types.DeleteContractSystemCredentialsMutation, Types.DeleteContractSystemCredentialsMutationVariables>;

/**
 * __useDeleteContractSystemCredentialsMutation__
 *
 * To run a mutation, you first call `useDeleteContractSystemCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractSystemCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractSystemCredentialsMutation, { data, loading, error }] = useDeleteContractSystemCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContractSystemCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteContractSystemCredentialsMutation, Types.DeleteContractSystemCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteContractSystemCredentialsMutation, Types.DeleteContractSystemCredentialsMutationVariables>(DeleteContractSystemCredentialsDocument, options);
      }
export type DeleteContractSystemCredentialsMutationHookResult = ReturnType<typeof useDeleteContractSystemCredentialsMutation>;
export type DeleteContractSystemCredentialsMutationResult = Apollo.MutationResult<Types.DeleteContractSystemCredentialsMutation>;
export type DeleteContractSystemCredentialsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteContractSystemCredentialsMutation, Types.DeleteContractSystemCredentialsMutationVariables>;
export const DeleteIngestionDocumentValidationErrorReviewDocument = gql`
    mutation deleteIngestionDocumentValidationErrorReview($input: ExternalDeleteIngestionDocumentValidationErrorReviewInput!) {
  externalDeleteIngestionDocumentValidationErrorReview(input: $input)
}
    `;
export type DeleteIngestionDocumentValidationErrorReviewMutationFn = Apollo.MutationFunction<Types.DeleteIngestionDocumentValidationErrorReviewMutation, Types.DeleteIngestionDocumentValidationErrorReviewMutationVariables>;

/**
 * __useDeleteIngestionDocumentValidationErrorReviewMutation__
 *
 * To run a mutation, you first call `useDeleteIngestionDocumentValidationErrorReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIngestionDocumentValidationErrorReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIngestionDocumentValidationErrorReviewMutation, { data, loading, error }] = useDeleteIngestionDocumentValidationErrorReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIngestionDocumentValidationErrorReviewMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteIngestionDocumentValidationErrorReviewMutation, Types.DeleteIngestionDocumentValidationErrorReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteIngestionDocumentValidationErrorReviewMutation, Types.DeleteIngestionDocumentValidationErrorReviewMutationVariables>(DeleteIngestionDocumentValidationErrorReviewDocument, options);
      }
export type DeleteIngestionDocumentValidationErrorReviewMutationHookResult = ReturnType<typeof useDeleteIngestionDocumentValidationErrorReviewMutation>;
export type DeleteIngestionDocumentValidationErrorReviewMutationResult = Apollo.MutationResult<Types.DeleteIngestionDocumentValidationErrorReviewMutation>;
export type DeleteIngestionDocumentValidationErrorReviewMutationOptions = Apollo.BaseMutationOptions<Types.DeleteIngestionDocumentValidationErrorReviewMutation, Types.DeleteIngestionDocumentValidationErrorReviewMutationVariables>;
export const DeleteIngestionFolderValidationErrorReviewDocument = gql`
    mutation deleteIngestionFolderValidationErrorReview($input: ExternalDeleteIngestionFolderValidationErrorReviewInput!) {
  externalDeleteIngestionFolderValidationErrorReview(input: $input)
}
    `;
export type DeleteIngestionFolderValidationErrorReviewMutationFn = Apollo.MutationFunction<Types.DeleteIngestionFolderValidationErrorReviewMutation, Types.DeleteIngestionFolderValidationErrorReviewMutationVariables>;

/**
 * __useDeleteIngestionFolderValidationErrorReviewMutation__
 *
 * To run a mutation, you first call `useDeleteIngestionFolderValidationErrorReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIngestionFolderValidationErrorReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIngestionFolderValidationErrorReviewMutation, { data, loading, error }] = useDeleteIngestionFolderValidationErrorReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIngestionFolderValidationErrorReviewMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteIngestionFolderValidationErrorReviewMutation, Types.DeleteIngestionFolderValidationErrorReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteIngestionFolderValidationErrorReviewMutation, Types.DeleteIngestionFolderValidationErrorReviewMutationVariables>(DeleteIngestionFolderValidationErrorReviewDocument, options);
      }
export type DeleteIngestionFolderValidationErrorReviewMutationHookResult = ReturnType<typeof useDeleteIngestionFolderValidationErrorReviewMutation>;
export type DeleteIngestionFolderValidationErrorReviewMutationResult = Apollo.MutationResult<Types.DeleteIngestionFolderValidationErrorReviewMutation>;
export type DeleteIngestionFolderValidationErrorReviewMutationOptions = Apollo.BaseMutationOptions<Types.DeleteIngestionFolderValidationErrorReviewMutation, Types.DeleteIngestionFolderValidationErrorReviewMutationVariables>;
export const DeleteIntegrationConnectionDocument = gql`
    mutation deleteIntegrationConnection($input: DeleteIntegrationConnectionInput!) {
  deleteIntegrationConnection(input: $input) {
    deleted
  }
}
    `;
export type DeleteIntegrationConnectionMutationFn = Apollo.MutationFunction<Types.DeleteIntegrationConnectionMutation, Types.DeleteIntegrationConnectionMutationVariables>;

/**
 * __useDeleteIntegrationConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationConnectionMutation, { data, loading, error }] = useDeleteIntegrationConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIntegrationConnectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteIntegrationConnectionMutation, Types.DeleteIntegrationConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteIntegrationConnectionMutation, Types.DeleteIntegrationConnectionMutationVariables>(DeleteIntegrationConnectionDocument, options);
      }
export type DeleteIntegrationConnectionMutationHookResult = ReturnType<typeof useDeleteIntegrationConnectionMutation>;
export type DeleteIntegrationConnectionMutationResult = Apollo.MutationResult<Types.DeleteIntegrationConnectionMutation>;
export type DeleteIntegrationConnectionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteIntegrationConnectionMutation, Types.DeleteIntegrationConnectionMutationVariables>;
export const DeleteListingDocumentsDocument = gql`
    mutation deleteListingDocuments($input: DeleteListingDocumentsInput!) {
  deleteListingDocuments(input: $input) {
    id
  }
}
    `;
export type DeleteListingDocumentsMutationFn = Apollo.MutationFunction<Types.DeleteListingDocumentsMutation, Types.DeleteListingDocumentsMutationVariables>;

/**
 * __useDeleteListingDocumentsMutation__
 *
 * To run a mutation, you first call `useDeleteListingDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListingDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListingDocumentsMutation, { data, loading, error }] = useDeleteListingDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteListingDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteListingDocumentsMutation, Types.DeleteListingDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteListingDocumentsMutation, Types.DeleteListingDocumentsMutationVariables>(DeleteListingDocumentsDocument, options);
      }
export type DeleteListingDocumentsMutationHookResult = ReturnType<typeof useDeleteListingDocumentsMutation>;
export type DeleteListingDocumentsMutationResult = Apollo.MutationResult<Types.DeleteListingDocumentsMutation>;
export type DeleteListingDocumentsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteListingDocumentsMutation, Types.DeleteListingDocumentsMutationVariables>;
export const DeleteNotificationTemplateDocument = gql`
    mutation DeleteNotificationTemplate($id: ID!) {
  deleteNotificationTemplate(id: $id)
}
    `;
export type DeleteNotificationTemplateMutationFn = Apollo.MutationFunction<Types.DeleteNotificationTemplateMutation, Types.DeleteNotificationTemplateMutationVariables>;

/**
 * __useDeleteNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationTemplateMutation, { data, loading, error }] = useDeleteNotificationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteNotificationTemplateMutation, Types.DeleteNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteNotificationTemplateMutation, Types.DeleteNotificationTemplateMutationVariables>(DeleteNotificationTemplateDocument, options);
      }
export type DeleteNotificationTemplateMutationHookResult = ReturnType<typeof useDeleteNotificationTemplateMutation>;
export type DeleteNotificationTemplateMutationResult = Apollo.MutationResult<Types.DeleteNotificationTemplateMutation>;
export type DeleteNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<Types.DeleteNotificationTemplateMutation, Types.DeleteNotificationTemplateMutationVariables>;
export const ExternalCreateOrUpdateIngestionDocumentValidationFeedbackDocument = gql`
    mutation ExternalCreateOrUpdateIngestionDocumentValidationFeedback($input: ExternalCreateIngestionDocumentValidationFeedbackInput!) {
  externalCreateOrUpdateIngestionDocumentValidationFeedback(input: $input) {
    ...IngestionDocumentValidationFeedback
  }
}
    ${IngestionDocumentValidationFeedbackFragmentDoc}`;
export type ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationFn = Apollo.MutationFunction<Types.ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, Types.ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables>;

/**
 * __useExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation__
 *
 * To run a mutation, you first call `useExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, { data, loading, error }] = useExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, Types.ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, Types.ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables>(ExternalCreateOrUpdateIngestionDocumentValidationFeedbackDocument, options);
      }
export type ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationHookResult = ReturnType<typeof useExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation>;
export type ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationResult = Apollo.MutationResult<Types.ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation>;
export type ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationOptions = Apollo.BaseMutationOptions<Types.ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, Types.ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables>;
export const ExternalCreateOrUpdateIngestionFolderValidationFeedbackDocument = gql`
    mutation ExternalCreateOrUpdateIngestionFolderValidationFeedback($input: ExternalCreateIngestionFolderValidationFeedbackInput!) {
  externalCreateOrUpdateIngestionFolderValidationFeedback(input: $input) {
    ...IngestionFolderValidationFeedback
  }
}
    ${IngestionFolderValidationFeedbackFragmentDoc}`;
export type ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutationFn = Apollo.MutationFunction<Types.ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation, Types.ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables>;

/**
 * __useExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation__
 *
 * To run a mutation, you first call `useExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalCreateOrUpdateIngestionFolderValidationFeedbackMutation, { data, loading, error }] = useExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation, Types.ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation, Types.ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables>(ExternalCreateOrUpdateIngestionFolderValidationFeedbackDocument, options);
      }
export type ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutationHookResult = ReturnType<typeof useExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation>;
export type ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutationResult = Apollo.MutationResult<Types.ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation>;
export type ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutationOptions = Apollo.BaseMutationOptions<Types.ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation, Types.ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables>;
export const ExternalSubmitValidationReviewsDocument = gql`
    mutation ExternalSubmitValidationReviews($input: ExternalSubmitValidationReviewsInput!) {
  externalSubmitValidationReviews(input: $input) {
    id
    submittedByUserUuid
    totalErrorCount
    hiddenErrorCount
    documentErrorCount
    folderErrorCount
    submittedAt
  }
}
    `;
export type ExternalSubmitValidationReviewsMutationFn = Apollo.MutationFunction<Types.ExternalSubmitValidationReviewsMutation, Types.ExternalSubmitValidationReviewsMutationVariables>;

/**
 * __useExternalSubmitValidationReviewsMutation__
 *
 * To run a mutation, you first call `useExternalSubmitValidationReviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalSubmitValidationReviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalSubmitValidationReviewsMutation, { data, loading, error }] = useExternalSubmitValidationReviewsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalSubmitValidationReviewsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExternalSubmitValidationReviewsMutation, Types.ExternalSubmitValidationReviewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExternalSubmitValidationReviewsMutation, Types.ExternalSubmitValidationReviewsMutationVariables>(ExternalSubmitValidationReviewsDocument, options);
      }
export type ExternalSubmitValidationReviewsMutationHookResult = ReturnType<typeof useExternalSubmitValidationReviewsMutation>;
export type ExternalSubmitValidationReviewsMutationResult = Apollo.MutationResult<Types.ExternalSubmitValidationReviewsMutation>;
export type ExternalSubmitValidationReviewsMutationOptions = Apollo.BaseMutationOptions<Types.ExternalSubmitValidationReviewsMutation, Types.ExternalSubmitValidationReviewsMutationVariables>;
export const ExternalSyncKeyTermsDocument = gql`
    mutation ExternalSyncKeyTerms($input: ExternalSyncKeyTermsInput!) {
  externalSyncKeyTerms(input: $input) {
    success
    externalEntityId
  }
}
    `;
export type ExternalSyncKeyTermsMutationFn = Apollo.MutationFunction<Types.ExternalSyncKeyTermsMutation, Types.ExternalSyncKeyTermsMutationVariables>;

/**
 * __useExternalSyncKeyTermsMutation__
 *
 * To run a mutation, you first call `useExternalSyncKeyTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalSyncKeyTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalSyncKeyTermsMutation, { data, loading, error }] = useExternalSyncKeyTermsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalSyncKeyTermsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExternalSyncKeyTermsMutation, Types.ExternalSyncKeyTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExternalSyncKeyTermsMutation, Types.ExternalSyncKeyTermsMutationVariables>(ExternalSyncKeyTermsDocument, options);
      }
export type ExternalSyncKeyTermsMutationHookResult = ReturnType<typeof useExternalSyncKeyTermsMutation>;
export type ExternalSyncKeyTermsMutationResult = Apollo.MutationResult<Types.ExternalSyncKeyTermsMutation>;
export type ExternalSyncKeyTermsMutationOptions = Apollo.BaseMutationOptions<Types.ExternalSyncKeyTermsMutation, Types.ExternalSyncKeyTermsMutationVariables>;
export const FollowListingDocument = gql`
    mutation followListing($input: FollowListingInput!) {
  followListing(input: $input) {
    isFollowingListing
  }
}
    `;
export type FollowListingMutationFn = Apollo.MutationFunction<Types.FollowListingMutation, Types.FollowListingMutationVariables>;

/**
 * __useFollowListingMutation__
 *
 * To run a mutation, you first call `useFollowListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followListingMutation, { data, loading, error }] = useFollowListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFollowListingMutation(baseOptions?: Apollo.MutationHookOptions<Types.FollowListingMutation, Types.FollowListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.FollowListingMutation, Types.FollowListingMutationVariables>(FollowListingDocument, options);
      }
export type FollowListingMutationHookResult = ReturnType<typeof useFollowListingMutation>;
export type FollowListingMutationResult = Apollo.MutationResult<Types.FollowListingMutation>;
export type FollowListingMutationOptions = Apollo.BaseMutationOptions<Types.FollowListingMutation, Types.FollowListingMutationVariables>;
export const GenerateListingPackagePdfDocument = gql`
    mutation GenerateListingPackagePdf($input: ListingInput!) {
  generateListingPackagePdf(input: $input) {
    fileName
    url
  }
}
    `;
export type GenerateListingPackagePdfMutationFn = Apollo.MutationFunction<Types.GenerateListingPackagePdfMutation, Types.GenerateListingPackagePdfMutationVariables>;

/**
 * __useGenerateListingPackagePdfMutation__
 *
 * To run a mutation, you first call `useGenerateListingPackagePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateListingPackagePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateListingPackagePdfMutation, { data, loading, error }] = useGenerateListingPackagePdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateListingPackagePdfMutation(baseOptions?: Apollo.MutationHookOptions<Types.GenerateListingPackagePdfMutation, Types.GenerateListingPackagePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GenerateListingPackagePdfMutation, Types.GenerateListingPackagePdfMutationVariables>(GenerateListingPackagePdfDocument, options);
      }
export type GenerateListingPackagePdfMutationHookResult = ReturnType<typeof useGenerateListingPackagePdfMutation>;
export type GenerateListingPackagePdfMutationResult = Apollo.MutationResult<Types.GenerateListingPackagePdfMutation>;
export type GenerateListingPackagePdfMutationOptions = Apollo.BaseMutationOptions<Types.GenerateListingPackagePdfMutation, Types.GenerateListingPackagePdfMutationVariables>;
export const GetOrCreateAgentByPhoneNumberDocument = gql`
    mutation GetOrCreateAgentByPhoneNumber($input: GetOrCreateAgentByPhoneNumberInput!) {
  getOrCreateAgentByPhoneNumber(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type GetOrCreateAgentByPhoneNumberMutationFn = Apollo.MutationFunction<Types.GetOrCreateAgentByPhoneNumberMutation, Types.GetOrCreateAgentByPhoneNumberMutationVariables>;

/**
 * __useGetOrCreateAgentByPhoneNumberMutation__
 *
 * To run a mutation, you first call `useGetOrCreateAgentByPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateAgentByPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateAgentByPhoneNumberMutation, { data, loading, error }] = useGetOrCreateAgentByPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrCreateAgentByPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<Types.GetOrCreateAgentByPhoneNumberMutation, Types.GetOrCreateAgentByPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GetOrCreateAgentByPhoneNumberMutation, Types.GetOrCreateAgentByPhoneNumberMutationVariables>(GetOrCreateAgentByPhoneNumberDocument, options);
      }
export type GetOrCreateAgentByPhoneNumberMutationHookResult = ReturnType<typeof useGetOrCreateAgentByPhoneNumberMutation>;
export type GetOrCreateAgentByPhoneNumberMutationResult = Apollo.MutationResult<Types.GetOrCreateAgentByPhoneNumberMutation>;
export type GetOrCreateAgentByPhoneNumberMutationOptions = Apollo.BaseMutationOptions<Types.GetOrCreateAgentByPhoneNumberMutation, Types.GetOrCreateAgentByPhoneNumberMutationVariables>;
export const GetOrCreateConsumerByPhoneNumberDocument = gql`
    mutation GetOrCreateConsumerByPhoneNumber($input: CreateOrUpdateConsumerByPhoneNumberInput!) {
  getOrCreateConsumerByPhoneNumber(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type GetOrCreateConsumerByPhoneNumberMutationFn = Apollo.MutationFunction<Types.GetOrCreateConsumerByPhoneNumberMutation, Types.GetOrCreateConsumerByPhoneNumberMutationVariables>;

/**
 * __useGetOrCreateConsumerByPhoneNumberMutation__
 *
 * To run a mutation, you first call `useGetOrCreateConsumerByPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateConsumerByPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateConsumerByPhoneNumberMutation, { data, loading, error }] = useGetOrCreateConsumerByPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrCreateConsumerByPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<Types.GetOrCreateConsumerByPhoneNumberMutation, Types.GetOrCreateConsumerByPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.GetOrCreateConsumerByPhoneNumberMutation, Types.GetOrCreateConsumerByPhoneNumberMutationVariables>(GetOrCreateConsumerByPhoneNumberDocument, options);
      }
export type GetOrCreateConsumerByPhoneNumberMutationHookResult = ReturnType<typeof useGetOrCreateConsumerByPhoneNumberMutation>;
export type GetOrCreateConsumerByPhoneNumberMutationResult = Apollo.MutationResult<Types.GetOrCreateConsumerByPhoneNumberMutation>;
export type GetOrCreateConsumerByPhoneNumberMutationOptions = Apollo.BaseMutationOptions<Types.GetOrCreateConsumerByPhoneNumberMutation, Types.GetOrCreateConsumerByPhoneNumberMutationVariables>;
export const InternalBatchAddUsersToOrganizationDocument = gql`
    mutation internalBatchAddUsersToOrganization($input: InternalBatchAddUsersToOrganizationInput!) {
  internalBatchAddUsersToOrganization(input: $input) {
    results {
      clientRowId
      success
      user {
        id
        userUuid
        firstName
        lastName
        email
        phoneNumber
        accessRole
      }
      error
    }
    successCount
    failureCount
  }
}
    `;
export type InternalBatchAddUsersToOrganizationMutationFn = Apollo.MutationFunction<Types.InternalBatchAddUsersToOrganizationMutation, Types.InternalBatchAddUsersToOrganizationMutationVariables>;

/**
 * __useInternalBatchAddUsersToOrganizationMutation__
 *
 * To run a mutation, you first call `useInternalBatchAddUsersToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalBatchAddUsersToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalBatchAddUsersToOrganizationMutation, { data, loading, error }] = useInternalBatchAddUsersToOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalBatchAddUsersToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.InternalBatchAddUsersToOrganizationMutation, Types.InternalBatchAddUsersToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InternalBatchAddUsersToOrganizationMutation, Types.InternalBatchAddUsersToOrganizationMutationVariables>(InternalBatchAddUsersToOrganizationDocument, options);
      }
export type InternalBatchAddUsersToOrganizationMutationHookResult = ReturnType<typeof useInternalBatchAddUsersToOrganizationMutation>;
export type InternalBatchAddUsersToOrganizationMutationResult = Apollo.MutationResult<Types.InternalBatchAddUsersToOrganizationMutation>;
export type InternalBatchAddUsersToOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.InternalBatchAddUsersToOrganizationMutation, Types.InternalBatchAddUsersToOrganizationMutationVariables>;
export const InternalEssentialsNotificationActionExecuteDocument = gql`
    mutation internalEssentialsNotificationActionExecute($input: InternalEssentialsNotificationActionExecuteInput!) {
  internalEssentialsNotificationActionExecute(input: $input) {
    success
    message
    postActionSummary
  }
}
    `;
export type InternalEssentialsNotificationActionExecuteMutationFn = Apollo.MutationFunction<Types.InternalEssentialsNotificationActionExecuteMutation, Types.InternalEssentialsNotificationActionExecuteMutationVariables>;

/**
 * __useInternalEssentialsNotificationActionExecuteMutation__
 *
 * To run a mutation, you first call `useInternalEssentialsNotificationActionExecuteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalEssentialsNotificationActionExecuteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalEssentialsNotificationActionExecuteMutation, { data, loading, error }] = useInternalEssentialsNotificationActionExecuteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalEssentialsNotificationActionExecuteMutation(baseOptions?: Apollo.MutationHookOptions<Types.InternalEssentialsNotificationActionExecuteMutation, Types.InternalEssentialsNotificationActionExecuteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InternalEssentialsNotificationActionExecuteMutation, Types.InternalEssentialsNotificationActionExecuteMutationVariables>(InternalEssentialsNotificationActionExecuteDocument, options);
      }
export type InternalEssentialsNotificationActionExecuteMutationHookResult = ReturnType<typeof useInternalEssentialsNotificationActionExecuteMutation>;
export type InternalEssentialsNotificationActionExecuteMutationResult = Apollo.MutationResult<Types.InternalEssentialsNotificationActionExecuteMutation>;
export type InternalEssentialsNotificationActionExecuteMutationOptions = Apollo.BaseMutationOptions<Types.InternalEssentialsNotificationActionExecuteMutation, Types.InternalEssentialsNotificationActionExecuteMutationVariables>;
export const InternalEssentialsNotificationActionPreviewDocument = gql`
    mutation internalEssentialsNotificationActionPreview($input: InternalEssentialsNotificationActionPreviewInput!) {
  internalEssentialsNotificationActionPreview(input: $input) {
    previewToken
    actionKind
    targetIds
    currentState
    proposedState
    warnings
  }
}
    `;
export type InternalEssentialsNotificationActionPreviewMutationFn = Apollo.MutationFunction<Types.InternalEssentialsNotificationActionPreviewMutation, Types.InternalEssentialsNotificationActionPreviewMutationVariables>;

/**
 * __useInternalEssentialsNotificationActionPreviewMutation__
 *
 * To run a mutation, you first call `useInternalEssentialsNotificationActionPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalEssentialsNotificationActionPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalEssentialsNotificationActionPreviewMutation, { data, loading, error }] = useInternalEssentialsNotificationActionPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalEssentialsNotificationActionPreviewMutation(baseOptions?: Apollo.MutationHookOptions<Types.InternalEssentialsNotificationActionPreviewMutation, Types.InternalEssentialsNotificationActionPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InternalEssentialsNotificationActionPreviewMutation, Types.InternalEssentialsNotificationActionPreviewMutationVariables>(InternalEssentialsNotificationActionPreviewDocument, options);
      }
export type InternalEssentialsNotificationActionPreviewMutationHookResult = ReturnType<typeof useInternalEssentialsNotificationActionPreviewMutation>;
export type InternalEssentialsNotificationActionPreviewMutationResult = Apollo.MutationResult<Types.InternalEssentialsNotificationActionPreviewMutation>;
export type InternalEssentialsNotificationActionPreviewMutationOptions = Apollo.BaseMutationOptions<Types.InternalEssentialsNotificationActionPreviewMutation, Types.InternalEssentialsNotificationActionPreviewMutationVariables>;
export const InternalUpdateOrganizationComplianceDashboardSettingsDocument = gql`
    mutation internalUpdateOrganizationComplianceDashboardSettings($input: UpdateOrganizationComplianceDashboardSettingsInput!) {
  internalUpdateOrganizationComplianceDashboardSettings(input: $input) {
    id
    officeSections {
      label
      officeValues
      value
    }
    updatedAt
  }
}
    `;
export type InternalUpdateOrganizationComplianceDashboardSettingsMutationFn = Apollo.MutationFunction<Types.InternalUpdateOrganizationComplianceDashboardSettingsMutation, Types.InternalUpdateOrganizationComplianceDashboardSettingsMutationVariables>;

/**
 * __useInternalUpdateOrganizationComplianceDashboardSettingsMutation__
 *
 * To run a mutation, you first call `useInternalUpdateOrganizationComplianceDashboardSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalUpdateOrganizationComplianceDashboardSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalUpdateOrganizationComplianceDashboardSettingsMutation, { data, loading, error }] = useInternalUpdateOrganizationComplianceDashboardSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalUpdateOrganizationComplianceDashboardSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.InternalUpdateOrganizationComplianceDashboardSettingsMutation, Types.InternalUpdateOrganizationComplianceDashboardSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InternalUpdateOrganizationComplianceDashboardSettingsMutation, Types.InternalUpdateOrganizationComplianceDashboardSettingsMutationVariables>(InternalUpdateOrganizationComplianceDashboardSettingsDocument, options);
      }
export type InternalUpdateOrganizationComplianceDashboardSettingsMutationHookResult = ReturnType<typeof useInternalUpdateOrganizationComplianceDashboardSettingsMutation>;
export type InternalUpdateOrganizationComplianceDashboardSettingsMutationResult = Apollo.MutationResult<Types.InternalUpdateOrganizationComplianceDashboardSettingsMutation>;
export type InternalUpdateOrganizationComplianceDashboardSettingsMutationOptions = Apollo.BaseMutationOptions<Types.InternalUpdateOrganizationComplianceDashboardSettingsMutation, Types.InternalUpdateOrganizationComplianceDashboardSettingsMutationVariables>;
export const JoinOrganizationDocument = gql`
    mutation joinOrganization($input: JoinOrganizationInput!) {
  joinOrganization(input: $input)
}
    `;
export type JoinOrganizationMutationFn = Apollo.MutationFunction<Types.JoinOrganizationMutation, Types.JoinOrganizationMutationVariables>;

/**
 * __useJoinOrganizationMutation__
 *
 * To run a mutation, you first call `useJoinOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinOrganizationMutation, { data, loading, error }] = useJoinOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<Types.JoinOrganizationMutation, Types.JoinOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.JoinOrganizationMutation, Types.JoinOrganizationMutationVariables>(JoinOrganizationDocument, options);
      }
export type JoinOrganizationMutationHookResult = ReturnType<typeof useJoinOrganizationMutation>;
export type JoinOrganizationMutationResult = Apollo.MutationResult<Types.JoinOrganizationMutation>;
export type JoinOrganizationMutationOptions = Apollo.BaseMutationOptions<Types.JoinOrganizationMutation, Types.JoinOrganizationMutationVariables>;
export const UpdateUserNotificationSettingsDocument = gql`
    mutation UpdateUserNotificationSettings($input: NotificationSettingsInput!) {
  updateUserNotificationSettings(input: $input) {
    email
    sms
  }
}
    `;
export type UpdateUserNotificationSettingsMutationFn = Apollo.MutationFunction<Types.UpdateUserNotificationSettingsMutation, Types.UpdateUserNotificationSettingsMutationVariables>;

/**
 * __useUpdateUserNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationSettingsMutation, { data, loading, error }] = useUpdateUserNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserNotificationSettingsMutation, Types.UpdateUserNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserNotificationSettingsMutation, Types.UpdateUserNotificationSettingsMutationVariables>(UpdateUserNotificationSettingsDocument, options);
      }
export type UpdateUserNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateUserNotificationSettingsMutation>;
export type UpdateUserNotificationSettingsMutationResult = Apollo.MutationResult<Types.UpdateUserNotificationSettingsMutation>;
export type UpdateUserNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserNotificationSettingsMutation, Types.UpdateUserNotificationSettingsMutationVariables>;
export const CreateOpenHouseDocument = gql`
    mutation CreateOpenHouse($input: CreateOpenHouseInput!) {
  createOpenHouse(input: $input) {
    openHouse {
      ...OpenHouseCard
    }
  }
}
    ${OpenHouseCardFragmentDoc}`;
export type CreateOpenHouseMutationFn = Apollo.MutationFunction<Types.CreateOpenHouseMutation, Types.CreateOpenHouseMutationVariables>;

/**
 * __useCreateOpenHouseMutation__
 *
 * To run a mutation, you first call `useCreateOpenHouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpenHouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpenHouseMutation, { data, loading, error }] = useCreateOpenHouseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpenHouseMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOpenHouseMutation, Types.CreateOpenHouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOpenHouseMutation, Types.CreateOpenHouseMutationVariables>(CreateOpenHouseDocument, options);
      }
export type CreateOpenHouseMutationHookResult = ReturnType<typeof useCreateOpenHouseMutation>;
export type CreateOpenHouseMutationResult = Apollo.MutationResult<Types.CreateOpenHouseMutation>;
export type CreateOpenHouseMutationOptions = Apollo.BaseMutationOptions<Types.CreateOpenHouseMutation, Types.CreateOpenHouseMutationVariables>;
export const UpdateOpenHouseDocument = gql`
    mutation UpdateOpenHouse($input: UpdateOpenHouseInput!) {
  updateOpenHouse(input: $input) {
    openHouse {
      ...OpenHouseCard
    }
  }
}
    ${OpenHouseCardFragmentDoc}`;
export type UpdateOpenHouseMutationFn = Apollo.MutationFunction<Types.UpdateOpenHouseMutation, Types.UpdateOpenHouseMutationVariables>;

/**
 * __useUpdateOpenHouseMutation__
 *
 * To run a mutation, you first call `useUpdateOpenHouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpenHouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpenHouseMutation, { data, loading, error }] = useUpdateOpenHouseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpenHouseMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOpenHouseMutation, Types.UpdateOpenHouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOpenHouseMutation, Types.UpdateOpenHouseMutationVariables>(UpdateOpenHouseDocument, options);
      }
export type UpdateOpenHouseMutationHookResult = ReturnType<typeof useUpdateOpenHouseMutation>;
export type UpdateOpenHouseMutationResult = Apollo.MutationResult<Types.UpdateOpenHouseMutation>;
export type UpdateOpenHouseMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOpenHouseMutation, Types.UpdateOpenHouseMutationVariables>;
export const DeleteOpenHouseDocument = gql`
    mutation DeleteOpenHouse($input: DeleteOpenHouseInput!) {
  deleteOpenHouse(input: $input) {
    success
  }
}
    `;
export type DeleteOpenHouseMutationFn = Apollo.MutationFunction<Types.DeleteOpenHouseMutation, Types.DeleteOpenHouseMutationVariables>;

/**
 * __useDeleteOpenHouseMutation__
 *
 * To run a mutation, you first call `useDeleteOpenHouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpenHouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpenHouseMutation, { data, loading, error }] = useDeleteOpenHouseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOpenHouseMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOpenHouseMutation, Types.DeleteOpenHouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOpenHouseMutation, Types.DeleteOpenHouseMutationVariables>(DeleteOpenHouseDocument, options);
      }
export type DeleteOpenHouseMutationHookResult = ReturnType<typeof useDeleteOpenHouseMutation>;
export type DeleteOpenHouseMutationResult = Apollo.MutationResult<Types.DeleteOpenHouseMutation>;
export type DeleteOpenHouseMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOpenHouseMutation, Types.DeleteOpenHouseMutationVariables>;
export const CreateOrganizationPartnerDocument = gql`
    mutation CreateOrganizationPartner($input: CreateOrganizationPartnerInput!) {
  createOrganizationPartner(input: $input) {
    ...OrganizationPartnerItem
  }
}
    ${OrganizationPartnerItemFragmentDoc}`;
export type CreateOrganizationPartnerMutationFn = Apollo.MutationFunction<Types.CreateOrganizationPartnerMutation, Types.CreateOrganizationPartnerMutationVariables>;

/**
 * __useCreateOrganizationPartnerMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationPartnerMutation, { data, loading, error }] = useCreateOrganizationPartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationPartnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrganizationPartnerMutation, Types.CreateOrganizationPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrganizationPartnerMutation, Types.CreateOrganizationPartnerMutationVariables>(CreateOrganizationPartnerDocument, options);
      }
export type CreateOrganizationPartnerMutationHookResult = ReturnType<typeof useCreateOrganizationPartnerMutation>;
export type CreateOrganizationPartnerMutationResult = Apollo.MutationResult<Types.CreateOrganizationPartnerMutation>;
export type CreateOrganizationPartnerMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrganizationPartnerMutation, Types.CreateOrganizationPartnerMutationVariables>;
export const UpdateOrganizationPartnerDocument = gql`
    mutation UpdateOrganizationPartner($input: UpdateOrganizationPartnerInput!) {
  updateOrganizationPartner(input: $input) {
    ...OrganizationPartnerItem
  }
}
    ${OrganizationPartnerItemFragmentDoc}`;
export type UpdateOrganizationPartnerMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationPartnerMutation, Types.UpdateOrganizationPartnerMutationVariables>;

/**
 * __useUpdateOrganizationPartnerMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPartnerMutation, { data, loading, error }] = useUpdateOrganizationPartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationPartnerMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationPartnerMutation, Types.UpdateOrganizationPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationPartnerMutation, Types.UpdateOrganizationPartnerMutationVariables>(UpdateOrganizationPartnerDocument, options);
      }
export type UpdateOrganizationPartnerMutationHookResult = ReturnType<typeof useUpdateOrganizationPartnerMutation>;
export type UpdateOrganizationPartnerMutationResult = Apollo.MutationResult<Types.UpdateOrganizationPartnerMutation>;
export type UpdateOrganizationPartnerMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationPartnerMutation, Types.UpdateOrganizationPartnerMutationVariables>;
export const UpsertOrganizationPartnerStageIntroDocument = gql`
    mutation UpsertOrganizationPartnerStageIntro($input: UpsertOrganizationPartnerStageIntroInput!) {
  upsertOrganizationPartnerStageIntro(input: $input) {
    ...OrganizationPartnerStageIntroItem
  }
}
    ${OrganizationPartnerStageIntroItemFragmentDoc}`;
export type UpsertOrganizationPartnerStageIntroMutationFn = Apollo.MutationFunction<Types.UpsertOrganizationPartnerStageIntroMutation, Types.UpsertOrganizationPartnerStageIntroMutationVariables>;

/**
 * __useUpsertOrganizationPartnerStageIntroMutation__
 *
 * To run a mutation, you first call `useUpsertOrganizationPartnerStageIntroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrganizationPartnerStageIntroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrganizationPartnerStageIntroMutation, { data, loading, error }] = useUpsertOrganizationPartnerStageIntroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOrganizationPartnerStageIntroMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpsertOrganizationPartnerStageIntroMutation, Types.UpsertOrganizationPartnerStageIntroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpsertOrganizationPartnerStageIntroMutation, Types.UpsertOrganizationPartnerStageIntroMutationVariables>(UpsertOrganizationPartnerStageIntroDocument, options);
      }
export type UpsertOrganizationPartnerStageIntroMutationHookResult = ReturnType<typeof useUpsertOrganizationPartnerStageIntroMutation>;
export type UpsertOrganizationPartnerStageIntroMutationResult = Apollo.MutationResult<Types.UpsertOrganizationPartnerStageIntroMutation>;
export type UpsertOrganizationPartnerStageIntroMutationOptions = Apollo.BaseMutationOptions<Types.UpsertOrganizationPartnerStageIntroMutation, Types.UpsertOrganizationPartnerStageIntroMutationVariables>;
export const DeleteOrganizationPartnerStageIntroDocument = gql`
    mutation DeleteOrganizationPartnerStageIntro($id: ID!) {
  deleteOrganizationPartnerStageIntro(id: $id)
}
    `;
export type DeleteOrganizationPartnerStageIntroMutationFn = Apollo.MutationFunction<Types.DeleteOrganizationPartnerStageIntroMutation, Types.DeleteOrganizationPartnerStageIntroMutationVariables>;

/**
 * __useDeleteOrganizationPartnerStageIntroMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationPartnerStageIntroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationPartnerStageIntroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationPartnerStageIntroMutation, { data, loading, error }] = useDeleteOrganizationPartnerStageIntroMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationPartnerStageIntroMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteOrganizationPartnerStageIntroMutation, Types.DeleteOrganizationPartnerStageIntroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteOrganizationPartnerStageIntroMutation, Types.DeleteOrganizationPartnerStageIntroMutationVariables>(DeleteOrganizationPartnerStageIntroDocument, options);
      }
export type DeleteOrganizationPartnerStageIntroMutationHookResult = ReturnType<typeof useDeleteOrganizationPartnerStageIntroMutation>;
export type DeleteOrganizationPartnerStageIntroMutationResult = Apollo.MutationResult<Types.DeleteOrganizationPartnerStageIntroMutation>;
export type DeleteOrganizationPartnerStageIntroMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrganizationPartnerStageIntroMutation, Types.DeleteOrganizationPartnerStageIntroMutationVariables>;
export const UpdateOrCreateOrganizationRosterPreferenceDocument = gql`
    mutation UpdateOrCreateOrganizationRosterPreference($input: UpdateOrCreateOrganizationRosterPreferenceInput!) {
  updateOrCreateOrganizationRosterPreference(input: $input) {
    id
    partnerType
    preferenceType
    partner {
      id
      name
    }
    partnerContact {
      id
      firstName
      lastName
      partner {
        id
        name
      }
    }
    roster {
      id
      preferences {
        id
        partnerType
        preferenceType
        partner {
          id
          name
        }
        partnerContact {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export type UpdateOrCreateOrganizationRosterPreferenceMutationFn = Apollo.MutationFunction<Types.UpdateOrCreateOrganizationRosterPreferenceMutation, Types.UpdateOrCreateOrganizationRosterPreferenceMutationVariables>;

/**
 * __useUpdateOrCreateOrganizationRosterPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateOrganizationRosterPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateOrganizationRosterPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateOrganizationRosterPreferenceMutation, { data, loading, error }] = useUpdateOrCreateOrganizationRosterPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreateOrganizationRosterPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrCreateOrganizationRosterPreferenceMutation, Types.UpdateOrCreateOrganizationRosterPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrCreateOrganizationRosterPreferenceMutation, Types.UpdateOrCreateOrganizationRosterPreferenceMutationVariables>(UpdateOrCreateOrganizationRosterPreferenceDocument, options);
      }
export type UpdateOrCreateOrganizationRosterPreferenceMutationHookResult = ReturnType<typeof useUpdateOrCreateOrganizationRosterPreferenceMutation>;
export type UpdateOrCreateOrganizationRosterPreferenceMutationResult = Apollo.MutationResult<Types.UpdateOrCreateOrganizationRosterPreferenceMutation>;
export type UpdateOrCreateOrganizationRosterPreferenceMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrCreateOrganizationRosterPreferenceMutation, Types.UpdateOrCreateOrganizationRosterPreferenceMutationVariables>;
export const UpdateOrganizationRosterEntryDocument = gql`
    mutation UpdateOrganizationRosterEntry($input: UpdateOrganizationRosterEntryInput!) {
  updateOrganizationRosterEntry(input: $input) {
    id
    isContactable
  }
}
    `;
export type UpdateOrganizationRosterEntryMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationRosterEntryMutation, Types.UpdateOrganizationRosterEntryMutationVariables>;

/**
 * __useUpdateOrganizationRosterEntryMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationRosterEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationRosterEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationRosterEntryMutation, { data, loading, error }] = useUpdateOrganizationRosterEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationRosterEntryMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationRosterEntryMutation, Types.UpdateOrganizationRosterEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationRosterEntryMutation, Types.UpdateOrganizationRosterEntryMutationVariables>(UpdateOrganizationRosterEntryDocument, options);
      }
export type UpdateOrganizationRosterEntryMutationHookResult = ReturnType<typeof useUpdateOrganizationRosterEntryMutation>;
export type UpdateOrganizationRosterEntryMutationResult = Apollo.MutationResult<Types.UpdateOrganizationRosterEntryMutation>;
export type UpdateOrganizationRosterEntryMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationRosterEntryMutation, Types.UpdateOrganizationRosterEntryMutationVariables>;
export const CreateOrganizationRosterEntryDocument = gql`
    mutation CreateOrganizationRosterEntry($input: CreateOrganizationRosterEntryInput!) {
  createOrganizationRosterEntry(input: $input) {
    ...OrganizationRosterItem
  }
}
    ${OrganizationRosterItemFragmentDoc}`;
export type CreateOrganizationRosterEntryMutationFn = Apollo.MutationFunction<Types.CreateOrganizationRosterEntryMutation, Types.CreateOrganizationRosterEntryMutationVariables>;

/**
 * __useCreateOrganizationRosterEntryMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationRosterEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationRosterEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationRosterEntryMutation, { data, loading, error }] = useCreateOrganizationRosterEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationRosterEntryMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrganizationRosterEntryMutation, Types.CreateOrganizationRosterEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrganizationRosterEntryMutation, Types.CreateOrganizationRosterEntryMutationVariables>(CreateOrganizationRosterEntryDocument, options);
      }
export type CreateOrganizationRosterEntryMutationHookResult = ReturnType<typeof useCreateOrganizationRosterEntryMutation>;
export type CreateOrganizationRosterEntryMutationResult = Apollo.MutationResult<Types.CreateOrganizationRosterEntryMutation>;
export type CreateOrganizationRosterEntryMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrganizationRosterEntryMutation, Types.CreateOrganizationRosterEntryMutationVariables>;
export const AddLoanOfficerContactDocument = gql`
    mutation AddLoanOfficerContact($input: AddLoanOfficerContactInput!) {
  addLoanOfficerContact(input: $input) {
    ...PartnerContact
  }
}
    ${PartnerContactFragmentDoc}`;
export type AddLoanOfficerContactMutationFn = Apollo.MutationFunction<Types.AddLoanOfficerContactMutation, Types.AddLoanOfficerContactMutationVariables>;

/**
 * __useAddLoanOfficerContactMutation__
 *
 * To run a mutation, you first call `useAddLoanOfficerContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLoanOfficerContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLoanOfficerContactMutation, { data, loading, error }] = useAddLoanOfficerContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLoanOfficerContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddLoanOfficerContactMutation, Types.AddLoanOfficerContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddLoanOfficerContactMutation, Types.AddLoanOfficerContactMutationVariables>(AddLoanOfficerContactDocument, options);
      }
export type AddLoanOfficerContactMutationHookResult = ReturnType<typeof useAddLoanOfficerContactMutation>;
export type AddLoanOfficerContactMutationResult = Apollo.MutationResult<Types.AddLoanOfficerContactMutation>;
export type AddLoanOfficerContactMutationOptions = Apollo.BaseMutationOptions<Types.AddLoanOfficerContactMutation, Types.AddLoanOfficerContactMutationVariables>;
export const AddTitleAgentContactDocument = gql`
    mutation AddTitleAgentContact($input: AddTitleAgentContactInput!) {
  addTitleAgentContact(input: $input) {
    ...PartnerContact
  }
}
    ${PartnerContactFragmentDoc}`;
export type AddTitleAgentContactMutationFn = Apollo.MutationFunction<Types.AddTitleAgentContactMutation, Types.AddTitleAgentContactMutationVariables>;

/**
 * __useAddTitleAgentContactMutation__
 *
 * To run a mutation, you first call `useAddTitleAgentContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTitleAgentContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTitleAgentContactMutation, { data, loading, error }] = useAddTitleAgentContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTitleAgentContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddTitleAgentContactMutation, Types.AddTitleAgentContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddTitleAgentContactMutation, Types.AddTitleAgentContactMutationVariables>(AddTitleAgentContactDocument, options);
      }
export type AddTitleAgentContactMutationHookResult = ReturnType<typeof useAddTitleAgentContactMutation>;
export type AddTitleAgentContactMutationResult = Apollo.MutationResult<Types.AddTitleAgentContactMutation>;
export type AddTitleAgentContactMutationOptions = Apollo.BaseMutationOptions<Types.AddTitleAgentContactMutation, Types.AddTitleAgentContactMutationVariables>;
export const AddInsuranceAgentContactDocument = gql`
    mutation AddInsuranceAgentContact($input: AddInsuranceAgentContactInput!) {
  addInsuranceAgentContact(input: $input) {
    ...PartnerContact
  }
}
    ${PartnerContactFragmentDoc}`;
export type AddInsuranceAgentContactMutationFn = Apollo.MutationFunction<Types.AddInsuranceAgentContactMutation, Types.AddInsuranceAgentContactMutationVariables>;

/**
 * __useAddInsuranceAgentContactMutation__
 *
 * To run a mutation, you first call `useAddInsuranceAgentContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInsuranceAgentContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInsuranceAgentContactMutation, { data, loading, error }] = useAddInsuranceAgentContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInsuranceAgentContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddInsuranceAgentContactMutation, Types.AddInsuranceAgentContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddInsuranceAgentContactMutation, Types.AddInsuranceAgentContactMutationVariables>(AddInsuranceAgentContactDocument, options);
      }
export type AddInsuranceAgentContactMutationHookResult = ReturnType<typeof useAddInsuranceAgentContactMutation>;
export type AddInsuranceAgentContactMutationResult = Apollo.MutationResult<Types.AddInsuranceAgentContactMutation>;
export type AddInsuranceAgentContactMutationOptions = Apollo.BaseMutationOptions<Types.AddInsuranceAgentContactMutation, Types.AddInsuranceAgentContactMutationVariables>;
export const UpdatePartnerContactDocument = gql`
    mutation UpdatePartnerContact($input: UpdatePartnerContactInput!) {
  updatePartnerContact(input: $input) {
    ...PartnerContact
  }
}
    ${PartnerContactFragmentDoc}`;
export type UpdatePartnerContactMutationFn = Apollo.MutationFunction<Types.UpdatePartnerContactMutation, Types.UpdatePartnerContactMutationVariables>;

/**
 * __useUpdatePartnerContactMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerContactMutation, { data, loading, error }] = useUpdatePartnerContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartnerContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePartnerContactMutation, Types.UpdatePartnerContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePartnerContactMutation, Types.UpdatePartnerContactMutationVariables>(UpdatePartnerContactDocument, options);
      }
export type UpdatePartnerContactMutationHookResult = ReturnType<typeof useUpdatePartnerContactMutation>;
export type UpdatePartnerContactMutationResult = Apollo.MutationResult<Types.UpdatePartnerContactMutation>;
export type UpdatePartnerContactMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePartnerContactMutation, Types.UpdatePartnerContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($id: ID!) {
  deleteContact(id: $id)
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<Types.DeleteContactMutation, Types.DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteContactMutation, Types.DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteContactMutation, Types.DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<Types.DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<Types.DeleteContactMutation, Types.DeleteContactMutationVariables>;
export const PublishNotificationTemplatesDocument = gql`
    mutation PublishNotificationTemplates($partnerId: ID!) {
  publishNotificationTemplates(partnerId: $partnerId) {
    ...NotificationTemplateListItem
  }
}
    ${NotificationTemplateListItemFragmentDoc}`;
export type PublishNotificationTemplatesMutationFn = Apollo.MutationFunction<Types.PublishNotificationTemplatesMutation, Types.PublishNotificationTemplatesMutationVariables>;

/**
 * __usePublishNotificationTemplatesMutation__
 *
 * To run a mutation, you first call `usePublishNotificationTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishNotificationTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishNotificationTemplatesMutation, { data, loading, error }] = usePublishNotificationTemplatesMutation({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function usePublishNotificationTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<Types.PublishNotificationTemplatesMutation, Types.PublishNotificationTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PublishNotificationTemplatesMutation, Types.PublishNotificationTemplatesMutationVariables>(PublishNotificationTemplatesDocument, options);
      }
export type PublishNotificationTemplatesMutationHookResult = ReturnType<typeof usePublishNotificationTemplatesMutation>;
export type PublishNotificationTemplatesMutationResult = Apollo.MutationResult<Types.PublishNotificationTemplatesMutation>;
export type PublishNotificationTemplatesMutationOptions = Apollo.BaseMutationOptions<Types.PublishNotificationTemplatesMutation, Types.PublishNotificationTemplatesMutationVariables>;
export const QueueAnalyzeForOfferIngestionJobDocument = gql`
    mutation QueueAnalyzeForOfferIngestionJob($input: QueueAnalyzeForOfferIngestionJobInput!) {
  queueAnalyzeForOfferIngestionJob(input: $input) {
    queuedJobsCount
  }
}
    `;
export type QueueAnalyzeForOfferIngestionJobMutationFn = Apollo.MutationFunction<Types.QueueAnalyzeForOfferIngestionJobMutation, Types.QueueAnalyzeForOfferIngestionJobMutationVariables>;

/**
 * __useQueueAnalyzeForOfferIngestionJobMutation__
 *
 * To run a mutation, you first call `useQueueAnalyzeForOfferIngestionJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueAnalyzeForOfferIngestionJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueAnalyzeForOfferIngestionJobMutation, { data, loading, error }] = useQueueAnalyzeForOfferIngestionJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQueueAnalyzeForOfferIngestionJobMutation(baseOptions?: Apollo.MutationHookOptions<Types.QueueAnalyzeForOfferIngestionJobMutation, Types.QueueAnalyzeForOfferIngestionJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.QueueAnalyzeForOfferIngestionJobMutation, Types.QueueAnalyzeForOfferIngestionJobMutationVariables>(QueueAnalyzeForOfferIngestionJobDocument, options);
      }
export type QueueAnalyzeForOfferIngestionJobMutationHookResult = ReturnType<typeof useQueueAnalyzeForOfferIngestionJobMutation>;
export type QueueAnalyzeForOfferIngestionJobMutationResult = Apollo.MutationResult<Types.QueueAnalyzeForOfferIngestionJobMutation>;
export type QueueAnalyzeForOfferIngestionJobMutationOptions = Apollo.BaseMutationOptions<Types.QueueAnalyzeForOfferIngestionJobMutation, Types.QueueAnalyzeForOfferIngestionJobMutationVariables>;
export const RemoveDryRunNotificationLogsDocument = gql`
    mutation removeDryRunNotificationLogs($input: RemoveDryRunNotificationLogsInput!) {
  removeDryRunNotificationLogs(input: $input) {
    deletedCount
    success
  }
}
    `;
export type RemoveDryRunNotificationLogsMutationFn = Apollo.MutationFunction<Types.RemoveDryRunNotificationLogsMutation, Types.RemoveDryRunNotificationLogsMutationVariables>;

/**
 * __useRemoveDryRunNotificationLogsMutation__
 *
 * To run a mutation, you first call `useRemoveDryRunNotificationLogsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDryRunNotificationLogsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDryRunNotificationLogsMutation, { data, loading, error }] = useRemoveDryRunNotificationLogsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDryRunNotificationLogsMutation(baseOptions?: Apollo.MutationHookOptions<Types.RemoveDryRunNotificationLogsMutation, Types.RemoveDryRunNotificationLogsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RemoveDryRunNotificationLogsMutation, Types.RemoveDryRunNotificationLogsMutationVariables>(RemoveDryRunNotificationLogsDocument, options);
      }
export type RemoveDryRunNotificationLogsMutationHookResult = ReturnType<typeof useRemoveDryRunNotificationLogsMutation>;
export type RemoveDryRunNotificationLogsMutationResult = Apollo.MutationResult<Types.RemoveDryRunNotificationLogsMutation>;
export type RemoveDryRunNotificationLogsMutationOptions = Apollo.BaseMutationOptions<Types.RemoveDryRunNotificationLogsMutation, Types.RemoveDryRunNotificationLogsMutationVariables>;
export const ReorderNotificationTemplatesDocument = gql`
    mutation ReorderNotificationTemplates($input: [ReorderNotificationTemplateInput!]!) {
  reorderNotificationTemplates(input: $input)
}
    `;
export type ReorderNotificationTemplatesMutationFn = Apollo.MutationFunction<Types.ReorderNotificationTemplatesMutation, Types.ReorderNotificationTemplatesMutationVariables>;

/**
 * __useReorderNotificationTemplatesMutation__
 *
 * To run a mutation, you first call `useReorderNotificationTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderNotificationTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderNotificationTemplatesMutation, { data, loading, error }] = useReorderNotificationTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderNotificationTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReorderNotificationTemplatesMutation, Types.ReorderNotificationTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReorderNotificationTemplatesMutation, Types.ReorderNotificationTemplatesMutationVariables>(ReorderNotificationTemplatesDocument, options);
      }
export type ReorderNotificationTemplatesMutationHookResult = ReturnType<typeof useReorderNotificationTemplatesMutation>;
export type ReorderNotificationTemplatesMutationResult = Apollo.MutationResult<Types.ReorderNotificationTemplatesMutation>;
export type ReorderNotificationTemplatesMutationOptions = Apollo.BaseMutationOptions<Types.ReorderNotificationTemplatesMutation, Types.ReorderNotificationTemplatesMutationVariables>;
export const ResendBoaShareLinkDocument = gql`
    mutation ResendBOAShareLink($token: String!) {
  resendBOAShareLink(token: $token)
}
    `;
export type ResendBoaShareLinkMutationFn = Apollo.MutationFunction<Types.ResendBoaShareLinkMutation, Types.ResendBoaShareLinkMutationVariables>;

/**
 * __useResendBoaShareLinkMutation__
 *
 * To run a mutation, you first call `useResendBoaShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendBoaShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendBoaShareLinkMutation, { data, loading, error }] = useResendBoaShareLinkMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResendBoaShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResendBoaShareLinkMutation, Types.ResendBoaShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResendBoaShareLinkMutation, Types.ResendBoaShareLinkMutationVariables>(ResendBoaShareLinkDocument, options);
      }
export type ResendBoaShareLinkMutationHookResult = ReturnType<typeof useResendBoaShareLinkMutation>;
export type ResendBoaShareLinkMutationResult = Apollo.MutationResult<Types.ResendBoaShareLinkMutation>;
export type ResendBoaShareLinkMutationOptions = Apollo.BaseMutationOptions<Types.ResendBoaShareLinkMutation, Types.ResendBoaShareLinkMutationVariables>;
export const ResendListingReportShareLinkDocument = gql`
    mutation resendListingReportShareLink($token: String!) {
  resendListingReportShareLink(token: $token)
}
    `;
export type ResendListingReportShareLinkMutationFn = Apollo.MutationFunction<Types.ResendListingReportShareLinkMutation, Types.ResendListingReportShareLinkMutationVariables>;

/**
 * __useResendListingReportShareLinkMutation__
 *
 * To run a mutation, you first call `useResendListingReportShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendListingReportShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendListingReportShareLinkMutation, { data, loading, error }] = useResendListingReportShareLinkMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResendListingReportShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.ResendListingReportShareLinkMutation, Types.ResendListingReportShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ResendListingReportShareLinkMutation, Types.ResendListingReportShareLinkMutationVariables>(ResendListingReportShareLinkDocument, options);
      }
export type ResendListingReportShareLinkMutationHookResult = ReturnType<typeof useResendListingReportShareLinkMutation>;
export type ResendListingReportShareLinkMutationResult = Apollo.MutationResult<Types.ResendListingReportShareLinkMutation>;
export type ResendListingReportShareLinkMutationOptions = Apollo.BaseMutationOptions<Types.ResendListingReportShareLinkMutation, Types.ResendListingReportShareLinkMutationVariables>;
export const RevokeBoaShareLinkDocument = gql`
    mutation RevokeBOAShareLink($input: RevokeBOAShareLinkInput!) {
  revokeBOAShareLink(input: $input) {
    ...ShareLink
  }
}
    ${ShareLinkFragmentDoc}`;
export type RevokeBoaShareLinkMutationFn = Apollo.MutationFunction<Types.RevokeBoaShareLinkMutation, Types.RevokeBoaShareLinkMutationVariables>;

/**
 * __useRevokeBoaShareLinkMutation__
 *
 * To run a mutation, you first call `useRevokeBoaShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeBoaShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeBoaShareLinkMutation, { data, loading, error }] = useRevokeBoaShareLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeBoaShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.RevokeBoaShareLinkMutation, Types.RevokeBoaShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RevokeBoaShareLinkMutation, Types.RevokeBoaShareLinkMutationVariables>(RevokeBoaShareLinkDocument, options);
      }
export type RevokeBoaShareLinkMutationHookResult = ReturnType<typeof useRevokeBoaShareLinkMutation>;
export type RevokeBoaShareLinkMutationResult = Apollo.MutationResult<Types.RevokeBoaShareLinkMutation>;
export type RevokeBoaShareLinkMutationOptions = Apollo.BaseMutationOptions<Types.RevokeBoaShareLinkMutation, Types.RevokeBoaShareLinkMutationVariables>;
export const RevokeInvitationDocument = gql`
    mutation revokeInvitation($id: ID!) {
  revokeInvitation(id: $id)
}
    `;
export type RevokeInvitationMutationFn = Apollo.MutationFunction<Types.RevokeInvitationMutation, Types.RevokeInvitationMutationVariables>;

/**
 * __useRevokeInvitationMutation__
 *
 * To run a mutation, you first call `useRevokeInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeInvitationMutation, { data, loading, error }] = useRevokeInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeInvitationMutation(baseOptions?: Apollo.MutationHookOptions<Types.RevokeInvitationMutation, Types.RevokeInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RevokeInvitationMutation, Types.RevokeInvitationMutationVariables>(RevokeInvitationDocument, options);
      }
export type RevokeInvitationMutationHookResult = ReturnType<typeof useRevokeInvitationMutation>;
export type RevokeInvitationMutationResult = Apollo.MutationResult<Types.RevokeInvitationMutation>;
export type RevokeInvitationMutationOptions = Apollo.BaseMutationOptions<Types.RevokeInvitationMutation, Types.RevokeInvitationMutationVariables>;
export const RevokeListingReportShareLinkDocument = gql`
    mutation revokeListingReportShareLink($input: RevokeListingReportShareLinkInput!) {
  revokeListingReportShareLink(input: $input) {
    ...ShareLink
  }
}
    ${ShareLinkFragmentDoc}`;
export type RevokeListingReportShareLinkMutationFn = Apollo.MutationFunction<Types.RevokeListingReportShareLinkMutation, Types.RevokeListingReportShareLinkMutationVariables>;

/**
 * __useRevokeListingReportShareLinkMutation__
 *
 * To run a mutation, you first call `useRevokeListingReportShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeListingReportShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeListingReportShareLinkMutation, { data, loading, error }] = useRevokeListingReportShareLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeListingReportShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.RevokeListingReportShareLinkMutation, Types.RevokeListingReportShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RevokeListingReportShareLinkMutation, Types.RevokeListingReportShareLinkMutationVariables>(RevokeListingReportShareLinkDocument, options);
      }
export type RevokeListingReportShareLinkMutationHookResult = ReturnType<typeof useRevokeListingReportShareLinkMutation>;
export type RevokeListingReportShareLinkMutationResult = Apollo.MutationResult<Types.RevokeListingReportShareLinkMutation>;
export type RevokeListingReportShareLinkMutationOptions = Apollo.BaseMutationOptions<Types.RevokeListingReportShareLinkMutation, Types.RevokeListingReportShareLinkMutationVariables>;
export const SendBoaShareLinkDocument = gql`
    mutation sendBOAShareLink($input: SendBOAShareLinkInput!) {
  sendBOAShareLink(input: $input) {
    ...ShareLink
  }
}
    ${ShareLinkFragmentDoc}`;
export type SendBoaShareLinkMutationFn = Apollo.MutationFunction<Types.SendBoaShareLinkMutation, Types.SendBoaShareLinkMutationVariables>;

/**
 * __useSendBoaShareLinkMutation__
 *
 * To run a mutation, you first call `useSendBoaShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBoaShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBoaShareLinkMutation, { data, loading, error }] = useSendBoaShareLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendBoaShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendBoaShareLinkMutation, Types.SendBoaShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendBoaShareLinkMutation, Types.SendBoaShareLinkMutationVariables>(SendBoaShareLinkDocument, options);
      }
export type SendBoaShareLinkMutationHookResult = ReturnType<typeof useSendBoaShareLinkMutation>;
export type SendBoaShareLinkMutationResult = Apollo.MutationResult<Types.SendBoaShareLinkMutation>;
export type SendBoaShareLinkMutationOptions = Apollo.BaseMutationOptions<Types.SendBoaShareLinkMutation, Types.SendBoaShareLinkMutationVariables>;
export const SendComplianceSummaryNotificationDocument = gql`
    mutation SendComplianceSummaryNotification($input: SendComplianceSummaryNotificationInput!) {
  sendComplianceSummaryNotification(input: $input) {
    workflowRunId
    success
  }
}
    `;
export type SendComplianceSummaryNotificationMutationFn = Apollo.MutationFunction<Types.SendComplianceSummaryNotificationMutation, Types.SendComplianceSummaryNotificationMutationVariables>;

/**
 * __useSendComplianceSummaryNotificationMutation__
 *
 * To run a mutation, you first call `useSendComplianceSummaryNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendComplianceSummaryNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendComplianceSummaryNotificationMutation, { data, loading, error }] = useSendComplianceSummaryNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendComplianceSummaryNotificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendComplianceSummaryNotificationMutation, Types.SendComplianceSummaryNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendComplianceSummaryNotificationMutation, Types.SendComplianceSummaryNotificationMutationVariables>(SendComplianceSummaryNotificationDocument, options);
      }
export type SendComplianceSummaryNotificationMutationHookResult = ReturnType<typeof useSendComplianceSummaryNotificationMutation>;
export type SendComplianceSummaryNotificationMutationResult = Apollo.MutationResult<Types.SendComplianceSummaryNotificationMutation>;
export type SendComplianceSummaryNotificationMutationOptions = Apollo.BaseMutationOptions<Types.SendComplianceSummaryNotificationMutation, Types.SendComplianceSummaryNotificationMutationVariables>;
export const SendListingReportShareLinkDocument = gql`
    mutation sendListingReportShareLink($input: SendListingReportShareLinkInput!) {
  sendListingReportShareLink(input: $input) {
    ...ShareLink
  }
}
    ${ShareLinkFragmentDoc}`;
export type SendListingReportShareLinkMutationFn = Apollo.MutationFunction<Types.SendListingReportShareLinkMutation, Types.SendListingReportShareLinkMutationVariables>;

/**
 * __useSendListingReportShareLinkMutation__
 *
 * To run a mutation, you first call `useSendListingReportShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendListingReportShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendListingReportShareLinkMutation, { data, loading, error }] = useSendListingReportShareLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendListingReportShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendListingReportShareLinkMutation, Types.SendListingReportShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendListingReportShareLinkMutation, Types.SendListingReportShareLinkMutationVariables>(SendListingReportShareLinkDocument, options);
      }
export type SendListingReportShareLinkMutationHookResult = ReturnType<typeof useSendListingReportShareLinkMutation>;
export type SendListingReportShareLinkMutationResult = Apollo.MutationResult<Types.SendListingReportShareLinkMutation>;
export type SendListingReportShareLinkMutationOptions = Apollo.BaseMutationOptions<Types.SendListingReportShareLinkMutation, Types.SendListingReportShareLinkMutationVariables>;
export const SendOtpFromInvitationLinkDocument = gql`
    mutation sendOTPFromInvitationLink($input: SendOTPFromInvitationLinkInput!) {
  sendOTPFromInvitationLink(input: $input) {
    agentName
    invitationId
    methodId
    name
    phoneNumberLast4
    listingId
  }
}
    `;
export type SendOtpFromInvitationLinkMutationFn = Apollo.MutationFunction<Types.SendOtpFromInvitationLinkMutation, Types.SendOtpFromInvitationLinkMutationVariables>;

/**
 * __useSendOtpFromInvitationLinkMutation__
 *
 * To run a mutation, you first call `useSendOtpFromInvitationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOtpFromInvitationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOtpFromInvitationLinkMutation, { data, loading, error }] = useSendOtpFromInvitationLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendOtpFromInvitationLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendOtpFromInvitationLinkMutation, Types.SendOtpFromInvitationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendOtpFromInvitationLinkMutation, Types.SendOtpFromInvitationLinkMutationVariables>(SendOtpFromInvitationLinkDocument, options);
      }
export type SendOtpFromInvitationLinkMutationHookResult = ReturnType<typeof useSendOtpFromInvitationLinkMutation>;
export type SendOtpFromInvitationLinkMutationResult = Apollo.MutationResult<Types.SendOtpFromInvitationLinkMutation>;
export type SendOtpFromInvitationLinkMutationOptions = Apollo.BaseMutationOptions<Types.SendOtpFromInvitationLinkMutation, Types.SendOtpFromInvitationLinkMutationVariables>;
export const SendSellerInvitationDocument = gql`
    mutation sendSellerInvitation($input: SendSellerInvitationInput!) {
  sendSellerInvitation(input: $input) {
    invitation {
      ...Invitation
    }
  }
}
    ${InvitationFragmentDoc}`;
export type SendSellerInvitationMutationFn = Apollo.MutationFunction<Types.SendSellerInvitationMutation, Types.SendSellerInvitationMutationVariables>;

/**
 * __useSendSellerInvitationMutation__
 *
 * To run a mutation, you first call `useSendSellerInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSellerInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSellerInvitationMutation, { data, loading, error }] = useSendSellerInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSellerInvitationMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendSellerInvitationMutation, Types.SendSellerInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendSellerInvitationMutation, Types.SendSellerInvitationMutationVariables>(SendSellerInvitationDocument, options);
      }
export type SendSellerInvitationMutationHookResult = ReturnType<typeof useSendSellerInvitationMutation>;
export type SendSellerInvitationMutationResult = Apollo.MutationResult<Types.SendSellerInvitationMutation>;
export type SendSellerInvitationMutationOptions = Apollo.BaseMutationOptions<Types.SendSellerInvitationMutation, Types.SendSellerInvitationMutationVariables>;
export const SendSignatureRequestToBuyersForOfferDocument = gql`
    mutation sendSignatureRequestToBuyersForOffer($input: SendSignatureRequestToBuyersForOfferInput!) {
  sendSignatureRequestToBuyersForOffer(input: $input) {
    offer {
      id
      status
    }
  }
}
    `;
export type SendSignatureRequestToBuyersForOfferMutationFn = Apollo.MutationFunction<Types.SendSignatureRequestToBuyersForOfferMutation, Types.SendSignatureRequestToBuyersForOfferMutationVariables>;

/**
 * __useSendSignatureRequestToBuyersForOfferMutation__
 *
 * To run a mutation, you first call `useSendSignatureRequestToBuyersForOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSignatureRequestToBuyersForOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSignatureRequestToBuyersForOfferMutation, { data, loading, error }] = useSendSignatureRequestToBuyersForOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSignatureRequestToBuyersForOfferMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendSignatureRequestToBuyersForOfferMutation, Types.SendSignatureRequestToBuyersForOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendSignatureRequestToBuyersForOfferMutation, Types.SendSignatureRequestToBuyersForOfferMutationVariables>(SendSignatureRequestToBuyersForOfferDocument, options);
      }
export type SendSignatureRequestToBuyersForOfferMutationHookResult = ReturnType<typeof useSendSignatureRequestToBuyersForOfferMutation>;
export type SendSignatureRequestToBuyersForOfferMutationResult = Apollo.MutationResult<Types.SendSignatureRequestToBuyersForOfferMutation>;
export type SendSignatureRequestToBuyersForOfferMutationOptions = Apollo.BaseMutationOptions<Types.SendSignatureRequestToBuyersForOfferMutation, Types.SendSignatureRequestToBuyersForOfferMutationVariables>;
export const SendTestNotificationDocument = gql`
    mutation SendTestNotification($input: SendTestNotificationInput!) {
  sendTestNotification(input: $input) {
    success
    notificationLogId
  }
}
    `;
export type SendTestNotificationMutationFn = Apollo.MutationFunction<Types.SendTestNotificationMutation, Types.SendTestNotificationMutationVariables>;

/**
 * __useSendTestNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationMutation, { data, loading, error }] = useSendTestNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTestNotificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.SendTestNotificationMutation, Types.SendTestNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SendTestNotificationMutation, Types.SendTestNotificationMutationVariables>(SendTestNotificationDocument, options);
      }
export type SendTestNotificationMutationHookResult = ReturnType<typeof useSendTestNotificationMutation>;
export type SendTestNotificationMutationResult = Apollo.MutationResult<Types.SendTestNotificationMutation>;
export type SendTestNotificationMutationOptions = Apollo.BaseMutationOptions<Types.SendTestNotificationMutation, Types.SendTestNotificationMutationVariables>;
export const ShareStorefrontWithBuyerDocument = gql`
    mutation ShareStorefrontWithBuyer($input: ShareStorefrontWithBuyerInput!) {
  shareStorefrontWithBuyer(input: $input)
}
    `;
export type ShareStorefrontWithBuyerMutationFn = Apollo.MutationFunction<Types.ShareStorefrontWithBuyerMutation, Types.ShareStorefrontWithBuyerMutationVariables>;

/**
 * __useShareStorefrontWithBuyerMutation__
 *
 * To run a mutation, you first call `useShareStorefrontWithBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareStorefrontWithBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareStorefrontWithBuyerMutation, { data, loading, error }] = useShareStorefrontWithBuyerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareStorefrontWithBuyerMutation(baseOptions?: Apollo.MutationHookOptions<Types.ShareStorefrontWithBuyerMutation, Types.ShareStorefrontWithBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ShareStorefrontWithBuyerMutation, Types.ShareStorefrontWithBuyerMutationVariables>(ShareStorefrontWithBuyerDocument, options);
      }
export type ShareStorefrontWithBuyerMutationHookResult = ReturnType<typeof useShareStorefrontWithBuyerMutation>;
export type ShareStorefrontWithBuyerMutationResult = Apollo.MutationResult<Types.ShareStorefrontWithBuyerMutation>;
export type ShareStorefrontWithBuyerMutationOptions = Apollo.BaseMutationOptions<Types.ShareStorefrontWithBuyerMutation, Types.ShareStorefrontWithBuyerMutationVariables>;
export const SignListingGuestbookDocument = gql`
    mutation signListingGuestbook($listingId: String!, $followListingReason: StorefrontSubscriptionReason!) {
  signListingGuestbook(input: {id: $listingId})
  followListing(input: {id: $listingId, reason: $followListingReason}) {
    isFollowingListing
  }
}
    `;
export type SignListingGuestbookMutationFn = Apollo.MutationFunction<Types.SignListingGuestbookMutation, Types.SignListingGuestbookMutationVariables>;

/**
 * __useSignListingGuestbookMutation__
 *
 * To run a mutation, you first call `useSignListingGuestbookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignListingGuestbookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signListingGuestbookMutation, { data, loading, error }] = useSignListingGuestbookMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      followListingReason: // value for 'followListingReason'
 *   },
 * });
 */
export function useSignListingGuestbookMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignListingGuestbookMutation, Types.SignListingGuestbookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignListingGuestbookMutation, Types.SignListingGuestbookMutationVariables>(SignListingGuestbookDocument, options);
      }
export type SignListingGuestbookMutationHookResult = ReturnType<typeof useSignListingGuestbookMutation>;
export type SignListingGuestbookMutationResult = Apollo.MutationResult<Types.SignListingGuestbookMutation>;
export type SignListingGuestbookMutationOptions = Apollo.BaseMutationOptions<Types.SignListingGuestbookMutation, Types.SignListingGuestbookMutationVariables>;
export const SignOpenHouseGuestbookDocument = gql`
    mutation SignOpenHouseGuestbook($input: OpenHouseGuestbookInput!) {
  signOpenHouseGuestbook(input: $input)
}
    `;
export type SignOpenHouseGuestbookMutationFn = Apollo.MutationFunction<Types.SignOpenHouseGuestbookMutation, Types.SignOpenHouseGuestbookMutationVariables>;

/**
 * __useSignOpenHouseGuestbookMutation__
 *
 * To run a mutation, you first call `useSignOpenHouseGuestbookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOpenHouseGuestbookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOpenHouseGuestbookMutation, { data, loading, error }] = useSignOpenHouseGuestbookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignOpenHouseGuestbookMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignOpenHouseGuestbookMutation, Types.SignOpenHouseGuestbookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignOpenHouseGuestbookMutation, Types.SignOpenHouseGuestbookMutationVariables>(SignOpenHouseGuestbookDocument, options);
      }
export type SignOpenHouseGuestbookMutationHookResult = ReturnType<typeof useSignOpenHouseGuestbookMutation>;
export type SignOpenHouseGuestbookMutationResult = Apollo.MutationResult<Types.SignOpenHouseGuestbookMutation>;
export type SignOpenHouseGuestbookMutationOptions = Apollo.BaseMutationOptions<Types.SignOpenHouseGuestbookMutation, Types.SignOpenHouseGuestbookMutationVariables>;
export const SignUpConsumerDocument = gql`
    mutation SignUpConsumer($input: SignUpInput!) {
  signUpConsumer(input: $input) {
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type SignUpConsumerMutationFn = Apollo.MutationFunction<Types.SignUpConsumerMutation, Types.SignUpConsumerMutationVariables>;

/**
 * __useSignUpConsumerMutation__
 *
 * To run a mutation, you first call `useSignUpConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpConsumerMutation, { data, loading, error }] = useSignUpConsumerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpConsumerMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignUpConsumerMutation, Types.SignUpConsumerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignUpConsumerMutation, Types.SignUpConsumerMutationVariables>(SignUpConsumerDocument, options);
      }
export type SignUpConsumerMutationHookResult = ReturnType<typeof useSignUpConsumerMutation>;
export type SignUpConsumerMutationResult = Apollo.MutationResult<Types.SignUpConsumerMutation>;
export type SignUpConsumerMutationOptions = Apollo.BaseMutationOptions<Types.SignUpConsumerMutation, Types.SignUpConsumerMutationVariables>;
export const SignUpAgentDocument = gql`
    mutation signUpAgent($input: SignUpAgentInput!) {
  signUpAgent(input: $input) {
    user {
      ...User
      licenses {
        id
      }
    }
  }
}
    ${UserFragmentDoc}`;
export type SignUpAgentMutationFn = Apollo.MutationFunction<Types.SignUpAgentMutation, Types.SignUpAgentMutationVariables>;

/**
 * __useSignUpAgentMutation__
 *
 * To run a mutation, you first call `useSignUpAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpAgentMutation, { data, loading, error }] = useSignUpAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.SignUpAgentMutation, Types.SignUpAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignUpAgentMutation, Types.SignUpAgentMutationVariables>(SignUpAgentDocument, options);
      }
export type SignUpAgentMutationHookResult = ReturnType<typeof useSignUpAgentMutation>;
export type SignUpAgentMutationResult = Apollo.MutationResult<Types.SignUpAgentMutation>;
export type SignUpAgentMutationOptions = Apollo.BaseMutationOptions<Types.SignUpAgentMutation, Types.SignUpAgentMutationVariables>;
export const SignUpAgentV2Document = gql`
    mutation signUpAgentV2($input: SignUpAgentV2Input!) {
  signUpAgentV2(input: $input) {
    user {
      ...User
      licenses {
        id
      }
    }
  }
}
    ${UserFragmentDoc}`;
export type SignUpAgentV2MutationFn = Apollo.MutationFunction<Types.SignUpAgentV2Mutation, Types.SignUpAgentV2MutationVariables>;

/**
 * __useSignUpAgentV2Mutation__
 *
 * To run a mutation, you first call `useSignUpAgentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpAgentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpAgentV2Mutation, { data, loading, error }] = useSignUpAgentV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpAgentV2Mutation(baseOptions?: Apollo.MutationHookOptions<Types.SignUpAgentV2Mutation, Types.SignUpAgentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SignUpAgentV2Mutation, Types.SignUpAgentV2MutationVariables>(SignUpAgentV2Document, options);
      }
export type SignUpAgentV2MutationHookResult = ReturnType<typeof useSignUpAgentV2Mutation>;
export type SignUpAgentV2MutationResult = Apollo.MutationResult<Types.SignUpAgentV2Mutation>;
export type SignUpAgentV2MutationOptions = Apollo.BaseMutationOptions<Types.SignUpAgentV2Mutation, Types.SignUpAgentV2MutationVariables>;
export const SubmitOfferForBuyersAgentDocument = gql`
    mutation submitOfferForBuyersAgent($input: SubmitOfferInput!) {
  submitOfferForBuyersAgent(input: $input) {
    offer {
      id
      noteToListingAgent
      submittedAt
    }
  }
}
    `;
export type SubmitOfferForBuyersAgentMutationFn = Apollo.MutationFunction<Types.SubmitOfferForBuyersAgentMutation, Types.SubmitOfferForBuyersAgentMutationVariables>;

/**
 * __useSubmitOfferForBuyersAgentMutation__
 *
 * To run a mutation, you first call `useSubmitOfferForBuyersAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOfferForBuyersAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOfferForBuyersAgentMutation, { data, loading, error }] = useSubmitOfferForBuyersAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOfferForBuyersAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.SubmitOfferForBuyersAgentMutation, Types.SubmitOfferForBuyersAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SubmitOfferForBuyersAgentMutation, Types.SubmitOfferForBuyersAgentMutationVariables>(SubmitOfferForBuyersAgentDocument, options);
      }
export type SubmitOfferForBuyersAgentMutationHookResult = ReturnType<typeof useSubmitOfferForBuyersAgentMutation>;
export type SubmitOfferForBuyersAgentMutationResult = Apollo.MutationResult<Types.SubmitOfferForBuyersAgentMutation>;
export type SubmitOfferForBuyersAgentMutationOptions = Apollo.BaseMutationOptions<Types.SubmitOfferForBuyersAgentMutation, Types.SubmitOfferForBuyersAgentMutationVariables>;
export const SubmitOfferToNonIndigoListingAgentDocument = gql`
    mutation SubmitOfferToNonIndigoListingAgent($input: SubmitOfferToNonIndigoListingAgentInput!) {
  submitOfferToNonIndigoListingAgent(input: $input) {
    offer {
      id
    }
  }
}
    `;
export type SubmitOfferToNonIndigoListingAgentMutationFn = Apollo.MutationFunction<Types.SubmitOfferToNonIndigoListingAgentMutation, Types.SubmitOfferToNonIndigoListingAgentMutationVariables>;

/**
 * __useSubmitOfferToNonIndigoListingAgentMutation__
 *
 * To run a mutation, you first call `useSubmitOfferToNonIndigoListingAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOfferToNonIndigoListingAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOfferToNonIndigoListingAgentMutation, { data, loading, error }] = useSubmitOfferToNonIndigoListingAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOfferToNonIndigoListingAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.SubmitOfferToNonIndigoListingAgentMutation, Types.SubmitOfferToNonIndigoListingAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SubmitOfferToNonIndigoListingAgentMutation, Types.SubmitOfferToNonIndigoListingAgentMutationVariables>(SubmitOfferToNonIndigoListingAgentDocument, options);
      }
export type SubmitOfferToNonIndigoListingAgentMutationHookResult = ReturnType<typeof useSubmitOfferToNonIndigoListingAgentMutation>;
export type SubmitOfferToNonIndigoListingAgentMutationResult = Apollo.MutationResult<Types.SubmitOfferToNonIndigoListingAgentMutation>;
export type SubmitOfferToNonIndigoListingAgentMutationOptions = Apollo.BaseMutationOptions<Types.SubmitOfferToNonIndigoListingAgentMutation, Types.SubmitOfferToNonIndigoListingAgentMutationVariables>;
export const TrackListingDocumentActionDocument = gql`
    mutation trackListingDocumentAction($input: TrackListingDocumentActionInput!) {
  trackListingDocumentAction(input: $input) {
    success
  }
}
    `;
export type TrackListingDocumentActionMutationFn = Apollo.MutationFunction<Types.TrackListingDocumentActionMutation, Types.TrackListingDocumentActionMutationVariables>;

/**
 * __useTrackListingDocumentActionMutation__
 *
 * To run a mutation, you first call `useTrackListingDocumentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackListingDocumentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackListingDocumentActionMutation, { data, loading, error }] = useTrackListingDocumentActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackListingDocumentActionMutation(baseOptions?: Apollo.MutationHookOptions<Types.TrackListingDocumentActionMutation, Types.TrackListingDocumentActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.TrackListingDocumentActionMutation, Types.TrackListingDocumentActionMutationVariables>(TrackListingDocumentActionDocument, options);
      }
export type TrackListingDocumentActionMutationHookResult = ReturnType<typeof useTrackListingDocumentActionMutation>;
export type TrackListingDocumentActionMutationResult = Apollo.MutationResult<Types.TrackListingDocumentActionMutation>;
export type TrackListingDocumentActionMutationOptions = Apollo.BaseMutationOptions<Types.TrackListingDocumentActionMutation, Types.TrackListingDocumentActionMutationVariables>;
export const UnfollowListingDocument = gql`
    mutation unfollowListing($input: ListingInput!) {
  unfollowListing(input: $input) {
    isFollowingListing
  }
}
    `;
export type UnfollowListingMutationFn = Apollo.MutationFunction<Types.UnfollowListingMutation, Types.UnfollowListingMutationVariables>;

/**
 * __useUnfollowListingMutation__
 *
 * To run a mutation, you first call `useUnfollowListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowListingMutation, { data, loading, error }] = useUnfollowListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnfollowListingMutation(baseOptions?: Apollo.MutationHookOptions<Types.UnfollowListingMutation, Types.UnfollowListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UnfollowListingMutation, Types.UnfollowListingMutationVariables>(UnfollowListingDocument, options);
      }
export type UnfollowListingMutationHookResult = ReturnType<typeof useUnfollowListingMutation>;
export type UnfollowListingMutationResult = Apollo.MutationResult<Types.UnfollowListingMutation>;
export type UnfollowListingMutationOptions = Apollo.BaseMutationOptions<Types.UnfollowListingMutation, Types.UnfollowListingMutationVariables>;
export const UpdateAiConversationDocument = gql`
    mutation updateAIConversation($input: UpdateAIConversationInput!) {
  updateAIConversation(input: $input) {
    ...AIConversation
  }
}
    ${AiConversationFragmentDoc}`;
export type UpdateAiConversationMutationFn = Apollo.MutationFunction<Types.UpdateAiConversationMutation, Types.UpdateAiConversationMutationVariables>;

/**
 * __useUpdateAiConversationMutation__
 *
 * To run a mutation, you first call `useUpdateAiConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiConversationMutation, { data, loading, error }] = useUpdateAiConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAiConversationMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAiConversationMutation, Types.UpdateAiConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAiConversationMutation, Types.UpdateAiConversationMutationVariables>(UpdateAiConversationDocument, options);
      }
export type UpdateAiConversationMutationHookResult = ReturnType<typeof useUpdateAiConversationMutation>;
export type UpdateAiConversationMutationResult = Apollo.MutationResult<Types.UpdateAiConversationMutation>;
export type UpdateAiConversationMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAiConversationMutation, Types.UpdateAiConversationMutationVariables>;
export const UpdateBuyerOfferAnalysisDocument = gql`
    mutation UpdateBuyerOfferAnalysis($input: UpdateBuyerOfferAnalysisInput!) {
  updateBuyerOfferAnalysis(input: $input) {
    id
  }
}
    `;
export type UpdateBuyerOfferAnalysisMutationFn = Apollo.MutationFunction<Types.UpdateBuyerOfferAnalysisMutation, Types.UpdateBuyerOfferAnalysisMutationVariables>;

/**
 * __useUpdateBuyerOfferAnalysisMutation__
 *
 * To run a mutation, you first call `useUpdateBuyerOfferAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuyerOfferAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuyerOfferAnalysisMutation, { data, loading, error }] = useUpdateBuyerOfferAnalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBuyerOfferAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateBuyerOfferAnalysisMutation, Types.UpdateBuyerOfferAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateBuyerOfferAnalysisMutation, Types.UpdateBuyerOfferAnalysisMutationVariables>(UpdateBuyerOfferAnalysisDocument, options);
      }
export type UpdateBuyerOfferAnalysisMutationHookResult = ReturnType<typeof useUpdateBuyerOfferAnalysisMutation>;
export type UpdateBuyerOfferAnalysisMutationResult = Apollo.MutationResult<Types.UpdateBuyerOfferAnalysisMutation>;
export type UpdateBuyerOfferAnalysisMutationOptions = Apollo.BaseMutationOptions<Types.UpdateBuyerOfferAnalysisMutation, Types.UpdateBuyerOfferAnalysisMutationVariables>;
export const UpdateIndigoContractDocument = gql`
    mutation updateIndigoContract($input: UpdateIndigoContractInput!, $includeFieldValues: Boolean = true, $includeContractDocuments: Boolean = false) {
  updateIndigoContract(input: $input) {
    ...IndigoContractsForCurrentUser
  }
}
    ${IndigoContractsForCurrentUserFragmentDoc}`;
export type UpdateIndigoContractMutationFn = Apollo.MutationFunction<Types.UpdateIndigoContractMutation, Types.UpdateIndigoContractMutationVariables>;

/**
 * __useUpdateIndigoContractMutation__
 *
 * To run a mutation, you first call `useUpdateIndigoContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndigoContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndigoContractMutation, { data, loading, error }] = useUpdateIndigoContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *      includeFieldValues: // value for 'includeFieldValues'
 *      includeContractDocuments: // value for 'includeContractDocuments'
 *   },
 * });
 */
export function useUpdateIndigoContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateIndigoContractMutation, Types.UpdateIndigoContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateIndigoContractMutation, Types.UpdateIndigoContractMutationVariables>(UpdateIndigoContractDocument, options);
      }
export type UpdateIndigoContractMutationHookResult = ReturnType<typeof useUpdateIndigoContractMutation>;
export type UpdateIndigoContractMutationResult = Apollo.MutationResult<Types.UpdateIndigoContractMutation>;
export type UpdateIndigoContractMutationOptions = Apollo.BaseMutationOptions<Types.UpdateIndigoContractMutation, Types.UpdateIndigoContractMutationVariables>;
export const UpdateListingComparableSetDocument = gql`
    mutation updateListingComparableSet($input: UpdateListingComparableSetInput!) {
  updateListingComparableSet(input: $input) {
    ...ListingComparableSet
  }
}
    ${ListingComparableSetFragmentDoc}`;
export type UpdateListingComparableSetMutationFn = Apollo.MutationFunction<Types.UpdateListingComparableSetMutation, Types.UpdateListingComparableSetMutationVariables>;

/**
 * __useUpdateListingComparableSetMutation__
 *
 * To run a mutation, you first call `useUpdateListingComparableSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingComparableSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingComparableSetMutation, { data, loading, error }] = useUpdateListingComparableSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingComparableSetMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateListingComparableSetMutation, Types.UpdateListingComparableSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateListingComparableSetMutation, Types.UpdateListingComparableSetMutationVariables>(UpdateListingComparableSetDocument, options);
      }
export type UpdateListingComparableSetMutationHookResult = ReturnType<typeof useUpdateListingComparableSetMutation>;
export type UpdateListingComparableSetMutationResult = Apollo.MutationResult<Types.UpdateListingComparableSetMutation>;
export type UpdateListingComparableSetMutationOptions = Apollo.BaseMutationOptions<Types.UpdateListingComparableSetMutation, Types.UpdateListingComparableSetMutationVariables>;
export const UpdateListingComparableSetForAgentDocument = gql`
    mutation updateListingComparableSetForAgent($input: UpdateListingComparableSetForAgentInput!) {
  updateListingComparableSetForAgent(input: $input) {
    ...ListingComparableSet
  }
}
    ${ListingComparableSetFragmentDoc}`;
export type UpdateListingComparableSetForAgentMutationFn = Apollo.MutationFunction<Types.UpdateListingComparableSetForAgentMutation, Types.UpdateListingComparableSetForAgentMutationVariables>;

/**
 * __useUpdateListingComparableSetForAgentMutation__
 *
 * To run a mutation, you first call `useUpdateListingComparableSetForAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingComparableSetForAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingComparableSetForAgentMutation, { data, loading, error }] = useUpdateListingComparableSetForAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingComparableSetForAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateListingComparableSetForAgentMutation, Types.UpdateListingComparableSetForAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateListingComparableSetForAgentMutation, Types.UpdateListingComparableSetForAgentMutationVariables>(UpdateListingComparableSetForAgentDocument, options);
      }
export type UpdateListingComparableSetForAgentMutationHookResult = ReturnType<typeof useUpdateListingComparableSetForAgentMutation>;
export type UpdateListingComparableSetForAgentMutationResult = Apollo.MutationResult<Types.UpdateListingComparableSetForAgentMutation>;
export type UpdateListingComparableSetForAgentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateListingComparableSetForAgentMutation, Types.UpdateListingComparableSetForAgentMutationVariables>;
export const UpdateListingComparableSetForBuyerOfferAnalysisDocument = gql`
    mutation UpdateListingComparableSetForBuyerOfferAnalysis($input: UpdateListingComparableSetForBuyerOfferAnalysisInput!) {
  updateListingComparableSetForBuyerOfferAnalysis(input: $input) {
    ...ListingComparableSet
  }
}
    ${ListingComparableSetFragmentDoc}`;
export type UpdateListingComparableSetForBuyerOfferAnalysisMutationFn = Apollo.MutationFunction<Types.UpdateListingComparableSetForBuyerOfferAnalysisMutation, Types.UpdateListingComparableSetForBuyerOfferAnalysisMutationVariables>;

/**
 * __useUpdateListingComparableSetForBuyerOfferAnalysisMutation__
 *
 * To run a mutation, you first call `useUpdateListingComparableSetForBuyerOfferAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingComparableSetForBuyerOfferAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingComparableSetForBuyerOfferAnalysisMutation, { data, loading, error }] = useUpdateListingComparableSetForBuyerOfferAnalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingComparableSetForBuyerOfferAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateListingComparableSetForBuyerOfferAnalysisMutation, Types.UpdateListingComparableSetForBuyerOfferAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateListingComparableSetForBuyerOfferAnalysisMutation, Types.UpdateListingComparableSetForBuyerOfferAnalysisMutationVariables>(UpdateListingComparableSetForBuyerOfferAnalysisDocument, options);
      }
export type UpdateListingComparableSetForBuyerOfferAnalysisMutationHookResult = ReturnType<typeof useUpdateListingComparableSetForBuyerOfferAnalysisMutation>;
export type UpdateListingComparableSetForBuyerOfferAnalysisMutationResult = Apollo.MutationResult<Types.UpdateListingComparableSetForBuyerOfferAnalysisMutation>;
export type UpdateListingComparableSetForBuyerOfferAnalysisMutationOptions = Apollo.BaseMutationOptions<Types.UpdateListingComparableSetForBuyerOfferAnalysisMutation, Types.UpdateListingComparableSetForBuyerOfferAnalysisMutationVariables>;
export const UpdateListingPreferenceDocument = gql`
    mutation updateListingPreference($input: UpdateListingPreferenceValueInput!, $preferenceValues: Boolean = true) {
  updateListingPreference(input: $input) {
    ...Listing
  }
}
    ${ListingFragmentDoc}`;
export type UpdateListingPreferenceMutationFn = Apollo.MutationFunction<Types.UpdateListingPreferenceMutation, Types.UpdateListingPreferenceMutationVariables>;

/**
 * __useUpdateListingPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateListingPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingPreferenceMutation, { data, loading, error }] = useUpdateListingPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      preferenceValues: // value for 'preferenceValues'
 *   },
 * });
 */
export function useUpdateListingPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateListingPreferenceMutation, Types.UpdateListingPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateListingPreferenceMutation, Types.UpdateListingPreferenceMutationVariables>(UpdateListingPreferenceDocument, options);
      }
export type UpdateListingPreferenceMutationHookResult = ReturnType<typeof useUpdateListingPreferenceMutation>;
export type UpdateListingPreferenceMutationResult = Apollo.MutationResult<Types.UpdateListingPreferenceMutation>;
export type UpdateListingPreferenceMutationOptions = Apollo.BaseMutationOptions<Types.UpdateListingPreferenceMutation, Types.UpdateListingPreferenceMutationVariables>;
export const UpdateNotificationTemplateDocument = gql`
    mutation UpdateNotificationTemplate($input: UpdateNotificationTemplateInput!) {
  updateNotificationTemplate(input: $input) {
    ...NotificationTemplateDetails
  }
}
    ${NotificationTemplateDetailsFragmentDoc}`;
export type UpdateNotificationTemplateMutationFn = Apollo.MutationFunction<Types.UpdateNotificationTemplateMutation, Types.UpdateNotificationTemplateMutationVariables>;

/**
 * __useUpdateNotificationTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationTemplateMutation, { data, loading, error }] = useUpdateNotificationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateNotificationTemplateMutation, Types.UpdateNotificationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateNotificationTemplateMutation, Types.UpdateNotificationTemplateMutationVariables>(UpdateNotificationTemplateDocument, options);
      }
export type UpdateNotificationTemplateMutationHookResult = ReturnType<typeof useUpdateNotificationTemplateMutation>;
export type UpdateNotificationTemplateMutationResult = Apollo.MutationResult<Types.UpdateNotificationTemplateMutation>;
export type UpdateNotificationTemplateMutationOptions = Apollo.BaseMutationOptions<Types.UpdateNotificationTemplateMutation, Types.UpdateNotificationTemplateMutationVariables>;
export const UpdateOfferForBuyersAgentDocument = gql`
    mutation updateOfferForBuyersAgent($input: UpdateOfferForBuyersAgentInput!) {
  updateOfferForBuyersAgent(input: $input) {
    offer {
      id
      contract {
        id
        fieldValues
        validations {
          ...ContractValidation
        }
      }
    }
  }
}
    ${ContractValidationFragmentDoc}`;
export type UpdateOfferForBuyersAgentMutationFn = Apollo.MutationFunction<Types.UpdateOfferForBuyersAgentMutation, Types.UpdateOfferForBuyersAgentMutationVariables>;

/**
 * __useUpdateOfferForBuyersAgentMutation__
 *
 * To run a mutation, you first call `useUpdateOfferForBuyersAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferForBuyersAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferForBuyersAgentMutation, { data, loading, error }] = useUpdateOfferForBuyersAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfferForBuyersAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOfferForBuyersAgentMutation, Types.UpdateOfferForBuyersAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOfferForBuyersAgentMutation, Types.UpdateOfferForBuyersAgentMutationVariables>(UpdateOfferForBuyersAgentDocument, options);
      }
export type UpdateOfferForBuyersAgentMutationHookResult = ReturnType<typeof useUpdateOfferForBuyersAgentMutation>;
export type UpdateOfferForBuyersAgentMutationResult = Apollo.MutationResult<Types.UpdateOfferForBuyersAgentMutation>;
export type UpdateOfferForBuyersAgentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOfferForBuyersAgentMutation, Types.UpdateOfferForBuyersAgentMutationVariables>;
export const UpdateOrCreateContractSystemCredentialsDocument = gql`
    mutation updateOrCreateContractSystemCredentials($input: UpdateContractSystemCredentialsInput!) {
  updateOrCreateContractSystemCredentials(input: $input) {
    id
    name
    contractSystemCredentials {
      id
      type
      username
      hasInvalidCredentials
    }
  }
}
    `;
export type UpdateOrCreateContractSystemCredentialsMutationFn = Apollo.MutationFunction<Types.UpdateOrCreateContractSystemCredentialsMutation, Types.UpdateOrCreateContractSystemCredentialsMutationVariables>;

/**
 * __useUpdateOrCreateContractSystemCredentialsMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateContractSystemCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateContractSystemCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateContractSystemCredentialsMutation, { data, loading, error }] = useUpdateOrCreateContractSystemCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreateContractSystemCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrCreateContractSystemCredentialsMutation, Types.UpdateOrCreateContractSystemCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrCreateContractSystemCredentialsMutation, Types.UpdateOrCreateContractSystemCredentialsMutationVariables>(UpdateOrCreateContractSystemCredentialsDocument, options);
      }
export type UpdateOrCreateContractSystemCredentialsMutationHookResult = ReturnType<typeof useUpdateOrCreateContractSystemCredentialsMutation>;
export type UpdateOrCreateContractSystemCredentialsMutationResult = Apollo.MutationResult<Types.UpdateOrCreateContractSystemCredentialsMutation>;
export type UpdateOrCreateContractSystemCredentialsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrCreateContractSystemCredentialsMutation, Types.UpdateOrCreateContractSystemCredentialsMutationVariables>;
export const UpdateOrganizationComplianceDashboardSettingsDocument = gql`
    mutation updateOrganizationComplianceDashboardSettings($input: UpdateOrganizationComplianceDashboardSettingsInput!) {
  updateOrganizationComplianceDashboardSettings(input: $input) {
    id
    officeSections {
      label
      officeValues
      value
    }
    updatedAt
  }
}
    `;
export type UpdateOrganizationComplianceDashboardSettingsMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationComplianceDashboardSettingsMutation, Types.UpdateOrganizationComplianceDashboardSettingsMutationVariables>;

/**
 * __useUpdateOrganizationComplianceDashboardSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationComplianceDashboardSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationComplianceDashboardSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationComplianceDashboardSettingsMutation, { data, loading, error }] = useUpdateOrganizationComplianceDashboardSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationComplianceDashboardSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationComplianceDashboardSettingsMutation, Types.UpdateOrganizationComplianceDashboardSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationComplianceDashboardSettingsMutation, Types.UpdateOrganizationComplianceDashboardSettingsMutationVariables>(UpdateOrganizationComplianceDashboardSettingsDocument, options);
      }
export type UpdateOrganizationComplianceDashboardSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationComplianceDashboardSettingsMutation>;
export type UpdateOrganizationComplianceDashboardSettingsMutationResult = Apollo.MutationResult<Types.UpdateOrganizationComplianceDashboardSettingsMutation>;
export type UpdateOrganizationComplianceDashboardSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationComplianceDashboardSettingsMutation, Types.UpdateOrganizationComplianceDashboardSettingsMutationVariables>;
export const UpdateOrganizationNotificationSettingsDocument = gql`
    mutation UpdateOrganizationNotificationSettings($input: UpdateOrganizationNotificationSettingsInput!) {
  updateOrganizationNotificationSettings(input: $input) {
    id
    sendWindowTimezone
    sendWindowRules {
      day
      from
      until
    }
  }
}
    `;
export type UpdateOrganizationNotificationSettingsMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationNotificationSettingsMutation, Types.UpdateOrganizationNotificationSettingsMutationVariables>;

/**
 * __useUpdateOrganizationNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationNotificationSettingsMutation, { data, loading, error }] = useUpdateOrganizationNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationNotificationSettingsMutation, Types.UpdateOrganizationNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationNotificationSettingsMutation, Types.UpdateOrganizationNotificationSettingsMutationVariables>(UpdateOrganizationNotificationSettingsDocument, options);
      }
export type UpdateOrganizationNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationNotificationSettingsMutation>;
export type UpdateOrganizationNotificationSettingsMutationResult = Apollo.MutationResult<Types.UpdateOrganizationNotificationSettingsMutation>;
export type UpdateOrganizationNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationNotificationSettingsMutation, Types.UpdateOrganizationNotificationSettingsMutationVariables>;
export const UpdatePartyForBuyersAgentDocument = gql`
    mutation UpdatePartyForBuyersAgent($input: UpdatePartyForBuyersAgentInput!) {
  updatePartyForBuyersAgent(input: $input) {
    ...Party
  }
}
    ${PartyFragmentDoc}`;
export type UpdatePartyForBuyersAgentMutationFn = Apollo.MutationFunction<Types.UpdatePartyForBuyersAgentMutation, Types.UpdatePartyForBuyersAgentMutationVariables>;

/**
 * __useUpdatePartyForBuyersAgentMutation__
 *
 * To run a mutation, you first call `useUpdatePartyForBuyersAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartyForBuyersAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartyForBuyersAgentMutation, { data, loading, error }] = useUpdatePartyForBuyersAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartyForBuyersAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePartyForBuyersAgentMutation, Types.UpdatePartyForBuyersAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePartyForBuyersAgentMutation, Types.UpdatePartyForBuyersAgentMutationVariables>(UpdatePartyForBuyersAgentDocument, options);
      }
export type UpdatePartyForBuyersAgentMutationHookResult = ReturnType<typeof useUpdatePartyForBuyersAgentMutation>;
export type UpdatePartyForBuyersAgentMutationResult = Apollo.MutationResult<Types.UpdatePartyForBuyersAgentMutation>;
export type UpdatePartyForBuyersAgentMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePartyForBuyersAgentMutation, Types.UpdatePartyForBuyersAgentMutationVariables>;
export const UpdatePropertyDetailsDocument = gql`
    mutation updatePropertyDetails($input: UpdatePropertyDetailsInput!) {
  updatePropertyDetails(input: $input) {
    success
    propertyDetails {
      ...PropertyDetails
    }
  }
}
    ${PropertyDetailsFragmentDoc}`;
export type UpdatePropertyDetailsMutationFn = Apollo.MutationFunction<Types.UpdatePropertyDetailsMutation, Types.UpdatePropertyDetailsMutationVariables>;

/**
 * __useUpdatePropertyDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyDetailsMutation, { data, loading, error }] = useUpdatePropertyDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePropertyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdatePropertyDetailsMutation, Types.UpdatePropertyDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdatePropertyDetailsMutation, Types.UpdatePropertyDetailsMutationVariables>(UpdatePropertyDetailsDocument, options);
      }
export type UpdatePropertyDetailsMutationHookResult = ReturnType<typeof useUpdatePropertyDetailsMutation>;
export type UpdatePropertyDetailsMutationResult = Apollo.MutationResult<Types.UpdatePropertyDetailsMutation>;
export type UpdatePropertyDetailsMutationOptions = Apollo.BaseMutationOptions<Types.UpdatePropertyDetailsMutation, Types.UpdatePropertyDetailsMutationVariables>;
export const UpdateStorefrontSetupDocument = gql`
    mutation UpdateStorefrontSetup($input: UpdateStorefrontSetupInput!) {
  updateStorefrontSetup(input: $input) {
    id
  }
}
    `;
export type UpdateStorefrontSetupMutationFn = Apollo.MutationFunction<Types.UpdateStorefrontSetupMutation, Types.UpdateStorefrontSetupMutationVariables>;

/**
 * __useUpdateStorefrontSetupMutation__
 *
 * To run a mutation, you first call `useUpdateStorefrontSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStorefrontSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStorefrontSetupMutation, { data, loading, error }] = useUpdateStorefrontSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStorefrontSetupMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateStorefrontSetupMutation, Types.UpdateStorefrontSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateStorefrontSetupMutation, Types.UpdateStorefrontSetupMutationVariables>(UpdateStorefrontSetupDocument, options);
      }
export type UpdateStorefrontSetupMutationHookResult = ReturnType<typeof useUpdateStorefrontSetupMutation>;
export type UpdateStorefrontSetupMutationResult = Apollo.MutationResult<Types.UpdateStorefrontSetupMutation>;
export type UpdateStorefrontSetupMutationOptions = Apollo.BaseMutationOptions<Types.UpdateStorefrontSetupMutation, Types.UpdateStorefrontSetupMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<Types.UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserMutation, Types.UpdateUserMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($input: UpdateUserSettingsInput!) {
  updateUserSettings(input: $input) {
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<Types.UpdateUserSettingsMutation, Types.UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateUserSettingsMutation, Types.UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateUserSettingsMutation, Types.UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<Types.UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateUserSettingsMutation, Types.UpdateUserSettingsMutationVariables>;
export const UploadAndExtractAgentNegotiationDocumentsDocument = gql`
    mutation uploadAndExtractAgentNegotiationDocuments($input: UploadListingDocumentInput!) {
  uploadAndExtractAgentNegotiationDocuments(input: $input) {
    listingDocumentUploads {
      id
      file {
        fileName
        url
      }
    }
    agentCompensationFields {
      flatFee
      isListingFirmPaying
      isSellerPaying
      percentOfGrossSalesPrice
    }
  }
}
    `;
export type UploadAndExtractAgentNegotiationDocumentsMutationFn = Apollo.MutationFunction<Types.UploadAndExtractAgentNegotiationDocumentsMutation, Types.UploadAndExtractAgentNegotiationDocumentsMutationVariables>;

/**
 * __useUploadAndExtractAgentNegotiationDocumentsMutation__
 *
 * To run a mutation, you first call `useUploadAndExtractAgentNegotiationDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAndExtractAgentNegotiationDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAndExtractAgentNegotiationDocumentsMutation, { data, loading, error }] = useUploadAndExtractAgentNegotiationDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAndExtractAgentNegotiationDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadAndExtractAgentNegotiationDocumentsMutation, Types.UploadAndExtractAgentNegotiationDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadAndExtractAgentNegotiationDocumentsMutation, Types.UploadAndExtractAgentNegotiationDocumentsMutationVariables>(UploadAndExtractAgentNegotiationDocumentsDocument, options);
      }
export type UploadAndExtractAgentNegotiationDocumentsMutationHookResult = ReturnType<typeof useUploadAndExtractAgentNegotiationDocumentsMutation>;
export type UploadAndExtractAgentNegotiationDocumentsMutationResult = Apollo.MutationResult<Types.UploadAndExtractAgentNegotiationDocumentsMutation>;
export type UploadAndExtractAgentNegotiationDocumentsMutationOptions = Apollo.BaseMutationOptions<Types.UploadAndExtractAgentNegotiationDocumentsMutation, Types.UploadAndExtractAgentNegotiationDocumentsMutationVariables>;
export const UploadListingDocumentDocument = gql`
    mutation uploadListingDocument($input: UploadListingDocumentInput!) {
  uploadListingDocument(input: $input) {
    id
    file {
      fileName
      url
    }
  }
}
    `;
export type UploadListingDocumentMutationFn = Apollo.MutationFunction<Types.UploadListingDocumentMutation, Types.UploadListingDocumentMutationVariables>;

/**
 * __useUploadListingDocumentMutation__
 *
 * To run a mutation, you first call `useUploadListingDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadListingDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadListingDocumentMutation, { data, loading, error }] = useUploadListingDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadListingDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadListingDocumentMutation, Types.UploadListingDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadListingDocumentMutation, Types.UploadListingDocumentMutationVariables>(UploadListingDocumentDocument, options);
      }
export type UploadListingDocumentMutationHookResult = ReturnType<typeof useUploadListingDocumentMutation>;
export type UploadListingDocumentMutationResult = Apollo.MutationResult<Types.UploadListingDocumentMutation>;
export type UploadListingDocumentMutationOptions = Apollo.BaseMutationOptions<Types.UploadListingDocumentMutation, Types.UploadListingDocumentMutationVariables>;
export const UploadOfferAsListingAgentDocument = gql`
    mutation uploadOfferAsListingAgent($input: UploadOfferInput!) {
  uploadOfferAsListingAgent(input: $input) {
    offer {
      id
      contractId
      file {
        fileName
        url
      }
    }
  }
}
    `;
export type UploadOfferAsListingAgentMutationFn = Apollo.MutationFunction<Types.UploadOfferAsListingAgentMutation, Types.UploadOfferAsListingAgentMutationVariables>;

/**
 * __useUploadOfferAsListingAgentMutation__
 *
 * To run a mutation, you first call `useUploadOfferAsListingAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOfferAsListingAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOfferAsListingAgentMutation, { data, loading, error }] = useUploadOfferAsListingAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadOfferAsListingAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadOfferAsListingAgentMutation, Types.UploadOfferAsListingAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadOfferAsListingAgentMutation, Types.UploadOfferAsListingAgentMutationVariables>(UploadOfferAsListingAgentDocument, options);
      }
export type UploadOfferAsListingAgentMutationHookResult = ReturnType<typeof useUploadOfferAsListingAgentMutation>;
export type UploadOfferAsListingAgentMutationResult = Apollo.MutationResult<Types.UploadOfferAsListingAgentMutation>;
export type UploadOfferAsListingAgentMutationOptions = Apollo.BaseMutationOptions<Types.UploadOfferAsListingAgentMutation, Types.UploadOfferAsListingAgentMutationVariables>;
export const UploadOfferForBuyersAgentDocument = gql`
    mutation uploadOfferForBuyersAgent($input: UploadOfferInput!, $isAgentVerified: Boolean = false) {
  uploadOfferForBuyersAgent(input: $input) @include(if: $isAgentVerified) {
    offer {
      id
      contractId
      file {
        fileName
        url
      }
    }
  }
  uploadOfferForUnauthenticatedBuyersAgent(input: $input) @skip(if: $isAgentVerified) {
    offer {
      id
      contractId
      file {
        fileName
        url
      }
    }
  }
}
    `;
export type UploadOfferForBuyersAgentMutationFn = Apollo.MutationFunction<Types.UploadOfferForBuyersAgentMutation, Types.UploadOfferForBuyersAgentMutationVariables>;

/**
 * __useUploadOfferForBuyersAgentMutation__
 *
 * To run a mutation, you first call `useUploadOfferForBuyersAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOfferForBuyersAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOfferForBuyersAgentMutation, { data, loading, error }] = useUploadOfferForBuyersAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isAgentVerified: // value for 'isAgentVerified'
 *   },
 * });
 */
export function useUploadOfferForBuyersAgentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UploadOfferForBuyersAgentMutation, Types.UploadOfferForBuyersAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UploadOfferForBuyersAgentMutation, Types.UploadOfferForBuyersAgentMutationVariables>(UploadOfferForBuyersAgentDocument, options);
      }
export type UploadOfferForBuyersAgentMutationHookResult = ReturnType<typeof useUploadOfferForBuyersAgentMutation>;
export type UploadOfferForBuyersAgentMutationResult = Apollo.MutationResult<Types.UploadOfferForBuyersAgentMutation>;
export type UploadOfferForBuyersAgentMutationOptions = Apollo.BaseMutationOptions<Types.UploadOfferForBuyersAgentMutation, Types.UploadOfferForBuyersAgentMutationVariables>;
export const VerifyShareLinkDocument = gql`
    mutation VerifyShareLink($token: String!) {
  verifyShareLink(input: {token: $token}) {
    isValid
    isExpired
    accessType
    isForPdf
    sharedBy {
      ...PublicUser
    }
  }
}
    ${PublicUserFragmentDoc}`;
export type VerifyShareLinkMutationFn = Apollo.MutationFunction<Types.VerifyShareLinkMutation, Types.VerifyShareLinkMutationVariables>;

/**
 * __useVerifyShareLinkMutation__
 *
 * To run a mutation, you first call `useVerifyShareLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyShareLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyShareLinkMutation, { data, loading, error }] = useVerifyShareLinkMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyShareLinkMutation(baseOptions?: Apollo.MutationHookOptions<Types.VerifyShareLinkMutation, Types.VerifyShareLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.VerifyShareLinkMutation, Types.VerifyShareLinkMutationVariables>(VerifyShareLinkDocument, options);
      }
export type VerifyShareLinkMutationHookResult = ReturnType<typeof useVerifyShareLinkMutation>;
export type VerifyShareLinkMutationResult = Apollo.MutationResult<Types.VerifyShareLinkMutation>;
export type VerifyShareLinkMutationOptions = Apollo.BaseMutationOptions<Types.VerifyShareLinkMutation, Types.VerifyShareLinkMutationVariables>;
export const AccessControlsListDocument = gql`
    query accessControlsList($cursor: String, $orderBy: String = "id", $perPage: Int = 100, $filters: AccessControlsListFilters!) {
  accessControlsList(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) {
    results {
      ...AccessControl
    }
  }
}
    ${AccessControlFragmentDoc}`;

/**
 * __useAccessControlsListQuery__
 *
 * To run a query within a React component, call `useAccessControlsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessControlsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessControlsListQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAccessControlsListQuery(baseOptions: Apollo.QueryHookOptions<Types.AccessControlsListQuery, Types.AccessControlsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AccessControlsListQuery, Types.AccessControlsListQueryVariables>(AccessControlsListDocument, options);
      }
export function useAccessControlsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AccessControlsListQuery, Types.AccessControlsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AccessControlsListQuery, Types.AccessControlsListQueryVariables>(AccessControlsListDocument, options);
        }
export type AccessControlsListQueryHookResult = ReturnType<typeof useAccessControlsListQuery>;
export type AccessControlsListLazyQueryHookResult = ReturnType<typeof useAccessControlsListLazyQuery>;
export type AccessControlsListQueryResult = Apollo.QueryResult<Types.AccessControlsListQuery, Types.AccessControlsListQueryVariables>;
export const ActiveIntegrationClientsDocument = gql`
    query activeIntegrationClients {
  activeIntegrationClients {
    ...ActiveIntegrationClient
  }
}
    ${ActiveIntegrationClientFragmentDoc}`;

/**
 * __useActiveIntegrationClientsQuery__
 *
 * To run a query within a React component, call `useActiveIntegrationClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveIntegrationClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveIntegrationClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveIntegrationClientsQuery(baseOptions?: Apollo.QueryHookOptions<Types.ActiveIntegrationClientsQuery, Types.ActiveIntegrationClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ActiveIntegrationClientsQuery, Types.ActiveIntegrationClientsQueryVariables>(ActiveIntegrationClientsDocument, options);
      }
export function useActiveIntegrationClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ActiveIntegrationClientsQuery, Types.ActiveIntegrationClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ActiveIntegrationClientsQuery, Types.ActiveIntegrationClientsQueryVariables>(ActiveIntegrationClientsDocument, options);
        }
export type ActiveIntegrationClientsQueryHookResult = ReturnType<typeof useActiveIntegrationClientsQuery>;
export type ActiveIntegrationClientsLazyQueryHookResult = ReturnType<typeof useActiveIntegrationClientsLazyQuery>;
export type ActiveIntegrationClientsQueryResult = Apollo.QueryResult<Types.ActiveIntegrationClientsQuery, Types.ActiveIntegrationClientsQueryVariables>;
export const AiConversationSessionFileSignedUrlDocument = gql`
    query aiConversationSessionFileSignedUrl($input: GetAIConversationSessionFileSignedUrlInput!) {
  aiConversationSessionFileSignedUrl(input: $input) {
    key
    file
    signedUrl
  }
}
    `;

/**
 * __useAiConversationSessionFileSignedUrlQuery__
 *
 * To run a query within a React component, call `useAiConversationSessionFileSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiConversationSessionFileSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiConversationSessionFileSignedUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiConversationSessionFileSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<Types.AiConversationSessionFileSignedUrlQuery, Types.AiConversationSessionFileSignedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AiConversationSessionFileSignedUrlQuery, Types.AiConversationSessionFileSignedUrlQueryVariables>(AiConversationSessionFileSignedUrlDocument, options);
      }
export function useAiConversationSessionFileSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AiConversationSessionFileSignedUrlQuery, Types.AiConversationSessionFileSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AiConversationSessionFileSignedUrlQuery, Types.AiConversationSessionFileSignedUrlQueryVariables>(AiConversationSessionFileSignedUrlDocument, options);
        }
export type AiConversationSessionFileSignedUrlQueryHookResult = ReturnType<typeof useAiConversationSessionFileSignedUrlQuery>;
export type AiConversationSessionFileSignedUrlLazyQueryHookResult = ReturnType<typeof useAiConversationSessionFileSignedUrlLazyQuery>;
export type AiConversationSessionFileSignedUrlQueryResult = Apollo.QueryResult<Types.AiConversationSessionFileSignedUrlQuery, Types.AiConversationSessionFileSignedUrlQueryVariables>;
export const AiConversationSessionFilesDocument = gql`
    query aiConversationSessionFiles($input: ListAIConversationSessionFilesInput!) {
  aiConversationSessionFiles(input: $input) {
    files {
      key
      file
    }
  }
}
    `;

/**
 * __useAiConversationSessionFilesQuery__
 *
 * To run a query within a React component, call `useAiConversationSessionFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiConversationSessionFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiConversationSessionFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiConversationSessionFilesQuery(baseOptions: Apollo.QueryHookOptions<Types.AiConversationSessionFilesQuery, Types.AiConversationSessionFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AiConversationSessionFilesQuery, Types.AiConversationSessionFilesQueryVariables>(AiConversationSessionFilesDocument, options);
      }
export function useAiConversationSessionFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AiConversationSessionFilesQuery, Types.AiConversationSessionFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AiConversationSessionFilesQuery, Types.AiConversationSessionFilesQueryVariables>(AiConversationSessionFilesDocument, options);
        }
export type AiConversationSessionFilesQueryHookResult = ReturnType<typeof useAiConversationSessionFilesQuery>;
export type AiConversationSessionFilesLazyQueryHookResult = ReturnType<typeof useAiConversationSessionFilesLazyQuery>;
export type AiConversationSessionFilesQueryResult = Apollo.QueryResult<Types.AiConversationSessionFilesQuery, Types.AiConversationSessionFilesQueryVariables>;
export const AiConversationsDocument = gql`
    query aiConversations($cursor: String, $orderBy: String = "updatedAt", $perPage: Int = 50, $filters: ListAIConversationsInput) {
  aiConversations(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) {
    results {
      ...AIConversation
    }
    pageInfo {
      hasNextPage
      nextCursor
    }
  }
}
    ${AiConversationFragmentDoc}`;

/**
 * __useAiConversationsQuery__
 *
 * To run a query within a React component, call `useAiConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiConversationsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAiConversationsQuery(baseOptions?: Apollo.QueryHookOptions<Types.AiConversationsQuery, Types.AiConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AiConversationsQuery, Types.AiConversationsQueryVariables>(AiConversationsDocument, options);
      }
export function useAiConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AiConversationsQuery, Types.AiConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AiConversationsQuery, Types.AiConversationsQueryVariables>(AiConversationsDocument, options);
        }
export type AiConversationsQueryHookResult = ReturnType<typeof useAiConversationsQuery>;
export type AiConversationsLazyQueryHookResult = ReturnType<typeof useAiConversationsLazyQuery>;
export type AiConversationsQueryResult = Apollo.QueryResult<Types.AiConversationsQuery, Types.AiConversationsQueryVariables>;
export const AllListingActivitiesForCurrentUserDocument = gql`
    query allListingActivitiesForCurrentUser($includeListing: Boolean! = true, $limit: Float = 10, $offset: Float = 0) {
  allListingActivitiesForCurrentUser(limit: $limit, offset: $offset) {
    results {
      ...Activity
    }
    hasNext
  }
}
    ${ActivityFragmentDoc}`;

/**
 * __useAllListingActivitiesForCurrentUserQuery__
 *
 * To run a query within a React component, call `useAllListingActivitiesForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllListingActivitiesForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllListingActivitiesForCurrentUserQuery({
 *   variables: {
 *      includeListing: // value for 'includeListing'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAllListingActivitiesForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllListingActivitiesForCurrentUserQuery, Types.AllListingActivitiesForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllListingActivitiesForCurrentUserQuery, Types.AllListingActivitiesForCurrentUserQueryVariables>(AllListingActivitiesForCurrentUserDocument, options);
      }
export function useAllListingActivitiesForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllListingActivitiesForCurrentUserQuery, Types.AllListingActivitiesForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllListingActivitiesForCurrentUserQuery, Types.AllListingActivitiesForCurrentUserQueryVariables>(AllListingActivitiesForCurrentUserDocument, options);
        }
export type AllListingActivitiesForCurrentUserQueryHookResult = ReturnType<typeof useAllListingActivitiesForCurrentUserQuery>;
export type AllListingActivitiesForCurrentUserLazyQueryHookResult = ReturnType<typeof useAllListingActivitiesForCurrentUserLazyQuery>;
export type AllListingActivitiesForCurrentUserQueryResult = Apollo.QueryResult<Types.AllListingActivitiesForCurrentUserQuery, Types.AllListingActivitiesForCurrentUserQueryVariables>;
export const AllMlSesDocument = gql`
    query allMLSes {
  allMLSes {
    mls {
      ...MLSObjectForAllMLSes
    }
  }
}
    ${MlsObjectForAllMlSesFragmentDoc}`;

/**
 * __useAllMlSesQuery__
 *
 * To run a query within a React component, call `useAllMlSesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMlSesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMlSesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMlSesQuery(baseOptions?: Apollo.QueryHookOptions<Types.AllMlSesQuery, Types.AllMlSesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AllMlSesQuery, Types.AllMlSesQueryVariables>(AllMlSesDocument, options);
      }
export function useAllMlSesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AllMlSesQuery, Types.AllMlSesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AllMlSesQuery, Types.AllMlSesQueryVariables>(AllMlSesDocument, options);
        }
export type AllMlSesQueryHookResult = ReturnType<typeof useAllMlSesQuery>;
export type AllMlSesLazyQueryHookResult = ReturnType<typeof useAllMlSesLazyQuery>;
export type AllMlSesQueryResult = Apollo.QueryResult<Types.AllMlSesQuery, Types.AllMlSesQueryVariables>;
export const AuditEssentialsNotificationsDocument = gql`
    query auditEssentialsNotifications($filters: AuditEssentialsNotificationsFilters!) {
  auditEssentialsNotifications(filters: $filters) {
    ...AuditEssentialsNotification
  }
}
    ${AuditEssentialsNotificationFragmentDoc}`;

/**
 * __useAuditEssentialsNotificationsQuery__
 *
 * To run a query within a React component, call `useAuditEssentialsNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditEssentialsNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditEssentialsNotificationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAuditEssentialsNotificationsQuery(baseOptions: Apollo.QueryHookOptions<Types.AuditEssentialsNotificationsQuery, Types.AuditEssentialsNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.AuditEssentialsNotificationsQuery, Types.AuditEssentialsNotificationsQueryVariables>(AuditEssentialsNotificationsDocument, options);
      }
export function useAuditEssentialsNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.AuditEssentialsNotificationsQuery, Types.AuditEssentialsNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.AuditEssentialsNotificationsQuery, Types.AuditEssentialsNotificationsQueryVariables>(AuditEssentialsNotificationsDocument, options);
        }
export type AuditEssentialsNotificationsQueryHookResult = ReturnType<typeof useAuditEssentialsNotificationsQuery>;
export type AuditEssentialsNotificationsLazyQueryHookResult = ReturnType<typeof useAuditEssentialsNotificationsLazyQuery>;
export type AuditEssentialsNotificationsQueryResult = Apollo.QueryResult<Types.AuditEssentialsNotificationsQuery, Types.AuditEssentialsNotificationsQueryVariables>;
export const OfferAutofillVariablesSchemaDocument = gql`
    query offerAutofillVariablesSchema($usState: USState!) {
  offerAutofillVariablesSchema(usState: $usState)
}
    `;

/**
 * __useOfferAutofillVariablesSchemaQuery__
 *
 * To run a query within a React component, call `useOfferAutofillVariablesSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferAutofillVariablesSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferAutofillVariablesSchemaQuery({
 *   variables: {
 *      usState: // value for 'usState'
 *   },
 * });
 */
export function useOfferAutofillVariablesSchemaQuery(baseOptions: Apollo.QueryHookOptions<Types.OfferAutofillVariablesSchemaQuery, Types.OfferAutofillVariablesSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OfferAutofillVariablesSchemaQuery, Types.OfferAutofillVariablesSchemaQueryVariables>(OfferAutofillVariablesSchemaDocument, options);
      }
export function useOfferAutofillVariablesSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OfferAutofillVariablesSchemaQuery, Types.OfferAutofillVariablesSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OfferAutofillVariablesSchemaQuery, Types.OfferAutofillVariablesSchemaQueryVariables>(OfferAutofillVariablesSchemaDocument, options);
        }
export type OfferAutofillVariablesSchemaQueryHookResult = ReturnType<typeof useOfferAutofillVariablesSchemaQuery>;
export type OfferAutofillVariablesSchemaLazyQueryHookResult = ReturnType<typeof useOfferAutofillVariablesSchemaLazyQuery>;
export type OfferAutofillVariablesSchemaQueryResult = Apollo.QueryResult<Types.OfferAutofillVariablesSchemaQuery, Types.OfferAutofillVariablesSchemaQueryVariables>;
export const OfferAutofillVariableValuesDocument = gql`
    query offerAutofillVariableValues($offerId: ID!) {
  offerAutofillVariableValues(offerIds: [$offerId]) {
    preference
    property {
      ...Property
    }
    seller {
      ...AutofillConsumer
    }
    buyer {
      ...AutofillConsumer
    }
    coBuyer {
      ...AutofillConsumer
    }
    coSeller {
      ...AutofillConsumer
    }
    latestSale {
      closedDate
      deedBook
      deedPage
      salePrice
      assessorParcelNumber
    }
    listingAgent {
      ...User
    }
    mlsListing {
      ...MLSListing
    }
    buyersAgent {
      ...User
    }
  }
}
    ${PropertyFragmentDoc}
${AutofillConsumerFragmentDoc}
${UserFragmentDoc}
${MlsListingFragmentDoc}`;

/**
 * __useOfferAutofillVariableValuesQuery__
 *
 * To run a query within a React component, call `useOfferAutofillVariableValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferAutofillVariableValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferAutofillVariableValuesQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useOfferAutofillVariableValuesQuery(baseOptions: Apollo.QueryHookOptions<Types.OfferAutofillVariableValuesQuery, Types.OfferAutofillVariableValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OfferAutofillVariableValuesQuery, Types.OfferAutofillVariableValuesQueryVariables>(OfferAutofillVariableValuesDocument, options);
      }
export function useOfferAutofillVariableValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OfferAutofillVariableValuesQuery, Types.OfferAutofillVariableValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OfferAutofillVariableValuesQuery, Types.OfferAutofillVariableValuesQueryVariables>(OfferAutofillVariableValuesDocument, options);
        }
export type OfferAutofillVariableValuesQueryHookResult = ReturnType<typeof useOfferAutofillVariableValuesQuery>;
export type OfferAutofillVariableValuesLazyQueryHookResult = ReturnType<typeof useOfferAutofillVariableValuesLazyQuery>;
export type OfferAutofillVariableValuesQueryResult = Apollo.QueryResult<Types.OfferAutofillVariableValuesQuery, Types.OfferAutofillVariableValuesQueryVariables>;
export const ListingAutofillVariableValuesDocument = gql`
    query listingAutofillVariableValues($listingIds: [ID!]!) {
  listingAutofillVariableValues(listingIds: $listingIds) {
    preference
    mlsListing {
      ...MLSListing
    }
  }
}
    ${MlsListingFragmentDoc}`;

/**
 * __useListingAutofillVariableValuesQuery__
 *
 * To run a query within a React component, call `useListingAutofillVariableValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingAutofillVariableValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingAutofillVariableValuesQuery({
 *   variables: {
 *      listingIds: // value for 'listingIds'
 *   },
 * });
 */
export function useListingAutofillVariableValuesQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingAutofillVariableValuesQuery, Types.ListingAutofillVariableValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingAutofillVariableValuesQuery, Types.ListingAutofillVariableValuesQueryVariables>(ListingAutofillVariableValuesDocument, options);
      }
export function useListingAutofillVariableValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingAutofillVariableValuesQuery, Types.ListingAutofillVariableValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingAutofillVariableValuesQuery, Types.ListingAutofillVariableValuesQueryVariables>(ListingAutofillVariableValuesDocument, options);
        }
export type ListingAutofillVariableValuesQueryHookResult = ReturnType<typeof useListingAutofillVariableValuesQuery>;
export type ListingAutofillVariableValuesLazyQueryHookResult = ReturnType<typeof useListingAutofillVariableValuesLazyQuery>;
export type ListingAutofillVariableValuesQueryResult = Apollo.QueryResult<Types.ListingAutofillVariableValuesQuery, Types.ListingAutofillVariableValuesQueryVariables>;
export const OfferAutofillValuesFromContractDocument = gql`
    query offerAutofillValuesFromContract($offerId: ID!) {
  offerAutofillVariableValuesFromContract(offerId: $offerId) {
    extractedBuyerInfos {
      primary {
        fullName
        entity {
          name
          title
        }
      }
      secondary {
        fullName
        entity {
          name
          title
        }
      }
    }
  }
}
    `;

/**
 * __useOfferAutofillValuesFromContractQuery__
 *
 * To run a query within a React component, call `useOfferAutofillValuesFromContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferAutofillValuesFromContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferAutofillValuesFromContractQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useOfferAutofillValuesFromContractQuery(baseOptions: Apollo.QueryHookOptions<Types.OfferAutofillValuesFromContractQuery, Types.OfferAutofillValuesFromContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OfferAutofillValuesFromContractQuery, Types.OfferAutofillValuesFromContractQueryVariables>(OfferAutofillValuesFromContractDocument, options);
      }
export function useOfferAutofillValuesFromContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OfferAutofillValuesFromContractQuery, Types.OfferAutofillValuesFromContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OfferAutofillValuesFromContractQuery, Types.OfferAutofillValuesFromContractQueryVariables>(OfferAutofillValuesFromContractDocument, options);
        }
export type OfferAutofillValuesFromContractQueryHookResult = ReturnType<typeof useOfferAutofillValuesFromContractQuery>;
export type OfferAutofillValuesFromContractLazyQueryHookResult = ReturnType<typeof useOfferAutofillValuesFromContractLazyQuery>;
export type OfferAutofillValuesFromContractQueryResult = Apollo.QueryResult<Types.OfferAutofillValuesFromContractQuery, Types.OfferAutofillValuesFromContractQueryVariables>;
export const BusinessOverviewOffersDocument = gql`
    query businessOverviewOffers($filters: BusinessOverviewOffersFilterInput!, $perPage: Int, $cursor: String) {
  businessOverviewOffers(
    filters: $filters
    perPage: $perPage
    cursor: $cursor
    orderBy: "-createdAt"
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...BizOverviewOffer
    }
  }
}
    ${PageInfoFragmentDoc}
${BizOverviewOfferFragmentDoc}`;

/**
 * __useBusinessOverviewOffersQuery__
 *
 * To run a query within a React component, call `useBusinessOverviewOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessOverviewOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessOverviewOffersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      perPage: // value for 'perPage'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useBusinessOverviewOffersQuery(baseOptions: Apollo.QueryHookOptions<Types.BusinessOverviewOffersQuery, Types.BusinessOverviewOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BusinessOverviewOffersQuery, Types.BusinessOverviewOffersQueryVariables>(BusinessOverviewOffersDocument, options);
      }
export function useBusinessOverviewOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BusinessOverviewOffersQuery, Types.BusinessOverviewOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BusinessOverviewOffersQuery, Types.BusinessOverviewOffersQueryVariables>(BusinessOverviewOffersDocument, options);
        }
export type BusinessOverviewOffersQueryHookResult = ReturnType<typeof useBusinessOverviewOffersQuery>;
export type BusinessOverviewOffersLazyQueryHookResult = ReturnType<typeof useBusinessOverviewOffersLazyQuery>;
export type BusinessOverviewOffersQueryResult = Apollo.QueryResult<Types.BusinessOverviewOffersQuery, Types.BusinessOverviewOffersQueryVariables>;
export const BusinessOverviewStatsDocument = gql`
    query BusinessOverviewStats($input: BusinessOverviewStatsInput!) {
  businessOverviewStats(input: $input) {
    stats {
      ...BusinessOverviewStat
    }
  }
}
    ${BusinessOverviewStatFragmentDoc}`;

/**
 * __useBusinessOverviewStatsQuery__
 *
 * To run a query within a React component, call `useBusinessOverviewStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessOverviewStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessOverviewStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBusinessOverviewStatsQuery(baseOptions: Apollo.QueryHookOptions<Types.BusinessOverviewStatsQuery, Types.BusinessOverviewStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BusinessOverviewStatsQuery, Types.BusinessOverviewStatsQueryVariables>(BusinessOverviewStatsDocument, options);
      }
export function useBusinessOverviewStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BusinessOverviewStatsQuery, Types.BusinessOverviewStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BusinessOverviewStatsQuery, Types.BusinessOverviewStatsQueryVariables>(BusinessOverviewStatsDocument, options);
        }
export type BusinessOverviewStatsQueryHookResult = ReturnType<typeof useBusinessOverviewStatsQuery>;
export type BusinessOverviewStatsLazyQueryHookResult = ReturnType<typeof useBusinessOverviewStatsLazyQuery>;
export type BusinessOverviewStatsQueryResult = Apollo.QueryResult<Types.BusinessOverviewStatsQuery, Types.BusinessOverviewStatsQueryVariables>;
export const BuyerClientsForCurrentAgentUserDocument = gql`
    query BuyerClientsForCurrentAgentUser {
  buyerClientsForCurrentAgentUser {
    ...Party
  }
}
    ${PartyFragmentDoc}`;

/**
 * __useBuyerClientsForCurrentAgentUserQuery__
 *
 * To run a query within a React component, call `useBuyerClientsForCurrentAgentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyerClientsForCurrentAgentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyerClientsForCurrentAgentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useBuyerClientsForCurrentAgentUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.BuyerClientsForCurrentAgentUserQuery, Types.BuyerClientsForCurrentAgentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BuyerClientsForCurrentAgentUserQuery, Types.BuyerClientsForCurrentAgentUserQueryVariables>(BuyerClientsForCurrentAgentUserDocument, options);
      }
export function useBuyerClientsForCurrentAgentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BuyerClientsForCurrentAgentUserQuery, Types.BuyerClientsForCurrentAgentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BuyerClientsForCurrentAgentUserQuery, Types.BuyerClientsForCurrentAgentUserQueryVariables>(BuyerClientsForCurrentAgentUserDocument, options);
        }
export type BuyerClientsForCurrentAgentUserQueryHookResult = ReturnType<typeof useBuyerClientsForCurrentAgentUserQuery>;
export type BuyerClientsForCurrentAgentUserLazyQueryHookResult = ReturnType<typeof useBuyerClientsForCurrentAgentUserLazyQuery>;
export type BuyerClientsForCurrentAgentUserQueryResult = Apollo.QueryResult<Types.BuyerClientsForCurrentAgentUserQuery, Types.BuyerClientsForCurrentAgentUserQueryVariables>;
export const BuyersForCurrentAgentPaginatedDocument = gql`
    query BuyersForCurrentAgentPaginated($cursor: String, $perPage: Int! = 20, $orderBy: String! = "-createdAt") {
  buyersForCurrentAgentPaginated(
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...Party
      latestBuyerOfferAnalysis {
        id
        createdAt
        listing {
          id
          property {
            ...Property
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${PartyFragmentDoc}
${PropertyFragmentDoc}`;

/**
 * __useBuyersForCurrentAgentPaginatedQuery__
 *
 * To run a query within a React component, call `useBuyersForCurrentAgentPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyersForCurrentAgentPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyersForCurrentAgentPaginatedQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useBuyersForCurrentAgentPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<Types.BuyersForCurrentAgentPaginatedQuery, Types.BuyersForCurrentAgentPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.BuyersForCurrentAgentPaginatedQuery, Types.BuyersForCurrentAgentPaginatedQueryVariables>(BuyersForCurrentAgentPaginatedDocument, options);
      }
export function useBuyersForCurrentAgentPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.BuyersForCurrentAgentPaginatedQuery, Types.BuyersForCurrentAgentPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.BuyersForCurrentAgentPaginatedQuery, Types.BuyersForCurrentAgentPaginatedQueryVariables>(BuyersForCurrentAgentPaginatedDocument, options);
        }
export type BuyersForCurrentAgentPaginatedQueryHookResult = ReturnType<typeof useBuyersForCurrentAgentPaginatedQuery>;
export type BuyersForCurrentAgentPaginatedLazyQueryHookResult = ReturnType<typeof useBuyersForCurrentAgentPaginatedLazyQuery>;
export type BuyersForCurrentAgentPaginatedQueryResult = Apollo.QueryResult<Types.BuyersForCurrentAgentPaginatedQuery, Types.BuyersForCurrentAgentPaginatedQueryVariables>;
export const CheckPermissionDocument = gql`
    query checkPermission($input: CheckPermissionInput!) {
  checkPermission(input: $input) {
    isAuthorized
    message
  }
}
    `;

/**
 * __useCheckPermissionQuery__
 *
 * To run a query within a React component, call `useCheckPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPermissionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckPermissionQuery(baseOptions: Apollo.QueryHookOptions<Types.CheckPermissionQuery, Types.CheckPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CheckPermissionQuery, Types.CheckPermissionQueryVariables>(CheckPermissionDocument, options);
      }
export function useCheckPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CheckPermissionQuery, Types.CheckPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CheckPermissionQuery, Types.CheckPermissionQueryVariables>(CheckPermissionDocument, options);
        }
export type CheckPermissionQueryHookResult = ReturnType<typeof useCheckPermissionQuery>;
export type CheckPermissionLazyQueryHookResult = ReturnType<typeof useCheckPermissionLazyQuery>;
export type CheckPermissionQueryResult = Apollo.QueryResult<Types.CheckPermissionQuery, Types.CheckPermissionQueryVariables>;
export const ComplianceDashboardOfficeOptionsDocument = gql`
    query complianceDashboardOfficeOptions($organizationId: ID!) {
  organizationComplianceDashboardMeta(
    organizationId: $organizationId
    input: {includeAllTimeScopeOptions: true}
  ) {
    filters {
      officeOptions {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useComplianceDashboardOfficeOptionsQuery__
 *
 * To run a query within a React component, call `useComplianceDashboardOfficeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceDashboardOfficeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceDashboardOfficeOptionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useComplianceDashboardOfficeOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.ComplianceDashboardOfficeOptionsQuery, Types.ComplianceDashboardOfficeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ComplianceDashboardOfficeOptionsQuery, Types.ComplianceDashboardOfficeOptionsQueryVariables>(ComplianceDashboardOfficeOptionsDocument, options);
      }
export function useComplianceDashboardOfficeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ComplianceDashboardOfficeOptionsQuery, Types.ComplianceDashboardOfficeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ComplianceDashboardOfficeOptionsQuery, Types.ComplianceDashboardOfficeOptionsQueryVariables>(ComplianceDashboardOfficeOptionsDocument, options);
        }
export type ComplianceDashboardOfficeOptionsQueryHookResult = ReturnType<typeof useComplianceDashboardOfficeOptionsQuery>;
export type ComplianceDashboardOfficeOptionsLazyQueryHookResult = ReturnType<typeof useComplianceDashboardOfficeOptionsLazyQuery>;
export type ComplianceDashboardOfficeOptionsQueryResult = Apollo.QueryResult<Types.ComplianceDashboardOfficeOptionsQuery, Types.ComplianceDashboardOfficeOptionsQueryVariables>;
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<Types.CurrentUserQuery, Types.CurrentUserQueryVariables>;
export const EventsForOfferDocument = gql`
    query EventsForOffer($input: EventsForOfferInput!) {
  eventsForOffer(input: $input) {
    name
    isDone
    doneAt
    label
  }
}
    `;

/**
 * __useEventsForOfferQuery__
 *
 * To run a query within a React component, call `useEventsForOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsForOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsForOfferQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventsForOfferQuery(baseOptions: Apollo.QueryHookOptions<Types.EventsForOfferQuery, Types.EventsForOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EventsForOfferQuery, Types.EventsForOfferQueryVariables>(EventsForOfferDocument, options);
      }
export function useEventsForOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EventsForOfferQuery, Types.EventsForOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EventsForOfferQuery, Types.EventsForOfferQueryVariables>(EventsForOfferDocument, options);
        }
export type EventsForOfferQueryHookResult = ReturnType<typeof useEventsForOfferQuery>;
export type EventsForOfferLazyQueryHookResult = ReturnType<typeof useEventsForOfferLazyQuery>;
export type EventsForOfferQueryResult = Apollo.QueryResult<Types.EventsForOfferQuery, Types.EventsForOfferQueryVariables>;
export const ExtensionCurrentUserAuthStateDocument = gql`
    query ExtensionCurrentUserAuthState {
  currentUser {
    id
    roles
  }
}
    `;

/**
 * __useExtensionCurrentUserAuthStateQuery__
 *
 * To run a query within a React component, call `useExtensionCurrentUserAuthStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionCurrentUserAuthStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionCurrentUserAuthStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useExtensionCurrentUserAuthStateQuery(baseOptions?: Apollo.QueryHookOptions<Types.ExtensionCurrentUserAuthStateQuery, Types.ExtensionCurrentUserAuthStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExtensionCurrentUserAuthStateQuery, Types.ExtensionCurrentUserAuthStateQueryVariables>(ExtensionCurrentUserAuthStateDocument, options);
      }
export function useExtensionCurrentUserAuthStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExtensionCurrentUserAuthStateQuery, Types.ExtensionCurrentUserAuthStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExtensionCurrentUserAuthStateQuery, Types.ExtensionCurrentUserAuthStateQueryVariables>(ExtensionCurrentUserAuthStateDocument, options);
        }
export type ExtensionCurrentUserAuthStateQueryHookResult = ReturnType<typeof useExtensionCurrentUserAuthStateQuery>;
export type ExtensionCurrentUserAuthStateLazyQueryHookResult = ReturnType<typeof useExtensionCurrentUserAuthStateLazyQuery>;
export type ExtensionCurrentUserAuthStateQueryResult = Apollo.QueryResult<Types.ExtensionCurrentUserAuthStateQuery, Types.ExtensionCurrentUserAuthStateQueryVariables>;
export const ExternalGetDistinctOfficeNamesDocument = gql`
    query ExternalGetDistinctOfficeNames($input: ExternalGetDistinctOfficeNamesInput!) {
  externalGetDistinctOfficeNames(input: $input)
}
    `;

/**
 * __useExternalGetDistinctOfficeNamesQuery__
 *
 * To run a query within a React component, call `useExternalGetDistinctOfficeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetDistinctOfficeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetDistinctOfficeNamesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetDistinctOfficeNamesQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetDistinctOfficeNamesQuery, Types.ExternalGetDistinctOfficeNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetDistinctOfficeNamesQuery, Types.ExternalGetDistinctOfficeNamesQueryVariables>(ExternalGetDistinctOfficeNamesDocument, options);
      }
export function useExternalGetDistinctOfficeNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetDistinctOfficeNamesQuery, Types.ExternalGetDistinctOfficeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetDistinctOfficeNamesQuery, Types.ExternalGetDistinctOfficeNamesQueryVariables>(ExternalGetDistinctOfficeNamesDocument, options);
        }
export type ExternalGetDistinctOfficeNamesQueryHookResult = ReturnType<typeof useExternalGetDistinctOfficeNamesQuery>;
export type ExternalGetDistinctOfficeNamesLazyQueryHookResult = ReturnType<typeof useExternalGetDistinctOfficeNamesLazyQuery>;
export type ExternalGetDistinctOfficeNamesQueryResult = Apollo.QueryResult<Types.ExternalGetDistinctOfficeNamesQuery, Types.ExternalGetDistinctOfficeNamesQueryVariables>;
export const ExternalGetDistinctStatusesDocument = gql`
    query ExternalGetDistinctStatuses($input: ExternalGetDistinctStatusesInput!) {
  externalGetDistinctStatuses(input: $input)
}
    `;

/**
 * __useExternalGetDistinctStatusesQuery__
 *
 * To run a query within a React component, call `useExternalGetDistinctStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetDistinctStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetDistinctStatusesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetDistinctStatusesQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetDistinctStatusesQuery, Types.ExternalGetDistinctStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetDistinctStatusesQuery, Types.ExternalGetDistinctStatusesQueryVariables>(ExternalGetDistinctStatusesDocument, options);
      }
export function useExternalGetDistinctStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetDistinctStatusesQuery, Types.ExternalGetDistinctStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetDistinctStatusesQuery, Types.ExternalGetDistinctStatusesQueryVariables>(ExternalGetDistinctStatusesDocument, options);
        }
export type ExternalGetDistinctStatusesQueryHookResult = ReturnType<typeof useExternalGetDistinctStatusesQuery>;
export type ExternalGetDistinctStatusesLazyQueryHookResult = ReturnType<typeof useExternalGetDistinctStatusesLazyQuery>;
export type ExternalGetDistinctStatusesQueryResult = Apollo.QueryResult<Types.ExternalGetDistinctStatusesQuery, Types.ExternalGetDistinctStatusesQueryVariables>;
export const ExternalGetIngestionDocumentDocument = gql`
    query externalGetIngestionDocument($input: ExternalIngestionDocumentArgs!) {
  externalGetIngestionDocument(input: $input) {
    ...GetIngestionDocument
  }
}
    ${GetIngestionDocumentFragmentDoc}`;

/**
 * __useExternalGetIngestionDocumentQuery__
 *
 * To run a query within a React component, call `useExternalGetIngestionDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetIngestionDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetIngestionDocumentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetIngestionDocumentQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetIngestionDocumentQuery, Types.ExternalGetIngestionDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetIngestionDocumentQuery, Types.ExternalGetIngestionDocumentQueryVariables>(ExternalGetIngestionDocumentDocument, options);
      }
export function useExternalGetIngestionDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetIngestionDocumentQuery, Types.ExternalGetIngestionDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetIngestionDocumentQuery, Types.ExternalGetIngestionDocumentQueryVariables>(ExternalGetIngestionDocumentDocument, options);
        }
export type ExternalGetIngestionDocumentQueryHookResult = ReturnType<typeof useExternalGetIngestionDocumentQuery>;
export type ExternalGetIngestionDocumentLazyQueryHookResult = ReturnType<typeof useExternalGetIngestionDocumentLazyQuery>;
export type ExternalGetIngestionDocumentQueryResult = Apollo.QueryResult<Types.ExternalGetIngestionDocumentQuery, Types.ExternalGetIngestionDocumentQueryVariables>;
export const ExternalGetIngestionDocumentValidationFeedbackDocument = gql`
    query ExternalGetIngestionDocumentValidationFeedback($input: ExternalGetIngestionDocumentValidationFeedbackInput!) {
  externalGetIngestionDocumentValidationFeedback(input: $input) {
    ...IngestionDocumentValidationFeedback
  }
}
    ${IngestionDocumentValidationFeedbackFragmentDoc}`;

/**
 * __useExternalGetIngestionDocumentValidationFeedbackQuery__
 *
 * To run a query within a React component, call `useExternalGetIngestionDocumentValidationFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetIngestionDocumentValidationFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetIngestionDocumentValidationFeedbackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetIngestionDocumentValidationFeedbackQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetIngestionDocumentValidationFeedbackQuery, Types.ExternalGetIngestionDocumentValidationFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetIngestionDocumentValidationFeedbackQuery, Types.ExternalGetIngestionDocumentValidationFeedbackQueryVariables>(ExternalGetIngestionDocumentValidationFeedbackDocument, options);
      }
export function useExternalGetIngestionDocumentValidationFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetIngestionDocumentValidationFeedbackQuery, Types.ExternalGetIngestionDocumentValidationFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetIngestionDocumentValidationFeedbackQuery, Types.ExternalGetIngestionDocumentValidationFeedbackQueryVariables>(ExternalGetIngestionDocumentValidationFeedbackDocument, options);
        }
export type ExternalGetIngestionDocumentValidationFeedbackQueryHookResult = ReturnType<typeof useExternalGetIngestionDocumentValidationFeedbackQuery>;
export type ExternalGetIngestionDocumentValidationFeedbackLazyQueryHookResult = ReturnType<typeof useExternalGetIngestionDocumentValidationFeedbackLazyQuery>;
export type ExternalGetIngestionDocumentValidationFeedbackQueryResult = Apollo.QueryResult<Types.ExternalGetIngestionDocumentValidationFeedbackQuery, Types.ExternalGetIngestionDocumentValidationFeedbackQueryVariables>;
export const ExternalGetIngestionFolderDocument = gql`
    query externalGetIngestionFolder($input: ExternalGetIngestionFolderInput!, $includeTransactionPipeline: Boolean! = true, $includeKeyTerms: Boolean! = true, $sortKeyTermsByDatetime: Boolean! = true) {
  externalGetIngestionFolder(input: $input) {
    ...ExternalIngestionFolder
  }
}
    ${ExternalIngestionFolderFragmentDoc}`;

/**
 * __useExternalGetIngestionFolderQuery__
 *
 * To run a query within a React component, call `useExternalGetIngestionFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetIngestionFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetIngestionFolderQuery({
 *   variables: {
 *      input: // value for 'input'
 *      includeTransactionPipeline: // value for 'includeTransactionPipeline'
 *      includeKeyTerms: // value for 'includeKeyTerms'
 *      sortKeyTermsByDatetime: // value for 'sortKeyTermsByDatetime'
 *   },
 * });
 */
export function useExternalGetIngestionFolderQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetIngestionFolderQuery, Types.ExternalGetIngestionFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetIngestionFolderQuery, Types.ExternalGetIngestionFolderQueryVariables>(ExternalGetIngestionFolderDocument, options);
      }
export function useExternalGetIngestionFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetIngestionFolderQuery, Types.ExternalGetIngestionFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetIngestionFolderQuery, Types.ExternalGetIngestionFolderQueryVariables>(ExternalGetIngestionFolderDocument, options);
        }
export type ExternalGetIngestionFolderQueryHookResult = ReturnType<typeof useExternalGetIngestionFolderQuery>;
export type ExternalGetIngestionFolderLazyQueryHookResult = ReturnType<typeof useExternalGetIngestionFolderLazyQuery>;
export type ExternalGetIngestionFolderQueryResult = Apollo.QueryResult<Types.ExternalGetIngestionFolderQuery, Types.ExternalGetIngestionFolderQueryVariables>;
export const ExternalGetIngestionFolderValidationFeedbackDocument = gql`
    query ExternalGetIngestionFolderValidationFeedback($input: ExternalGetIngestionFolderValidationFeedbackInput!) {
  externalGetIngestionFolderValidationFeedback(input: $input) {
    ...IngestionFolderValidationFeedback
  }
}
    ${IngestionFolderValidationFeedbackFragmentDoc}`;

/**
 * __useExternalGetIngestionFolderValidationFeedbackQuery__
 *
 * To run a query within a React component, call `useExternalGetIngestionFolderValidationFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetIngestionFolderValidationFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetIngestionFolderValidationFeedbackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetIngestionFolderValidationFeedbackQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetIngestionFolderValidationFeedbackQuery, Types.ExternalGetIngestionFolderValidationFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetIngestionFolderValidationFeedbackQuery, Types.ExternalGetIngestionFolderValidationFeedbackQueryVariables>(ExternalGetIngestionFolderValidationFeedbackDocument, options);
      }
export function useExternalGetIngestionFolderValidationFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetIngestionFolderValidationFeedbackQuery, Types.ExternalGetIngestionFolderValidationFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetIngestionFolderValidationFeedbackQuery, Types.ExternalGetIngestionFolderValidationFeedbackQueryVariables>(ExternalGetIngestionFolderValidationFeedbackDocument, options);
        }
export type ExternalGetIngestionFolderValidationFeedbackQueryHookResult = ReturnType<typeof useExternalGetIngestionFolderValidationFeedbackQuery>;
export type ExternalGetIngestionFolderValidationFeedbackLazyQueryHookResult = ReturnType<typeof useExternalGetIngestionFolderValidationFeedbackLazyQuery>;
export type ExternalGetIngestionFolderValidationFeedbackQueryResult = Apollo.QueryResult<Types.ExternalGetIngestionFolderValidationFeedbackQuery, Types.ExternalGetIngestionFolderValidationFeedbackQueryVariables>;
export const ExternalGetValidationReportDataDocument = gql`
    query externalGetValidationReportData($input: ExternalGetValidationReportDataInput!) {
  externalGetValidationReportData(input: $input) {
    ...ExternalValidationReportData
  }
}
    ${ExternalValidationReportDataFragmentDoc}`;

/**
 * __useExternalGetValidationReportDataQuery__
 *
 * To run a query within a React component, call `useExternalGetValidationReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetValidationReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetValidationReportDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetValidationReportDataQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetValidationReportDataQuery, Types.ExternalGetValidationReportDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetValidationReportDataQuery, Types.ExternalGetValidationReportDataQueryVariables>(ExternalGetValidationReportDataDocument, options);
      }
export function useExternalGetValidationReportDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetValidationReportDataQuery, Types.ExternalGetValidationReportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetValidationReportDataQuery, Types.ExternalGetValidationReportDataQueryVariables>(ExternalGetValidationReportDataDocument, options);
        }
export type ExternalGetValidationReportDataQueryHookResult = ReturnType<typeof useExternalGetValidationReportDataQuery>;
export type ExternalGetValidationReportDataLazyQueryHookResult = ReturnType<typeof useExternalGetValidationReportDataLazyQuery>;
export type ExternalGetValidationReportDataQueryResult = Apollo.QueryResult<Types.ExternalGetValidationReportDataQuery, Types.ExternalGetValidationReportDataQueryVariables>;
export const ExternalIngestionDocumentsForFolderDocument = gql`
    query ExternalIngestionDocumentsForFolder($input: ExternalIngestionDocumentsForFolderInput!) {
  externalIngestionDocumentsForFolder(input: $input) {
    ...ExternalIngestionDocument
  }
}
    ${ExternalIngestionDocumentFragmentDoc}`;

/**
 * __useExternalIngestionDocumentsForFolderQuery__
 *
 * To run a query within a React component, call `useExternalIngestionDocumentsForFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIngestionDocumentsForFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIngestionDocumentsForFolderQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalIngestionDocumentsForFolderQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalIngestionDocumentsForFolderQuery, Types.ExternalIngestionDocumentsForFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalIngestionDocumentsForFolderQuery, Types.ExternalIngestionDocumentsForFolderQueryVariables>(ExternalIngestionDocumentsForFolderDocument, options);
      }
export function useExternalIngestionDocumentsForFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalIngestionDocumentsForFolderQuery, Types.ExternalIngestionDocumentsForFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalIngestionDocumentsForFolderQuery, Types.ExternalIngestionDocumentsForFolderQueryVariables>(ExternalIngestionDocumentsForFolderDocument, options);
        }
export type ExternalIngestionDocumentsForFolderQueryHookResult = ReturnType<typeof useExternalIngestionDocumentsForFolderQuery>;
export type ExternalIngestionDocumentsForFolderLazyQueryHookResult = ReturnType<typeof useExternalIngestionDocumentsForFolderLazyQuery>;
export type ExternalIngestionDocumentsForFolderQueryResult = Apollo.QueryResult<Types.ExternalIngestionDocumentsForFolderQuery, Types.ExternalIngestionDocumentsForFolderQueryVariables>;
export const ExternalIngestionFolderListForOrganizationDocument = gql`
    query ExternalIngestionFolderListForOrganization($input: ExternalIngestionFolderListForOrganizationInput!, $orderBy: String, $perPage: Int, $cursor: String, $includeTransactionPipeline: Boolean! = true) {
  externalIngestionFolderListForOrganization(
    input: $input
    orderBy: $orderBy
    perPage: $perPage
    cursor: $cursor
  ) {
    results {
      ...ExternalIngestionFolderListRow
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
      totalCount
    }
  }
}
    ${ExternalIngestionFolderListRowFragmentDoc}`;

/**
 * __useExternalIngestionFolderListForOrganizationQuery__
 *
 * To run a query within a React component, call `useExternalIngestionFolderListForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIngestionFolderListForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIngestionFolderListForOrganizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      cursor: // value for 'cursor'
 *      includeTransactionPipeline: // value for 'includeTransactionPipeline'
 *   },
 * });
 */
export function useExternalIngestionFolderListForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalIngestionFolderListForOrganizationQuery, Types.ExternalIngestionFolderListForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalIngestionFolderListForOrganizationQuery, Types.ExternalIngestionFolderListForOrganizationQueryVariables>(ExternalIngestionFolderListForOrganizationDocument, options);
      }
export function useExternalIngestionFolderListForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalIngestionFolderListForOrganizationQuery, Types.ExternalIngestionFolderListForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalIngestionFolderListForOrganizationQuery, Types.ExternalIngestionFolderListForOrganizationQueryVariables>(ExternalIngestionFolderListForOrganizationDocument, options);
        }
export type ExternalIngestionFolderListForOrganizationQueryHookResult = ReturnType<typeof useExternalIngestionFolderListForOrganizationQuery>;
export type ExternalIngestionFolderListForOrganizationLazyQueryHookResult = ReturnType<typeof useExternalIngestionFolderListForOrganizationLazyQuery>;
export type ExternalIngestionFolderListForOrganizationQueryResult = Apollo.QueryResult<Types.ExternalIngestionFolderListForOrganizationQuery, Types.ExternalIngestionFolderListForOrganizationQueryVariables>;
export const ExternalIngestionFolderPlatformUrlDocument = gql`
    query externalIngestionFolderPlatformUrl($input: ExternalIngestionFolderPlatformUrlInput!) {
  externalIngestionFolderPlatformUrl(input: $input)
}
    `;

/**
 * __useExternalIngestionFolderPlatformUrlQuery__
 *
 * To run a query within a React component, call `useExternalIngestionFolderPlatformUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIngestionFolderPlatformUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIngestionFolderPlatformUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalIngestionFolderPlatformUrlQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalIngestionFolderPlatformUrlQuery, Types.ExternalIngestionFolderPlatformUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalIngestionFolderPlatformUrlQuery, Types.ExternalIngestionFolderPlatformUrlQueryVariables>(ExternalIngestionFolderPlatformUrlDocument, options);
      }
export function useExternalIngestionFolderPlatformUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalIngestionFolderPlatformUrlQuery, Types.ExternalIngestionFolderPlatformUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalIngestionFolderPlatformUrlQuery, Types.ExternalIngestionFolderPlatformUrlQueryVariables>(ExternalIngestionFolderPlatformUrlDocument, options);
        }
export type ExternalIngestionFolderPlatformUrlQueryHookResult = ReturnType<typeof useExternalIngestionFolderPlatformUrlQuery>;
export type ExternalIngestionFolderPlatformUrlLazyQueryHookResult = ReturnType<typeof useExternalIngestionFolderPlatformUrlLazyQuery>;
export type ExternalIngestionFolderPlatformUrlQueryResult = Apollo.QueryResult<Types.ExternalIngestionFolderPlatformUrlQuery, Types.ExternalIngestionFolderPlatformUrlQueryVariables>;
export const FindMlsAgentDocument = gql`
    query findMLSAgent($input: FindMLSAgentInput!) {
  findMLSAgent(input: $input) {
    ...FindMLSAgent
  }
}
    ${FindMlsAgentFragmentDoc}`;

/**
 * __useFindMlsAgentQuery__
 *
 * To run a query within a React component, call `useFindMlsAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMlsAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMlsAgentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindMlsAgentQuery(baseOptions: Apollo.QueryHookOptions<Types.FindMlsAgentQuery, Types.FindMlsAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindMlsAgentQuery, Types.FindMlsAgentQueryVariables>(FindMlsAgentDocument, options);
      }
export function useFindMlsAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindMlsAgentQuery, Types.FindMlsAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindMlsAgentQuery, Types.FindMlsAgentQueryVariables>(FindMlsAgentDocument, options);
        }
export type FindMlsAgentQueryHookResult = ReturnType<typeof useFindMlsAgentQuery>;
export type FindMlsAgentLazyQueryHookResult = ReturnType<typeof useFindMlsAgentLazyQuery>;
export type FindMlsAgentQueryResult = Apollo.QueryResult<Types.FindMlsAgentQuery, Types.FindMlsAgentQueryVariables>;
export const FindMlsAgentByEmailDocument = gql`
    query findMLSAgentByEmail($email: String!) {
  findMLSAgentByEmail(email: $email) {
    mlsAgent {
      MemberFirstName
      MemberLastName
      MemberMobilePhone
      MemberEmail
      OriginatingSystemName
      OfficeMlsId
    }
    office {
      OfficeName
      OfficeMlsId
    }
  }
}
    `;

/**
 * __useFindMlsAgentByEmailQuery__
 *
 * To run a query within a React component, call `useFindMlsAgentByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMlsAgentByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMlsAgentByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFindMlsAgentByEmailQuery(baseOptions: Apollo.QueryHookOptions<Types.FindMlsAgentByEmailQuery, Types.FindMlsAgentByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindMlsAgentByEmailQuery, Types.FindMlsAgentByEmailQueryVariables>(FindMlsAgentByEmailDocument, options);
      }
export function useFindMlsAgentByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindMlsAgentByEmailQuery, Types.FindMlsAgentByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindMlsAgentByEmailQuery, Types.FindMlsAgentByEmailQueryVariables>(FindMlsAgentByEmailDocument, options);
        }
export type FindMlsAgentByEmailQueryHookResult = ReturnType<typeof useFindMlsAgentByEmailQuery>;
export type FindMlsAgentByEmailLazyQueryHookResult = ReturnType<typeof useFindMlsAgentByEmailLazyQuery>;
export type FindMlsAgentByEmailQueryResult = Apollo.QueryResult<Types.FindMlsAgentByEmailQuery, Types.FindMlsAgentByEmailQueryVariables>;
export const FindMlsAgentByMlsIdDocument = gql`
    query findMLSAgentByMlsId($input: FindMLSAgentByMlsIdInput!) {
  findMLSAgentByMlsId(input: $input) {
    ...FindMLSAgent
  }
}
    ${FindMlsAgentFragmentDoc}`;

/**
 * __useFindMlsAgentByMlsIdQuery__
 *
 * To run a query within a React component, call `useFindMlsAgentByMlsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMlsAgentByMlsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMlsAgentByMlsIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindMlsAgentByMlsIdQuery(baseOptions: Apollo.QueryHookOptions<Types.FindMlsAgentByMlsIdQuery, Types.FindMlsAgentByMlsIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindMlsAgentByMlsIdQuery, Types.FindMlsAgentByMlsIdQueryVariables>(FindMlsAgentByMlsIdDocument, options);
      }
export function useFindMlsAgentByMlsIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindMlsAgentByMlsIdQuery, Types.FindMlsAgentByMlsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindMlsAgentByMlsIdQuery, Types.FindMlsAgentByMlsIdQueryVariables>(FindMlsAgentByMlsIdDocument, options);
        }
export type FindMlsAgentByMlsIdQueryHookResult = ReturnType<typeof useFindMlsAgentByMlsIdQuery>;
export type FindMlsAgentByMlsIdLazyQueryHookResult = ReturnType<typeof useFindMlsAgentByMlsIdLazyQuery>;
export type FindMlsAgentByMlsIdQueryResult = Apollo.QueryResult<Types.FindMlsAgentByMlsIdQuery, Types.FindMlsAgentByMlsIdQueryVariables>;
export const FindMlsAgentsByNameDocument = gql`
    query findMLSAgentsByName($input: FindMLSAgentsByNameInput!) {
  findMLSAgentsByName(input: $input) {
    mlsAgent {
      MemberFirstName
      MemberLastName
      MemberMobilePhone
      OriginatingSystemName
      OfficeMlsId
      MemberMlsId
    }
    office {
      OfficeName
      OfficeMlsId
    }
    mls {
      originatingSystemName
    }
  }
}
    `;

/**
 * __useFindMlsAgentsByNameQuery__
 *
 * To run a query within a React component, call `useFindMlsAgentsByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMlsAgentsByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMlsAgentsByNameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindMlsAgentsByNameQuery(baseOptions: Apollo.QueryHookOptions<Types.FindMlsAgentsByNameQuery, Types.FindMlsAgentsByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindMlsAgentsByNameQuery, Types.FindMlsAgentsByNameQueryVariables>(FindMlsAgentsByNameDocument, options);
      }
export function useFindMlsAgentsByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindMlsAgentsByNameQuery, Types.FindMlsAgentsByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindMlsAgentsByNameQuery, Types.FindMlsAgentsByNameQueryVariables>(FindMlsAgentsByNameDocument, options);
        }
export type FindMlsAgentsByNameQueryHookResult = ReturnType<typeof useFindMlsAgentsByNameQuery>;
export type FindMlsAgentsByNameLazyQueryHookResult = ReturnType<typeof useFindMlsAgentsByNameLazyQuery>;
export type FindMlsAgentsByNameQueryResult = Apollo.QueryResult<Types.FindMlsAgentsByNameQuery, Types.FindMlsAgentsByNameQueryVariables>;
export const FindMlsAgentsByPhoneNumberDocument = gql`
    query findMLSAgentsByPhoneNumber($input: FindMLSAgentsByPhoneNumberInput!) {
  findMLSAgentsByPhoneNumber(input: $input) {
    ...FindMLSAgent
  }
}
    ${FindMlsAgentFragmentDoc}`;

/**
 * __useFindMlsAgentsByPhoneNumberQuery__
 *
 * To run a query within a React component, call `useFindMlsAgentsByPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMlsAgentsByPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMlsAgentsByPhoneNumberQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindMlsAgentsByPhoneNumberQuery(baseOptions: Apollo.QueryHookOptions<Types.FindMlsAgentsByPhoneNumberQuery, Types.FindMlsAgentsByPhoneNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindMlsAgentsByPhoneNumberQuery, Types.FindMlsAgentsByPhoneNumberQueryVariables>(FindMlsAgentsByPhoneNumberDocument, options);
      }
export function useFindMlsAgentsByPhoneNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindMlsAgentsByPhoneNumberQuery, Types.FindMlsAgentsByPhoneNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindMlsAgentsByPhoneNumberQuery, Types.FindMlsAgentsByPhoneNumberQueryVariables>(FindMlsAgentsByPhoneNumberDocument, options);
        }
export type FindMlsAgentsByPhoneNumberQueryHookResult = ReturnType<typeof useFindMlsAgentsByPhoneNumberQuery>;
export type FindMlsAgentsByPhoneNumberLazyQueryHookResult = ReturnType<typeof useFindMlsAgentsByPhoneNumberLazyQuery>;
export type FindMlsAgentsByPhoneNumberQueryResult = Apollo.QueryResult<Types.FindMlsAgentsByPhoneNumberQuery, Types.FindMlsAgentsByPhoneNumberQueryVariables>;
export const FindMlsListingByAddressDocument = gql`
    query findMLSListingByAddress($input: FindMLSListingByAddressInput!) {
  findMLSListingByAddress(input: $input) {
    ...MLSListing
  }
}
    ${MlsListingFragmentDoc}`;

/**
 * __useFindMlsListingByAddressQuery__
 *
 * To run a query within a React component, call `useFindMlsListingByAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMlsListingByAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMlsListingByAddressQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindMlsListingByAddressQuery(baseOptions: Apollo.QueryHookOptions<Types.FindMlsListingByAddressQuery, Types.FindMlsListingByAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindMlsListingByAddressQuery, Types.FindMlsListingByAddressQueryVariables>(FindMlsListingByAddressDocument, options);
      }
export function useFindMlsListingByAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindMlsListingByAddressQuery, Types.FindMlsListingByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindMlsListingByAddressQuery, Types.FindMlsListingByAddressQueryVariables>(FindMlsListingByAddressDocument, options);
        }
export type FindMlsListingByAddressQueryHookResult = ReturnType<typeof useFindMlsListingByAddressQuery>;
export type FindMlsListingByAddressLazyQueryHookResult = ReturnType<typeof useFindMlsListingByAddressLazyQuery>;
export type FindMlsListingByAddressQueryResult = Apollo.QueryResult<Types.FindMlsListingByAddressQuery, Types.FindMlsListingByAddressQueryVariables>;
export const FindUserCapturedPropertyDetailsByAddressDocument = gql`
    query findUserCapturedPropertyDetailsByAddress($input: FindUserCapturedPropertyDetailsByAddressInput!) {
  findUserCapturedPropertyDetailsByAddress(input: $input) {
    ...PropertyDetails
  }
}
    ${PropertyDetailsFragmentDoc}`;

/**
 * __useFindUserCapturedPropertyDetailsByAddressQuery__
 *
 * To run a query within a React component, call `useFindUserCapturedPropertyDetailsByAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUserCapturedPropertyDetailsByAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUserCapturedPropertyDetailsByAddressQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindUserCapturedPropertyDetailsByAddressQuery(baseOptions: Apollo.QueryHookOptions<Types.FindUserCapturedPropertyDetailsByAddressQuery, Types.FindUserCapturedPropertyDetailsByAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FindUserCapturedPropertyDetailsByAddressQuery, Types.FindUserCapturedPropertyDetailsByAddressQueryVariables>(FindUserCapturedPropertyDetailsByAddressDocument, options);
      }
export function useFindUserCapturedPropertyDetailsByAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FindUserCapturedPropertyDetailsByAddressQuery, Types.FindUserCapturedPropertyDetailsByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FindUserCapturedPropertyDetailsByAddressQuery, Types.FindUserCapturedPropertyDetailsByAddressQueryVariables>(FindUserCapturedPropertyDetailsByAddressDocument, options);
        }
export type FindUserCapturedPropertyDetailsByAddressQueryHookResult = ReturnType<typeof useFindUserCapturedPropertyDetailsByAddressQuery>;
export type FindUserCapturedPropertyDetailsByAddressLazyQueryHookResult = ReturnType<typeof useFindUserCapturedPropertyDetailsByAddressLazyQuery>;
export type FindUserCapturedPropertyDetailsByAddressQueryResult = Apollo.QueryResult<Types.FindUserCapturedPropertyDetailsByAddressQuery, Types.FindUserCapturedPropertyDetailsByAddressQueryVariables>;
export const FollowedListingsDocument = gql`
    query FollowedListings($preferenceValues: Boolean = false) {
  followedListings {
    ...Listing
  }
}
    ${ListingFragmentDoc}`;

/**
 * __useFollowedListingsQuery__
 *
 * To run a query within a React component, call `useFollowedListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowedListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowedListingsQuery({
 *   variables: {
 *      preferenceValues: // value for 'preferenceValues'
 *   },
 * });
 */
export function useFollowedListingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.FollowedListingsQuery, Types.FollowedListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FollowedListingsQuery, Types.FollowedListingsQueryVariables>(FollowedListingsDocument, options);
      }
export function useFollowedListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FollowedListingsQuery, Types.FollowedListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FollowedListingsQuery, Types.FollowedListingsQueryVariables>(FollowedListingsDocument, options);
        }
export type FollowedListingsQueryHookResult = ReturnType<typeof useFollowedListingsQuery>;
export type FollowedListingsLazyQueryHookResult = ReturnType<typeof useFollowedListingsLazyQuery>;
export type FollowedListingsQueryResult = Apollo.QueryResult<Types.FollowedListingsQuery, Types.FollowedListingsQueryVariables>;
export const GetBoaByShareLinkTokenDocument = gql`
    query GetBOAByShareLinkToken($input: GetBOAByShareLinkTokenInput!, $preferenceValues: Boolean! = false) {
  getBOAByShareLinkToken(input: $input) {
    ...BuyerOfferAnalysis
  }
}
    ${BuyerOfferAnalysisFragmentDoc}`;

/**
 * __useGetBoaByShareLinkTokenQuery__
 *
 * To run a query within a React component, call `useGetBoaByShareLinkTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoaByShareLinkTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoaByShareLinkTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *      preferenceValues: // value for 'preferenceValues'
 *   },
 * });
 */
export function useGetBoaByShareLinkTokenQuery(baseOptions: Apollo.QueryHookOptions<Types.GetBoaByShareLinkTokenQuery, Types.GetBoaByShareLinkTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetBoaByShareLinkTokenQuery, Types.GetBoaByShareLinkTokenQueryVariables>(GetBoaByShareLinkTokenDocument, options);
      }
export function useGetBoaByShareLinkTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetBoaByShareLinkTokenQuery, Types.GetBoaByShareLinkTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetBoaByShareLinkTokenQuery, Types.GetBoaByShareLinkTokenQueryVariables>(GetBoaByShareLinkTokenDocument, options);
        }
export type GetBoaByShareLinkTokenQueryHookResult = ReturnType<typeof useGetBoaByShareLinkTokenQuery>;
export type GetBoaByShareLinkTokenLazyQueryHookResult = ReturnType<typeof useGetBoaByShareLinkTokenLazyQuery>;
export type GetBoaByShareLinkTokenQueryResult = Apollo.QueryResult<Types.GetBoaByShareLinkTokenQuery, Types.GetBoaByShareLinkTokenQueryVariables>;
export const GetBoaShareLinksDocument = gql`
    query getBOAShareLinks($buyerOfferAnalysisId: String!) {
  getBOAShareLinks(buyerOfferAnalysisId: $buyerOfferAnalysisId) {
    ...ShareLink
  }
}
    ${ShareLinkFragmentDoc}`;

/**
 * __useGetBoaShareLinksQuery__
 *
 * To run a query within a React component, call `useGetBoaShareLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoaShareLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoaShareLinksQuery({
 *   variables: {
 *      buyerOfferAnalysisId: // value for 'buyerOfferAnalysisId'
 *   },
 * });
 */
export function useGetBoaShareLinksQuery(baseOptions: Apollo.QueryHookOptions<Types.GetBoaShareLinksQuery, Types.GetBoaShareLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetBoaShareLinksQuery, Types.GetBoaShareLinksQueryVariables>(GetBoaShareLinksDocument, options);
      }
export function useGetBoaShareLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetBoaShareLinksQuery, Types.GetBoaShareLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetBoaShareLinksQuery, Types.GetBoaShareLinksQueryVariables>(GetBoaShareLinksDocument, options);
        }
export type GetBoaShareLinksQueryHookResult = ReturnType<typeof useGetBoaShareLinksQuery>;
export type GetBoaShareLinksLazyQueryHookResult = ReturnType<typeof useGetBoaShareLinksLazyQuery>;
export type GetBoaShareLinksQueryResult = Apollo.QueryResult<Types.GetBoaShareLinksQuery, Types.GetBoaShareLinksQueryVariables>;
export const GetBusinessOverviewOfferDetailsDocument = gql`
    query getBusinessOverviewOfferDetails($offerId: String!) {
  getBusinessOverviewOfferDetails(offerId: $offerId) {
    offerToPurchaseUrl
    metadata {
      ...GetOfferMetadata
    }
  }
}
    ${GetOfferMetadataFragmentDoc}`;

/**
 * __useGetBusinessOverviewOfferDetailsQuery__
 *
 * To run a query within a React component, call `useGetBusinessOverviewOfferDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessOverviewOfferDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessOverviewOfferDetailsQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useGetBusinessOverviewOfferDetailsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetBusinessOverviewOfferDetailsQuery, Types.GetBusinessOverviewOfferDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetBusinessOverviewOfferDetailsQuery, Types.GetBusinessOverviewOfferDetailsQueryVariables>(GetBusinessOverviewOfferDetailsDocument, options);
      }
export function useGetBusinessOverviewOfferDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetBusinessOverviewOfferDetailsQuery, Types.GetBusinessOverviewOfferDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetBusinessOverviewOfferDetailsQuery, Types.GetBusinessOverviewOfferDetailsQueryVariables>(GetBusinessOverviewOfferDetailsDocument, options);
        }
export type GetBusinessOverviewOfferDetailsQueryHookResult = ReturnType<typeof useGetBusinessOverviewOfferDetailsQuery>;
export type GetBusinessOverviewOfferDetailsLazyQueryHookResult = ReturnType<typeof useGetBusinessOverviewOfferDetailsLazyQuery>;
export type GetBusinessOverviewOfferDetailsQueryResult = Apollo.QueryResult<Types.GetBusinessOverviewOfferDetailsQuery, Types.GetBusinessOverviewOfferDetailsQueryVariables>;
export const GetBuyerOfferAnalysisDocument = gql`
    query GetBuyerOfferAnalysis($uuid: String!, $preferenceValues: Boolean! = false) {
  getBuyerOfferAnalysis(uuid: $uuid) {
    ...BuyerOfferAnalysis
  }
}
    ${BuyerOfferAnalysisFragmentDoc}`;

/**
 * __useGetBuyerOfferAnalysisQuery__
 *
 * To run a query within a React component, call `useGetBuyerOfferAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerOfferAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerOfferAnalysisQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      preferenceValues: // value for 'preferenceValues'
 *   },
 * });
 */
export function useGetBuyerOfferAnalysisQuery(baseOptions: Apollo.QueryHookOptions<Types.GetBuyerOfferAnalysisQuery, Types.GetBuyerOfferAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetBuyerOfferAnalysisQuery, Types.GetBuyerOfferAnalysisQueryVariables>(GetBuyerOfferAnalysisDocument, options);
      }
export function useGetBuyerOfferAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetBuyerOfferAnalysisQuery, Types.GetBuyerOfferAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetBuyerOfferAnalysisQuery, Types.GetBuyerOfferAnalysisQueryVariables>(GetBuyerOfferAnalysisDocument, options);
        }
export type GetBuyerOfferAnalysisQueryHookResult = ReturnType<typeof useGetBuyerOfferAnalysisQuery>;
export type GetBuyerOfferAnalysisLazyQueryHookResult = ReturnType<typeof useGetBuyerOfferAnalysisLazyQuery>;
export type GetBuyerOfferAnalysisQueryResult = Apollo.QueryResult<Types.GetBuyerOfferAnalysisQuery, Types.GetBuyerOfferAnalysisQueryVariables>;
export const GetIngestionDocumentReviewsDocument = gql`
    query getIngestionDocumentReviews($input: ExternalGetIngestionDocumentReviewsInput!) {
  externalGetIngestionDocumentReviews(input: $input) {
    ...IngestionDocumentReview
  }
}
    ${IngestionDocumentReviewFragmentDoc}`;

/**
 * __useGetIngestionDocumentReviewsQuery__
 *
 * To run a query within a React component, call `useGetIngestionDocumentReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIngestionDocumentReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIngestionDocumentReviewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIngestionDocumentReviewsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetIngestionDocumentReviewsQuery, Types.GetIngestionDocumentReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetIngestionDocumentReviewsQuery, Types.GetIngestionDocumentReviewsQueryVariables>(GetIngestionDocumentReviewsDocument, options);
      }
export function useGetIngestionDocumentReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetIngestionDocumentReviewsQuery, Types.GetIngestionDocumentReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetIngestionDocumentReviewsQuery, Types.GetIngestionDocumentReviewsQueryVariables>(GetIngestionDocumentReviewsDocument, options);
        }
export type GetIngestionDocumentReviewsQueryHookResult = ReturnType<typeof useGetIngestionDocumentReviewsQuery>;
export type GetIngestionDocumentReviewsLazyQueryHookResult = ReturnType<typeof useGetIngestionDocumentReviewsLazyQuery>;
export type GetIngestionDocumentReviewsQueryResult = Apollo.QueryResult<Types.GetIngestionDocumentReviewsQuery, Types.GetIngestionDocumentReviewsQueryVariables>;
export const GetIngestionDocumentValidationErrorReviewsDocument = gql`
    query getIngestionDocumentValidationErrorReviews($input: ExternalGetIngestionDocumentValidationErrorReviewsInput!) {
  externalGetIngestionDocumentValidationErrorReviews(input: $input) {
    ...IngestionDocumentValidationErrorReview
  }
}
    ${IngestionDocumentValidationErrorReviewFragmentDoc}`;

/**
 * __useGetIngestionDocumentValidationErrorReviewsQuery__
 *
 * To run a query within a React component, call `useGetIngestionDocumentValidationErrorReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIngestionDocumentValidationErrorReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIngestionDocumentValidationErrorReviewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIngestionDocumentValidationErrorReviewsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetIngestionDocumentValidationErrorReviewsQuery, Types.GetIngestionDocumentValidationErrorReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetIngestionDocumentValidationErrorReviewsQuery, Types.GetIngestionDocumentValidationErrorReviewsQueryVariables>(GetIngestionDocumentValidationErrorReviewsDocument, options);
      }
export function useGetIngestionDocumentValidationErrorReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetIngestionDocumentValidationErrorReviewsQuery, Types.GetIngestionDocumentValidationErrorReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetIngestionDocumentValidationErrorReviewsQuery, Types.GetIngestionDocumentValidationErrorReviewsQueryVariables>(GetIngestionDocumentValidationErrorReviewsDocument, options);
        }
export type GetIngestionDocumentValidationErrorReviewsQueryHookResult = ReturnType<typeof useGetIngestionDocumentValidationErrorReviewsQuery>;
export type GetIngestionDocumentValidationErrorReviewsLazyQueryHookResult = ReturnType<typeof useGetIngestionDocumentValidationErrorReviewsLazyQuery>;
export type GetIngestionDocumentValidationErrorReviewsQueryResult = Apollo.QueryResult<Types.GetIngestionDocumentValidationErrorReviewsQuery, Types.GetIngestionDocumentValidationErrorReviewsQueryVariables>;
export const GetIngestionFolderValidationErrorReviewsDocument = gql`
    query getIngestionFolderValidationErrorReviews($input: ExternalGetIngestionFolderValidationErrorReviewsInput!) {
  externalGetIngestionFolderValidationErrorReviews(input: $input) {
    ...IngestionFolderValidationErrorReview
  }
}
    ${IngestionFolderValidationErrorReviewFragmentDoc}`;

/**
 * __useGetIngestionFolderValidationErrorReviewsQuery__
 *
 * To run a query within a React component, call `useGetIngestionFolderValidationErrorReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIngestionFolderValidationErrorReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIngestionFolderValidationErrorReviewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIngestionFolderValidationErrorReviewsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetIngestionFolderValidationErrorReviewsQuery, Types.GetIngestionFolderValidationErrorReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetIngestionFolderValidationErrorReviewsQuery, Types.GetIngestionFolderValidationErrorReviewsQueryVariables>(GetIngestionFolderValidationErrorReviewsDocument, options);
      }
export function useGetIngestionFolderValidationErrorReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetIngestionFolderValidationErrorReviewsQuery, Types.GetIngestionFolderValidationErrorReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetIngestionFolderValidationErrorReviewsQuery, Types.GetIngestionFolderValidationErrorReviewsQueryVariables>(GetIngestionFolderValidationErrorReviewsDocument, options);
        }
export type GetIngestionFolderValidationErrorReviewsQueryHookResult = ReturnType<typeof useGetIngestionFolderValidationErrorReviewsQuery>;
export type GetIngestionFolderValidationErrorReviewsLazyQueryHookResult = ReturnType<typeof useGetIngestionFolderValidationErrorReviewsLazyQuery>;
export type GetIngestionFolderValidationErrorReviewsQueryResult = Apollo.QueryResult<Types.GetIngestionFolderValidationErrorReviewsQuery, Types.GetIngestionFolderValidationErrorReviewsQueryVariables>;
export const GetInviteeDetailByCodeDocument = gql`
    query GetInviteeDetailByCode($input: SendOTPFromInvitationLinkInput!) {
  getInviteeDetailByCode(input: $input) {
    id
    firstName
    lastName
    email
    phoneNumber
  }
}
    `;

/**
 * __useGetInviteeDetailByCodeQuery__
 *
 * To run a query within a React component, call `useGetInviteeDetailByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteeDetailByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteeDetailByCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInviteeDetailByCodeQuery(baseOptions: Apollo.QueryHookOptions<Types.GetInviteeDetailByCodeQuery, Types.GetInviteeDetailByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetInviteeDetailByCodeQuery, Types.GetInviteeDetailByCodeQueryVariables>(GetInviteeDetailByCodeDocument, options);
      }
export function useGetInviteeDetailByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetInviteeDetailByCodeQuery, Types.GetInviteeDetailByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetInviteeDetailByCodeQuery, Types.GetInviteeDetailByCodeQueryVariables>(GetInviteeDetailByCodeDocument, options);
        }
export type GetInviteeDetailByCodeQueryHookResult = ReturnType<typeof useGetInviteeDetailByCodeQuery>;
export type GetInviteeDetailByCodeLazyQueryHookResult = ReturnType<typeof useGetInviteeDetailByCodeLazyQuery>;
export type GetInviteeDetailByCodeQueryResult = Apollo.QueryResult<Types.GetInviteeDetailByCodeQuery, Types.GetInviteeDetailByCodeQueryVariables>;
export const GetListingPricingEvaluationStatusDocument = gql`
    query getListingPricingEvaluationStatus($input: ListingPricingEvaluationInput!) {
  getListingPricingEvaluationStatus(input: $input) {
    status
    errorMessage
    processingStep
    evaluation {
      ...ListingPricingEvaluation
    }
  }
}
    ${ListingPricingEvaluationFragmentDoc}`;

/**
 * __useGetListingPricingEvaluationStatusQuery__
 *
 * To run a query within a React component, call `useGetListingPricingEvaluationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingPricingEvaluationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingPricingEvaluationStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListingPricingEvaluationStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.GetListingPricingEvaluationStatusQuery, Types.GetListingPricingEvaluationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetListingPricingEvaluationStatusQuery, Types.GetListingPricingEvaluationStatusQueryVariables>(GetListingPricingEvaluationStatusDocument, options);
      }
export function useGetListingPricingEvaluationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetListingPricingEvaluationStatusQuery, Types.GetListingPricingEvaluationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetListingPricingEvaluationStatusQuery, Types.GetListingPricingEvaluationStatusQueryVariables>(GetListingPricingEvaluationStatusDocument, options);
        }
export type GetListingPricingEvaluationStatusQueryHookResult = ReturnType<typeof useGetListingPricingEvaluationStatusQuery>;
export type GetListingPricingEvaluationStatusLazyQueryHookResult = ReturnType<typeof useGetListingPricingEvaluationStatusLazyQuery>;
export type GetListingPricingEvaluationStatusQueryResult = Apollo.QueryResult<Types.GetListingPricingEvaluationStatusQuery, Types.GetListingPricingEvaluationStatusQueryVariables>;
export const GetListingReportDocument = gql`
    query getListingReport($input: ListingReportInput!) {
  getListingReport(input: $input) {
    ...ListingReportResponse
  }
}
    ${ListingReportResponseFragmentDoc}`;

/**
 * __useGetListingReportQuery__
 *
 * To run a query within a React component, call `useGetListingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListingReportQuery(baseOptions: Apollo.QueryHookOptions<Types.GetListingReportQuery, Types.GetListingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetListingReportQuery, Types.GetListingReportQueryVariables>(GetListingReportDocument, options);
      }
export function useGetListingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetListingReportQuery, Types.GetListingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetListingReportQuery, Types.GetListingReportQueryVariables>(GetListingReportDocument, options);
        }
export type GetListingReportQueryHookResult = ReturnType<typeof useGetListingReportQuery>;
export type GetListingReportLazyQueryHookResult = ReturnType<typeof useGetListingReportLazyQuery>;
export type GetListingReportQueryResult = Apollo.QueryResult<Types.GetListingReportQuery, Types.GetListingReportQueryVariables>;
export const GetListingReportByShareLinkTokenDocument = gql`
    query getListingReportByShareLinkToken($input: GetListingReportByShareLinkTokenInput!) {
  getListingReportByShareLinkToken(input: $input) {
    ...ListingReportResponse
  }
}
    ${ListingReportResponseFragmentDoc}`;

/**
 * __useGetListingReportByShareLinkTokenQuery__
 *
 * To run a query within a React component, call `useGetListingReportByShareLinkTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingReportByShareLinkTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingReportByShareLinkTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListingReportByShareLinkTokenQuery(baseOptions: Apollo.QueryHookOptions<Types.GetListingReportByShareLinkTokenQuery, Types.GetListingReportByShareLinkTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetListingReportByShareLinkTokenQuery, Types.GetListingReportByShareLinkTokenQueryVariables>(GetListingReportByShareLinkTokenDocument, options);
      }
export function useGetListingReportByShareLinkTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetListingReportByShareLinkTokenQuery, Types.GetListingReportByShareLinkTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetListingReportByShareLinkTokenQuery, Types.GetListingReportByShareLinkTokenQueryVariables>(GetListingReportByShareLinkTokenDocument, options);
        }
export type GetListingReportByShareLinkTokenQueryHookResult = ReturnType<typeof useGetListingReportByShareLinkTokenQuery>;
export type GetListingReportByShareLinkTokenLazyQueryHookResult = ReturnType<typeof useGetListingReportByShareLinkTokenLazyQuery>;
export type GetListingReportByShareLinkTokenQueryResult = Apollo.QueryResult<Types.GetListingReportByShareLinkTokenQuery, Types.GetListingReportByShareLinkTokenQueryVariables>;
export const GetListingReportPdfDocument = gql`
    query getListingReportPdf($input: GetListingReportPdfInput!) {
  getListingReportPdf(input: $input) {
    file {
      url
      fileName
    }
  }
}
    `;

/**
 * __useGetListingReportPdfQuery__
 *
 * To run a query within a React component, call `useGetListingReportPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingReportPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingReportPdfQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListingReportPdfQuery(baseOptions: Apollo.QueryHookOptions<Types.GetListingReportPdfQuery, Types.GetListingReportPdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetListingReportPdfQuery, Types.GetListingReportPdfQueryVariables>(GetListingReportPdfDocument, options);
      }
export function useGetListingReportPdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetListingReportPdfQuery, Types.GetListingReportPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetListingReportPdfQuery, Types.GetListingReportPdfQueryVariables>(GetListingReportPdfDocument, options);
        }
export type GetListingReportPdfQueryHookResult = ReturnType<typeof useGetListingReportPdfQuery>;
export type GetListingReportPdfLazyQueryHookResult = ReturnType<typeof useGetListingReportPdfLazyQuery>;
export type GetListingReportPdfQueryResult = Apollo.QueryResult<Types.GetListingReportPdfQuery, Types.GetListingReportPdfQueryVariables>;
export const GetListingReportShareLinksDocument = gql`
    query getListingReportShareLinks($input: GetListingReportShareLinksInput!) {
  getListingReportShareLinks(input: $input) {
    ...ShareLink
  }
}
    ${ShareLinkFragmentDoc}`;

/**
 * __useGetListingReportShareLinksQuery__
 *
 * To run a query within a React component, call `useGetListingReportShareLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingReportShareLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingReportShareLinksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetListingReportShareLinksQuery(baseOptions: Apollo.QueryHookOptions<Types.GetListingReportShareLinksQuery, Types.GetListingReportShareLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetListingReportShareLinksQuery, Types.GetListingReportShareLinksQueryVariables>(GetListingReportShareLinksDocument, options);
      }
export function useGetListingReportShareLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetListingReportShareLinksQuery, Types.GetListingReportShareLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetListingReportShareLinksQuery, Types.GetListingReportShareLinksQueryVariables>(GetListingReportShareLinksDocument, options);
        }
export type GetListingReportShareLinksQueryHookResult = ReturnType<typeof useGetListingReportShareLinksQuery>;
export type GetListingReportShareLinksLazyQueryHookResult = ReturnType<typeof useGetListingReportShareLinksLazyQuery>;
export type GetListingReportShareLinksQueryResult = Apollo.QueryResult<Types.GetListingReportShareLinksQuery, Types.GetListingReportShareLinksQueryVariables>;
export const GetOfferForBuyersAgentDocument = gql`
    query getOfferForBuyersAgent($input: GetOfferForBuyersAgentInput!) {
  getOfferForBuyersAgent(input: $input) {
    ...Offer
    contract {
      ...OfferContract
    }
    listing {
      id
      property {
        id
        slug
        state
      }
      mlsListing {
        ...MLSListing
      }
    }
  }
}
    ${OfferFragmentDoc}
${OfferContractFragmentDoc}
${MlsListingFragmentDoc}`;

/**
 * __useGetOfferForBuyersAgentQuery__
 *
 * To run a query within a React component, call `useGetOfferForBuyersAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferForBuyersAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferForBuyersAgentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOfferForBuyersAgentQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOfferForBuyersAgentQuery, Types.GetOfferForBuyersAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOfferForBuyersAgentQuery, Types.GetOfferForBuyersAgentQueryVariables>(GetOfferForBuyersAgentDocument, options);
      }
export function useGetOfferForBuyersAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOfferForBuyersAgentQuery, Types.GetOfferForBuyersAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOfferForBuyersAgentQuery, Types.GetOfferForBuyersAgentQueryVariables>(GetOfferForBuyersAgentDocument, options);
        }
export type GetOfferForBuyersAgentQueryHookResult = ReturnType<typeof useGetOfferForBuyersAgentQuery>;
export type GetOfferForBuyersAgentLazyQueryHookResult = ReturnType<typeof useGetOfferForBuyersAgentLazyQuery>;
export type GetOfferForBuyersAgentQueryResult = Apollo.QueryResult<Types.GetOfferForBuyersAgentQuery, Types.GetOfferForBuyersAgentQueryVariables>;
export const GetOfferForListingAgentDocument = gql`
    query getOfferForListingAgent($input: GetOfferForListingAgentInput!) {
  getOfferForListingAgent(input: $input) {
    ...Offer
    contract {
      ...OfferContract
    }
    listing {
      id
      property {
        id
        slug
        state
      }
      mlsListing {
        ...MLSListing
      }
    }
  }
}
    ${OfferFragmentDoc}
${OfferContractFragmentDoc}
${MlsListingFragmentDoc}`;

/**
 * __useGetOfferForListingAgentQuery__
 *
 * To run a query within a React component, call `useGetOfferForListingAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferForListingAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferForListingAgentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOfferForListingAgentQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOfferForListingAgentQuery, Types.GetOfferForListingAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOfferForListingAgentQuery, Types.GetOfferForListingAgentQueryVariables>(GetOfferForListingAgentDocument, options);
      }
export function useGetOfferForListingAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOfferForListingAgentQuery, Types.GetOfferForListingAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOfferForListingAgentQuery, Types.GetOfferForListingAgentQueryVariables>(GetOfferForListingAgentDocument, options);
        }
export type GetOfferForListingAgentQueryHookResult = ReturnType<typeof useGetOfferForListingAgentQuery>;
export type GetOfferForListingAgentLazyQueryHookResult = ReturnType<typeof useGetOfferForListingAgentLazyQuery>;
export type GetOfferForListingAgentQueryResult = Apollo.QueryResult<Types.GetOfferForListingAgentQuery, Types.GetOfferForListingAgentQueryVariables>;
export const GetOfferRecsDocument = gql`
    query GetOfferRecs($input: GetOfferRecsInput!) {
  getOfferRecs(input: $input) {
    ...OfferRecs
  }
}
    ${OfferRecsFragmentDoc}`;

/**
 * __useGetOfferRecsQuery__
 *
 * To run a query within a React component, call `useGetOfferRecsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferRecsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferRecsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOfferRecsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOfferRecsQuery, Types.GetOfferRecsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOfferRecsQuery, Types.GetOfferRecsQueryVariables>(GetOfferRecsDocument, options);
      }
export function useGetOfferRecsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOfferRecsQuery, Types.GetOfferRecsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOfferRecsQuery, Types.GetOfferRecsQueryVariables>(GetOfferRecsDocument, options);
        }
export type GetOfferRecsQueryHookResult = ReturnType<typeof useGetOfferRecsQuery>;
export type GetOfferRecsLazyQueryHookResult = ReturnType<typeof useGetOfferRecsLazyQuery>;
export type GetOfferRecsQueryResult = Apollo.QueryResult<Types.GetOfferRecsQuery, Types.GetOfferRecsQueryVariables>;
export const GetOfferScorecardsForAgentDocument = gql`
    query getOfferScorecardsForAgent($cursor: String, $perPage: Int! = 10, $orderBy: String! = "-createdAt", $filters: OfferScorecardsFilterInput!, $preferenceValues: Boolean! = false) {
  offerScorecardsForAgent(
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
    filters: $filters
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...BuyerOfferAnalysis
    }
  }
}
    ${PageInfoFragmentDoc}
${BuyerOfferAnalysisFragmentDoc}`;

/**
 * __useGetOfferScorecardsForAgentQuery__
 *
 * To run a query within a React component, call `useGetOfferScorecardsForAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferScorecardsForAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferScorecardsForAgentQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      preferenceValues: // value for 'preferenceValues'
 *   },
 * });
 */
export function useGetOfferScorecardsForAgentQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOfferScorecardsForAgentQuery, Types.GetOfferScorecardsForAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOfferScorecardsForAgentQuery, Types.GetOfferScorecardsForAgentQueryVariables>(GetOfferScorecardsForAgentDocument, options);
      }
export function useGetOfferScorecardsForAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOfferScorecardsForAgentQuery, Types.GetOfferScorecardsForAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOfferScorecardsForAgentQuery, Types.GetOfferScorecardsForAgentQueryVariables>(GetOfferScorecardsForAgentDocument, options);
        }
export type GetOfferScorecardsForAgentQueryHookResult = ReturnType<typeof useGetOfferScorecardsForAgentQuery>;
export type GetOfferScorecardsForAgentLazyQueryHookResult = ReturnType<typeof useGetOfferScorecardsForAgentLazyQuery>;
export type GetOfferScorecardsForAgentQueryResult = Apollo.QueryResult<Types.GetOfferScorecardsForAgentQuery, Types.GetOfferScorecardsForAgentQueryVariables>;
export const GetOfferScorecardsForOrgDocument = gql`
    query getOfferScorecardsForOrg($cursor: String, $perPage: Int! = 10, $orderBy: String! = "-createdAt", $filters: OfferScorecardsFilterInput!) {
  offerScorecardsForOrg(
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
    filters: $filters
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...TeamLeadOfferScorecardRow
    }
  }
}
    ${PageInfoFragmentDoc}
${TeamLeadOfferScorecardRowFragmentDoc}`;

/**
 * __useGetOfferScorecardsForOrgQuery__
 *
 * To run a query within a React component, call `useGetOfferScorecardsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferScorecardsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferScorecardsForOrgQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOfferScorecardsForOrgQuery(baseOptions: Apollo.QueryHookOptions<Types.GetOfferScorecardsForOrgQuery, Types.GetOfferScorecardsForOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOfferScorecardsForOrgQuery, Types.GetOfferScorecardsForOrgQueryVariables>(GetOfferScorecardsForOrgDocument, options);
      }
export function useGetOfferScorecardsForOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOfferScorecardsForOrgQuery, Types.GetOfferScorecardsForOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOfferScorecardsForOrgQuery, Types.GetOfferScorecardsForOrgQueryVariables>(GetOfferScorecardsForOrgDocument, options);
        }
export type GetOfferScorecardsForOrgQueryHookResult = ReturnType<typeof useGetOfferScorecardsForOrgQuery>;
export type GetOfferScorecardsForOrgLazyQueryHookResult = ReturnType<typeof useGetOfferScorecardsForOrgLazyQuery>;
export type GetOfferScorecardsForOrgQueryResult = Apollo.QueryResult<Types.GetOfferScorecardsForOrgQuery, Types.GetOfferScorecardsForOrgQueryVariables>;
export const GetOfferScorecardsMetricsForOrgDocument = gql`
    query getOfferScorecardsMetricsForOrg {
  offerScorecardsMetricsForOrg {
    created {
      value
      delta
    }
    shared {
      value
      delta
    }
    averageScore {
      value
      delta
    }
  }
}
    `;

/**
 * __useGetOfferScorecardsMetricsForOrgQuery__
 *
 * To run a query within a React component, call `useGetOfferScorecardsMetricsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferScorecardsMetricsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferScorecardsMetricsForOrgQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferScorecardsMetricsForOrgQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetOfferScorecardsMetricsForOrgQuery, Types.GetOfferScorecardsMetricsForOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetOfferScorecardsMetricsForOrgQuery, Types.GetOfferScorecardsMetricsForOrgQueryVariables>(GetOfferScorecardsMetricsForOrgDocument, options);
      }
export function useGetOfferScorecardsMetricsForOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetOfferScorecardsMetricsForOrgQuery, Types.GetOfferScorecardsMetricsForOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetOfferScorecardsMetricsForOrgQuery, Types.GetOfferScorecardsMetricsForOrgQueryVariables>(GetOfferScorecardsMetricsForOrgDocument, options);
        }
export type GetOfferScorecardsMetricsForOrgQueryHookResult = ReturnType<typeof useGetOfferScorecardsMetricsForOrgQuery>;
export type GetOfferScorecardsMetricsForOrgLazyQueryHookResult = ReturnType<typeof useGetOfferScorecardsMetricsForOrgLazyQuery>;
export type GetOfferScorecardsMetricsForOrgQueryResult = Apollo.QueryResult<Types.GetOfferScorecardsMetricsForOrgQuery, Types.GetOfferScorecardsMetricsForOrgQueryVariables>;
export const GetPropertyDetailsDocument = gql`
    query getPropertyDetails($input: GetPropertyDetailsInput!) {
  getPropertyDetails(input: $input) {
    result {
      ...GetPropertyDetailsResult
    }
    location {
      ...Location
    }
  }
}
    ${GetPropertyDetailsResultFragmentDoc}
${LocationFragmentDoc}`;

/**
 * __useGetPropertyDetailsQuery__
 *
 * To run a query within a React component, call `useGetPropertyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPropertyDetailsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetPropertyDetailsQuery, Types.GetPropertyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetPropertyDetailsQuery, Types.GetPropertyDetailsQueryVariables>(GetPropertyDetailsDocument, options);
      }
export function useGetPropertyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetPropertyDetailsQuery, Types.GetPropertyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetPropertyDetailsQuery, Types.GetPropertyDetailsQueryVariables>(GetPropertyDetailsDocument, options);
        }
export type GetPropertyDetailsQueryHookResult = ReturnType<typeof useGetPropertyDetailsQuery>;
export type GetPropertyDetailsLazyQueryHookResult = ReturnType<typeof useGetPropertyDetailsLazyQuery>;
export type GetPropertyDetailsQueryResult = Apollo.QueryResult<Types.GetPropertyDetailsQuery, Types.GetPropertyDetailsQueryVariables>;
export const GetSingleUserCapturedPropertyDetailsDocument = gql`
    query getSingleUserCapturedPropertyDetails($propertyDetailsId: String!) {
  getSingleUserCapturedPropertyDetails(propertyDetailsId: $propertyDetailsId) {
    ...PropertyDetails
  }
}
    ${PropertyDetailsFragmentDoc}`;

/**
 * __useGetSingleUserCapturedPropertyDetailsQuery__
 *
 * To run a query within a React component, call `useGetSingleUserCapturedPropertyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleUserCapturedPropertyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleUserCapturedPropertyDetailsQuery({
 *   variables: {
 *      propertyDetailsId: // value for 'propertyDetailsId'
 *   },
 * });
 */
export function useGetSingleUserCapturedPropertyDetailsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSingleUserCapturedPropertyDetailsQuery, Types.GetSingleUserCapturedPropertyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSingleUserCapturedPropertyDetailsQuery, Types.GetSingleUserCapturedPropertyDetailsQueryVariables>(GetSingleUserCapturedPropertyDetailsDocument, options);
      }
export function useGetSingleUserCapturedPropertyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSingleUserCapturedPropertyDetailsQuery, Types.GetSingleUserCapturedPropertyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSingleUserCapturedPropertyDetailsQuery, Types.GetSingleUserCapturedPropertyDetailsQueryVariables>(GetSingleUserCapturedPropertyDetailsDocument, options);
        }
export type GetSingleUserCapturedPropertyDetailsQueryHookResult = ReturnType<typeof useGetSingleUserCapturedPropertyDetailsQuery>;
export type GetSingleUserCapturedPropertyDetailsLazyQueryHookResult = ReturnType<typeof useGetSingleUserCapturedPropertyDetailsLazyQuery>;
export type GetSingleUserCapturedPropertyDetailsQueryResult = Apollo.QueryResult<Types.GetSingleUserCapturedPropertyDetailsQuery, Types.GetSingleUserCapturedPropertyDetailsQueryVariables>;
export const GetUserCapturedPropertyDetailsDocument = gql`
    query getUserCapturedPropertyDetails {
  getUserCapturedPropertyDetails {
    ...PropertyDetails
  }
}
    ${PropertyDetailsFragmentDoc}`;

/**
 * __useGetUserCapturedPropertyDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserCapturedPropertyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCapturedPropertyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCapturedPropertyDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCapturedPropertyDetailsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetUserCapturedPropertyDetailsQuery, Types.GetUserCapturedPropertyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserCapturedPropertyDetailsQuery, Types.GetUserCapturedPropertyDetailsQueryVariables>(GetUserCapturedPropertyDetailsDocument, options);
      }
export function useGetUserCapturedPropertyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserCapturedPropertyDetailsQuery, Types.GetUserCapturedPropertyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserCapturedPropertyDetailsQuery, Types.GetUserCapturedPropertyDetailsQueryVariables>(GetUserCapturedPropertyDetailsDocument, options);
        }
export type GetUserCapturedPropertyDetailsQueryHookResult = ReturnType<typeof useGetUserCapturedPropertyDetailsQuery>;
export type GetUserCapturedPropertyDetailsLazyQueryHookResult = ReturnType<typeof useGetUserCapturedPropertyDetailsLazyQuery>;
export type GetUserCapturedPropertyDetailsQueryResult = Apollo.QueryResult<Types.GetUserCapturedPropertyDetailsQuery, Types.GetUserCapturedPropertyDetailsQueryVariables>;
export const GetUserCapturedPropertyDetailsByTokenDocument = gql`
    query getUserCapturedPropertyDetailsByToken($input: GetUserCapturedPropertyDetailsByTokenInput!) {
  getUserCapturedPropertyDetailsByToken(input: $input) {
    ...PropertyDetails
  }
}
    ${PropertyDetailsFragmentDoc}`;

/**
 * __useGetUserCapturedPropertyDetailsByTokenQuery__
 *
 * To run a query within a React component, call `useGetUserCapturedPropertyDetailsByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCapturedPropertyDetailsByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCapturedPropertyDetailsByTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserCapturedPropertyDetailsByTokenQuery(baseOptions: Apollo.QueryHookOptions<Types.GetUserCapturedPropertyDetailsByTokenQuery, Types.GetUserCapturedPropertyDetailsByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserCapturedPropertyDetailsByTokenQuery, Types.GetUserCapturedPropertyDetailsByTokenQueryVariables>(GetUserCapturedPropertyDetailsByTokenDocument, options);
      }
export function useGetUserCapturedPropertyDetailsByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserCapturedPropertyDetailsByTokenQuery, Types.GetUserCapturedPropertyDetailsByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserCapturedPropertyDetailsByTokenQuery, Types.GetUserCapturedPropertyDetailsByTokenQueryVariables>(GetUserCapturedPropertyDetailsByTokenDocument, options);
        }
export type GetUserCapturedPropertyDetailsByTokenQueryHookResult = ReturnType<typeof useGetUserCapturedPropertyDetailsByTokenQuery>;
export type GetUserCapturedPropertyDetailsByTokenLazyQueryHookResult = ReturnType<typeof useGetUserCapturedPropertyDetailsByTokenLazyQuery>;
export type GetUserCapturedPropertyDetailsByTokenQueryResult = Apollo.QueryResult<Types.GetUserCapturedPropertyDetailsByTokenQuery, Types.GetUserCapturedPropertyDetailsByTokenQueryVariables>;
export const GetUserToursDocument = gql`
    query GetUserTours {
  getUserTours {
    id
    tourName
  }
}
    `;

/**
 * __useGetUserToursQuery__
 *
 * To run a query within a React component, call `useGetUserToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserToursQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserToursQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetUserToursQuery, Types.GetUserToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserToursQuery, Types.GetUserToursQueryVariables>(GetUserToursDocument, options);
      }
export function useGetUserToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserToursQuery, Types.GetUserToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserToursQuery, Types.GetUserToursQueryVariables>(GetUserToursDocument, options);
        }
export type GetUserToursQueryHookResult = ReturnType<typeof useGetUserToursQuery>;
export type GetUserToursLazyQueryHookResult = ReturnType<typeof useGetUserToursLazyQuery>;
export type GetUserToursQueryResult = Apollo.QueryResult<Types.GetUserToursQuery, Types.GetUserToursQueryVariables>;
export const HasSignedListingGuestbookDocument = gql`
    query HasSignedListingGuestbook($input: ListingInput!) {
  hasSignedListingGuestbook(input: $input) {
    hasSigned
  }
}
    `;

/**
 * __useHasSignedListingGuestbookQuery__
 *
 * To run a query within a React component, call `useHasSignedListingGuestbookQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasSignedListingGuestbookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSignedListingGuestbookQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHasSignedListingGuestbookQuery(baseOptions: Apollo.QueryHookOptions<Types.HasSignedListingGuestbookQuery, Types.HasSignedListingGuestbookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.HasSignedListingGuestbookQuery, Types.HasSignedListingGuestbookQueryVariables>(HasSignedListingGuestbookDocument, options);
      }
export function useHasSignedListingGuestbookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.HasSignedListingGuestbookQuery, Types.HasSignedListingGuestbookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.HasSignedListingGuestbookQuery, Types.HasSignedListingGuestbookQueryVariables>(HasSignedListingGuestbookDocument, options);
        }
export type HasSignedListingGuestbookQueryHookResult = ReturnType<typeof useHasSignedListingGuestbookQuery>;
export type HasSignedListingGuestbookLazyQueryHookResult = ReturnType<typeof useHasSignedListingGuestbookLazyQuery>;
export type HasSignedListingGuestbookQueryResult = Apollo.QueryResult<Types.HasSignedListingGuestbookQuery, Types.HasSignedListingGuestbookQueryVariables>;
export const IndigoContractsForCurrentUserDocument = gql`
    query indigoContractsForCurrentUser($filters: IndigoContractsForCurrentUserFilters, $cursor: String, $orderBy: String! = "-id", $perPage: Int! = 10, $includeFieldValues: Boolean = false, $includeContractDocuments: Boolean = false) {
  indigoContractsForCurrentUser(
    filters: $filters
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...IndigoContractsForCurrentUser
    }
  }
}
    ${PageInfoFragmentDoc}
${IndigoContractsForCurrentUserFragmentDoc}`;

/**
 * __useIndigoContractsForCurrentUserQuery__
 *
 * To run a query within a React component, call `useIndigoContractsForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndigoContractsForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndigoContractsForCurrentUserQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      includeFieldValues: // value for 'includeFieldValues'
 *      includeContractDocuments: // value for 'includeContractDocuments'
 *   },
 * });
 */
export function useIndigoContractsForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.IndigoContractsForCurrentUserQuery, Types.IndigoContractsForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IndigoContractsForCurrentUserQuery, Types.IndigoContractsForCurrentUserQueryVariables>(IndigoContractsForCurrentUserDocument, options);
      }
export function useIndigoContractsForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IndigoContractsForCurrentUserQuery, Types.IndigoContractsForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IndigoContractsForCurrentUserQuery, Types.IndigoContractsForCurrentUserQueryVariables>(IndigoContractsForCurrentUserDocument, options);
        }
export type IndigoContractsForCurrentUserQueryHookResult = ReturnType<typeof useIndigoContractsForCurrentUserQuery>;
export type IndigoContractsForCurrentUserLazyQueryHookResult = ReturnType<typeof useIndigoContractsForCurrentUserLazyQuery>;
export type IndigoContractsForCurrentUserQueryResult = Apollo.QueryResult<Types.IndigoContractsForCurrentUserQuery, Types.IndigoContractsForCurrentUserQueryVariables>;
export const InitiateListingPricingEvaluationDocument = gql`
    query initiateListingPricingEvaluation($input: ListingPricingEvaluationInput!) {
  initiateListingPricingEvaluation(input: $input) {
    status
    errorMessage
    jobId
  }
}
    `;

/**
 * __useInitiateListingPricingEvaluationQuery__
 *
 * To run a query within a React component, call `useInitiateListingPricingEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitiateListingPricingEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitiateListingPricingEvaluationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateListingPricingEvaluationQuery(baseOptions: Apollo.QueryHookOptions<Types.InitiateListingPricingEvaluationQuery, Types.InitiateListingPricingEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InitiateListingPricingEvaluationQuery, Types.InitiateListingPricingEvaluationQueryVariables>(InitiateListingPricingEvaluationDocument, options);
      }
export function useInitiateListingPricingEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InitiateListingPricingEvaluationQuery, Types.InitiateListingPricingEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InitiateListingPricingEvaluationQuery, Types.InitiateListingPricingEvaluationQueryVariables>(InitiateListingPricingEvaluationDocument, options);
        }
export type InitiateListingPricingEvaluationQueryHookResult = ReturnType<typeof useInitiateListingPricingEvaluationQuery>;
export type InitiateListingPricingEvaluationLazyQueryHookResult = ReturnType<typeof useInitiateListingPricingEvaluationLazyQuery>;
export type InitiateListingPricingEvaluationQueryResult = Apollo.QueryResult<Types.InitiateListingPricingEvaluationQuery, Types.InitiateListingPricingEvaluationQueryVariables>;
export const IntegrationConnectionsForOrganizationDocument = gql`
    query integrationConnectionsForOrganization($organizationId: ID!) {
  integrationConnectionsForOrganization(input: {organizationId: $organizationId}) {
    id
    user {
      id
      firstName
      lastName
      fullName
    }
    providerAccountName
    integrationClient {
      id
    }
  }
}
    `;

/**
 * __useIntegrationConnectionsForOrganizationQuery__
 *
 * To run a query within a React component, call `useIntegrationConnectionsForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationConnectionsForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationConnectionsForOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useIntegrationConnectionsForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<Types.IntegrationConnectionsForOrganizationQuery, Types.IntegrationConnectionsForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IntegrationConnectionsForOrganizationQuery, Types.IntegrationConnectionsForOrganizationQueryVariables>(IntegrationConnectionsForOrganizationDocument, options);
      }
export function useIntegrationConnectionsForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IntegrationConnectionsForOrganizationQuery, Types.IntegrationConnectionsForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IntegrationConnectionsForOrganizationQuery, Types.IntegrationConnectionsForOrganizationQueryVariables>(IntegrationConnectionsForOrganizationDocument, options);
        }
export type IntegrationConnectionsForOrganizationQueryHookResult = ReturnType<typeof useIntegrationConnectionsForOrganizationQuery>;
export type IntegrationConnectionsForOrganizationLazyQueryHookResult = ReturnType<typeof useIntegrationConnectionsForOrganizationLazyQuery>;
export type IntegrationConnectionsForOrganizationQueryResult = Apollo.QueryResult<Types.IntegrationConnectionsForOrganizationQuery, Types.IntegrationConnectionsForOrganizationQueryVariables>;
export const InternalComplianceDashboardOfficeOptionsDocument = gql`
    query internalComplianceDashboardOfficeOptions($organizationId: ID!) {
  internalOrganizationComplianceDashboardMeta(
    organizationId: $organizationId
    input: {includeAllTimeScopeOptions: true}
  ) {
    filters {
      officeOptions {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useInternalComplianceDashboardOfficeOptionsQuery__
 *
 * To run a query within a React component, call `useInternalComplianceDashboardOfficeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalComplianceDashboardOfficeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalComplianceDashboardOfficeOptionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInternalComplianceDashboardOfficeOptionsQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalComplianceDashboardOfficeOptionsQuery, Types.InternalComplianceDashboardOfficeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalComplianceDashboardOfficeOptionsQuery, Types.InternalComplianceDashboardOfficeOptionsQueryVariables>(InternalComplianceDashboardOfficeOptionsDocument, options);
      }
export function useInternalComplianceDashboardOfficeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalComplianceDashboardOfficeOptionsQuery, Types.InternalComplianceDashboardOfficeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalComplianceDashboardOfficeOptionsQuery, Types.InternalComplianceDashboardOfficeOptionsQueryVariables>(InternalComplianceDashboardOfficeOptionsDocument, options);
        }
export type InternalComplianceDashboardOfficeOptionsQueryHookResult = ReturnType<typeof useInternalComplianceDashboardOfficeOptionsQuery>;
export type InternalComplianceDashboardOfficeOptionsLazyQueryHookResult = ReturnType<typeof useInternalComplianceDashboardOfficeOptionsLazyQuery>;
export type InternalComplianceDashboardOfficeOptionsQueryResult = Apollo.QueryResult<Types.InternalComplianceDashboardOfficeOptionsQuery, Types.InternalComplianceDashboardOfficeOptionsQueryVariables>;
export const InternalEssentialsNotificationFolderDebugDocument = gql`
    query internalEssentialsNotificationFolderDebug($input: InternalEssentialsNotificationFolderDebugInput!) {
  internalEssentialsNotificationFolderDebug(input: $input) {
    organizationUuid
    folderId
    transactionSide
    stage
    candidates {
      ...SimulationCandidateResult
    }
    excludedTemplates {
      ...DebugTemplateSource
    }
  }
}
    ${SimulationCandidateResultFragmentDoc}
${DebugTemplateSourceFragmentDoc}`;

/**
 * __useInternalEssentialsNotificationFolderDebugQuery__
 *
 * To run a query within a React component, call `useInternalEssentialsNotificationFolderDebugQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalEssentialsNotificationFolderDebugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalEssentialsNotificationFolderDebugQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalEssentialsNotificationFolderDebugQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalEssentialsNotificationFolderDebugQuery, Types.InternalEssentialsNotificationFolderDebugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalEssentialsNotificationFolderDebugQuery, Types.InternalEssentialsNotificationFolderDebugQueryVariables>(InternalEssentialsNotificationFolderDebugDocument, options);
      }
export function useInternalEssentialsNotificationFolderDebugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalEssentialsNotificationFolderDebugQuery, Types.InternalEssentialsNotificationFolderDebugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalEssentialsNotificationFolderDebugQuery, Types.InternalEssentialsNotificationFolderDebugQueryVariables>(InternalEssentialsNotificationFolderDebugDocument, options);
        }
export type InternalEssentialsNotificationFolderDebugQueryHookResult = ReturnType<typeof useInternalEssentialsNotificationFolderDebugQuery>;
export type InternalEssentialsNotificationFolderDebugLazyQueryHookResult = ReturnType<typeof useInternalEssentialsNotificationFolderDebugLazyQuery>;
export type InternalEssentialsNotificationFolderDebugQueryResult = Apollo.QueryResult<Types.InternalEssentialsNotificationFolderDebugQuery, Types.InternalEssentialsNotificationFolderDebugQueryVariables>;
export const InternalEssentialsNotificationLogDebugDocument = gql`
    query internalEssentialsNotificationLogDebug($logId: ID!) {
  internalEssentialsNotificationLogDebug(logId: $logId) {
    ...InternalEssentialsNotificationLogDebug
  }
}
    ${InternalEssentialsNotificationLogDebugFragmentDoc}`;

/**
 * __useInternalEssentialsNotificationLogDebugQuery__
 *
 * To run a query within a React component, call `useInternalEssentialsNotificationLogDebugQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalEssentialsNotificationLogDebugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalEssentialsNotificationLogDebugQuery({
 *   variables: {
 *      logId: // value for 'logId'
 *   },
 * });
 */
export function useInternalEssentialsNotificationLogDebugQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalEssentialsNotificationLogDebugQuery, Types.InternalEssentialsNotificationLogDebugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalEssentialsNotificationLogDebugQuery, Types.InternalEssentialsNotificationLogDebugQueryVariables>(InternalEssentialsNotificationLogDebugDocument, options);
      }
export function useInternalEssentialsNotificationLogDebugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalEssentialsNotificationLogDebugQuery, Types.InternalEssentialsNotificationLogDebugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalEssentialsNotificationLogDebugQuery, Types.InternalEssentialsNotificationLogDebugQueryVariables>(InternalEssentialsNotificationLogDebugDocument, options);
        }
export type InternalEssentialsNotificationLogDebugQueryHookResult = ReturnType<typeof useInternalEssentialsNotificationLogDebugQuery>;
export type InternalEssentialsNotificationLogDebugLazyQueryHookResult = ReturnType<typeof useInternalEssentialsNotificationLogDebugLazyQuery>;
export type InternalEssentialsNotificationLogDebugQueryResult = Apollo.QueryResult<Types.InternalEssentialsNotificationLogDebugQuery, Types.InternalEssentialsNotificationLogDebugQueryVariables>;
export const InternalEssentialsNotificationLogsDocument = gql`
    query internalEssentialsNotificationLogs($organizationId: ID!, $partnerId: ID, $cursor: String, $perPage: Int = 50, $orderBy: String = "-createdAt") {
  internalEssentialsNotificationLogs(
    organizationId: $organizationId
    partnerId: $partnerId
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
  ) {
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
      totalCount
    }
    results {
      ...InternalEssentialsNotificationLogItem
    }
  }
}
    ${InternalEssentialsNotificationLogItemFragmentDoc}`;

/**
 * __useInternalEssentialsNotificationLogsQuery__
 *
 * To run a query within a React component, call `useInternalEssentialsNotificationLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalEssentialsNotificationLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalEssentialsNotificationLogsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      partnerId: // value for 'partnerId'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useInternalEssentialsNotificationLogsQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalEssentialsNotificationLogsQuery, Types.InternalEssentialsNotificationLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalEssentialsNotificationLogsQuery, Types.InternalEssentialsNotificationLogsQueryVariables>(InternalEssentialsNotificationLogsDocument, options);
      }
export function useInternalEssentialsNotificationLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalEssentialsNotificationLogsQuery, Types.InternalEssentialsNotificationLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalEssentialsNotificationLogsQuery, Types.InternalEssentialsNotificationLogsQueryVariables>(InternalEssentialsNotificationLogsDocument, options);
        }
export type InternalEssentialsNotificationLogsQueryHookResult = ReturnType<typeof useInternalEssentialsNotificationLogsQuery>;
export type InternalEssentialsNotificationLogsLazyQueryHookResult = ReturnType<typeof useInternalEssentialsNotificationLogsLazyQuery>;
export type InternalEssentialsNotificationLogsQueryResult = Apollo.QueryResult<Types.InternalEssentialsNotificationLogsQuery, Types.InternalEssentialsNotificationLogsQueryVariables>;
export const InternalGetIngestionDocumentDocument = gql`
    query internalGetIngestionDocument($ingestionDocumentId: ID!) {
  getIngestionDocument(ingestionDocumentId: $ingestionDocumentId) {
    ...InternalGetIngestionDocument
  }
}
    ${InternalGetIngestionDocumentFragmentDoc}`;

/**
 * __useInternalGetIngestionDocumentQuery__
 *
 * To run a query within a React component, call `useInternalGetIngestionDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalGetIngestionDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalGetIngestionDocumentQuery({
 *   variables: {
 *      ingestionDocumentId: // value for 'ingestionDocumentId'
 *   },
 * });
 */
export function useInternalGetIngestionDocumentQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalGetIngestionDocumentQuery, Types.InternalGetIngestionDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalGetIngestionDocumentQuery, Types.InternalGetIngestionDocumentQueryVariables>(InternalGetIngestionDocumentDocument, options);
      }
export function useInternalGetIngestionDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalGetIngestionDocumentQuery, Types.InternalGetIngestionDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalGetIngestionDocumentQuery, Types.InternalGetIngestionDocumentQueryVariables>(InternalGetIngestionDocumentDocument, options);
        }
export type InternalGetIngestionDocumentQueryHookResult = ReturnType<typeof useInternalGetIngestionDocumentQuery>;
export type InternalGetIngestionDocumentLazyQueryHookResult = ReturnType<typeof useInternalGetIngestionDocumentLazyQuery>;
export type InternalGetIngestionDocumentQueryResult = Apollo.QueryResult<Types.InternalGetIngestionDocumentQuery, Types.InternalGetIngestionDocumentQueryVariables>;
export const InternalOrganizationComplianceDashboardSettingsDocument = gql`
    query internalOrganizationComplianceDashboardSettings($organizationId: ID!) {
  internalOrganizationComplianceDashboardSettings(organizationId: $organizationId) {
    id
    officeSections {
      label
      officeValues
      value
    }
    updatedAt
  }
}
    `;

/**
 * __useInternalOrganizationComplianceDashboardSettingsQuery__
 *
 * To run a query within a React component, call `useInternalOrganizationComplianceDashboardSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalOrganizationComplianceDashboardSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalOrganizationComplianceDashboardSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useInternalOrganizationComplianceDashboardSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalOrganizationComplianceDashboardSettingsQuery, Types.InternalOrganizationComplianceDashboardSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalOrganizationComplianceDashboardSettingsQuery, Types.InternalOrganizationComplianceDashboardSettingsQueryVariables>(InternalOrganizationComplianceDashboardSettingsDocument, options);
      }
export function useInternalOrganizationComplianceDashboardSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalOrganizationComplianceDashboardSettingsQuery, Types.InternalOrganizationComplianceDashboardSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalOrganizationComplianceDashboardSettingsQuery, Types.InternalOrganizationComplianceDashboardSettingsQueryVariables>(InternalOrganizationComplianceDashboardSettingsDocument, options);
        }
export type InternalOrganizationComplianceDashboardSettingsQueryHookResult = ReturnType<typeof useInternalOrganizationComplianceDashboardSettingsQuery>;
export type InternalOrganizationComplianceDashboardSettingsLazyQueryHookResult = ReturnType<typeof useInternalOrganizationComplianceDashboardSettingsLazyQuery>;
export type InternalOrganizationComplianceDashboardSettingsQueryResult = Apollo.QueryResult<Types.InternalOrganizationComplianceDashboardSettingsQuery, Types.InternalOrganizationComplianceDashboardSettingsQueryVariables>;
export const InternalOrganizationUsersDocument = gql`
    query internalOrganizationUsers($organizationId: ID!, $cursor: String, $perPage: Int = 50, $orderBy: String = "-id") {
  internalOrganizationUsers(
    organizationId: $organizationId
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
  ) {
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
      totalCount
    }
    results {
      id
      userUuid
      firstName
      lastName
      email
      phoneNumber
      roles
      accessRole
    }
  }
}
    `;

/**
 * __useInternalOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useInternalOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalOrganizationUsersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useInternalOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalOrganizationUsersQuery, Types.InternalOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalOrganizationUsersQuery, Types.InternalOrganizationUsersQueryVariables>(InternalOrganizationUsersDocument, options);
      }
export function useInternalOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalOrganizationUsersQuery, Types.InternalOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalOrganizationUsersQuery, Types.InternalOrganizationUsersQueryVariables>(InternalOrganizationUsersDocument, options);
        }
export type InternalOrganizationUsersQueryHookResult = ReturnType<typeof useInternalOrganizationUsersQuery>;
export type InternalOrganizationUsersLazyQueryHookResult = ReturnType<typeof useInternalOrganizationUsersLazyQuery>;
export type InternalOrganizationUsersQueryResult = Apollo.QueryResult<Types.InternalOrganizationUsersQuery, Types.InternalOrganizationUsersQueryVariables>;
export const InvitationsListDocument = gql`
    query invitationsList($filters: AccessControlsListFilters!) {
  invitationsList(filters: $filters, perPage: 100, orderBy: "id") {
    results {
      ...Invitation
      inviteeAccessRole
    }
  }
}
    ${InvitationFragmentDoc}`;

/**
 * __useInvitationsListQuery__
 *
 * To run a query within a React component, call `useInvitationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useInvitationsListQuery(baseOptions: Apollo.QueryHookOptions<Types.InvitationsListQuery, Types.InvitationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InvitationsListQuery, Types.InvitationsListQueryVariables>(InvitationsListDocument, options);
      }
export function useInvitationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InvitationsListQuery, Types.InvitationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InvitationsListQuery, Types.InvitationsListQueryVariables>(InvitationsListDocument, options);
        }
export type InvitationsListQueryHookResult = ReturnType<typeof useInvitationsListQuery>;
export type InvitationsListLazyQueryHookResult = ReturnType<typeof useInvitationsListLazyQuery>;
export type InvitationsListQueryResult = Apollo.QueryResult<Types.InvitationsListQuery, Types.InvitationsListQueryVariables>;
export const IsFollowingListingDocument = gql`
    query IsFollowingListing($input: ListingInput!) {
  isFollowingListing(input: $input) {
    isFollowingListing
  }
}
    `;

/**
 * __useIsFollowingListingQuery__
 *
 * To run a query within a React component, call `useIsFollowingListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsFollowingListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsFollowingListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsFollowingListingQuery(baseOptions: Apollo.QueryHookOptions<Types.IsFollowingListingQuery, Types.IsFollowingListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IsFollowingListingQuery, Types.IsFollowingListingQueryVariables>(IsFollowingListingDocument, options);
      }
export function useIsFollowingListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IsFollowingListingQuery, Types.IsFollowingListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IsFollowingListingQuery, Types.IsFollowingListingQueryVariables>(IsFollowingListingDocument, options);
        }
export type IsFollowingListingQueryHookResult = ReturnType<typeof useIsFollowingListingQuery>;
export type IsFollowingListingLazyQueryHookResult = ReturnType<typeof useIsFollowingListingLazyQuery>;
export type IsFollowingListingQueryResult = Apollo.QueryResult<Types.IsFollowingListingQuery, Types.IsFollowingListingQueryVariables>;
export const IsOpenHouseGuestBookSignedDocument = gql`
    query IsOpenHouseGuestBookSigned($input: GetOpenHouseGuestbookStatusInput!) {
  isOpenHouseGuestbookSigned(input: $input)
}
    `;

/**
 * __useIsOpenHouseGuestBookSignedQuery__
 *
 * To run a query within a React component, call `useIsOpenHouseGuestBookSignedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOpenHouseGuestBookSignedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOpenHouseGuestBookSignedQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsOpenHouseGuestBookSignedQuery(baseOptions: Apollo.QueryHookOptions<Types.IsOpenHouseGuestBookSignedQuery, Types.IsOpenHouseGuestBookSignedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IsOpenHouseGuestBookSignedQuery, Types.IsOpenHouseGuestBookSignedQueryVariables>(IsOpenHouseGuestBookSignedDocument, options);
      }
export function useIsOpenHouseGuestBookSignedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IsOpenHouseGuestBookSignedQuery, Types.IsOpenHouseGuestBookSignedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IsOpenHouseGuestBookSignedQuery, Types.IsOpenHouseGuestBookSignedQueryVariables>(IsOpenHouseGuestBookSignedDocument, options);
        }
export type IsOpenHouseGuestBookSignedQueryHookResult = ReturnType<typeof useIsOpenHouseGuestBookSignedQuery>;
export type IsOpenHouseGuestBookSignedLazyQueryHookResult = ReturnType<typeof useIsOpenHouseGuestBookSignedLazyQuery>;
export type IsOpenHouseGuestBookSignedQueryResult = Apollo.QueryResult<Types.IsOpenHouseGuestBookSignedQuery, Types.IsOpenHouseGuestBookSignedQueryVariables>;
export const LatestUnsubmittedOfferForBuyersAgentDocument = gql`
    query latestUnsubmittedOfferForBuyersAgent($input: OffersForListingInput!, $isAgentVerified: Boolean = false, $onlyId: Boolean = false) {
  latestUnsubmittedOfferForBuyersAgent(input: $input) @include(if: $isAgentVerified) {
    id @include(if: $onlyId)
    ...Offer @skip(if: $onlyId)
    contract @skip(if: $onlyId) {
      ...OfferContract
    }
    party @include(if: $onlyId) {
      id
    }
  }
  latestUnsubmittedOfferForUnauthenticatedBuyersAgent(input: $input) @skip(if: $isAgentVerified) {
    id @include(if: $onlyId)
    ...Offer @skip(if: $onlyId)
    contract @skip(if: $onlyId) {
      ...OfferContract
    }
  }
}
    ${OfferFragmentDoc}
${OfferContractFragmentDoc}`;

/**
 * __useLatestUnsubmittedOfferForBuyersAgentQuery__
 *
 * To run a query within a React component, call `useLatestUnsubmittedOfferForBuyersAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestUnsubmittedOfferForBuyersAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestUnsubmittedOfferForBuyersAgentQuery({
 *   variables: {
 *      input: // value for 'input'
 *      isAgentVerified: // value for 'isAgentVerified'
 *      onlyId: // value for 'onlyId'
 *   },
 * });
 */
export function useLatestUnsubmittedOfferForBuyersAgentQuery(baseOptions: Apollo.QueryHookOptions<Types.LatestUnsubmittedOfferForBuyersAgentQuery, Types.LatestUnsubmittedOfferForBuyersAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.LatestUnsubmittedOfferForBuyersAgentQuery, Types.LatestUnsubmittedOfferForBuyersAgentQueryVariables>(LatestUnsubmittedOfferForBuyersAgentDocument, options);
      }
export function useLatestUnsubmittedOfferForBuyersAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.LatestUnsubmittedOfferForBuyersAgentQuery, Types.LatestUnsubmittedOfferForBuyersAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.LatestUnsubmittedOfferForBuyersAgentQuery, Types.LatestUnsubmittedOfferForBuyersAgentQueryVariables>(LatestUnsubmittedOfferForBuyersAgentDocument, options);
        }
export type LatestUnsubmittedOfferForBuyersAgentQueryHookResult = ReturnType<typeof useLatestUnsubmittedOfferForBuyersAgentQuery>;
export type LatestUnsubmittedOfferForBuyersAgentLazyQueryHookResult = ReturnType<typeof useLatestUnsubmittedOfferForBuyersAgentLazyQuery>;
export type LatestUnsubmittedOfferForBuyersAgentQueryResult = Apollo.QueryResult<Types.LatestUnsubmittedOfferForBuyersAgentQuery, Types.LatestUnsubmittedOfferForBuyersAgentQueryVariables>;
export const ListingDocument = gql`
    query Listing($input: ListingInput!, $preferenceValues: Boolean = false) {
  listing(input: $input) {
    ...Listing
  }
}
    ${ListingFragmentDoc}`;

/**
 * __useListingQuery__
 *
 * To run a query within a React component, call `useListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      preferenceValues: // value for 'preferenceValues'
 *   },
 * });
 */
export function useListingQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingQuery, Types.ListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingQuery, Types.ListingQueryVariables>(ListingDocument, options);
      }
export function useListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingQuery, Types.ListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingQuery, Types.ListingQueryVariables>(ListingDocument, options);
        }
export type ListingQueryHookResult = ReturnType<typeof useListingQuery>;
export type ListingLazyQueryHookResult = ReturnType<typeof useListingLazyQuery>;
export type ListingQueryResult = Apollo.QueryResult<Types.ListingQuery, Types.ListingQueryVariables>;
export const ListingActivitiesDocument = gql`
    query ListingActivities($input: ListingInput!) {
  listingActivities(input: $input) {
    id
    type
    user {
      ...PublicUser
    }
    metadata
    createdAt
  }
}
    ${PublicUserFragmentDoc}`;

/**
 * __useListingActivitiesQuery__
 *
 * To run a query within a React component, call `useListingActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingActivitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingActivitiesQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingActivitiesQuery, Types.ListingActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingActivitiesQuery, Types.ListingActivitiesQueryVariables>(ListingActivitiesDocument, options);
      }
export function useListingActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingActivitiesQuery, Types.ListingActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingActivitiesQuery, Types.ListingActivitiesQueryVariables>(ListingActivitiesDocument, options);
        }
export type ListingActivitiesQueryHookResult = ReturnType<typeof useListingActivitiesQuery>;
export type ListingActivitiesLazyQueryHookResult = ReturnType<typeof useListingActivitiesLazyQuery>;
export type ListingActivitiesQueryResult = Apollo.QueryResult<Types.ListingActivitiesQuery, Types.ListingActivitiesQueryVariables>;
export const ListingAndOffersDocument = gql`
    query ListingAndOffers($listingId: String!, $preferenceValues: Boolean = true) {
  listing(input: {id: $listingId}) {
    ...Listing
  }
  offersForListing(input: {listingId: $listingId}) {
    ...OffersForListing
  }
}
    ${ListingFragmentDoc}
${OffersForListingFragmentDoc}`;

/**
 * __useListingAndOffersQuery__
 *
 * To run a query within a React component, call `useListingAndOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingAndOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingAndOffersQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      preferenceValues: // value for 'preferenceValues'
 *   },
 * });
 */
export function useListingAndOffersQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingAndOffersQuery, Types.ListingAndOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingAndOffersQuery, Types.ListingAndOffersQueryVariables>(ListingAndOffersDocument, options);
      }
export function useListingAndOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingAndOffersQuery, Types.ListingAndOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingAndOffersQuery, Types.ListingAndOffersQueryVariables>(ListingAndOffersDocument, options);
        }
export type ListingAndOffersQueryHookResult = ReturnType<typeof useListingAndOffersQuery>;
export type ListingAndOffersLazyQueryHookResult = ReturnType<typeof useListingAndOffersLazyQuery>;
export type ListingAndOffersQueryResult = Apollo.QueryResult<Types.ListingAndOffersQuery, Types.ListingAndOffersQueryVariables>;
export const ListingAnnouncementsDocument = gql`
    query listingAnnouncements($input: ListingAnnouncementInput!) {
  listingAnnouncements(input: $input) {
    ...ListingAnnouncement
  }
}
    ${ListingAnnouncementFragmentDoc}`;

/**
 * __useListingAnnouncementsQuery__
 *
 * To run a query within a React component, call `useListingAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingAnnouncementsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingAnnouncementsQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingAnnouncementsQuery, Types.ListingAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingAnnouncementsQuery, Types.ListingAnnouncementsQueryVariables>(ListingAnnouncementsDocument, options);
      }
export function useListingAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingAnnouncementsQuery, Types.ListingAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingAnnouncementsQuery, Types.ListingAnnouncementsQueryVariables>(ListingAnnouncementsDocument, options);
        }
export type ListingAnnouncementsQueryHookResult = ReturnType<typeof useListingAnnouncementsQuery>;
export type ListingAnnouncementsLazyQueryHookResult = ReturnType<typeof useListingAnnouncementsLazyQuery>;
export type ListingAnnouncementsQueryResult = Apollo.QueryResult<Types.ListingAnnouncementsQuery, Types.ListingAnnouncementsQueryVariables>;
export const ListingAnnouncementsCountDocument = gql`
    query listingAnnouncementsCount($input: ListingAnnouncementInput!) {
  listingAnnouncementsCount(input: $input)
}
    `;

/**
 * __useListingAnnouncementsCountQuery__
 *
 * To run a query within a React component, call `useListingAnnouncementsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingAnnouncementsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingAnnouncementsCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingAnnouncementsCountQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingAnnouncementsCountQuery, Types.ListingAnnouncementsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingAnnouncementsCountQuery, Types.ListingAnnouncementsCountQueryVariables>(ListingAnnouncementsCountDocument, options);
      }
export function useListingAnnouncementsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingAnnouncementsCountQuery, Types.ListingAnnouncementsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingAnnouncementsCountQuery, Types.ListingAnnouncementsCountQueryVariables>(ListingAnnouncementsCountDocument, options);
        }
export type ListingAnnouncementsCountQueryHookResult = ReturnType<typeof useListingAnnouncementsCountQuery>;
export type ListingAnnouncementsCountLazyQueryHookResult = ReturnType<typeof useListingAnnouncementsCountLazyQuery>;
export type ListingAnnouncementsCountQueryResult = Apollo.QueryResult<Types.ListingAnnouncementsCountQuery, Types.ListingAnnouncementsCountQueryVariables>;
export const ListingComparableSetDocument = gql`
    query listingComparableSet($input: ListingComparableSetInput!) {
  listingComparableSet(input: $input) {
    ...ListingComparableSet
  }
}
    ${ListingComparableSetFragmentDoc}`;

/**
 * __useListingComparableSetQuery__
 *
 * To run a query within a React component, call `useListingComparableSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingComparableSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingComparableSetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingComparableSetQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingComparableSetQuery, Types.ListingComparableSetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingComparableSetQuery, Types.ListingComparableSetQueryVariables>(ListingComparableSetDocument, options);
      }
export function useListingComparableSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingComparableSetQuery, Types.ListingComparableSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingComparableSetQuery, Types.ListingComparableSetQueryVariables>(ListingComparableSetDocument, options);
        }
export type ListingComparableSetQueryHookResult = ReturnType<typeof useListingComparableSetQuery>;
export type ListingComparableSetLazyQueryHookResult = ReturnType<typeof useListingComparableSetLazyQuery>;
export type ListingComparableSetQueryResult = Apollo.QueryResult<Types.ListingComparableSetQuery, Types.ListingComparableSetQueryVariables>;
export const ListingComparableSetForAgentDocument = gql`
    query listingComparableSetForAgent($input: ListingComparableSetForAgentInput!) {
  listingComparableSetForAgent(input: $input) {
    ...ListingComparableSet
  }
}
    ${ListingComparableSetFragmentDoc}`;

/**
 * __useListingComparableSetForAgentQuery__
 *
 * To run a query within a React component, call `useListingComparableSetForAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingComparableSetForAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingComparableSetForAgentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingComparableSetForAgentQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingComparableSetForAgentQuery, Types.ListingComparableSetForAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingComparableSetForAgentQuery, Types.ListingComparableSetForAgentQueryVariables>(ListingComparableSetForAgentDocument, options);
      }
export function useListingComparableSetForAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingComparableSetForAgentQuery, Types.ListingComparableSetForAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingComparableSetForAgentQuery, Types.ListingComparableSetForAgentQueryVariables>(ListingComparableSetForAgentDocument, options);
        }
export type ListingComparableSetForAgentQueryHookResult = ReturnType<typeof useListingComparableSetForAgentQuery>;
export type ListingComparableSetForAgentLazyQueryHookResult = ReturnType<typeof useListingComparableSetForAgentLazyQuery>;
export type ListingComparableSetForAgentQueryResult = Apollo.QueryResult<Types.ListingComparableSetForAgentQuery, Types.ListingComparableSetForAgentQueryVariables>;
export const ListingComparableSetForBoaTokenDocument = gql`
    query listingComparableSetForBOAToken($input: ListingComparableSetForBOATokenInput!) {
  listingComparableSetForBOAToken(input: $input) {
    ...ListingComparableSet
  }
}
    ${ListingComparableSetFragmentDoc}`;

/**
 * __useListingComparableSetForBoaTokenQuery__
 *
 * To run a query within a React component, call `useListingComparableSetForBoaTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingComparableSetForBoaTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingComparableSetForBoaTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingComparableSetForBoaTokenQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingComparableSetForBoaTokenQuery, Types.ListingComparableSetForBoaTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingComparableSetForBoaTokenQuery, Types.ListingComparableSetForBoaTokenQueryVariables>(ListingComparableSetForBoaTokenDocument, options);
      }
export function useListingComparableSetForBoaTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingComparableSetForBoaTokenQuery, Types.ListingComparableSetForBoaTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingComparableSetForBoaTokenQuery, Types.ListingComparableSetForBoaTokenQueryVariables>(ListingComparableSetForBoaTokenDocument, options);
        }
export type ListingComparableSetForBoaTokenQueryHookResult = ReturnType<typeof useListingComparableSetForBoaTokenQuery>;
export type ListingComparableSetForBoaTokenLazyQueryHookResult = ReturnType<typeof useListingComparableSetForBoaTokenLazyQuery>;
export type ListingComparableSetForBoaTokenQueryResult = Apollo.QueryResult<Types.ListingComparableSetForBoaTokenQuery, Types.ListingComparableSetForBoaTokenQueryVariables>;
export const ListingComparableSetForBuyerOfferAnalysisDocument = gql`
    query listingComparableSetForBuyerOfferAnalysis($input: ListingComparableSetForBuyerOfferAnalysisInput!) {
  listingComparableSetForBuyerOfferAnalysis(input: $input) {
    ...ListingComparableSet
  }
}
    ${ListingComparableSetFragmentDoc}`;

/**
 * __useListingComparableSetForBuyerOfferAnalysisQuery__
 *
 * To run a query within a React component, call `useListingComparableSetForBuyerOfferAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingComparableSetForBuyerOfferAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingComparableSetForBuyerOfferAnalysisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingComparableSetForBuyerOfferAnalysisQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingComparableSetForBuyerOfferAnalysisQuery, Types.ListingComparableSetForBuyerOfferAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingComparableSetForBuyerOfferAnalysisQuery, Types.ListingComparableSetForBuyerOfferAnalysisQueryVariables>(ListingComparableSetForBuyerOfferAnalysisDocument, options);
      }
export function useListingComparableSetForBuyerOfferAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingComparableSetForBuyerOfferAnalysisQuery, Types.ListingComparableSetForBuyerOfferAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingComparableSetForBuyerOfferAnalysisQuery, Types.ListingComparableSetForBuyerOfferAnalysisQueryVariables>(ListingComparableSetForBuyerOfferAnalysisDocument, options);
        }
export type ListingComparableSetForBuyerOfferAnalysisQueryHookResult = ReturnType<typeof useListingComparableSetForBuyerOfferAnalysisQuery>;
export type ListingComparableSetForBuyerOfferAnalysisLazyQueryHookResult = ReturnType<typeof useListingComparableSetForBuyerOfferAnalysisLazyQuery>;
export type ListingComparableSetForBuyerOfferAnalysisQueryResult = Apollo.QueryResult<Types.ListingComparableSetForBuyerOfferAnalysisQuery, Types.ListingComparableSetForBuyerOfferAnalysisQueryVariables>;
export const ListingComparableSetForReportTokenDocument = gql`
    query listingComparableSetForReportToken($input: ListingComparableSetForReportTokenInput!) {
  listingComparableSetForReportToken(input: $input) {
    ...ListingComparableSet
  }
}
    ${ListingComparableSetFragmentDoc}`;

/**
 * __useListingComparableSetForReportTokenQuery__
 *
 * To run a query within a React component, call `useListingComparableSetForReportTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingComparableSetForReportTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingComparableSetForReportTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingComparableSetForReportTokenQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingComparableSetForReportTokenQuery, Types.ListingComparableSetForReportTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingComparableSetForReportTokenQuery, Types.ListingComparableSetForReportTokenQueryVariables>(ListingComparableSetForReportTokenDocument, options);
      }
export function useListingComparableSetForReportTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingComparableSetForReportTokenQuery, Types.ListingComparableSetForReportTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingComparableSetForReportTokenQuery, Types.ListingComparableSetForReportTokenQueryVariables>(ListingComparableSetForReportTokenDocument, options);
        }
export type ListingComparableSetForReportTokenQueryHookResult = ReturnType<typeof useListingComparableSetForReportTokenQuery>;
export type ListingComparableSetForReportTokenLazyQueryHookResult = ReturnType<typeof useListingComparableSetForReportTokenLazyQuery>;
export type ListingComparableSetForReportTokenQueryResult = Apollo.QueryResult<Types.ListingComparableSetForReportTokenQuery, Types.ListingComparableSetForReportTokenQueryVariables>;
export const ListingDocumentTypesDocument = gql`
    query listingDocumentTypes($input: ListingDocumentTypesInput!) {
  listingDocumentTypes(input: $input) {
    ...ListingDocumentType
  }
}
    ${ListingDocumentTypeFragmentDoc}`;

/**
 * __useListingDocumentTypesQuery__
 *
 * To run a query within a React component, call `useListingDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingDocumentTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingDocumentTypesQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingDocumentTypesQuery, Types.ListingDocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingDocumentTypesQuery, Types.ListingDocumentTypesQueryVariables>(ListingDocumentTypesDocument, options);
      }
export function useListingDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingDocumentTypesQuery, Types.ListingDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingDocumentTypesQuery, Types.ListingDocumentTypesQueryVariables>(ListingDocumentTypesDocument, options);
        }
export type ListingDocumentTypesQueryHookResult = ReturnType<typeof useListingDocumentTypesQuery>;
export type ListingDocumentTypesLazyQueryHookResult = ReturnType<typeof useListingDocumentTypesLazyQuery>;
export type ListingDocumentTypesQueryResult = Apollo.QueryResult<Types.ListingDocumentTypesQuery, Types.ListingDocumentTypesQueryVariables>;
export const ListingDocumentUploadsDocument = gql`
    query listingDocumentUploads($input: ListingDocumentUploadsInput!) {
  listingDocumentUploads(input: $input) {
    listingDocumentType {
      ...ListingDocumentType
      ...ListingDocumentTypeWithDocuments
    }
    ...ListingDocumentUpload
  }
}
    ${ListingDocumentTypeFragmentDoc}
${ListingDocumentTypeWithDocumentsFragmentDoc}
${ListingDocumentUploadFragmentDoc}`;

/**
 * __useListingDocumentUploadsQuery__
 *
 * To run a query within a React component, call `useListingDocumentUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingDocumentUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingDocumentUploadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingDocumentUploadsQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingDocumentUploadsQuery, Types.ListingDocumentUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingDocumentUploadsQuery, Types.ListingDocumentUploadsQueryVariables>(ListingDocumentUploadsDocument, options);
      }
export function useListingDocumentUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingDocumentUploadsQuery, Types.ListingDocumentUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingDocumentUploadsQuery, Types.ListingDocumentUploadsQueryVariables>(ListingDocumentUploadsDocument, options);
        }
export type ListingDocumentUploadsQueryHookResult = ReturnType<typeof useListingDocumentUploadsQuery>;
export type ListingDocumentUploadsLazyQueryHookResult = ReturnType<typeof useListingDocumentUploadsLazyQuery>;
export type ListingDocumentUploadsQueryResult = Apollo.QueryResult<Types.ListingDocumentUploadsQuery, Types.ListingDocumentUploadsQueryVariables>;
export const ListingFollowersDocument = gql`
    query ListingFollowers($input: ListingInput!) {
  listingFollowers(input: $input) {
    listingFollowers {
      ...ListingFollower
    }
  }
}
    ${ListingFollowerFragmentDoc}`;

/**
 * __useListingFollowersQuery__
 *
 * To run a query within a React component, call `useListingFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingFollowersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingFollowersQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingFollowersQuery, Types.ListingFollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingFollowersQuery, Types.ListingFollowersQueryVariables>(ListingFollowersDocument, options);
      }
export function useListingFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingFollowersQuery, Types.ListingFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingFollowersQuery, Types.ListingFollowersQueryVariables>(ListingFollowersDocument, options);
        }
export type ListingFollowersQueryHookResult = ReturnType<typeof useListingFollowersQuery>;
export type ListingFollowersLazyQueryHookResult = ReturnType<typeof useListingFollowersLazyQuery>;
export type ListingFollowersQueryResult = Apollo.QueryResult<Types.ListingFollowersQuery, Types.ListingFollowersQueryVariables>;
export const ListingforMlsListingDocument = gql`
    query ListingforMLSListing($input: MLSListingInput!) {
  syncListingFromMLS(input: $input) {
    id
    property {
      id
      slug
    }
  }
}
    `;

/**
 * __useListingforMlsListingQuery__
 *
 * To run a query within a React component, call `useListingforMlsListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingforMlsListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingforMlsListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingforMlsListingQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingforMlsListingQuery, Types.ListingforMlsListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingforMlsListingQuery, Types.ListingforMlsListingQueryVariables>(ListingforMlsListingDocument, options);
      }
export function useListingforMlsListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingforMlsListingQuery, Types.ListingforMlsListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingforMlsListingQuery, Types.ListingforMlsListingQueryVariables>(ListingforMlsListingDocument, options);
        }
export type ListingforMlsListingQueryHookResult = ReturnType<typeof useListingforMlsListingQuery>;
export type ListingforMlsListingLazyQueryHookResult = ReturnType<typeof useListingforMlsListingLazyQuery>;
export type ListingforMlsListingQueryResult = Apollo.QueryResult<Types.ListingforMlsListingQuery, Types.ListingforMlsListingQueryVariables>;
export const ListingOpenHousesDocument = gql`
    query ListingOpenHouses($input: ListingOpenHousesInput!) {
  listingOpenHouses(input: $input) {
    results {
      ...OpenHouseCard
    }
  }
}
    ${OpenHouseCardFragmentDoc}`;

/**
 * __useListingOpenHousesQuery__
 *
 * To run a query within a React component, call `useListingOpenHousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingOpenHousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingOpenHousesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingOpenHousesQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingOpenHousesQuery, Types.ListingOpenHousesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingOpenHousesQuery, Types.ListingOpenHousesQueryVariables>(ListingOpenHousesDocument, options);
      }
export function useListingOpenHousesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingOpenHousesQuery, Types.ListingOpenHousesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingOpenHousesQuery, Types.ListingOpenHousesQueryVariables>(ListingOpenHousesDocument, options);
        }
export type ListingOpenHousesQueryHookResult = ReturnType<typeof useListingOpenHousesQuery>;
export type ListingOpenHousesLazyQueryHookResult = ReturnType<typeof useListingOpenHousesLazyQuery>;
export type ListingOpenHousesQueryResult = Apollo.QueryResult<Types.ListingOpenHousesQuery, Types.ListingOpenHousesQueryVariables>;
export const ListingsForCurrentUserDocument = gql`
    query ListingsForCurrentUser($cursor: String, $preferenceValues: Boolean = false, $perPage: Int! = 20, $orderBy: String! = "-listDate", $filters: ListingsFilterArgs!) {
  listingsForCurrentUser(
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
    filters: $filters
  ) {
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      perPage
      prevCursor
      totalCount
    }
    results {
      ...Listing
      isSharedListing
    }
  }
}
    ${ListingFragmentDoc}`;

/**
 * __useListingsForCurrentUserQuery__
 *
 * To run a query within a React component, call `useListingsForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsForCurrentUserQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      preferenceValues: // value for 'preferenceValues'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListingsForCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingsForCurrentUserQuery, Types.ListingsForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingsForCurrentUserQuery, Types.ListingsForCurrentUserQueryVariables>(ListingsForCurrentUserDocument, options);
      }
export function useListingsForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingsForCurrentUserQuery, Types.ListingsForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingsForCurrentUserQuery, Types.ListingsForCurrentUserQueryVariables>(ListingsForCurrentUserDocument, options);
        }
export type ListingsForCurrentUserQueryHookResult = ReturnType<typeof useListingsForCurrentUserQuery>;
export type ListingsForCurrentUserLazyQueryHookResult = ReturnType<typeof useListingsForCurrentUserLazyQuery>;
export type ListingsForCurrentUserQueryResult = Apollo.QueryResult<Types.ListingsForCurrentUserQuery, Types.ListingsForCurrentUserQueryVariables>;
export const ListingsForOrganizationDocument = gql`
    query ListingsForOrganization($cursor: String, $perPage: Int! = 20, $orderBy: String! = "-listDate", $filters: ListingsForOrganizationFilterArgs!) {
  listingsForOrganization(
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
    filters: $filters
  ) {
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      perPage
      prevCursor
      totalCount
    }
    results {
      ...ListingForOrganization
    }
  }
}
    ${ListingForOrganizationFragmentDoc}`;

/**
 * __useListingsForOrganizationQuery__
 *
 * To run a query within a React component, call `useListingsForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingsForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingsForOrganizationQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListingsForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<Types.ListingsForOrganizationQuery, Types.ListingsForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ListingsForOrganizationQuery, Types.ListingsForOrganizationQueryVariables>(ListingsForOrganizationDocument, options);
      }
export function useListingsForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ListingsForOrganizationQuery, Types.ListingsForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ListingsForOrganizationQuery, Types.ListingsForOrganizationQueryVariables>(ListingsForOrganizationDocument, options);
        }
export type ListingsForOrganizationQueryHookResult = ReturnType<typeof useListingsForOrganizationQuery>;
export type ListingsForOrganizationLazyQueryHookResult = ReturnType<typeof useListingsForOrganizationLazyQuery>;
export type ListingsForOrganizationQueryResult = Apollo.QueryResult<Types.ListingsForOrganizationQuery, Types.ListingsForOrganizationQueryVariables>;
export const NotificationLogAutofillVariablesSchemaDocument = gql`
    query notificationLogAutofillVariablesSchema {
  notificationLogAutofillVariablesSchema
}
    `;

/**
 * __useNotificationLogAutofillVariablesSchemaQuery__
 *
 * To run a query within a React component, call `useNotificationLogAutofillVariablesSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationLogAutofillVariablesSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationLogAutofillVariablesSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationLogAutofillVariablesSchemaQuery(baseOptions?: Apollo.QueryHookOptions<Types.NotificationLogAutofillVariablesSchemaQuery, Types.NotificationLogAutofillVariablesSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NotificationLogAutofillVariablesSchemaQuery, Types.NotificationLogAutofillVariablesSchemaQueryVariables>(NotificationLogAutofillVariablesSchemaDocument, options);
      }
export function useNotificationLogAutofillVariablesSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NotificationLogAutofillVariablesSchemaQuery, Types.NotificationLogAutofillVariablesSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NotificationLogAutofillVariablesSchemaQuery, Types.NotificationLogAutofillVariablesSchemaQueryVariables>(NotificationLogAutofillVariablesSchemaDocument, options);
        }
export type NotificationLogAutofillVariablesSchemaQueryHookResult = ReturnType<typeof useNotificationLogAutofillVariablesSchemaQuery>;
export type NotificationLogAutofillVariablesSchemaLazyQueryHookResult = ReturnType<typeof useNotificationLogAutofillVariablesSchemaLazyQuery>;
export type NotificationLogAutofillVariablesSchemaQueryResult = Apollo.QueryResult<Types.NotificationLogAutofillVariablesSchemaQuery, Types.NotificationLogAutofillVariablesSchemaQueryVariables>;
export const NotificationLogAutofillValuesDocument = gql`
    query notificationLogAutofillValues($notificationLogId: ID, $notificationTemplateId: ID) {
  notificationLogAutofillValues(
    notificationLogId: $notificationLogId
    notificationTemplateId: $notificationTemplateId
  ) {
    normalizedFieldValues
    assignedAgentFirstName
    assignedAgentName
    assignedPartnerCalendarSchedulingUrl
    assignedPartnerEmail
    assignedPartnerFirstName
    assignedPartnerName
    assignedPartnerPhoneNumber
    assignedPartnerPreApprovalAppUrl
    buyerAgentFirstName
    buyersFirstNames
    listingAgentFirstName
    partnerCompanyName
    sellersFirstNames
  }
}
    `;

/**
 * __useNotificationLogAutofillValuesQuery__
 *
 * To run a query within a React component, call `useNotificationLogAutofillValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationLogAutofillValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationLogAutofillValuesQuery({
 *   variables: {
 *      notificationLogId: // value for 'notificationLogId'
 *      notificationTemplateId: // value for 'notificationTemplateId'
 *   },
 * });
 */
export function useNotificationLogAutofillValuesQuery(baseOptions?: Apollo.QueryHookOptions<Types.NotificationLogAutofillValuesQuery, Types.NotificationLogAutofillValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NotificationLogAutofillValuesQuery, Types.NotificationLogAutofillValuesQueryVariables>(NotificationLogAutofillValuesDocument, options);
      }
export function useNotificationLogAutofillValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NotificationLogAutofillValuesQuery, Types.NotificationLogAutofillValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NotificationLogAutofillValuesQuery, Types.NotificationLogAutofillValuesQueryVariables>(NotificationLogAutofillValuesDocument, options);
        }
export type NotificationLogAutofillValuesQueryHookResult = ReturnType<typeof useNotificationLogAutofillValuesQuery>;
export type NotificationLogAutofillValuesLazyQueryHookResult = ReturnType<typeof useNotificationLogAutofillValuesLazyQuery>;
export type NotificationLogAutofillValuesQueryResult = Apollo.QueryResult<Types.NotificationLogAutofillValuesQuery, Types.NotificationLogAutofillValuesQueryVariables>;
export const GetUserNotificationSettingsDocument = gql`
    query GetUserNotificationSettings {
  userNotificationSettings {
    email
    sms
  }
}
    `;

/**
 * __useGetUserNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<Types.GetUserNotificationSettingsQuery, Types.GetUserNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetUserNotificationSettingsQuery, Types.GetUserNotificationSettingsQueryVariables>(GetUserNotificationSettingsDocument, options);
      }
export function useGetUserNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetUserNotificationSettingsQuery, Types.GetUserNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetUserNotificationSettingsQuery, Types.GetUserNotificationSettingsQueryVariables>(GetUserNotificationSettingsDocument, options);
        }
export type GetUserNotificationSettingsQueryHookResult = ReturnType<typeof useGetUserNotificationSettingsQuery>;
export type GetUserNotificationSettingsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationSettingsLazyQuery>;
export type GetUserNotificationSettingsQueryResult = Apollo.QueryResult<Types.GetUserNotificationSettingsQuery, Types.GetUserNotificationSettingsQueryVariables>;
export const NotificationTemplateDocument = gql`
    query NotificationTemplate($id: ID!) {
  notificationTemplate(id: $id) {
    ...NotificationTemplateDetails
  }
}
    ${NotificationTemplateDetailsFragmentDoc}`;

/**
 * __useNotificationTemplateQuery__
 *
 * To run a query within a React component, call `useNotificationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationTemplateQuery(baseOptions: Apollo.QueryHookOptions<Types.NotificationTemplateQuery, Types.NotificationTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NotificationTemplateQuery, Types.NotificationTemplateQueryVariables>(NotificationTemplateDocument, options);
      }
export function useNotificationTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NotificationTemplateQuery, Types.NotificationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NotificationTemplateQuery, Types.NotificationTemplateQueryVariables>(NotificationTemplateDocument, options);
        }
export type NotificationTemplateQueryHookResult = ReturnType<typeof useNotificationTemplateQuery>;
export type NotificationTemplateLazyQueryHookResult = ReturnType<typeof useNotificationTemplateLazyQuery>;
export type NotificationTemplateQueryResult = Apollo.QueryResult<Types.NotificationTemplateQuery, Types.NotificationTemplateQueryVariables>;
export const NotificationTemplatesListDocument = gql`
    query NotificationTemplatesList($partnerId: ID!, $cursor: String, $perPage: Int = 50, $orderBy: String = "orderIndex", $filters: NotificationTemplateFilters) {
  notificationTemplatesList(
    partnerId: $partnerId
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
    filters: $filters
  ) {
    results {
      ...NotificationTemplateListItem
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
      totalCount
      perPage
    }
  }
}
    ${NotificationTemplateListItemFragmentDoc}`;

/**
 * __useNotificationTemplatesListQuery__
 *
 * To run a query within a React component, call `useNotificationTemplatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationTemplatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationTemplatesListQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNotificationTemplatesListQuery(baseOptions: Apollo.QueryHookOptions<Types.NotificationTemplatesListQuery, Types.NotificationTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.NotificationTemplatesListQuery, Types.NotificationTemplatesListQueryVariables>(NotificationTemplatesListDocument, options);
      }
export function useNotificationTemplatesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.NotificationTemplatesListQuery, Types.NotificationTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.NotificationTemplatesListQuery, Types.NotificationTemplatesListQueryVariables>(NotificationTemplatesListDocument, options);
        }
export type NotificationTemplatesListQueryHookResult = ReturnType<typeof useNotificationTemplatesListQuery>;
export type NotificationTemplatesListLazyQueryHookResult = ReturnType<typeof useNotificationTemplatesListLazyQuery>;
export type NotificationTemplatesListQueryResult = Apollo.QueryResult<Types.NotificationTemplatesListQuery, Types.NotificationTemplatesListQueryVariables>;
export const OfferAutofillValuesDocument = gql`
    query offerAutofillValues($listingId: ID, $offerId: ID, $documentVersionIds: [ID!]!, $fieldValues: JSONObject!) {
  offerAutofillValues(
    listingId: $listingId
    offerId: $offerId
    documentVersionIds: $documentVersionIds
    fieldValues: $fieldValues
  ) {
    readOnlyAutofillValues
    autofillValues
    helpTextAutofillValues
    optionsAutofillValues
  }
}
    `;

/**
 * __useOfferAutofillValuesQuery__
 *
 * To run a query within a React component, call `useOfferAutofillValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferAutofillValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferAutofillValuesQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      offerId: // value for 'offerId'
 *      documentVersionIds: // value for 'documentVersionIds'
 *      fieldValues: // value for 'fieldValues'
 *   },
 * });
 */
export function useOfferAutofillValuesQuery(baseOptions: Apollo.QueryHookOptions<Types.OfferAutofillValuesQuery, Types.OfferAutofillValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OfferAutofillValuesQuery, Types.OfferAutofillValuesQueryVariables>(OfferAutofillValuesDocument, options);
      }
export function useOfferAutofillValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OfferAutofillValuesQuery, Types.OfferAutofillValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OfferAutofillValuesQuery, Types.OfferAutofillValuesQueryVariables>(OfferAutofillValuesDocument, options);
        }
export type OfferAutofillValuesQueryHookResult = ReturnType<typeof useOfferAutofillValuesQuery>;
export type OfferAutofillValuesLazyQueryHookResult = ReturnType<typeof useOfferAutofillValuesLazyQuery>;
export type OfferAutofillValuesQueryResult = Apollo.QueryResult<Types.OfferAutofillValuesQuery, Types.OfferAutofillValuesQueryVariables>;
export const OfferMetricsDocument = gql`
    query offerMetrics {
  offerMetrics {
    accepted_bid_ask
    not_accepted_earnest_money_deposit
    property_city
    property_state
    purchase_price_range
    not_accepted_due_diligence_fee
    not_accepted_due_diligence_and_deposit
    not_accepted_bid_ask
    interval_start
    accepted_earnest_money_deposit
    accepted_due_diligence_fee
    accepted_due_diligence_and_deposit
  }
}
    `;

/**
 * __useOfferMetricsQuery__
 *
 * To run a query within a React component, call `useOfferMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfferMetricsQuery(baseOptions?: Apollo.QueryHookOptions<Types.OfferMetricsQuery, Types.OfferMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OfferMetricsQuery, Types.OfferMetricsQueryVariables>(OfferMetricsDocument, options);
      }
export function useOfferMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OfferMetricsQuery, Types.OfferMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OfferMetricsQuery, Types.OfferMetricsQueryVariables>(OfferMetricsDocument, options);
        }
export type OfferMetricsQueryHookResult = ReturnType<typeof useOfferMetricsQuery>;
export type OfferMetricsLazyQueryHookResult = ReturnType<typeof useOfferMetricsLazyQuery>;
export type OfferMetricsQueryResult = Apollo.QueryResult<Types.OfferMetricsQuery, Types.OfferMetricsQueryVariables>;
export const OffersForCurentUserDocument = gql`
    query offersForCurentUser($cursor: String, $orderBy: String! = "-id", $perPage: Int! = 10, $filters: OffersForCurrentUserFilters) {
  offersForCurrentUser(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...OffersForCurrentUser
    }
  }
}
    ${PageInfoFragmentDoc}
${OffersForCurrentUserFragmentDoc}`;

/**
 * __useOffersForCurentUserQuery__
 *
 * To run a query within a React component, call `useOffersForCurentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersForCurentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersForCurentUserQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOffersForCurentUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.OffersForCurentUserQuery, Types.OffersForCurentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OffersForCurentUserQuery, Types.OffersForCurentUserQueryVariables>(OffersForCurentUserDocument, options);
      }
export function useOffersForCurentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OffersForCurentUserQuery, Types.OffersForCurentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OffersForCurentUserQuery, Types.OffersForCurentUserQueryVariables>(OffersForCurentUserDocument, options);
        }
export type OffersForCurentUserQueryHookResult = ReturnType<typeof useOffersForCurentUserQuery>;
export type OffersForCurentUserLazyQueryHookResult = ReturnType<typeof useOffersForCurentUserLazyQuery>;
export type OffersForCurentUserQueryResult = Apollo.QueryResult<Types.OffersForCurentUserQuery, Types.OffersForCurentUserQueryVariables>;
export const OpenHousesForCurrentUserDocument = gql`
    query OpenHousesForCurrentUser($cursor: String, $perPage: Int! = 10, $orderBy: String! = "-date", $filters: OpenHousesFilterArgs) {
  openHousesForCurrentUser(
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
    filters: $filters
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...OpenHouseForCurrentUser
    }
  }
}
    ${PageInfoFragmentDoc}
${OpenHouseForCurrentUserFragmentDoc}`;

/**
 * __useOpenHousesForCurrentUserQuery__
 *
 * To run a query within a React component, call `useOpenHousesForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenHousesForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenHousesForCurrentUserQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOpenHousesForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.OpenHousesForCurrentUserQuery, Types.OpenHousesForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpenHousesForCurrentUserQuery, Types.OpenHousesForCurrentUserQueryVariables>(OpenHousesForCurrentUserDocument, options);
      }
export function useOpenHousesForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpenHousesForCurrentUserQuery, Types.OpenHousesForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpenHousesForCurrentUserQuery, Types.OpenHousesForCurrentUserQueryVariables>(OpenHousesForCurrentUserDocument, options);
        }
export type OpenHousesForCurrentUserQueryHookResult = ReturnType<typeof useOpenHousesForCurrentUserQuery>;
export type OpenHousesForCurrentUserLazyQueryHookResult = ReturnType<typeof useOpenHousesForCurrentUserLazyQuery>;
export type OpenHousesForCurrentUserQueryResult = Apollo.QueryResult<Types.OpenHousesForCurrentUserQuery, Types.OpenHousesForCurrentUserQueryVariables>;
export const OpenHouseDocument = gql`
    query OpenHouse($input: OpenHouseInput!) {
  openHouse(input: $input) {
    id
    date
    startTime
    endTime
    listing {
      id
      property {
        slug
      }
      mlsListing {
        id
        mlsId
        mls {
          originatingSystemName
        }
        address {
          full
          state
          city
          postalCode
        }
        photos
      }
    }
  }
}
    `;

/**
 * __useOpenHouseQuery__
 *
 * To run a query within a React component, call `useOpenHouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenHouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenHouseQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenHouseQuery(baseOptions: Apollo.QueryHookOptions<Types.OpenHouseQuery, Types.OpenHouseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OpenHouseQuery, Types.OpenHouseQueryVariables>(OpenHouseDocument, options);
      }
export function useOpenHouseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OpenHouseQuery, Types.OpenHouseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OpenHouseQuery, Types.OpenHouseQueryVariables>(OpenHouseDocument, options);
        }
export type OpenHouseQueryHookResult = ReturnType<typeof useOpenHouseQuery>;
export type OpenHouseLazyQueryHookResult = ReturnType<typeof useOpenHouseLazyQuery>;
export type OpenHouseQueryResult = Apollo.QueryResult<Types.OpenHouseQuery, Types.OpenHouseQueryVariables>;
export const OrgListingAggDeltaByStatusDocument = gql`
    query OrgListingAggDeltaByStatus($input: OrgListingAggDeltaByStatusInput!) {
  orgListingAggDeltaByStatus(input: $input) {
    organization {
      ...Organization
    }
    differences {
      status
      countDifference
      sumListPriceDifference
    }
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useOrgListingAggDeltaByStatusQuery__
 *
 * To run a query within a React component, call `useOrgListingAggDeltaByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgListingAggDeltaByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgListingAggDeltaByStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgListingAggDeltaByStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.OrgListingAggDeltaByStatusQuery, Types.OrgListingAggDeltaByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrgListingAggDeltaByStatusQuery, Types.OrgListingAggDeltaByStatusQueryVariables>(OrgListingAggDeltaByStatusDocument, options);
      }
export function useOrgListingAggDeltaByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrgListingAggDeltaByStatusQuery, Types.OrgListingAggDeltaByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrgListingAggDeltaByStatusQuery, Types.OrgListingAggDeltaByStatusQueryVariables>(OrgListingAggDeltaByStatusDocument, options);
        }
export type OrgListingAggDeltaByStatusQueryHookResult = ReturnType<typeof useOrgListingAggDeltaByStatusQuery>;
export type OrgListingAggDeltaByStatusLazyQueryHookResult = ReturnType<typeof useOrgListingAggDeltaByStatusLazyQuery>;
export type OrgListingAggDeltaByStatusQueryResult = Apollo.QueryResult<Types.OrgListingAggDeltaByStatusQuery, Types.OrgListingAggDeltaByStatusQueryVariables>;
export const OrgTransactionStatsByZipCodeDocument = gql`
    query orgTransactionStatsByZipCode($filters: AgentPerformanceFilters!) {
  orgTransactionStatsByZipCode(filters: $filters) {
    buy_side_homes_count
    unknown_homes_count
    zip_code
    buy_side_volume
    closed_homes_count
    closed_volume
    pending_homes_count
    pending_volume
    sell_side_homes_count
    sell_side_volume
    total_homes_count
    total_volume
  }
}
    `;

/**
 * __useOrgTransactionStatsByZipCodeQuery__
 *
 * To run a query within a React component, call `useOrgTransactionStatsByZipCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgTransactionStatsByZipCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgTransactionStatsByZipCodeQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOrgTransactionStatsByZipCodeQuery(baseOptions: Apollo.QueryHookOptions<Types.OrgTransactionStatsByZipCodeQuery, Types.OrgTransactionStatsByZipCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrgTransactionStatsByZipCodeQuery, Types.OrgTransactionStatsByZipCodeQueryVariables>(OrgTransactionStatsByZipCodeDocument, options);
      }
export function useOrgTransactionStatsByZipCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrgTransactionStatsByZipCodeQuery, Types.OrgTransactionStatsByZipCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrgTransactionStatsByZipCodeQuery, Types.OrgTransactionStatsByZipCodeQueryVariables>(OrgTransactionStatsByZipCodeDocument, options);
        }
export type OrgTransactionStatsByZipCodeQueryHookResult = ReturnType<typeof useOrgTransactionStatsByZipCodeQuery>;
export type OrgTransactionStatsByZipCodeLazyQueryHookResult = ReturnType<typeof useOrgTransactionStatsByZipCodeLazyQuery>;
export type OrgTransactionStatsByZipCodeQueryResult = Apollo.QueryResult<Types.OrgTransactionStatsByZipCodeQuery, Types.OrgTransactionStatsByZipCodeQueryVariables>;
export const OrganizationComplianceDashboardDocument = gql`
    query organizationComplianceDashboard($organizationId: ID!, $input: OrganizationComplianceDashboardInput) {
  organizationComplianceDashboard(organizationId: $organizationId, input: $input) {
    banner {
      ...ComplianceDashboardBanner
    }
    filters {
      ...ComplianceDashboardFilters
    }
    summary {
      ...ComplianceDashboardSummary
    }
    sections {
      id
      title
      selectedBreakdown
      breakdownOptions {
        label
        value
      }
      cards {
        ...ComplianceDashboardMetricCard
      }
    }
    insights {
      ...ComplianceDashboardInsights
    }
    leaderboard {
      ...ComplianceDashboardLeaderboardRow
    }
  }
}
    ${ComplianceDashboardBannerFragmentDoc}
${ComplianceDashboardFiltersFragmentDoc}
${ComplianceDashboardSummaryFragmentDoc}
${ComplianceDashboardMetricCardFragmentDoc}
${ComplianceDashboardInsightsFragmentDoc}
${ComplianceDashboardLeaderboardRowFragmentDoc}`;

/**
 * __useOrganizationComplianceDashboardQuery__
 *
 * To run a query within a React component, call `useOrganizationComplianceDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationComplianceDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationComplianceDashboardQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationComplianceDashboardQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationComplianceDashboardQuery, Types.OrganizationComplianceDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationComplianceDashboardQuery, Types.OrganizationComplianceDashboardQueryVariables>(OrganizationComplianceDashboardDocument, options);
      }
export function useOrganizationComplianceDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationComplianceDashboardQuery, Types.OrganizationComplianceDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationComplianceDashboardQuery, Types.OrganizationComplianceDashboardQueryVariables>(OrganizationComplianceDashboardDocument, options);
        }
export type OrganizationComplianceDashboardQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardQuery>;
export type OrganizationComplianceDashboardLazyQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardLazyQuery>;
export type OrganizationComplianceDashboardQueryResult = Apollo.QueryResult<Types.OrganizationComplianceDashboardQuery, Types.OrganizationComplianceDashboardQueryVariables>;
export const OrganizationComplianceDashboardCardDocument = gql`
    query organizationComplianceDashboardCard($cardKey: ComplianceDashboardCardKey!, $organizationId: ID!, $input: OrganizationComplianceDashboardInput) {
  organizationComplianceDashboardCard(
    cardKey: $cardKey
    organizationId: $organizationId
    input: $input
  ) {
    ...ComplianceDashboardMetricCard
  }
}
    ${ComplianceDashboardMetricCardFragmentDoc}`;

/**
 * __useOrganizationComplianceDashboardCardQuery__
 *
 * To run a query within a React component, call `useOrganizationComplianceDashboardCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationComplianceDashboardCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationComplianceDashboardCardQuery({
 *   variables: {
 *      cardKey: // value for 'cardKey'
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationComplianceDashboardCardQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationComplianceDashboardCardQuery, Types.OrganizationComplianceDashboardCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationComplianceDashboardCardQuery, Types.OrganizationComplianceDashboardCardQueryVariables>(OrganizationComplianceDashboardCardDocument, options);
      }
export function useOrganizationComplianceDashboardCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationComplianceDashboardCardQuery, Types.OrganizationComplianceDashboardCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationComplianceDashboardCardQuery, Types.OrganizationComplianceDashboardCardQueryVariables>(OrganizationComplianceDashboardCardDocument, options);
        }
export type OrganizationComplianceDashboardCardQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardCardQuery>;
export type OrganizationComplianceDashboardCardLazyQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardCardLazyQuery>;
export type OrganizationComplianceDashboardCardQueryResult = Apollo.QueryResult<Types.OrganizationComplianceDashboardCardQuery, Types.OrganizationComplianceDashboardCardQueryVariables>;
export const OrganizationComplianceDashboardInsightsDocument = gql`
    query organizationComplianceDashboardInsights($organizationId: ID!, $input: OrganizationComplianceDashboardInput) {
  organizationComplianceDashboardInsights(
    organizationId: $organizationId
    input: $input
  ) {
    ...ComplianceDashboardInsights
  }
}
    ${ComplianceDashboardInsightsFragmentDoc}`;

/**
 * __useOrganizationComplianceDashboardInsightsQuery__
 *
 * To run a query within a React component, call `useOrganizationComplianceDashboardInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationComplianceDashboardInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationComplianceDashboardInsightsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationComplianceDashboardInsightsQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationComplianceDashboardInsightsQuery, Types.OrganizationComplianceDashboardInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationComplianceDashboardInsightsQuery, Types.OrganizationComplianceDashboardInsightsQueryVariables>(OrganizationComplianceDashboardInsightsDocument, options);
      }
export function useOrganizationComplianceDashboardInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationComplianceDashboardInsightsQuery, Types.OrganizationComplianceDashboardInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationComplianceDashboardInsightsQuery, Types.OrganizationComplianceDashboardInsightsQueryVariables>(OrganizationComplianceDashboardInsightsDocument, options);
        }
export type OrganizationComplianceDashboardInsightsQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardInsightsQuery>;
export type OrganizationComplianceDashboardInsightsLazyQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardInsightsLazyQuery>;
export type OrganizationComplianceDashboardInsightsQueryResult = Apollo.QueryResult<Types.OrganizationComplianceDashboardInsightsQuery, Types.OrganizationComplianceDashboardInsightsQueryVariables>;
export const OrganizationComplianceDashboardLeaderboardDocument = gql`
    query organizationComplianceDashboardLeaderboard($organizationId: ID!, $input: OrganizationComplianceDashboardInput) {
  organizationComplianceDashboardLeaderboard(
    organizationId: $organizationId
    input: $input
  ) {
    ...ComplianceDashboardLeaderboardRow
  }
}
    ${ComplianceDashboardLeaderboardRowFragmentDoc}`;

/**
 * __useOrganizationComplianceDashboardLeaderboardQuery__
 *
 * To run a query within a React component, call `useOrganizationComplianceDashboardLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationComplianceDashboardLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationComplianceDashboardLeaderboardQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationComplianceDashboardLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationComplianceDashboardLeaderboardQuery, Types.OrganizationComplianceDashboardLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationComplianceDashboardLeaderboardQuery, Types.OrganizationComplianceDashboardLeaderboardQueryVariables>(OrganizationComplianceDashboardLeaderboardDocument, options);
      }
export function useOrganizationComplianceDashboardLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationComplianceDashboardLeaderboardQuery, Types.OrganizationComplianceDashboardLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationComplianceDashboardLeaderboardQuery, Types.OrganizationComplianceDashboardLeaderboardQueryVariables>(OrganizationComplianceDashboardLeaderboardDocument, options);
        }
export type OrganizationComplianceDashboardLeaderboardQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardLeaderboardQuery>;
export type OrganizationComplianceDashboardLeaderboardLazyQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardLeaderboardLazyQuery>;
export type OrganizationComplianceDashboardLeaderboardQueryResult = Apollo.QueryResult<Types.OrganizationComplianceDashboardLeaderboardQuery, Types.OrganizationComplianceDashboardLeaderboardQueryVariables>;
export const OrganizationComplianceDashboardMetaDocument = gql`
    query organizationComplianceDashboardMeta($organizationId: ID!, $input: OrganizationComplianceDashboardInput) {
  organizationComplianceDashboardMeta(
    organizationId: $organizationId
    input: $input
  ) {
    autoApprovalEnabled
    banner {
      ...ComplianceDashboardBanner
    }
    filters {
      ...ComplianceDashboardFilters
    }
    summary {
      ...ComplianceDashboardSummary
    }
    sections {
      ...ComplianceDashboardSectionLayout
    }
  }
}
    ${ComplianceDashboardBannerFragmentDoc}
${ComplianceDashboardFiltersFragmentDoc}
${ComplianceDashboardSummaryFragmentDoc}
${ComplianceDashboardSectionLayoutFragmentDoc}`;

/**
 * __useOrganizationComplianceDashboardMetaQuery__
 *
 * To run a query within a React component, call `useOrganizationComplianceDashboardMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationComplianceDashboardMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationComplianceDashboardMetaQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationComplianceDashboardMetaQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationComplianceDashboardMetaQuery, Types.OrganizationComplianceDashboardMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationComplianceDashboardMetaQuery, Types.OrganizationComplianceDashboardMetaQueryVariables>(OrganizationComplianceDashboardMetaDocument, options);
      }
export function useOrganizationComplianceDashboardMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationComplianceDashboardMetaQuery, Types.OrganizationComplianceDashboardMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationComplianceDashboardMetaQuery, Types.OrganizationComplianceDashboardMetaQueryVariables>(OrganizationComplianceDashboardMetaDocument, options);
        }
export type OrganizationComplianceDashboardMetaQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardMetaQuery>;
export type OrganizationComplianceDashboardMetaLazyQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardMetaLazyQuery>;
export type OrganizationComplianceDashboardMetaQueryResult = Apollo.QueryResult<Types.OrganizationComplianceDashboardMetaQuery, Types.OrganizationComplianceDashboardMetaQueryVariables>;
export const OrganizationComplianceDashboardSettingsDocument = gql`
    query organizationComplianceDashboardSettings($organizationId: ID!) {
  organizationComplianceDashboardSettings(organizationId: $organizationId) {
    id
    officeSections {
      label
      officeValues
      value
    }
    updatedAt
  }
}
    `;

/**
 * __useOrganizationComplianceDashboardSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationComplianceDashboardSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationComplianceDashboardSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationComplianceDashboardSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationComplianceDashboardSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationComplianceDashboardSettingsQuery, Types.OrganizationComplianceDashboardSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationComplianceDashboardSettingsQuery, Types.OrganizationComplianceDashboardSettingsQueryVariables>(OrganizationComplianceDashboardSettingsDocument, options);
      }
export function useOrganizationComplianceDashboardSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationComplianceDashboardSettingsQuery, Types.OrganizationComplianceDashboardSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationComplianceDashboardSettingsQuery, Types.OrganizationComplianceDashboardSettingsQueryVariables>(OrganizationComplianceDashboardSettingsDocument, options);
        }
export type OrganizationComplianceDashboardSettingsQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardSettingsQuery>;
export type OrganizationComplianceDashboardSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardSettingsLazyQuery>;
export type OrganizationComplianceDashboardSettingsQueryResult = Apollo.QueryResult<Types.OrganizationComplianceDashboardSettingsQuery, Types.OrganizationComplianceDashboardSettingsQueryVariables>;
export const OrganizationComplianceDashboardTransactionRowsDocument = gql`
    query organizationComplianceDashboardTransactionRows($organizationId: ID!, $input: OrganizationComplianceDashboardInput, $offset: Int, $limit: Int) {
  organizationComplianceDashboardTransactionRows(
    organizationId: $organizationId
    input: $input
    offset: $offset
    limit: $limit
  ) {
    ...ComplianceDashboardTransactionRow
  }
}
    ${ComplianceDashboardTransactionRowFragmentDoc}`;

/**
 * __useOrganizationComplianceDashboardTransactionRowsQuery__
 *
 * To run a query within a React component, call `useOrganizationComplianceDashboardTransactionRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationComplianceDashboardTransactionRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationComplianceDashboardTransactionRowsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOrganizationComplianceDashboardTransactionRowsQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationComplianceDashboardTransactionRowsQuery, Types.OrganizationComplianceDashboardTransactionRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationComplianceDashboardTransactionRowsQuery, Types.OrganizationComplianceDashboardTransactionRowsQueryVariables>(OrganizationComplianceDashboardTransactionRowsDocument, options);
      }
export function useOrganizationComplianceDashboardTransactionRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationComplianceDashboardTransactionRowsQuery, Types.OrganizationComplianceDashboardTransactionRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationComplianceDashboardTransactionRowsQuery, Types.OrganizationComplianceDashboardTransactionRowsQueryVariables>(OrganizationComplianceDashboardTransactionRowsDocument, options);
        }
export type OrganizationComplianceDashboardTransactionRowsQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardTransactionRowsQuery>;
export type OrganizationComplianceDashboardTransactionRowsLazyQueryHookResult = ReturnType<typeof useOrganizationComplianceDashboardTransactionRowsLazyQuery>;
export type OrganizationComplianceDashboardTransactionRowsQueryResult = Apollo.QueryResult<Types.OrganizationComplianceDashboardTransactionRowsQuery, Types.OrganizationComplianceDashboardTransactionRowsQueryVariables>;
export const OrganizationCrawlerInfoDocument = gql`
    query organizationCrawlerInfo($id: ID!) {
  organization(id: $id) {
    ...OrganizationCrawlerInfo
  }
}
    ${OrganizationCrawlerInfoFragmentDoc}`;

/**
 * __useOrganizationCrawlerInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationCrawlerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCrawlerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationCrawlerInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationCrawlerInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationCrawlerInfoQuery, Types.OrganizationCrawlerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationCrawlerInfoQuery, Types.OrganizationCrawlerInfoQueryVariables>(OrganizationCrawlerInfoDocument, options);
      }
export function useOrganizationCrawlerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationCrawlerInfoQuery, Types.OrganizationCrawlerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationCrawlerInfoQuery, Types.OrganizationCrawlerInfoQueryVariables>(OrganizationCrawlerInfoDocument, options);
        }
export type OrganizationCrawlerInfoQueryHookResult = ReturnType<typeof useOrganizationCrawlerInfoQuery>;
export type OrganizationCrawlerInfoLazyQueryHookResult = ReturnType<typeof useOrganizationCrawlerInfoLazyQuery>;
export type OrganizationCrawlerInfoQueryResult = Apollo.QueryResult<Types.OrganizationCrawlerInfoQuery, Types.OrganizationCrawlerInfoQueryVariables>;
export const OrganizationListingAggregatesByStatusDocument = gql`
    query OrganizationListingAggregatesByStatus($organizationId: String!) {
  organizationListingAggregatesByStatus(organizationId: $organizationId) {
    organization {
      ...Organization
    }
    aggregates {
      status
      count
      sumListPrice
      sumClosePrice
    }
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useOrganizationListingAggregatesByStatusQuery__
 *
 * To run a query within a React component, call `useOrganizationListingAggregatesByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationListingAggregatesByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationListingAggregatesByStatusQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationListingAggregatesByStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationListingAggregatesByStatusQuery, Types.OrganizationListingAggregatesByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationListingAggregatesByStatusQuery, Types.OrganizationListingAggregatesByStatusQueryVariables>(OrganizationListingAggregatesByStatusDocument, options);
      }
export function useOrganizationListingAggregatesByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationListingAggregatesByStatusQuery, Types.OrganizationListingAggregatesByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationListingAggregatesByStatusQuery, Types.OrganizationListingAggregatesByStatusQueryVariables>(OrganizationListingAggregatesByStatusDocument, options);
        }
export type OrganizationListingAggregatesByStatusQueryHookResult = ReturnType<typeof useOrganizationListingAggregatesByStatusQuery>;
export type OrganizationListingAggregatesByStatusLazyQueryHookResult = ReturnType<typeof useOrganizationListingAggregatesByStatusLazyQuery>;
export type OrganizationListingAggregatesByStatusQueryResult = Apollo.QueryResult<Types.OrganizationListingAggregatesByStatusQuery, Types.OrganizationListingAggregatesByStatusQueryVariables>;
export const OrganizationNotificationSettingsDocument = gql`
    query OrganizationNotificationSettings($organizationId: String!) {
  organizationNotificationSettings(organizationId: $organizationId) {
    id
    sendWindowTimezone
    sendWindowRules {
      day
      from
      until
    }
  }
}
    `;

/**
 * __useOrganizationNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationNotificationSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationNotificationSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationNotificationSettingsQuery, Types.OrganizationNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationNotificationSettingsQuery, Types.OrganizationNotificationSettingsQueryVariables>(OrganizationNotificationSettingsDocument, options);
      }
export function useOrganizationNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationNotificationSettingsQuery, Types.OrganizationNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationNotificationSettingsQuery, Types.OrganizationNotificationSettingsQueryVariables>(OrganizationNotificationSettingsDocument, options);
        }
export type OrganizationNotificationSettingsQueryHookResult = ReturnType<typeof useOrganizationNotificationSettingsQuery>;
export type OrganizationNotificationSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationNotificationSettingsLazyQuery>;
export type OrganizationNotificationSettingsQueryResult = Apollo.QueryResult<Types.OrganizationNotificationSettingsQuery, Types.OrganizationNotificationSettingsQueryVariables>;
export const OrganizationOfficesAndTeamsDocument = gql`
    query OrganizationOfficesAndTeams($organizationId: ID!) {
  organizationOfficesAndTeams(id: $organizationId) {
    offices {
      id
      name
    }
    teams {
      id
      name
    }
  }
}
    `;

/**
 * __useOrganizationOfficesAndTeamsQuery__
 *
 * To run a query within a React component, call `useOrganizationOfficesAndTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationOfficesAndTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationOfficesAndTeamsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationOfficesAndTeamsQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationOfficesAndTeamsQuery, Types.OrganizationOfficesAndTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationOfficesAndTeamsQuery, Types.OrganizationOfficesAndTeamsQueryVariables>(OrganizationOfficesAndTeamsDocument, options);
      }
export function useOrganizationOfficesAndTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationOfficesAndTeamsQuery, Types.OrganizationOfficesAndTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationOfficesAndTeamsQuery, Types.OrganizationOfficesAndTeamsQueryVariables>(OrganizationOfficesAndTeamsDocument, options);
        }
export type OrganizationOfficesAndTeamsQueryHookResult = ReturnType<typeof useOrganizationOfficesAndTeamsQuery>;
export type OrganizationOfficesAndTeamsLazyQueryHookResult = ReturnType<typeof useOrganizationOfficesAndTeamsLazyQuery>;
export type OrganizationOfficesAndTeamsQueryResult = Apollo.QueryResult<Types.OrganizationOfficesAndTeamsQuery, Types.OrganizationOfficesAndTeamsQueryVariables>;
export const OrganizationPartnerStageIntrosDocument = gql`
    query OrganizationPartnerStageIntros($partnerId: ID!, $side: TransactionSide!) {
  organizationPartnerStageIntros(partnerId: $partnerId, side: $side) {
    ...OrganizationPartnerStageIntroItem
  }
}
    ${OrganizationPartnerStageIntroItemFragmentDoc}`;

/**
 * __useOrganizationPartnerStageIntrosQuery__
 *
 * To run a query within a React component, call `useOrganizationPartnerStageIntrosQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPartnerStageIntrosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPartnerStageIntrosQuery({
 *   variables: {
 *      partnerId: // value for 'partnerId'
 *      side: // value for 'side'
 *   },
 * });
 */
export function useOrganizationPartnerStageIntrosQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationPartnerStageIntrosQuery, Types.OrganizationPartnerStageIntrosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationPartnerStageIntrosQuery, Types.OrganizationPartnerStageIntrosQueryVariables>(OrganizationPartnerStageIntrosDocument, options);
      }
export function useOrganizationPartnerStageIntrosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationPartnerStageIntrosQuery, Types.OrganizationPartnerStageIntrosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationPartnerStageIntrosQuery, Types.OrganizationPartnerStageIntrosQueryVariables>(OrganizationPartnerStageIntrosDocument, options);
        }
export type OrganizationPartnerStageIntrosQueryHookResult = ReturnType<typeof useOrganizationPartnerStageIntrosQuery>;
export type OrganizationPartnerStageIntrosLazyQueryHookResult = ReturnType<typeof useOrganizationPartnerStageIntrosLazyQuery>;
export type OrganizationPartnerStageIntrosQueryResult = Apollo.QueryResult<Types.OrganizationPartnerStageIntrosQuery, Types.OrganizationPartnerStageIntrosQueryVariables>;
export const OrganizationPartnersDocument = gql`
    query OrganizationPartners($organizationId: ID!, $cursor: String, $perPage: Int = 20, $orderBy: String = "-createdAt", $filters: OrganizationPartnerFilters) {
  organizationPartners(
    organizationId: $organizationId
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
    filters: $filters
  ) {
    results {
      ...OrganizationPartnerItem
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
      totalCount
      perPage
    }
  }
}
    ${OrganizationPartnerItemFragmentDoc}`;

/**
 * __useOrganizationPartnersQuery__
 *
 * To run a query within a React component, call `useOrganizationPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPartnersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOrganizationPartnersQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationPartnersQuery, Types.OrganizationPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationPartnersQuery, Types.OrganizationPartnersQueryVariables>(OrganizationPartnersDocument, options);
      }
export function useOrganizationPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationPartnersQuery, Types.OrganizationPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationPartnersQuery, Types.OrganizationPartnersQueryVariables>(OrganizationPartnersDocument, options);
        }
export type OrganizationPartnersQueryHookResult = ReturnType<typeof useOrganizationPartnersQuery>;
export type OrganizationPartnersLazyQueryHookResult = ReturnType<typeof useOrganizationPartnersLazyQuery>;
export type OrganizationPartnersQueryResult = Apollo.QueryResult<Types.OrganizationPartnersQuery, Types.OrganizationPartnersQueryVariables>;
export const OrganizationRosterListDocument = gql`
    query OrganizationRosterList($organizationId: ID!, $filters: OrganizationRosterFilters, $cursor: String, $perPage: Int = 50) {
  organizationRosterList(
    organizationId: $organizationId
    cursor: $cursor
    perPage: $perPage
    filters: $filters
  ) {
    results {
      ...OrganizationRosterItem
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
      totalCount
      perPage
    }
  }
}
    ${OrganizationRosterItemFragmentDoc}`;

/**
 * __useOrganizationRosterListQuery__
 *
 * To run a query within a React component, call `useOrganizationRosterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRosterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRosterListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useOrganizationRosterListQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationRosterListQuery, Types.OrganizationRosterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationRosterListQuery, Types.OrganizationRosterListQueryVariables>(OrganizationRosterListDocument, options);
      }
export function useOrganizationRosterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationRosterListQuery, Types.OrganizationRosterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationRosterListQuery, Types.OrganizationRosterListQueryVariables>(OrganizationRosterListDocument, options);
        }
export type OrganizationRosterListQueryHookResult = ReturnType<typeof useOrganizationRosterListQuery>;
export type OrganizationRosterListLazyQueryHookResult = ReturnType<typeof useOrganizationRosterListLazyQuery>;
export type OrganizationRosterListQueryResult = Apollo.QueryResult<Types.OrganizationRosterListQuery, Types.OrganizationRosterListQueryVariables>;
export const OrganizationsForCurrentUserDocument = gql`
    query organizationsForCurrentUser {
  organizationsForCurrentUser {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;

/**
 * __useOrganizationsForCurrentUserQuery__
 *
 * To run a query within a React component, call `useOrganizationsForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsForCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.OrganizationsForCurrentUserQuery, Types.OrganizationsForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationsForCurrentUserQuery, Types.OrganizationsForCurrentUserQueryVariables>(OrganizationsForCurrentUserDocument, options);
      }
export function useOrganizationsForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationsForCurrentUserQuery, Types.OrganizationsForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationsForCurrentUserQuery, Types.OrganizationsForCurrentUserQueryVariables>(OrganizationsForCurrentUserDocument, options);
        }
export type OrganizationsForCurrentUserQueryHookResult = ReturnType<typeof useOrganizationsForCurrentUserQuery>;
export type OrganizationsForCurrentUserLazyQueryHookResult = ReturnType<typeof useOrganizationsForCurrentUserLazyQuery>;
export type OrganizationsForCurrentUserQueryResult = Apollo.QueryResult<Types.OrganizationsForCurrentUserQuery, Types.OrganizationsForCurrentUserQueryVariables>;
export const PartnerContactsListDocument = gql`
    query PartnerContactsList($filters: ContactFilters!) {
  partnerContactsList(filters: $filters) {
    ...PartnerContact
  }
}
    ${PartnerContactFragmentDoc}`;

/**
 * __usePartnerContactsListQuery__
 *
 * To run a query within a React component, call `usePartnerContactsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerContactsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerContactsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePartnerContactsListQuery(baseOptions: Apollo.QueryHookOptions<Types.PartnerContactsListQuery, Types.PartnerContactsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PartnerContactsListQuery, Types.PartnerContactsListQueryVariables>(PartnerContactsListDocument, options);
      }
export function usePartnerContactsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PartnerContactsListQuery, Types.PartnerContactsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PartnerContactsListQuery, Types.PartnerContactsListQueryVariables>(PartnerContactsListDocument, options);
        }
export type PartnerContactsListQueryHookResult = ReturnType<typeof usePartnerContactsListQuery>;
export type PartnerContactsListLazyQueryHookResult = ReturnType<typeof usePartnerContactsListLazyQuery>;
export type PartnerContactsListQueryResult = Apollo.QueryResult<Types.PartnerContactsListQuery, Types.PartnerContactsListQueryVariables>;
export const PartyAndBuyerInfoDocument = gql`
    query PartyAndBuyerInfo($input: PartyAndBuyerInfoInput!) {
  partyAndBuyerInfo(input: $input) {
    ...Party
  }
}
    ${PartyFragmentDoc}`;

/**
 * __usePartyAndBuyerInfoQuery__
 *
 * To run a query within a React component, call `usePartyAndBuyerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyAndBuyerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyAndBuyerInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyAndBuyerInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.PartyAndBuyerInfoQuery, Types.PartyAndBuyerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PartyAndBuyerInfoQuery, Types.PartyAndBuyerInfoQueryVariables>(PartyAndBuyerInfoDocument, options);
      }
export function usePartyAndBuyerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PartyAndBuyerInfoQuery, Types.PartyAndBuyerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PartyAndBuyerInfoQuery, Types.PartyAndBuyerInfoQueryVariables>(PartyAndBuyerInfoDocument, options);
        }
export type PartyAndBuyerInfoQueryHookResult = ReturnType<typeof usePartyAndBuyerInfoQuery>;
export type PartyAndBuyerInfoLazyQueryHookResult = ReturnType<typeof usePartyAndBuyerInfoLazyQuery>;
export type PartyAndBuyerInfoQueryResult = Apollo.QueryResult<Types.PartyAndBuyerInfoQuery, Types.PartyAndBuyerInfoQueryVariables>;
export const PartyVariableValuesDocument = gql`
    query partyVariableValues($partyIds: [ID!]!) {
  partyAutofillVariableValues(partyIds: $partyIds) {
    buyer {
      ...AutofillConsumer
    }
    coBuyer {
      ...AutofillConsumer
    }
    buyersAgent {
      ...User
    }
    buyersAgentRESOMemberData {
      ...RESOMember
    }
    buyersAgentRESOOfficeData {
      ...RESOOffice
    }
    partyFinancing {
      id
      financingType
      loanAmount
    }
    buyerSignatures
    buyersAgentSignatures
  }
}
    ${AutofillConsumerFragmentDoc}
${UserFragmentDoc}
${ResoMemberFragmentDoc}
${ResoOfficeFragmentDoc}`;

/**
 * __usePartyVariableValuesQuery__
 *
 * To run a query within a React component, call `usePartyVariableValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyVariableValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyVariableValuesQuery({
 *   variables: {
 *      partyIds: // value for 'partyIds'
 *   },
 * });
 */
export function usePartyVariableValuesQuery(baseOptions: Apollo.QueryHookOptions<Types.PartyVariableValuesQuery, Types.PartyVariableValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PartyVariableValuesQuery, Types.PartyVariableValuesQueryVariables>(PartyVariableValuesDocument, options);
      }
export function usePartyVariableValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PartyVariableValuesQuery, Types.PartyVariableValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PartyVariableValuesQuery, Types.PartyVariableValuesQueryVariables>(PartyVariableValuesDocument, options);
        }
export type PartyVariableValuesQueryHookResult = ReturnType<typeof usePartyVariableValuesQuery>;
export type PartyVariableValuesLazyQueryHookResult = ReturnType<typeof usePartyVariableValuesLazyQuery>;
export type PartyVariableValuesQueryResult = Apollo.QueryResult<Types.PartyVariableValuesQuery, Types.PartyVariableValuesQueryVariables>;
export const PerAgentOfferAcceptRateDocument = gql`
    query perAgentOfferAcceptRate($filters: AgentPerformanceFilters!) {
  perAgentOfferAcceptRate(filters: $filters) {
    ...PerAgentOfferAcceptRate
  }
}
    ${PerAgentOfferAcceptRateFragmentDoc}`;

/**
 * __usePerAgentOfferAcceptRateQuery__
 *
 * To run a query within a React component, call `usePerAgentOfferAcceptRateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerAgentOfferAcceptRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerAgentOfferAcceptRateQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePerAgentOfferAcceptRateQuery(baseOptions: Apollo.QueryHookOptions<Types.PerAgentOfferAcceptRateQuery, Types.PerAgentOfferAcceptRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PerAgentOfferAcceptRateQuery, Types.PerAgentOfferAcceptRateQueryVariables>(PerAgentOfferAcceptRateDocument, options);
      }
export function usePerAgentOfferAcceptRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PerAgentOfferAcceptRateQuery, Types.PerAgentOfferAcceptRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PerAgentOfferAcceptRateQuery, Types.PerAgentOfferAcceptRateQueryVariables>(PerAgentOfferAcceptRateDocument, options);
        }
export type PerAgentOfferAcceptRateQueryHookResult = ReturnType<typeof usePerAgentOfferAcceptRateQuery>;
export type PerAgentOfferAcceptRateLazyQueryHookResult = ReturnType<typeof usePerAgentOfferAcceptRateLazyQuery>;
export type PerAgentOfferAcceptRateQueryResult = Apollo.QueryResult<Types.PerAgentOfferAcceptRateQuery, Types.PerAgentOfferAcceptRateQueryVariables>;
export const PerAgentTransactionStatsDocument = gql`
    query perAgentTransactionStats($filters: AgentPerformanceFilters!) {
  perAgentTransactionStats(filters: $filters) {
    ...PerAgentTransactionStats
  }
}
    ${PerAgentTransactionStatsFragmentDoc}`;

/**
 * __usePerAgentTransactionStatsQuery__
 *
 * To run a query within a React component, call `usePerAgentTransactionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerAgentTransactionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerAgentTransactionStatsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePerAgentTransactionStatsQuery(baseOptions: Apollo.QueryHookOptions<Types.PerAgentTransactionStatsQuery, Types.PerAgentTransactionStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PerAgentTransactionStatsQuery, Types.PerAgentTransactionStatsQueryVariables>(PerAgentTransactionStatsDocument, options);
      }
export function usePerAgentTransactionStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PerAgentTransactionStatsQuery, Types.PerAgentTransactionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PerAgentTransactionStatsQuery, Types.PerAgentTransactionStatsQueryVariables>(PerAgentTransactionStatsDocument, options);
        }
export type PerAgentTransactionStatsQueryHookResult = ReturnType<typeof usePerAgentTransactionStatsQuery>;
export type PerAgentTransactionStatsLazyQueryHookResult = ReturnType<typeof usePerAgentTransactionStatsLazyQuery>;
export type PerAgentTransactionStatsQueryResult = Apollo.QueryResult<Types.PerAgentTransactionStatsQuery, Types.PerAgentTransactionStatsQueryVariables>;
export const PerOfficeOfferAcceptRateDocument = gql`
    query perOfficeOfferAcceptRate($filters: AgentPerformanceFilters!) {
  perOfficeOfferAcceptRate(filters: $filters) {
    ...PerOfficeOfferAcceptRate
  }
}
    ${PerOfficeOfferAcceptRateFragmentDoc}`;

/**
 * __usePerOfficeOfferAcceptRateQuery__
 *
 * To run a query within a React component, call `usePerOfficeOfferAcceptRateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerOfficeOfferAcceptRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerOfficeOfferAcceptRateQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePerOfficeOfferAcceptRateQuery(baseOptions: Apollo.QueryHookOptions<Types.PerOfficeOfferAcceptRateQuery, Types.PerOfficeOfferAcceptRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PerOfficeOfferAcceptRateQuery, Types.PerOfficeOfferAcceptRateQueryVariables>(PerOfficeOfferAcceptRateDocument, options);
      }
export function usePerOfficeOfferAcceptRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PerOfficeOfferAcceptRateQuery, Types.PerOfficeOfferAcceptRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PerOfficeOfferAcceptRateQuery, Types.PerOfficeOfferAcceptRateQueryVariables>(PerOfficeOfferAcceptRateDocument, options);
        }
export type PerOfficeOfferAcceptRateQueryHookResult = ReturnType<typeof usePerOfficeOfferAcceptRateQuery>;
export type PerOfficeOfferAcceptRateLazyQueryHookResult = ReturnType<typeof usePerOfficeOfferAcceptRateLazyQuery>;
export type PerOfficeOfferAcceptRateQueryResult = Apollo.QueryResult<Types.PerOfficeOfferAcceptRateQuery, Types.PerOfficeOfferAcceptRateQueryVariables>;
export const PerOfficeTransactionStatsDocument = gql`
    query perOfficeTransactionStats($filters: AgentPerformanceFilters!) {
  perOfficeTransactionStats(filters: $filters) {
    ...PerOfficeTransactionStats
  }
}
    ${PerOfficeTransactionStatsFragmentDoc}`;

/**
 * __usePerOfficeTransactionStatsQuery__
 *
 * To run a query within a React component, call `usePerOfficeTransactionStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerOfficeTransactionStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerOfficeTransactionStatsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePerOfficeTransactionStatsQuery(baseOptions: Apollo.QueryHookOptions<Types.PerOfficeTransactionStatsQuery, Types.PerOfficeTransactionStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PerOfficeTransactionStatsQuery, Types.PerOfficeTransactionStatsQueryVariables>(PerOfficeTransactionStatsDocument, options);
      }
export function usePerOfficeTransactionStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PerOfficeTransactionStatsQuery, Types.PerOfficeTransactionStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PerOfficeTransactionStatsQuery, Types.PerOfficeTransactionStatsQueryVariables>(PerOfficeTransactionStatsDocument, options);
        }
export type PerOfficeTransactionStatsQueryHookResult = ReturnType<typeof usePerOfficeTransactionStatsQuery>;
export type PerOfficeTransactionStatsLazyQueryHookResult = ReturnType<typeof usePerOfficeTransactionStatsLazyQuery>;
export type PerOfficeTransactionStatsQueryResult = Apollo.QueryResult<Types.PerOfficeTransactionStatsQuery, Types.PerOfficeTransactionStatsQueryVariables>;
export const PreferencesDocument = gql`
    query Preferences($input: PreferencesInput!) {
  preferences(input: $input) {
    ...Preference
  }
}
    ${PreferenceFragmentDoc}`;

/**
 * __usePreferencesQuery__
 *
 * To run a query within a React component, call `usePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreferencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreferencesQuery(baseOptions: Apollo.QueryHookOptions<Types.PreferencesQuery, Types.PreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PreferencesQuery, Types.PreferencesQueryVariables>(PreferencesDocument, options);
      }
export function usePreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PreferencesQuery, Types.PreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PreferencesQuery, Types.PreferencesQueryVariables>(PreferencesDocument, options);
        }
export type PreferencesQueryHookResult = ReturnType<typeof usePreferencesQuery>;
export type PreferencesLazyQueryHookResult = ReturnType<typeof usePreferencesLazyQuery>;
export type PreferencesQueryResult = Apollo.QueryResult<Types.PreferencesQuery, Types.PreferencesQueryVariables>;
export const PrioritizedListingsForCurrentUserDocument = gql`
    query PrioritizedListingsForCurrentUser($cursor: String, $preferenceValues: Boolean = false, $perPage: Int! = 15, $orderBy: String! = "-lastActivityDate") {
  prioritizedListingsForCurrentUser(
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...PrioritizedListing
    }
  }
}
    ${PageInfoFragmentDoc}
${PrioritizedListingFragmentDoc}`;

/**
 * __usePrioritizedListingsForCurrentUserQuery__
 *
 * To run a query within a React component, call `usePrioritizedListingsForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrioritizedListingsForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrioritizedListingsForCurrentUserQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      preferenceValues: // value for 'preferenceValues'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePrioritizedListingsForCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<Types.PrioritizedListingsForCurrentUserQuery, Types.PrioritizedListingsForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PrioritizedListingsForCurrentUserQuery, Types.PrioritizedListingsForCurrentUserQueryVariables>(PrioritizedListingsForCurrentUserDocument, options);
      }
export function usePrioritizedListingsForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PrioritizedListingsForCurrentUserQuery, Types.PrioritizedListingsForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PrioritizedListingsForCurrentUserQuery, Types.PrioritizedListingsForCurrentUserQueryVariables>(PrioritizedListingsForCurrentUserDocument, options);
        }
export type PrioritizedListingsForCurrentUserQueryHookResult = ReturnType<typeof usePrioritizedListingsForCurrentUserQuery>;
export type PrioritizedListingsForCurrentUserLazyQueryHookResult = ReturnType<typeof usePrioritizedListingsForCurrentUserLazyQuery>;
export type PrioritizedListingsForCurrentUserQueryResult = Apollo.QueryResult<Types.PrioritizedListingsForCurrentUserQuery, Types.PrioritizedListingsForCurrentUserQueryVariables>;
export const PublicFeaturedStorefrontsDocument = gql`
    query publicFeaturedStorefronts($perPage: Int = 10, $cursor: String, $orderBy: String = "-listDate") {
  featuredStorefronts(perPage: $perPage, cursor: $cursor, orderBy: $orderBy) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...PublicFeaturedStorefront
    }
  }
}
    ${PageInfoFragmentDoc}
${PublicFeaturedStorefrontFragmentDoc}`;

/**
 * __usePublicFeaturedStorefrontsQuery__
 *
 * To run a query within a React component, call `usePublicFeaturedStorefrontsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicFeaturedStorefrontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicFeaturedStorefrontsQuery({
 *   variables: {
 *      perPage: // value for 'perPage'
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePublicFeaturedStorefrontsQuery(baseOptions?: Apollo.QueryHookOptions<Types.PublicFeaturedStorefrontsQuery, Types.PublicFeaturedStorefrontsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicFeaturedStorefrontsQuery, Types.PublicFeaturedStorefrontsQueryVariables>(PublicFeaturedStorefrontsDocument, options);
      }
export function usePublicFeaturedStorefrontsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicFeaturedStorefrontsQuery, Types.PublicFeaturedStorefrontsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicFeaturedStorefrontsQuery, Types.PublicFeaturedStorefrontsQueryVariables>(PublicFeaturedStorefrontsDocument, options);
        }
export type PublicFeaturedStorefrontsQueryHookResult = ReturnType<typeof usePublicFeaturedStorefrontsQuery>;
export type PublicFeaturedStorefrontsLazyQueryHookResult = ReturnType<typeof usePublicFeaturedStorefrontsLazyQuery>;
export type PublicFeaturedStorefrontsQueryResult = Apollo.QueryResult<Types.PublicFeaturedStorefrontsQuery, Types.PublicFeaturedStorefrontsQueryVariables>;
export const PublicListingDocument = gql`
    query PublicListing($input: PublicListingInput!) {
  publicListing(input: $input) {
    ...PublicListing
  }
}
    ${PublicListingFragmentDoc}`;

/**
 * __usePublicListingQuery__
 *
 * To run a query within a React component, call `usePublicListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicListingQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicListingQuery, Types.PublicListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicListingQuery, Types.PublicListingQueryVariables>(PublicListingDocument, options);
      }
export function usePublicListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicListingQuery, Types.PublicListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicListingQuery, Types.PublicListingQueryVariables>(PublicListingDocument, options);
        }
export type PublicListingQueryHookResult = ReturnType<typeof usePublicListingQuery>;
export type PublicListingLazyQueryHookResult = ReturnType<typeof usePublicListingLazyQuery>;
export type PublicListingQueryResult = Apollo.QueryResult<Types.PublicListingQuery, Types.PublicListingQueryVariables>;
export const PublicListingAnnouncementsDocument = gql`
    query publicListingAnnouncements($input: PublicListingAnnouncementInput!) {
  publicListingAnnouncements(input: $input) {
    ...PublicListingAnnouncement
  }
}
    ${PublicListingAnnouncementFragmentDoc}`;

/**
 * __usePublicListingAnnouncementsQuery__
 *
 * To run a query within a React component, call `usePublicListingAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicListingAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicListingAnnouncementsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicListingAnnouncementsQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicListingAnnouncementsQuery, Types.PublicListingAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicListingAnnouncementsQuery, Types.PublicListingAnnouncementsQueryVariables>(PublicListingAnnouncementsDocument, options);
      }
export function usePublicListingAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicListingAnnouncementsQuery, Types.PublicListingAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicListingAnnouncementsQuery, Types.PublicListingAnnouncementsQueryVariables>(PublicListingAnnouncementsDocument, options);
        }
export type PublicListingAnnouncementsQueryHookResult = ReturnType<typeof usePublicListingAnnouncementsQuery>;
export type PublicListingAnnouncementsLazyQueryHookResult = ReturnType<typeof usePublicListingAnnouncementsLazyQuery>;
export type PublicListingAnnouncementsQueryResult = Apollo.QueryResult<Types.PublicListingAnnouncementsQuery, Types.PublicListingAnnouncementsQueryVariables>;
export const PublicListingComparableSetDocument = gql`
    query publicListingComparableSet($input: PublicListingComparableSetInput!) {
  publicListingComparableSet(input: $input) {
    ...PublicListingComparableSet
  }
}
    ${PublicListingComparableSetFragmentDoc}`;

/**
 * __usePublicListingComparableSetQuery__
 *
 * To run a query within a React component, call `usePublicListingComparableSetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicListingComparableSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicListingComparableSetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicListingComparableSetQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicListingComparableSetQuery, Types.PublicListingComparableSetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicListingComparableSetQuery, Types.PublicListingComparableSetQueryVariables>(PublicListingComparableSetDocument, options);
      }
export function usePublicListingComparableSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicListingComparableSetQuery, Types.PublicListingComparableSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicListingComparableSetQuery, Types.PublicListingComparableSetQueryVariables>(PublicListingComparableSetDocument, options);
        }
export type PublicListingComparableSetQueryHookResult = ReturnType<typeof usePublicListingComparableSetQuery>;
export type PublicListingComparableSetLazyQueryHookResult = ReturnType<typeof usePublicListingComparableSetLazyQuery>;
export type PublicListingComparableSetQueryResult = Apollo.QueryResult<Types.PublicListingComparableSetQuery, Types.PublicListingComparableSetQueryVariables>;
export const PublicListingDocumentTypesDocument = gql`
    query publicListingDocumentTypes($input: PublicListingDocumentTypesInput!) {
  publicListingDocumentTypes(input: $input) {
    ...PublicListingDocumentType
  }
}
    ${PublicListingDocumentTypeFragmentDoc}`;

/**
 * __usePublicListingDocumentTypesQuery__
 *
 * To run a query within a React component, call `usePublicListingDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicListingDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicListingDocumentTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicListingDocumentTypesQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicListingDocumentTypesQuery, Types.PublicListingDocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicListingDocumentTypesQuery, Types.PublicListingDocumentTypesQueryVariables>(PublicListingDocumentTypesDocument, options);
      }
export function usePublicListingDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicListingDocumentTypesQuery, Types.PublicListingDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicListingDocumentTypesQuery, Types.PublicListingDocumentTypesQueryVariables>(PublicListingDocumentTypesDocument, options);
        }
export type PublicListingDocumentTypesQueryHookResult = ReturnType<typeof usePublicListingDocumentTypesQuery>;
export type PublicListingDocumentTypesLazyQueryHookResult = ReturnType<typeof usePublicListingDocumentTypesLazyQuery>;
export type PublicListingDocumentTypesQueryResult = Apollo.QueryResult<Types.PublicListingDocumentTypesQuery, Types.PublicListingDocumentTypesQueryVariables>;
export const PublicListingDocumentUploadsDocument = gql`
    query publicListingDocumentUploads($input: PublicListingDocumentUploadsInput!) {
  publicListingDocumentUploads(input: $input) {
    listingDocumentType {
      ...PublicListingDocumentType
      ...PublicListingDocumentTypeWithDocuments
    }
    ...PublicListingDocumentUpload
  }
}
    ${PublicListingDocumentTypeFragmentDoc}
${PublicListingDocumentTypeWithDocumentsFragmentDoc}
${PublicListingDocumentUploadFragmentDoc}`;

/**
 * __usePublicListingDocumentUploadsQuery__
 *
 * To run a query within a React component, call `usePublicListingDocumentUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicListingDocumentUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicListingDocumentUploadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicListingDocumentUploadsQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicListingDocumentUploadsQuery, Types.PublicListingDocumentUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicListingDocumentUploadsQuery, Types.PublicListingDocumentUploadsQueryVariables>(PublicListingDocumentUploadsDocument, options);
      }
export function usePublicListingDocumentUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicListingDocumentUploadsQuery, Types.PublicListingDocumentUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicListingDocumentUploadsQuery, Types.PublicListingDocumentUploadsQueryVariables>(PublicListingDocumentUploadsDocument, options);
        }
export type PublicListingDocumentUploadsQueryHookResult = ReturnType<typeof usePublicListingDocumentUploadsQuery>;
export type PublicListingDocumentUploadsLazyQueryHookResult = ReturnType<typeof usePublicListingDocumentUploadsLazyQuery>;
export type PublicListingDocumentUploadsQueryResult = Apollo.QueryResult<Types.PublicListingDocumentUploadsQuery, Types.PublicListingDocumentUploadsQueryVariables>;
export const PublicPreferencesDocument = gql`
    query PublicPreferences($input: PublicPreferencesInput!) {
  publicPreferences(input: $input) {
    ...PublicPreference
  }
}
    ${PublicPreferenceFragmentDoc}`;

/**
 * __usePublicPreferencesQuery__
 *
 * To run a query within a React component, call `usePublicPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPreferencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicPreferencesQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicPreferencesQuery, Types.PublicPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicPreferencesQuery, Types.PublicPreferencesQueryVariables>(PublicPreferencesDocument, options);
      }
export function usePublicPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicPreferencesQuery, Types.PublicPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicPreferencesQuery, Types.PublicPreferencesQueryVariables>(PublicPreferencesDocument, options);
        }
export type PublicPreferencesQueryHookResult = ReturnType<typeof usePublicPreferencesQuery>;
export type PublicPreferencesLazyQueryHookResult = ReturnType<typeof usePublicPreferencesLazyQuery>;
export type PublicPreferencesQueryResult = Apollo.QueryResult<Types.PublicPreferencesQuery, Types.PublicPreferencesQueryVariables>;
export const PublicAgentUserListingsDocument = gql`
    query PublicAgentUserListings($cursor: String, $perPage: Int! = 20, $orderBy: String! = "-listDate", $input: PublicAgentUserListingsInput!) {
  publicAgentUserListings(
    cursor: $cursor
    perPage: $perPage
    orderBy: $orderBy
    input: $input
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...PublicUserListing
    }
  }
}
    ${PageInfoFragmentDoc}
${PublicUserListingFragmentDoc}`;

/**
 * __usePublicAgentUserListingsQuery__
 *
 * To run a query within a React component, call `usePublicAgentUserListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicAgentUserListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicAgentUserListingsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicAgentUserListingsQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicAgentUserListingsQuery, Types.PublicAgentUserListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicAgentUserListingsQuery, Types.PublicAgentUserListingsQueryVariables>(PublicAgentUserListingsDocument, options);
      }
export function usePublicAgentUserListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicAgentUserListingsQuery, Types.PublicAgentUserListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicAgentUserListingsQuery, Types.PublicAgentUserListingsQueryVariables>(PublicAgentUserListingsDocument, options);
        }
export type PublicAgentUserListingsQueryHookResult = ReturnType<typeof usePublicAgentUserListingsQuery>;
export type PublicAgentUserListingsLazyQueryHookResult = ReturnType<typeof usePublicAgentUserListingsLazyQuery>;
export type PublicAgentUserListingsQueryResult = Apollo.QueryResult<Types.PublicAgentUserListingsQuery, Types.PublicAgentUserListingsQueryVariables>;
export const PublicUserWithLicensesDocument = gql`
    query PublicUserWithLicenses($input: GetUserInput!) {
  getPublicUserWithLicenses(input: $input) {
    ...PublicUserWithLicenses
  }
}
    ${PublicUserWithLicensesFragmentDoc}`;

/**
 * __usePublicUserWithLicensesQuery__
 *
 * To run a query within a React component, call `usePublicUserWithLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUserWithLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUserWithLicensesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicUserWithLicensesQuery(baseOptions: Apollo.QueryHookOptions<Types.PublicUserWithLicensesQuery, Types.PublicUserWithLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PublicUserWithLicensesQuery, Types.PublicUserWithLicensesQueryVariables>(PublicUserWithLicensesDocument, options);
      }
export function usePublicUserWithLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PublicUserWithLicensesQuery, Types.PublicUserWithLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PublicUserWithLicensesQuery, Types.PublicUserWithLicensesQueryVariables>(PublicUserWithLicensesDocument, options);
        }
export type PublicUserWithLicensesQueryHookResult = ReturnType<typeof usePublicUserWithLicensesQuery>;
export type PublicUserWithLicensesLazyQueryHookResult = ReturnType<typeof usePublicUserWithLicensesLazyQuery>;
export type PublicUserWithLicensesQueryResult = Apollo.QueryResult<Types.PublicUserWithLicensesQuery, Types.PublicUserWithLicensesQueryVariables>;
export const SearchMlsListingsByAddressDocument = gql`
    query SearchMlsListingsByAddress($input: SearchMlsListingsByAddressInput!) {
  searchMlsListingsByAddress(input: $input) {
    ...MLSListing
  }
}
    ${MlsListingFragmentDoc}`;

/**
 * __useSearchMlsListingsByAddressQuery__
 *
 * To run a query within a React component, call `useSearchMlsListingsByAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMlsListingsByAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMlsListingsByAddressQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchMlsListingsByAddressQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchMlsListingsByAddressQuery, Types.SearchMlsListingsByAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchMlsListingsByAddressQuery, Types.SearchMlsListingsByAddressQueryVariables>(SearchMlsListingsByAddressDocument, options);
      }
export function useSearchMlsListingsByAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchMlsListingsByAddressQuery, Types.SearchMlsListingsByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchMlsListingsByAddressQuery, Types.SearchMlsListingsByAddressQueryVariables>(SearchMlsListingsByAddressDocument, options);
        }
export type SearchMlsListingsByAddressQueryHookResult = ReturnType<typeof useSearchMlsListingsByAddressQuery>;
export type SearchMlsListingsByAddressLazyQueryHookResult = ReturnType<typeof useSearchMlsListingsByAddressLazyQuery>;
export type SearchMlsListingsByAddressQueryResult = Apollo.QueryResult<Types.SearchMlsListingsByAddressQuery, Types.SearchMlsListingsByAddressQueryVariables>;
export const SearchMlsListingsWithFiltersDocument = gql`
    query SearchMlsListingsWithFilters($input: SearchMLSListingsWithFiltersInput!) {
  searchMlsListingsWithFilters(input: $input) {
    totalCount
    mlsListings {
      mlsListing {
        ...MLSListingSearchResult
      }
      listing {
        ...ListingForSearchMlsListing
      }
    }
  }
}
    ${MlsListingSearchResultFragmentDoc}
${ListingForSearchMlsListingFragmentDoc}`;

/**
 * __useSearchMlsListingsWithFiltersQuery__
 *
 * To run a query within a React component, call `useSearchMlsListingsWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMlsListingsWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMlsListingsWithFiltersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchMlsListingsWithFiltersQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchMlsListingsWithFiltersQuery, Types.SearchMlsListingsWithFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchMlsListingsWithFiltersQuery, Types.SearchMlsListingsWithFiltersQueryVariables>(SearchMlsListingsWithFiltersDocument, options);
      }
export function useSearchMlsListingsWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchMlsListingsWithFiltersQuery, Types.SearchMlsListingsWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchMlsListingsWithFiltersQuery, Types.SearchMlsListingsWithFiltersQueryVariables>(SearchMlsListingsWithFiltersDocument, options);
        }
export type SearchMlsListingsWithFiltersQueryHookResult = ReturnType<typeof useSearchMlsListingsWithFiltersQuery>;
export type SearchMlsListingsWithFiltersLazyQueryHookResult = ReturnType<typeof useSearchMlsListingsWithFiltersLazyQuery>;
export type SearchMlsListingsWithFiltersQueryResult = Apollo.QueryResult<Types.SearchMlsListingsWithFiltersQuery, Types.SearchMlsListingsWithFiltersQueryVariables>;
export const StorefrontActivitiesDocument = gql`
    query StorefrontActivities($input: StorefrontActivitiesInput!) {
  storefrontActivities(input: $input) {
    id
    type
    user {
      ...PublicUser
    }
    metadata
    createdAt
  }
}
    ${PublicUserFragmentDoc}`;

/**
 * __useStorefrontActivitiesQuery__
 *
 * To run a query within a React component, call `useStorefrontActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontActivitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStorefrontActivitiesQuery(baseOptions: Apollo.QueryHookOptions<Types.StorefrontActivitiesQuery, Types.StorefrontActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.StorefrontActivitiesQuery, Types.StorefrontActivitiesQueryVariables>(StorefrontActivitiesDocument, options);
      }
export function useStorefrontActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.StorefrontActivitiesQuery, Types.StorefrontActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.StorefrontActivitiesQuery, Types.StorefrontActivitiesQueryVariables>(StorefrontActivitiesDocument, options);
        }
export type StorefrontActivitiesQueryHookResult = ReturnType<typeof useStorefrontActivitiesQuery>;
export type StorefrontActivitiesLazyQueryHookResult = ReturnType<typeof useStorefrontActivitiesLazyQuery>;
export type StorefrontActivitiesQueryResult = Apollo.QueryResult<Types.StorefrontActivitiesQuery, Types.StorefrontActivitiesQueryVariables>;
export const StorefrontActivitiesSummaryDocument = gql`
    query StorefrontActivitiesSummary($input: StorefrontActivitiesSummaryInput!) {
  storefrontActivitiesSummary(input: $input) {
    ...StorefrontActivitySummary
  }
}
    ${StorefrontActivitySummaryFragmentDoc}`;

/**
 * __useStorefrontActivitiesSummaryQuery__
 *
 * To run a query within a React component, call `useStorefrontActivitiesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontActivitiesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontActivitiesSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStorefrontActivitiesSummaryQuery(baseOptions: Apollo.QueryHookOptions<Types.StorefrontActivitiesSummaryQuery, Types.StorefrontActivitiesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.StorefrontActivitiesSummaryQuery, Types.StorefrontActivitiesSummaryQueryVariables>(StorefrontActivitiesSummaryDocument, options);
      }
export function useStorefrontActivitiesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.StorefrontActivitiesSummaryQuery, Types.StorefrontActivitiesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.StorefrontActivitiesSummaryQuery, Types.StorefrontActivitiesSummaryQueryVariables>(StorefrontActivitiesSummaryDocument, options);
        }
export type StorefrontActivitiesSummaryQueryHookResult = ReturnType<typeof useStorefrontActivitiesSummaryQuery>;
export type StorefrontActivitiesSummaryLazyQueryHookResult = ReturnType<typeof useStorefrontActivitiesSummaryLazyQuery>;
export type StorefrontActivitiesSummaryQueryResult = Apollo.QueryResult<Types.StorefrontActivitiesSummaryQuery, Types.StorefrontActivitiesSummaryQueryVariables>;
export const StorefrontDocViewsSummaryDocument = gql`
    query StorefrontDocViewsSummary($input: StorefrontActivitySummaryInput!) {
  storefrontActivitySummary(input: $input) {
    count
    users {
      ...User
    }
    activities {
      id
      type
      createdAt
      user {
        id
      }
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useStorefrontDocViewsSummaryQuery__
 *
 * To run a query within a React component, call `useStorefrontDocViewsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorefrontDocViewsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorefrontDocViewsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStorefrontDocViewsSummaryQuery(baseOptions: Apollo.QueryHookOptions<Types.StorefrontDocViewsSummaryQuery, Types.StorefrontDocViewsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.StorefrontDocViewsSummaryQuery, Types.StorefrontDocViewsSummaryQueryVariables>(StorefrontDocViewsSummaryDocument, options);
      }
export function useStorefrontDocViewsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.StorefrontDocViewsSummaryQuery, Types.StorefrontDocViewsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.StorefrontDocViewsSummaryQuery, Types.StorefrontDocViewsSummaryQueryVariables>(StorefrontDocViewsSummaryDocument, options);
        }
export type StorefrontDocViewsSummaryQueryHookResult = ReturnType<typeof useStorefrontDocViewsSummaryQuery>;
export type StorefrontDocViewsSummaryLazyQueryHookResult = ReturnType<typeof useStorefrontDocViewsSummaryLazyQuery>;
export type StorefrontDocViewsSummaryQueryResult = Apollo.QueryResult<Types.StorefrontDocViewsSummaryQuery, Types.StorefrontDocViewsSummaryQueryVariables>;
export const GuestbookSignersDocument = gql`
    query GuestbookSigners($input: ListingInput!) {
  guestbookSigners(input: $input) {
    signers {
      ...GuestbookSigner
    }
  }
}
    ${GuestbookSignerFragmentDoc}`;

/**
 * __useGuestbookSignersQuery__
 *
 * To run a query within a React component, call `useGuestbookSignersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestbookSignersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestbookSignersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestbookSignersQuery(baseOptions: Apollo.QueryHookOptions<Types.GuestbookSignersQuery, Types.GuestbookSignersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GuestbookSignersQuery, Types.GuestbookSignersQueryVariables>(GuestbookSignersDocument, options);
      }
export function useGuestbookSignersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GuestbookSignersQuery, Types.GuestbookSignersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GuestbookSignersQuery, Types.GuestbookSignersQueryVariables>(GuestbookSignersDocument, options);
        }
export type GuestbookSignersQueryHookResult = ReturnType<typeof useGuestbookSignersQuery>;
export type GuestbookSignersLazyQueryHookResult = ReturnType<typeof useGuestbookSignersLazyQuery>;
export type GuestbookSignersQueryResult = Apollo.QueryResult<Types.GuestbookSignersQuery, Types.GuestbookSignersQueryVariables>;
export const TransactionNotificationLogDocument = gql`
    query transactionNotificationLog($id: ID!) {
  transactionNotificationLog(id: $id) {
    ...TransactionNotificationLog
  }
}
    ${TransactionNotificationLogFragmentDoc}`;

/**
 * __useTransactionNotificationLogQuery__
 *
 * To run a query within a React component, call `useTransactionNotificationLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionNotificationLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionNotificationLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransactionNotificationLogQuery(baseOptions: Apollo.QueryHookOptions<Types.TransactionNotificationLogQuery, Types.TransactionNotificationLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TransactionNotificationLogQuery, Types.TransactionNotificationLogQueryVariables>(TransactionNotificationLogDocument, options);
      }
export function useTransactionNotificationLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TransactionNotificationLogQuery, Types.TransactionNotificationLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TransactionNotificationLogQuery, Types.TransactionNotificationLogQueryVariables>(TransactionNotificationLogDocument, options);
        }
export type TransactionNotificationLogQueryHookResult = ReturnType<typeof useTransactionNotificationLogQuery>;
export type TransactionNotificationLogLazyQueryHookResult = ReturnType<typeof useTransactionNotificationLogLazyQuery>;
export type TransactionNotificationLogQueryResult = Apollo.QueryResult<Types.TransactionNotificationLogQuery, Types.TransactionNotificationLogQueryVariables>;
export const TransactionNotificationLogsDocument = gql`
    query transactionNotificationLogs($organizationId: ID!, $cursor: String, $orderBy: String = "-createdAt", $perPage: Int = 20, $filters: NotificationLogFilters) {
  transactionNotificationLogs(
    organizationId: $organizationId
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) {
    results {
      ...TransactionNotificationLog
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      perPage
      totalCount
      prevCursor
      nextCursor
    }
  }
}
    ${TransactionNotificationLogFragmentDoc}`;

/**
 * __useTransactionNotificationLogsQuery__
 *
 * To run a query within a React component, call `useTransactionNotificationLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionNotificationLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionNotificationLogsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTransactionNotificationLogsQuery(baseOptions: Apollo.QueryHookOptions<Types.TransactionNotificationLogsQuery, Types.TransactionNotificationLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TransactionNotificationLogsQuery, Types.TransactionNotificationLogsQueryVariables>(TransactionNotificationLogsDocument, options);
      }
export function useTransactionNotificationLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TransactionNotificationLogsQuery, Types.TransactionNotificationLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TransactionNotificationLogsQuery, Types.TransactionNotificationLogsQueryVariables>(TransactionNotificationLogsDocument, options);
        }
export type TransactionNotificationLogsQueryHookResult = ReturnType<typeof useTransactionNotificationLogsQuery>;
export type TransactionNotificationLogsLazyQueryHookResult = ReturnType<typeof useTransactionNotificationLogsLazyQuery>;
export type TransactionNotificationLogsQueryResult = Apollo.QueryResult<Types.TransactionNotificationLogsQuery, Types.TransactionNotificationLogsQueryVariables>;
export const ZipCodesGeoDocument = gql`
    query zipCodesGeo($filters: ZipCodesGeoFilters!) {
  zipCodesGeo(filters: $filters) {
    zip_code
    city
    county_names
    geo_shape
  }
}
    `;

/**
 * __useZipCodesGeoQuery__
 *
 * To run a query within a React component, call `useZipCodesGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useZipCodesGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZipCodesGeoQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useZipCodesGeoQuery(baseOptions: Apollo.QueryHookOptions<Types.ZipCodesGeoQuery, Types.ZipCodesGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ZipCodesGeoQuery, Types.ZipCodesGeoQueryVariables>(ZipCodesGeoDocument, options);
      }
export function useZipCodesGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ZipCodesGeoQuery, Types.ZipCodesGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ZipCodesGeoQuery, Types.ZipCodesGeoQueryVariables>(ZipCodesGeoDocument, options);
        }
export type ZipCodesGeoQueryHookResult = ReturnType<typeof useZipCodesGeoQuery>;
export type ZipCodesGeoLazyQueryHookResult = ReturnType<typeof useZipCodesGeoLazyQuery>;
export type ZipCodesGeoQueryResult = Apollo.QueryResult<Types.ZipCodesGeoQuery, Types.ZipCodesGeoQueryVariables>;